
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebf7c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebf7c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dOhvT", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $a0dd87a8a139447a$export$ffb0004e005737fa; }, function (v) { return $a0dd87a8a139447a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $a0dd87a8a139447a$export$34b9dba7ce09269b; }, function (v) { return $a0dd87a8a139447a$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $a0dd87a8a139447a$export$25062201e9e25d76; }, function (v) { return $a0dd87a8a139447a$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0dd87a8a139447a$export$ffb0004e005737fa;
var $a0dd87a8a139447a$export$34b9dba7ce09269b;
var $a0dd87a8a139447a$export$25062201e9e25d76;
'use strict';
parcelRequire("3nlTJ");

var $8dE9F = parcelRequire("8dE9F");
var $a0dd87a8a139447a$var$g = 60103;
$a0dd87a8a139447a$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $a0dd87a8a139447a$var$h = Symbol.for;
    $a0dd87a8a139447a$var$g = $a0dd87a8a139447a$var$h("react.element");
    $a0dd87a8a139447a$export$ffb0004e005737fa = $a0dd87a8a139447a$var$h("react.fragment");
}
var $a0dd87a8a139447a$var$m = $8dE9F.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $a0dd87a8a139447a$var$n = Object.prototype.hasOwnProperty, $a0dd87a8a139447a$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a0dd87a8a139447a$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$a0dd87a8a139447a$var$n.call(a, b) && !$a0dd87a8a139447a$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $a0dd87a8a139447a$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $a0dd87a8a139447a$var$m.current
    };
}
$a0dd87a8a139447a$export$34b9dba7ce09269b = $a0dd87a8a139447a$var$q;
$a0dd87a8a139447a$export$25062201e9e25d76 = $a0dd87a8a139447a$var$q;

});
parcelRegister("3nlTJ", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $275481915b26d912$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $275481915b26d912$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $275481915b26d912$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $275481915b26d912$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $275481915b26d912$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $275481915b26d912$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $275481915b26d912$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($275481915b26d912$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($275481915b26d912$var$getOwnPropertySymbols) {
            symbols = $275481915b26d912$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($275481915b26d912$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("8dE9F", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cg6iZ"));

});
parcelRegister("cg6iZ", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8ecbdec2a92f604a$export$ffb0004e005737fa; }, function (v) { return $8ecbdec2a92f604a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8ecbdec2a92f604a$export$5f8d39834fd61797; }, function (v) { return $8ecbdec2a92f604a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $8ecbdec2a92f604a$export$e2c29f18771995cb; }, function (v) { return $8ecbdec2a92f604a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $8ecbdec2a92f604a$export$74bf444e3cd11ea5; }, function (v) { return $8ecbdec2a92f604a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $8ecbdec2a92f604a$export$dca3b0875bd9a954; }, function (v) { return $8ecbdec2a92f604a$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $8ecbdec2a92f604a$export$16fa2f45be04daa8; }, function (v) { return $8ecbdec2a92f604a$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $8ecbdec2a92f604a$export$221d75b3f55bb0bd; }, function (v) { return $8ecbdec2a92f604a$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8ecbdec2a92f604a$export$ae55be85d98224ed; }, function (v) { return $8ecbdec2a92f604a$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $8ecbdec2a92f604a$export$e530037191fcd5d7; }, function (v) { return $8ecbdec2a92f604a$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $8ecbdec2a92f604a$export$fd42f52fd3ae1109; }, function (v) { return $8ecbdec2a92f604a$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $8ecbdec2a92f604a$export$c8a8987d4410bf2d; }, function (v) { return $8ecbdec2a92f604a$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $8ecbdec2a92f604a$export$d38cd72104c1f0e9; }, function (v) { return $8ecbdec2a92f604a$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $8ecbdec2a92f604a$export$7d1e3a5e95ceca43; }, function (v) { return $8ecbdec2a92f604a$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $8ecbdec2a92f604a$export$257a8862b851cb5b; }, function (v) { return $8ecbdec2a92f604a$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $8ecbdec2a92f604a$export$a8257692ac88316c; }, function (v) { return $8ecbdec2a92f604a$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $8ecbdec2a92f604a$export$488013bae63b21da; }, function (v) { return $8ecbdec2a92f604a$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $8ecbdec2a92f604a$export$7c73462e0d25e514; }, function (v) { return $8ecbdec2a92f604a$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $8ecbdec2a92f604a$export$35808ee640e87ca7; }, function (v) { return $8ecbdec2a92f604a$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $8ecbdec2a92f604a$export$fae74005e78b1a27; }, function (v) { return $8ecbdec2a92f604a$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $8ecbdec2a92f604a$export$dc8fbce3eb94dc1e; }, function (v) { return $8ecbdec2a92f604a$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $8ecbdec2a92f604a$export$6d9c69b0de29b591; }, function (v) { return $8ecbdec2a92f604a$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $8ecbdec2a92f604a$export$d5a552a76deda3c2; }, function (v) { return $8ecbdec2a92f604a$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $8ecbdec2a92f604a$export$e5c5a5f917a5871c; }, function (v) { return $8ecbdec2a92f604a$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $8ecbdec2a92f604a$export$1538c33de8887b59; }, function (v) { return $8ecbdec2a92f604a$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $8ecbdec2a92f604a$export$13e3392192263954; }, function (v) { return $8ecbdec2a92f604a$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $8ecbdec2a92f604a$export$b8f5890fc79d6aca; }, function (v) { return $8ecbdec2a92f604a$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $8ecbdec2a92f604a$export$60241385465d0a34; }, function (v) { return $8ecbdec2a92f604a$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $8ecbdec2a92f604a$export$83d89fbfd8236492; }, function (v) { return $8ecbdec2a92f604a$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ecbdec2a92f604a$export$ffb0004e005737fa;
var $8ecbdec2a92f604a$export$5f8d39834fd61797;
var $8ecbdec2a92f604a$export$e2c29f18771995cb;
var $8ecbdec2a92f604a$export$74bf444e3cd11ea5;
var $8ecbdec2a92f604a$export$dca3b0875bd9a954;
var $8ecbdec2a92f604a$export$16fa2f45be04daa8;
var $8ecbdec2a92f604a$export$221d75b3f55bb0bd;
var $8ecbdec2a92f604a$export$ae55be85d98224ed;
var $8ecbdec2a92f604a$export$e530037191fcd5d7;
var $8ecbdec2a92f604a$export$fd42f52fd3ae1109;
var $8ecbdec2a92f604a$export$c8a8987d4410bf2d;
var $8ecbdec2a92f604a$export$d38cd72104c1f0e9;
var $8ecbdec2a92f604a$export$7d1e3a5e95ceca43;
var $8ecbdec2a92f604a$export$257a8862b851cb5b;
var $8ecbdec2a92f604a$export$a8257692ac88316c;
var $8ecbdec2a92f604a$export$488013bae63b21da;
var $8ecbdec2a92f604a$export$7c73462e0d25e514;
var $8ecbdec2a92f604a$export$35808ee640e87ca7;
var $8ecbdec2a92f604a$export$fae74005e78b1a27;
var $8ecbdec2a92f604a$export$dc8fbce3eb94dc1e;
var $8ecbdec2a92f604a$export$6d9c69b0de29b591;
var $8ecbdec2a92f604a$export$d5a552a76deda3c2;
var $8ecbdec2a92f604a$export$e5c5a5f917a5871c;
var $8ecbdec2a92f604a$export$1538c33de8887b59;
var $8ecbdec2a92f604a$export$13e3392192263954;
var $8ecbdec2a92f604a$export$b8f5890fc79d6aca;
var $8ecbdec2a92f604a$export$60241385465d0a34;
var $8ecbdec2a92f604a$export$83d89fbfd8236492;
'use strict';

var $3nlTJ = parcelRequire("3nlTJ");
var $8ecbdec2a92f604a$var$n = 60103, $8ecbdec2a92f604a$var$p = 60106;
$8ecbdec2a92f604a$export$ffb0004e005737fa = 60107;
$8ecbdec2a92f604a$export$5f8d39834fd61797 = 60108;
$8ecbdec2a92f604a$export$e2c29f18771995cb = 60114;
var $8ecbdec2a92f604a$var$q = 60109, $8ecbdec2a92f604a$var$r = 60110, $8ecbdec2a92f604a$var$t = 60112;
$8ecbdec2a92f604a$export$74bf444e3cd11ea5 = 60113;
var $8ecbdec2a92f604a$var$u = 60115, $8ecbdec2a92f604a$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $8ecbdec2a92f604a$var$w = Symbol.for;
    $8ecbdec2a92f604a$var$n = $8ecbdec2a92f604a$var$w("react.element");
    $8ecbdec2a92f604a$var$p = $8ecbdec2a92f604a$var$w("react.portal");
    $8ecbdec2a92f604a$export$ffb0004e005737fa = $8ecbdec2a92f604a$var$w("react.fragment");
    $8ecbdec2a92f604a$export$5f8d39834fd61797 = $8ecbdec2a92f604a$var$w("react.strict_mode");
    $8ecbdec2a92f604a$export$e2c29f18771995cb = $8ecbdec2a92f604a$var$w("react.profiler");
    $8ecbdec2a92f604a$var$q = $8ecbdec2a92f604a$var$w("react.provider");
    $8ecbdec2a92f604a$var$r = $8ecbdec2a92f604a$var$w("react.context");
    $8ecbdec2a92f604a$var$t = $8ecbdec2a92f604a$var$w("react.forward_ref");
    $8ecbdec2a92f604a$export$74bf444e3cd11ea5 = $8ecbdec2a92f604a$var$w("react.suspense");
    $8ecbdec2a92f604a$var$u = $8ecbdec2a92f604a$var$w("react.memo");
    $8ecbdec2a92f604a$var$v = $8ecbdec2a92f604a$var$w("react.lazy");
}
var $8ecbdec2a92f604a$var$x = "function" === typeof Symbol && Symbol.iterator;
function $8ecbdec2a92f604a$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8ecbdec2a92f604a$var$x && a[$8ecbdec2a92f604a$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $8ecbdec2a92f604a$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8ecbdec2a92f604a$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8ecbdec2a92f604a$var$B = {};
function $8ecbdec2a92f604a$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $8ecbdec2a92f604a$var$B;
    this.updater = c || $8ecbdec2a92f604a$var$A;
}
$8ecbdec2a92f604a$var$C.prototype.isReactComponent = {};
$8ecbdec2a92f604a$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($8ecbdec2a92f604a$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$8ecbdec2a92f604a$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $8ecbdec2a92f604a$var$D() {}
$8ecbdec2a92f604a$var$D.prototype = $8ecbdec2a92f604a$var$C.prototype;
function $8ecbdec2a92f604a$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $8ecbdec2a92f604a$var$B;
    this.updater = c || $8ecbdec2a92f604a$var$A;
}
var $8ecbdec2a92f604a$var$F = $8ecbdec2a92f604a$var$E.prototype = new $8ecbdec2a92f604a$var$D;
$8ecbdec2a92f604a$var$F.constructor = $8ecbdec2a92f604a$var$E;
$3nlTJ($8ecbdec2a92f604a$var$F, $8ecbdec2a92f604a$var$C.prototype);
$8ecbdec2a92f604a$var$F.isPureReactComponent = !0;
var $8ecbdec2a92f604a$var$G = {
    current: null
}, $8ecbdec2a92f604a$var$H = Object.prototype.hasOwnProperty, $8ecbdec2a92f604a$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8ecbdec2a92f604a$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$8ecbdec2a92f604a$var$H.call(b, e) && !$8ecbdec2a92f604a$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $8ecbdec2a92f604a$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $8ecbdec2a92f604a$var$G.current
    };
}
function $8ecbdec2a92f604a$var$K(a, b) {
    return {
        $$typeof: $8ecbdec2a92f604a$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $8ecbdec2a92f604a$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8ecbdec2a92f604a$var$n;
}
function $8ecbdec2a92f604a$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $8ecbdec2a92f604a$var$M = /\/+/g;
function $8ecbdec2a92f604a$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $8ecbdec2a92f604a$var$escape("" + a.key) : b.toString(36);
}
function $8ecbdec2a92f604a$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $8ecbdec2a92f604a$var$n:
                case $8ecbdec2a92f604a$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $8ecbdec2a92f604a$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($8ecbdec2a92f604a$var$M, "$&/") + "/"), $8ecbdec2a92f604a$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($8ecbdec2a92f604a$var$L(d) && (d = $8ecbdec2a92f604a$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($8ecbdec2a92f604a$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $8ecbdec2a92f604a$var$N(k, g);
        h += $8ecbdec2a92f604a$var$O(k, b, c, f, d);
    }
    else if (f = $8ecbdec2a92f604a$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $8ecbdec2a92f604a$var$N(k, g++), h += $8ecbdec2a92f604a$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($8ecbdec2a92f604a$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $8ecbdec2a92f604a$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $8ecbdec2a92f604a$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $8ecbdec2a92f604a$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $8ecbdec2a92f604a$var$R = {
    current: null
};
function $8ecbdec2a92f604a$var$S() {
    var a = $8ecbdec2a92f604a$var$R.current;
    if (null === a) throw Error($8ecbdec2a92f604a$var$z(321));
    return a;
}
var $8ecbdec2a92f604a$var$T = {
    ReactCurrentDispatcher: $8ecbdec2a92f604a$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $8ecbdec2a92f604a$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $3nlTJ
};
$8ecbdec2a92f604a$export$dca3b0875bd9a954 = {
    map: $8ecbdec2a92f604a$var$P,
    forEach: function(a, b, c) {
        $8ecbdec2a92f604a$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $8ecbdec2a92f604a$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $8ecbdec2a92f604a$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$8ecbdec2a92f604a$var$L(a)) throw Error($8ecbdec2a92f604a$var$z(143));
        return a;
    }
};
$8ecbdec2a92f604a$export$16fa2f45be04daa8 = $8ecbdec2a92f604a$var$C;
$8ecbdec2a92f604a$export$221d75b3f55bb0bd = $8ecbdec2a92f604a$var$E;
$8ecbdec2a92f604a$export$ae55be85d98224ed = $8ecbdec2a92f604a$var$T;
$8ecbdec2a92f604a$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($8ecbdec2a92f604a$var$z(267, a));
    var e = $3nlTJ({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $8ecbdec2a92f604a$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$8ecbdec2a92f604a$var$H.call(b, f) && !$8ecbdec2a92f604a$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $8ecbdec2a92f604a$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$8ecbdec2a92f604a$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $8ecbdec2a92f604a$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $8ecbdec2a92f604a$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$8ecbdec2a92f604a$export$c8a8987d4410bf2d = $8ecbdec2a92f604a$var$J;
$8ecbdec2a92f604a$export$d38cd72104c1f0e9 = function(a) {
    var b = $8ecbdec2a92f604a$var$J.bind(null, a);
    b.type = a;
    return b;
};
$8ecbdec2a92f604a$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8ecbdec2a92f604a$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $8ecbdec2a92f604a$var$t,
        render: a
    };
};
$8ecbdec2a92f604a$export$a8257692ac88316c = $8ecbdec2a92f604a$var$L;
$8ecbdec2a92f604a$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $8ecbdec2a92f604a$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $8ecbdec2a92f604a$var$Q
    };
};
$8ecbdec2a92f604a$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $8ecbdec2a92f604a$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$8ecbdec2a92f604a$export$35808ee640e87ca7 = function(a, b) {
    return $8ecbdec2a92f604a$var$S().useCallback(a, b);
};
$8ecbdec2a92f604a$export$fae74005e78b1a27 = function(a, b) {
    return $8ecbdec2a92f604a$var$S().useContext(a, b);
};
$8ecbdec2a92f604a$export$dc8fbce3eb94dc1e = function() {};
$8ecbdec2a92f604a$export$6d9c69b0de29b591 = function(a, b) {
    return $8ecbdec2a92f604a$var$S().useEffect(a, b);
};
$8ecbdec2a92f604a$export$d5a552a76deda3c2 = function(a, b, c) {
    return $8ecbdec2a92f604a$var$S().useImperativeHandle(a, b, c);
};
$8ecbdec2a92f604a$export$e5c5a5f917a5871c = function(a, b) {
    return $8ecbdec2a92f604a$var$S().useLayoutEffect(a, b);
};
$8ecbdec2a92f604a$export$1538c33de8887b59 = function(a, b) {
    return $8ecbdec2a92f604a$var$S().useMemo(a, b);
};
$8ecbdec2a92f604a$export$13e3392192263954 = function(a, b, c) {
    return $8ecbdec2a92f604a$var$S().useReducer(a, b, c);
};
$8ecbdec2a92f604a$export$b8f5890fc79d6aca = function(a) {
    return $8ecbdec2a92f604a$var$S().useRef(a);
};
$8ecbdec2a92f604a$export$60241385465d0a34 = function(a) {
    return $8ecbdec2a92f604a$var$S().useState(a);
};
$8ecbdec2a92f604a$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("7Jm6X", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $5a0de332bc9fe1e8$export$2b8d127b894957b9; }, function (v) { return $5a0de332bc9fe1e8$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $5a0de332bc9fe1e8$export$cea3a54a6425200c; }, function (v) { return $5a0de332bc9fe1e8$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $5a0de332bc9fe1e8$export$a7c73072b1a182ae; }, function (v) { return $5a0de332bc9fe1e8$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $5a0de332bc9fe1e8$export$9f27bc3417b4524d; }, function (v) { return $5a0de332bc9fe1e8$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $5a0de332bc9fe1e8$export$db77ccec0bb4ccac; }, function (v) { return $5a0de332bc9fe1e8$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $5a0de332bc9fe1e8$export$8392c0c9d3dcbd35; }, function (v) { return $5a0de332bc9fe1e8$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5a0de332bc9fe1e8$export$ffb0004e005737fa; }, function (v) { return $5a0de332bc9fe1e8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $5a0de332bc9fe1e8$export$b624eff549462981; }, function (v) { return $5a0de332bc9fe1e8$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $5a0de332bc9fe1e8$export$7897aa7841a5380c; }, function (v) { return $5a0de332bc9fe1e8$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $5a0de332bc9fe1e8$export$602eac185826482c; }, function (v) { return $5a0de332bc9fe1e8$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $5a0de332bc9fe1e8$export$e2c29f18771995cb; }, function (v) { return $5a0de332bc9fe1e8$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5a0de332bc9fe1e8$export$5f8d39834fd61797; }, function (v) { return $5a0de332bc9fe1e8$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5a0de332bc9fe1e8$export$74bf444e3cd11ea5; }, function (v) { return $5a0de332bc9fe1e8$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $5a0de332bc9fe1e8$export$92387174baf9b227; }, function (v) { return $5a0de332bc9fe1e8$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $5a0de332bc9fe1e8$export$ec112efeb987d9c6; }, function (v) { return $5a0de332bc9fe1e8$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $5a0de332bc9fe1e8$export$b706b080d889d2c9; }, function (v) { return $5a0de332bc9fe1e8$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $5a0de332bc9fe1e8$export$5be5a87408f70ddc; }, function (v) { return $5a0de332bc9fe1e8$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $5a0de332bc9fe1e8$export$45a5e7f76e0caa8d; }, function (v) { return $5a0de332bc9fe1e8$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $5a0de332bc9fe1e8$export$455c2e768291efa6; }, function (v) { return $5a0de332bc9fe1e8$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $5a0de332bc9fe1e8$export$9522e17588c12572; }, function (v) { return $5a0de332bc9fe1e8$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $5a0de332bc9fe1e8$export$2110ac352bb060b9; }, function (v) { return $5a0de332bc9fe1e8$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $5a0de332bc9fe1e8$export$56885ab8b9c456ab; }, function (v) { return $5a0de332bc9fe1e8$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $5a0de332bc9fe1e8$export$d927fcb6adf8f9de; }, function (v) { return $5a0de332bc9fe1e8$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $5a0de332bc9fe1e8$export$b82d16f27459e05a; }, function (v) { return $5a0de332bc9fe1e8$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $5a0de332bc9fe1e8$export$522c17b4f5e123e8; }, function (v) { return $5a0de332bc9fe1e8$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $5a0de332bc9fe1e8$export$1aabd8a0274ecfd6; }, function (v) { return $5a0de332bc9fe1e8$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $5a0de332bc9fe1e8$export$9b621391a187a31a; }, function (v) { return $5a0de332bc9fe1e8$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $5a0de332bc9fe1e8$export$f5bbd400c2f4426f; }, function (v) { return $5a0de332bc9fe1e8$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5a0de332bc9fe1e8$export$2b8d127b894957b9;
var $5a0de332bc9fe1e8$export$cea3a54a6425200c;
var $5a0de332bc9fe1e8$export$a7c73072b1a182ae;
var $5a0de332bc9fe1e8$export$9f27bc3417b4524d;
var $5a0de332bc9fe1e8$export$db77ccec0bb4ccac;
var $5a0de332bc9fe1e8$export$8392c0c9d3dcbd35;
var $5a0de332bc9fe1e8$export$ffb0004e005737fa;
var $5a0de332bc9fe1e8$export$b624eff549462981;
var $5a0de332bc9fe1e8$export$7897aa7841a5380c;
var $5a0de332bc9fe1e8$export$602eac185826482c;
var $5a0de332bc9fe1e8$export$e2c29f18771995cb;
var $5a0de332bc9fe1e8$export$5f8d39834fd61797;
var $5a0de332bc9fe1e8$export$74bf444e3cd11ea5;
var $5a0de332bc9fe1e8$export$92387174baf9b227;
var $5a0de332bc9fe1e8$export$ec112efeb987d9c6;
var $5a0de332bc9fe1e8$export$b706b080d889d2c9;
var $5a0de332bc9fe1e8$export$5be5a87408f70ddc;
var $5a0de332bc9fe1e8$export$45a5e7f76e0caa8d;
var $5a0de332bc9fe1e8$export$455c2e768291efa6;
var $5a0de332bc9fe1e8$export$9522e17588c12572;
var $5a0de332bc9fe1e8$export$2110ac352bb060b9;
var $5a0de332bc9fe1e8$export$56885ab8b9c456ab;
var $5a0de332bc9fe1e8$export$d927fcb6adf8f9de;
var $5a0de332bc9fe1e8$export$b82d16f27459e05a;
var $5a0de332bc9fe1e8$export$522c17b4f5e123e8;
var $5a0de332bc9fe1e8$export$1aabd8a0274ecfd6;
var $5a0de332bc9fe1e8$export$9b621391a187a31a;
var $5a0de332bc9fe1e8$export$f5bbd400c2f4426f;
'use strict';
var $5a0de332bc9fe1e8$var$b = "function" === typeof Symbol && Symbol.for, $5a0de332bc9fe1e8$var$c = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.element") : 60103, $5a0de332bc9fe1e8$var$d = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.portal") : 60106, $5a0de332bc9fe1e8$var$e = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.fragment") : 60107, $5a0de332bc9fe1e8$var$f = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.strict_mode") : 60108, $5a0de332bc9fe1e8$var$g = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.profiler") : 60114, $5a0de332bc9fe1e8$var$h = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.provider") : 60109, $5a0de332bc9fe1e8$var$k = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.context") : 60110, $5a0de332bc9fe1e8$var$l = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.async_mode") : 60111, $5a0de332bc9fe1e8$var$m = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.concurrent_mode") : 60111, $5a0de332bc9fe1e8$var$n = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.forward_ref") : 60112, $5a0de332bc9fe1e8$var$p = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.suspense") : 60113, $5a0de332bc9fe1e8$var$q = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.suspense_list") : 60120, $5a0de332bc9fe1e8$var$r = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.memo") : 60115, $5a0de332bc9fe1e8$var$t = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.lazy") : 60116, $5a0de332bc9fe1e8$var$v = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.block") : 60121, $5a0de332bc9fe1e8$var$w = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.fundamental") : 60117, $5a0de332bc9fe1e8$var$x = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.responder") : 60118, $5a0de332bc9fe1e8$var$y = $5a0de332bc9fe1e8$var$b ? Symbol.for("react.scope") : 60119;
function $5a0de332bc9fe1e8$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $5a0de332bc9fe1e8$var$c:
                switch(a = a.type, a){
                    case $5a0de332bc9fe1e8$var$l:
                    case $5a0de332bc9fe1e8$var$m:
                    case $5a0de332bc9fe1e8$var$e:
                    case $5a0de332bc9fe1e8$var$g:
                    case $5a0de332bc9fe1e8$var$f:
                    case $5a0de332bc9fe1e8$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $5a0de332bc9fe1e8$var$k:
                            case $5a0de332bc9fe1e8$var$n:
                            case $5a0de332bc9fe1e8$var$t:
                            case $5a0de332bc9fe1e8$var$r:
                            case $5a0de332bc9fe1e8$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $5a0de332bc9fe1e8$var$d:
                return u;
        }
    }
}
function $5a0de332bc9fe1e8$var$A(a) {
    return $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$m;
}
$5a0de332bc9fe1e8$export$2b8d127b894957b9 = $5a0de332bc9fe1e8$var$l;
$5a0de332bc9fe1e8$export$cea3a54a6425200c = $5a0de332bc9fe1e8$var$m;
$5a0de332bc9fe1e8$export$a7c73072b1a182ae = $5a0de332bc9fe1e8$var$k;
$5a0de332bc9fe1e8$export$9f27bc3417b4524d = $5a0de332bc9fe1e8$var$h;
$5a0de332bc9fe1e8$export$db77ccec0bb4ccac = $5a0de332bc9fe1e8$var$c;
$5a0de332bc9fe1e8$export$8392c0c9d3dcbd35 = $5a0de332bc9fe1e8$var$n;
$5a0de332bc9fe1e8$export$ffb0004e005737fa = $5a0de332bc9fe1e8$var$e;
$5a0de332bc9fe1e8$export$b624eff549462981 = $5a0de332bc9fe1e8$var$t;
$5a0de332bc9fe1e8$export$7897aa7841a5380c = $5a0de332bc9fe1e8$var$r;
$5a0de332bc9fe1e8$export$602eac185826482c = $5a0de332bc9fe1e8$var$d;
$5a0de332bc9fe1e8$export$e2c29f18771995cb = $5a0de332bc9fe1e8$var$g;
$5a0de332bc9fe1e8$export$5f8d39834fd61797 = $5a0de332bc9fe1e8$var$f;
$5a0de332bc9fe1e8$export$74bf444e3cd11ea5 = $5a0de332bc9fe1e8$var$p;
$5a0de332bc9fe1e8$export$92387174baf9b227 = function(a) {
    return $5a0de332bc9fe1e8$var$A(a) || $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$l;
};
$5a0de332bc9fe1e8$export$ec112efeb987d9c6 = $5a0de332bc9fe1e8$var$A;
$5a0de332bc9fe1e8$export$b706b080d889d2c9 = function(a) {
    return $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$k;
};
$5a0de332bc9fe1e8$export$5be5a87408f70ddc = function(a) {
    return $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$h;
};
$5a0de332bc9fe1e8$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5a0de332bc9fe1e8$var$c;
};
$5a0de332bc9fe1e8$export$455c2e768291efa6 = function(a) {
    return $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$n;
};
$5a0de332bc9fe1e8$export$9522e17588c12572 = function(a) {
    return $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$e;
};
$5a0de332bc9fe1e8$export$2110ac352bb060b9 = function(a) {
    return $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$t;
};
$5a0de332bc9fe1e8$export$56885ab8b9c456ab = function(a) {
    return $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$r;
};
$5a0de332bc9fe1e8$export$d927fcb6adf8f9de = function(a) {
    return $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$d;
};
$5a0de332bc9fe1e8$export$b82d16f27459e05a = function(a) {
    return $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$g;
};
$5a0de332bc9fe1e8$export$522c17b4f5e123e8 = function(a) {
    return $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$f;
};
$5a0de332bc9fe1e8$export$1aabd8a0274ecfd6 = function(a) {
    return $5a0de332bc9fe1e8$var$z(a) === $5a0de332bc9fe1e8$var$p;
};
$5a0de332bc9fe1e8$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $5a0de332bc9fe1e8$var$e || a === $5a0de332bc9fe1e8$var$m || a === $5a0de332bc9fe1e8$var$g || a === $5a0de332bc9fe1e8$var$f || a === $5a0de332bc9fe1e8$var$p || a === $5a0de332bc9fe1e8$var$q || "object" === typeof a && null !== a && (a.$$typeof === $5a0de332bc9fe1e8$var$t || a.$$typeof === $5a0de332bc9fe1e8$var$r || a.$$typeof === $5a0de332bc9fe1e8$var$h || a.$$typeof === $5a0de332bc9fe1e8$var$k || a.$$typeof === $5a0de332bc9fe1e8$var$n || a.$$typeof === $5a0de332bc9fe1e8$var$w || a.$$typeof === $5a0de332bc9fe1e8$var$x || a.$$typeof === $5a0de332bc9fe1e8$var$y || a.$$typeof === $5a0de332bc9fe1e8$var$v);
};
$5a0de332bc9fe1e8$export$f5bbd400c2f4426f = $5a0de332bc9fe1e8$var$z;

});

parcelRegister("i8bOW", function(module, exports) {
function $d33224ad293a7f6a$var$_extends() {
    return module.exports = $d33224ad293a7f6a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d33224ad293a7f6a$var$_extends.apply(null, arguments);
}
module.exports = $d33224ad293a7f6a$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3KM02", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $8dE9F = parcelRequire("8dE9F");

var $3nlTJ = parcelRequire("3nlTJ");

var $caQ7I = parcelRequire("caQ7I");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$8dE9F) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $8dE9F.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $3nlTJ({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $8dE9F.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $3nlTJ({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $3nlTJ({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $3nlTJ({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $caQ7I.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $caQ7I.unstable_scheduleCallback($caQ7I.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $caQ7I.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $caQ7I.unstable_UserBlockingPriority, ed = $caQ7I.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $3nlTJ(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $3nlTJ({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $3nlTJ({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $3nlTJ({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $3nlTJ({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $3nlTJ({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $3nlTJ({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $3nlTJ({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $3nlTJ({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $3nlTJ({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $3nlTJ({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $3nlTJ({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $3nlTJ({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $3nlTJ({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $caQ7I.unstable_runWithPriority, Of = $caQ7I.unstable_scheduleCallback, Pf = $caQ7I.unstable_cancelCallback, Qf = $caQ7I.unstable_shouldYield, Rf = $caQ7I.unstable_requestPaint, Sf = $caQ7I.unstable_now, Tf = $caQ7I.unstable_getCurrentPriorityLevel, Uf = $caQ7I.unstable_ImmediatePriority, Vf = $caQ7I.unstable_UserBlockingPriority, Wf = $caQ7I.unstable_NormalPriority, Xf = $caQ7I.unstable_LowPriority, Yf = $caQ7I.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $3nlTJ({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $3nlTJ({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $8dE9F.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $3nlTJ({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $3nlTJ({}, e, {
                    value: void 0
                });
                d = $3nlTJ({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $3nlTJ({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("caQ7I", function(module, exports) {
'use strict';

module.exports = (parcelRequire("la9px"));

});
parcelRegister("la9px", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f681d4f651990713$export$c4744153514ff05d; }, function (v) { return $f681d4f651990713$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f681d4f651990713$export$b5836b71941fa3ed; }, function (v) { return $f681d4f651990713$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f681d4f651990713$export$d66a1c1c77bd778b; }, function (v) { return $f681d4f651990713$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f681d4f651990713$export$3e506c1ccc9cc1a7; }, function (v) { return $f681d4f651990713$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f681d4f651990713$export$e26fe2ed2fa76875; }, function (v) { return $f681d4f651990713$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f681d4f651990713$export$502329bbf4b505b1; }, function (v) { return $f681d4f651990713$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f681d4f651990713$export$6e3807111c4874c4; }, function (v) { return $f681d4f651990713$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f681d4f651990713$export$c27134553091fb3a; }, function (v) { return $f681d4f651990713$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f681d4f651990713$export$33ee1acdc04fd2a2; }, function (v) { return $f681d4f651990713$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f681d4f651990713$export$b00a404bbd5edef2; }, function (v) { return $f681d4f651990713$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f681d4f651990713$export$8352ce38b91d0c62; }, function (v) { return $f681d4f651990713$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f681d4f651990713$export$d3dfb8e4810cb555; }, function (v) { return $f681d4f651990713$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f681d4f651990713$export$839f9183b0465a69; }, function (v) { return $f681d4f651990713$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f681d4f651990713$export$72fdf0e06517287b; }, function (v) { return $f681d4f651990713$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f681d4f651990713$export$4b844e58a3e414b4; }, function (v) { return $f681d4f651990713$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f681d4f651990713$export$816d2913ae6b83b1; }, function (v) { return $f681d4f651990713$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f681d4f651990713$export$61bcfe829111a1d0; }, function (v) { return $f681d4f651990713$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f681d4f651990713$export$7ee8c9beb337bc3f; }, function (v) { return $f681d4f651990713$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f681d4f651990713$export$cf845f2c119da08a; }, function (v) { return $f681d4f651990713$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f681d4f651990713$export$c4744153514ff05d;
var $f681d4f651990713$export$b5836b71941fa3ed;
var $f681d4f651990713$export$d66a1c1c77bd778b;
var $f681d4f651990713$export$3e506c1ccc9cc1a7;
var $f681d4f651990713$export$e26fe2ed2fa76875;
var $f681d4f651990713$export$502329bbf4b505b1;
var $f681d4f651990713$export$6e3807111c4874c4;
var $f681d4f651990713$export$c27134553091fb3a;
var $f681d4f651990713$export$33ee1acdc04fd2a2;
var $f681d4f651990713$export$b00a404bbd5edef2;
var $f681d4f651990713$export$8352ce38b91d0c62;
var $f681d4f651990713$export$d3dfb8e4810cb555;
var $f681d4f651990713$export$839f9183b0465a69;
var $f681d4f651990713$export$72fdf0e06517287b;
var $f681d4f651990713$export$4b844e58a3e414b4;
var $f681d4f651990713$export$816d2913ae6b83b1;
var $f681d4f651990713$export$61bcfe829111a1d0;
var $f681d4f651990713$export$7ee8c9beb337bc3f;
var $f681d4f651990713$export$cf845f2c119da08a;
'use strict';
var $f681d4f651990713$var$f, $f681d4f651990713$var$g, $f681d4f651990713$var$h, $f681d4f651990713$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f681d4f651990713$var$l = performance;
    $f681d4f651990713$export$c4744153514ff05d = function() {
        return $f681d4f651990713$var$l.now();
    };
} else {
    var $f681d4f651990713$var$p = Date, $f681d4f651990713$var$q = $f681d4f651990713$var$p.now();
    $f681d4f651990713$export$c4744153514ff05d = function() {
        return $f681d4f651990713$var$p.now() - $f681d4f651990713$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $f681d4f651990713$var$t = null, $f681d4f651990713$var$u = null, $f681d4f651990713$var$w = function() {
        if (null !== $f681d4f651990713$var$t) try {
            var a = $f681d4f651990713$export$c4744153514ff05d();
            $f681d4f651990713$var$t(!0, a);
            $f681d4f651990713$var$t = null;
        } catch (b) {
            throw setTimeout($f681d4f651990713$var$w, 0), b;
        }
    };
    $f681d4f651990713$var$f = function(a) {
        null !== $f681d4f651990713$var$t ? setTimeout($f681d4f651990713$var$f, 0, a) : ($f681d4f651990713$var$t = a, setTimeout($f681d4f651990713$var$w, 0));
    };
    $f681d4f651990713$var$g = function(a, b) {
        $f681d4f651990713$var$u = setTimeout(a, b);
    };
    $f681d4f651990713$var$h = function() {
        clearTimeout($f681d4f651990713$var$u);
    };
    $f681d4f651990713$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $f681d4f651990713$var$k = $f681d4f651990713$export$d66a1c1c77bd778b = function() {};
} else {
    var $f681d4f651990713$var$x = window.setTimeout, $f681d4f651990713$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $f681d4f651990713$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $f681d4f651990713$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $f681d4f651990713$var$A = !1, $f681d4f651990713$var$B = null, $f681d4f651990713$var$C = -1, $f681d4f651990713$var$D = 5, $f681d4f651990713$var$E = 0;
    $f681d4f651990713$export$b5836b71941fa3ed = function() {
        return $f681d4f651990713$export$c4744153514ff05d() >= $f681d4f651990713$var$E;
    };
    $f681d4f651990713$var$k = function() {};
    $f681d4f651990713$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f681d4f651990713$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $f681d4f651990713$var$F = new MessageChannel, $f681d4f651990713$var$G = $f681d4f651990713$var$F.port2;
    $f681d4f651990713$var$F.port1.onmessage = function() {
        if (null !== $f681d4f651990713$var$B) {
            var a = $f681d4f651990713$export$c4744153514ff05d();
            $f681d4f651990713$var$E = a + $f681d4f651990713$var$D;
            try {
                $f681d4f651990713$var$B(!0, a) ? $f681d4f651990713$var$G.postMessage(null) : ($f681d4f651990713$var$A = !1, $f681d4f651990713$var$B = null);
            } catch (b) {
                throw $f681d4f651990713$var$G.postMessage(null), b;
            }
        } else $f681d4f651990713$var$A = !1;
    };
    $f681d4f651990713$var$f = function(a) {
        $f681d4f651990713$var$B = a;
        $f681d4f651990713$var$A || ($f681d4f651990713$var$A = !0, $f681d4f651990713$var$G.postMessage(null));
    };
    $f681d4f651990713$var$g = function(a, b) {
        $f681d4f651990713$var$C = $f681d4f651990713$var$x(function() {
            a($f681d4f651990713$export$c4744153514ff05d());
        }, b);
    };
    $f681d4f651990713$var$h = function() {
        $f681d4f651990713$var$y($f681d4f651990713$var$C);
        $f681d4f651990713$var$C = -1;
    };
}
function $f681d4f651990713$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $f681d4f651990713$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f681d4f651990713$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $f681d4f651990713$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $f681d4f651990713$var$I(n, c)) void 0 !== r && 0 > $f681d4f651990713$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $f681d4f651990713$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $f681d4f651990713$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $f681d4f651990713$var$L = [], $f681d4f651990713$var$M = [], $f681d4f651990713$var$N = 1, $f681d4f651990713$var$O = null, $f681d4f651990713$var$P = 3, $f681d4f651990713$var$Q = !1, $f681d4f651990713$var$R = !1, $f681d4f651990713$var$S = !1;
function $f681d4f651990713$var$T(a) {
    for(var b = $f681d4f651990713$var$J($f681d4f651990713$var$M); null !== b;){
        if (null === b.callback) $f681d4f651990713$var$K($f681d4f651990713$var$M);
        else if (b.startTime <= a) $f681d4f651990713$var$K($f681d4f651990713$var$M), b.sortIndex = b.expirationTime, $f681d4f651990713$var$H($f681d4f651990713$var$L, b);
        else break;
        b = $f681d4f651990713$var$J($f681d4f651990713$var$M);
    }
}
function $f681d4f651990713$var$U(a) {
    $f681d4f651990713$var$S = !1;
    $f681d4f651990713$var$T(a);
    if (!$f681d4f651990713$var$R) {
        if (null !== $f681d4f651990713$var$J($f681d4f651990713$var$L)) $f681d4f651990713$var$R = !0, $f681d4f651990713$var$f($f681d4f651990713$var$V);
        else {
            var b = $f681d4f651990713$var$J($f681d4f651990713$var$M);
            null !== b && $f681d4f651990713$var$g($f681d4f651990713$var$U, b.startTime - a);
        }
    }
}
function $f681d4f651990713$var$V(a, b) {
    $f681d4f651990713$var$R = !1;
    $f681d4f651990713$var$S && ($f681d4f651990713$var$S = !1, $f681d4f651990713$var$h());
    $f681d4f651990713$var$Q = !0;
    var c = $f681d4f651990713$var$P;
    try {
        $f681d4f651990713$var$T(b);
        for($f681d4f651990713$var$O = $f681d4f651990713$var$J($f681d4f651990713$var$L); null !== $f681d4f651990713$var$O && (!($f681d4f651990713$var$O.expirationTime > b) || a && !$f681d4f651990713$export$b5836b71941fa3ed());){
            var d = $f681d4f651990713$var$O.callback;
            if ("function" === typeof d) {
                $f681d4f651990713$var$O.callback = null;
                $f681d4f651990713$var$P = $f681d4f651990713$var$O.priorityLevel;
                var e = d($f681d4f651990713$var$O.expirationTime <= b);
                b = $f681d4f651990713$export$c4744153514ff05d();
                "function" === typeof e ? $f681d4f651990713$var$O.callback = e : $f681d4f651990713$var$O === $f681d4f651990713$var$J($f681d4f651990713$var$L) && $f681d4f651990713$var$K($f681d4f651990713$var$L);
                $f681d4f651990713$var$T(b);
            } else $f681d4f651990713$var$K($f681d4f651990713$var$L);
            $f681d4f651990713$var$O = $f681d4f651990713$var$J($f681d4f651990713$var$L);
        }
        if (null !== $f681d4f651990713$var$O) var m = !0;
        else {
            var n = $f681d4f651990713$var$J($f681d4f651990713$var$M);
            null !== n && $f681d4f651990713$var$g($f681d4f651990713$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $f681d4f651990713$var$O = null, $f681d4f651990713$var$P = c, $f681d4f651990713$var$Q = !1;
    }
}
var $f681d4f651990713$var$W = $f681d4f651990713$var$k;
$f681d4f651990713$export$3e506c1ccc9cc1a7 = 5;
$f681d4f651990713$export$e26fe2ed2fa76875 = 1;
$f681d4f651990713$export$502329bbf4b505b1 = 4;
$f681d4f651990713$export$6e3807111c4874c4 = 3;
$f681d4f651990713$export$c27134553091fb3a = null;
$f681d4f651990713$export$33ee1acdc04fd2a2 = 2;
$f681d4f651990713$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f681d4f651990713$export$8352ce38b91d0c62 = function() {
    $f681d4f651990713$var$R || $f681d4f651990713$var$Q || ($f681d4f651990713$var$R = !0, $f681d4f651990713$var$f($f681d4f651990713$var$V));
};
$f681d4f651990713$export$d3dfb8e4810cb555 = function() {
    return $f681d4f651990713$var$P;
};
$f681d4f651990713$export$839f9183b0465a69 = function() {
    return $f681d4f651990713$var$J($f681d4f651990713$var$L);
};
$f681d4f651990713$export$72fdf0e06517287b = function(a) {
    switch($f681d4f651990713$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f681d4f651990713$var$P;
    }
    var c = $f681d4f651990713$var$P;
    $f681d4f651990713$var$P = b;
    try {
        return a();
    } finally{
        $f681d4f651990713$var$P = c;
    }
};
$f681d4f651990713$export$4b844e58a3e414b4 = function() {};
$f681d4f651990713$export$816d2913ae6b83b1 = $f681d4f651990713$var$W;
$f681d4f651990713$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f681d4f651990713$var$P;
    $f681d4f651990713$var$P = a;
    try {
        return b();
    } finally{
        $f681d4f651990713$var$P = c;
    }
};
$f681d4f651990713$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f681d4f651990713$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f681d4f651990713$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f681d4f651990713$var$H($f681d4f651990713$var$M, a), null === $f681d4f651990713$var$J($f681d4f651990713$var$L) && a === $f681d4f651990713$var$J($f681d4f651990713$var$M) && ($f681d4f651990713$var$S ? $f681d4f651990713$var$h() : $f681d4f651990713$var$S = !0, $f681d4f651990713$var$g($f681d4f651990713$var$U, c - d))) : (a.sortIndex = e, $f681d4f651990713$var$H($f681d4f651990713$var$L, a), $f681d4f651990713$var$R || $f681d4f651990713$var$Q || ($f681d4f651990713$var$R = !0, $f681d4f651990713$var$f($f681d4f651990713$var$V)));
    return a;
};
$f681d4f651990713$export$cf845f2c119da08a = function(a) {
    var b = $f681d4f651990713$var$P;
    return function() {
        var c = $f681d4f651990713$var$P;
        $f681d4f651990713$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f681d4f651990713$var$P = c;
        }
    };
};

});



parcelRegister("ciD6D", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $i16Ha = parcelRequire("i16Ha");
function $8f45801abdad4af0$var$emptyFunction() {}
function $8f45801abdad4af0$var$emptyFunctionWithReset() {}
$8f45801abdad4af0$var$emptyFunctionWithReset.resetWarningCache = $8f45801abdad4af0$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $i16Ha) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $8f45801abdad4af0$var$emptyFunctionWithReset,
        resetWarningCache: $8f45801abdad4af0$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("i16Ha", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $d1dd8380ec46c4b2$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $d1dd8380ec46c4b2$var$ReactPropTypesSecret;

});


parcelRegister("gEeCx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c1ebb9216f000fd2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $c1ebb9216f000fd2$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $c1ebb9216f000fd2$export$13a2d3ef13012b32; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("47OeM")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("311cM")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("311cM")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("iUv4u")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("42HDs")).default; });
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $6kinT = parcelRequire("6kinT");

var $6DrM0 = parcelRequire("6DrM0");

var $311cM = parcelRequire("311cM");
var $47OeM = parcelRequire("47OeM");

var $iUv4u = parcelRequire("iUv4u");

var $42HDs = parcelRequire("42HDs");
'use client';
function $c1ebb9216f000fd2$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $6kinT.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $c1ebb9216f000fd2$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $c1ebb9216f000fd2$var$wrapper = [];
function $c1ebb9216f000fd2$export$13a2d3ef13012b32(styles) {
    $c1ebb9216f000fd2$var$wrapper[0] = styles;
    return (0, $6DrM0.serializeStyles)($c1ebb9216f000fd2$var$wrapper);
}

});
parcelRegister("6kinT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49b2df10e66f69a5$export$2e2bcd8739ae039; });

var $f8iEm = parcelRequire("f8iEm");
parcelRequire("i8bOW");

parcelRequire("6DrM0");
parcelRequire("kgAOu");
parcelRequire("gMYkM");
parcelRequire("8dE9F");
parcelRequire("9UsnS");
var $49b2df10e66f69a5$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $49b2df10e66f69a5$export$2e2bcd8739ae039 = (0, $f8iEm.default).bind(null);
$49b2df10e66f69a5$var$tags.forEach(function(tagName) {
    $49b2df10e66f69a5$export$2e2bcd8739ae039[tagName] = $49b2df10e66f69a5$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("f8iEm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b04611d9b96ed58c$export$2e2bcd8739ae039; });

var $7TrLl = parcelRequire("7TrLl");
parcelRequire("311cM");
var $47OeM = parcelRequire("47OeM");

var $6DrM0 = parcelRequire("6DrM0");

var $kgAOu = parcelRequire("kgAOu");

var $gMYkM = parcelRequire("gMYkM");

var $8dE9F = parcelRequire("8dE9F");

var $9UsnS = parcelRequire("9UsnS");
var $b04611d9b96ed58c$var$isBrowser = typeof document !== 'undefined';
var $b04611d9b96ed58c$var$isDevelopment = false;
var $b04611d9b96ed58c$var$testOmitPropsOnStringTag = (0, $9UsnS.default);
var $b04611d9b96ed58c$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $b04611d9b96ed58c$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $b04611d9b96ed58c$var$testOmitPropsOnStringTag : $b04611d9b96ed58c$var$testOmitPropsOnComponent;
};
var $b04611d9b96ed58c$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $b04611d9b96ed58c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $gMYkM.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $kgAOu.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $gMYkM.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$b04611d9b96ed58c$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8dE9F.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $b04611d9b96ed58c$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $b04611d9b96ed58c$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $b04611d9b96ed58c$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $47OeM.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $8dE9F.useContext((0, $47OeM.T));
            }
            if (typeof props.className === 'string') className = (0, $gMYkM.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $6DrM0.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $b04611d9b96ed58c$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $8dE9F.createElement($8dE9F.Fragment, null, /*#__PURE__*/ $8dE9F.createElement($b04611d9b96ed58c$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $8dE9F.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $b04611d9b96ed58c$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7TrLl.default)({}, options, nextOptions, {
                shouldForwardProp: $b04611d9b96ed58c$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("7TrLl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bf3348c95eac548$export$2e2bcd8739ae039; });
function $5bf3348c95eac548$export$2e2bcd8739ae039() {
    return $5bf3348c95eac548$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5bf3348c95eac548$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("311cM", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $23226668e5c6fcec$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $23226668e5c6fcec$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $23226668e5c6fcec$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("47OeM")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("47OeM")).w; });

var $47OeM = parcelRequire("47OeM");

var $8dE9F = parcelRequire("8dE9F");

var $gMYkM = parcelRequire("gMYkM");

var $kgAOu = parcelRequire("kgAOu");

var $6DrM0 = parcelRequire("6DrM0");
parcelRequire("2bJBJ");
parcelRequire("i8bOW");
parcelRequire("2S6Ov");

parcelRequire("9AM9V");
var $23226668e5c6fcec$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $47OeM.h).call(props, 'css')) return $8dE9F.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $47OeM.E);
    createElementArgArray[1] = (0, $47OeM.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $8dE9F.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($23226668e5c6fcec$export$c8a8987d4410bf2d || ($23226668e5c6fcec$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $23226668e5c6fcec$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $47OeM.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $6DrM0.serializeStyles)([
        styles
    ], undefined, $8dE9F.useContext((0, $47OeM.T)));
    if (!(0, $47OeM.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $8dE9F.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8dE9F.useRef();
    (0, $kgAOu.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $kgAOu.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $gMYkM.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $23226668e5c6fcec$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $6DrM0.serializeStyles)(args);
}
function $23226668e5c6fcec$export$d25ddfdf17c3ad3e() {
    var insertable = $23226668e5c6fcec$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $23226668e5c6fcec$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $23226668e5c6fcec$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $gMYkM.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $23226668e5c6fcec$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $kgAOu.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $gMYkM.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $47OeM.i) && res !== undefined) rules += res;
        }
        if (!(0, $47OeM.i)) return rules;
    });
    if (!(0, $47OeM.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $8dE9F.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $23226668e5c6fcec$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $47OeM.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $47OeM.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $6DrM0.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $gMYkM.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $47OeM.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $23226668e5c6fcec$var$merge(cache.registered, css, $23226668e5c6fcec$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8dE9F.useContext((0, $47OeM.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8dE9F.createElement($8dE9F.Fragment, null, /*#__PURE__*/ $8dE9F.createElement($23226668e5c6fcec$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("47OeM", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $300ec8fb23f50c4c$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $300ec8fb23f50c4c$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $300ec8fb23f50c4c$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $300ec8fb23f50c4c$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $300ec8fb23f50c4c$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $300ec8fb23f50c4c$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $300ec8fb23f50c4c$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $300ec8fb23f50c4c$export$a9c23c6ac3fc3eca; });

var $8dE9F = parcelRequire("8dE9F");

var $2bJBJ = parcelRequire("2bJBJ");

var $7TrLl = parcelRequire("7TrLl");

var $2S6Ov = parcelRequire("2S6Ov");

var $g1yNM = parcelRequire("g1yNM");

var $gMYkM = parcelRequire("gMYkM");

var $6DrM0 = parcelRequire("6DrM0");

var $kgAOu = parcelRequire("kgAOu");
var $300ec8fb23f50c4c$export$407448d2b89b1813 = false;
var $300ec8fb23f50c4c$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $300ec8fb23f50c4c$var$EmotionCacheContext = /* #__PURE__ */ $8dE9F.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $2bJBJ.default)({
    key: 'css'
}) : null);
var $300ec8fb23f50c4c$export$e7094788287c5e9b = $300ec8fb23f50c4c$var$EmotionCacheContext.Provider;
var $300ec8fb23f50c4c$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8dE9F.useContext)($300ec8fb23f50c4c$var$EmotionCacheContext);
};
var $300ec8fb23f50c4c$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $8dE9F.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8dE9F.useContext)($300ec8fb23f50c4c$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$300ec8fb23f50c4c$export$23f2a1d2818174ef) $300ec8fb23f50c4c$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $8dE9F.useContext)($300ec8fb23f50c4c$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $2bJBJ.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $8dE9F.createElement($300ec8fb23f50c4c$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $300ec8fb23f50c4c$export$971d5caa766a69d7 = /* #__PURE__ */ $8dE9F.createContext({});
var $300ec8fb23f50c4c$export$3b14a55fb2447963 = function useTheme() {
    return $8dE9F.useContext($300ec8fb23f50c4c$export$971d5caa766a69d7);
};
var $300ec8fb23f50c4c$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $7TrLl.default)({}, outerTheme, theme);
};
var $300ec8fb23f50c4c$var$createCacheWithTheme = /* #__PURE__ */ (0, $2S6Ov.default)(function(outerTheme) {
    return (0, $2S6Ov.default)(function(theme) {
        return $300ec8fb23f50c4c$var$getTheme(outerTheme, theme);
    });
});
var $300ec8fb23f50c4c$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $8dE9F.useContext($300ec8fb23f50c4c$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $300ec8fb23f50c4c$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8dE9F.createElement($300ec8fb23f50c4c$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $300ec8fb23f50c4c$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $8dE9F.forwardRef(function render(props, ref) {
        var theme = $8dE9F.useContext($300ec8fb23f50c4c$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8dE9F.createElement(Component, (0, $7TrLl.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $g1yNM.default)(WithTheme, Component);
}
var $300ec8fb23f50c4c$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $300ec8fb23f50c4c$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $300ec8fb23f50c4c$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($300ec8fb23f50c4c$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$300ec8fb23f50c4c$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $300ec8fb23f50c4c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $gMYkM.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $kgAOu.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $gMYkM.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$300ec8fb23f50c4c$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8dE9F.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $300ec8fb23f50c4c$var$Emotion = /* #__PURE__ */ $300ec8fb23f50c4c$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$300ec8fb23f50c4c$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $gMYkM.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $6DrM0.serializeStyles)(registeredStyles, undefined, $8dE9F.useContext($300ec8fb23f50c4c$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($300ec8fb23f50c4c$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $300ec8fb23f50c4c$var$typePropName && !$300ec8fb23f50c4c$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $8dE9F.createElement($8dE9F.Fragment, null, /*#__PURE__*/ $8dE9F.createElement($300ec8fb23f50c4c$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $8dE9F.createElement(WrappedComponent, newProps));
});
var $300ec8fb23f50c4c$export$a9c23c6ac3fc3eca = $300ec8fb23f50c4c$var$Emotion;

});
parcelRegister("2bJBJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $197ffc8ab1736a56$export$2e2bcd8739ae039; });

var $cyxZI = parcelRequire("cyxZI");

var $aKsud = parcelRequire("aKsud");

var $2S6Ov = parcelRequire("2S6Ov");

var $9tDIK = parcelRequire("9tDIK");
var $197ffc8ab1736a56$var$isBrowser = typeof document !== 'undefined';
var $197ffc8ab1736a56$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $aKsud.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $aKsud.token)(character)) break;
        (0, $aKsud.next)();
    }
    return (0, $aKsud.slice)(begin, (0, $aKsud.position));
};
var $197ffc8ab1736a56$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $aKsud.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $aKsud.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $197ffc8ab1736a56$var$identifierWithPointTracking((0, $aKsud.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $aKsud.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $aKsud.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $aKsud.from)(character);
    }
    while (character = (0, $aKsud.next)());
    return parsed;
};
var $197ffc8ab1736a56$var$getRules = function getRules(value, points) {
    return (0, $aKsud.dealloc)($197ffc8ab1736a56$var$toRules((0, $aKsud.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $197ffc8ab1736a56$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $197ffc8ab1736a56$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$197ffc8ab1736a56$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $197ffc8ab1736a56$var$fixedElements.set(element, true);
    var points = [];
    var rules = $197ffc8ab1736a56$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $197ffc8ab1736a56$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $197ffc8ab1736a56$var$prefix(value, length) {
    switch((0, $aKsud.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $aKsud.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $aKsud.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $aKsud.WEBKIT) + value + (0, $aKsud.MOZ) + value + (0, $aKsud.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $aKsud.WEBKIT) + value + (0, $aKsud.MS) + value + value;
        // order
        case 6165:
            return (0, $aKsud.WEBKIT) + value + (0, $aKsud.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $aKsud.WEBKIT) + value + (0, $aKsud.replace)(value, /(\w+).+(:[^]+)/, (0, $aKsud.WEBKIT) + 'box-$1$2' + (0, $aKsud.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $aKsud.WEBKIT) + value + (0, $aKsud.MS) + 'flex-item-' + (0, $aKsud.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $aKsud.WEBKIT) + value + (0, $aKsud.MS) + 'flex-line-pack' + (0, $aKsud.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $aKsud.WEBKIT) + value + (0, $aKsud.MS) + (0, $aKsud.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $aKsud.WEBKIT) + value + (0, $aKsud.MS) + (0, $aKsud.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $aKsud.WEBKIT) + 'box-' + (0, $aKsud.replace)(value, '-grow', '') + (0, $aKsud.WEBKIT) + value + (0, $aKsud.MS) + (0, $aKsud.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $aKsud.WEBKIT) + (0, $aKsud.replace)(value, /([^-])(transform)/g, '$1' + (0, $aKsud.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $aKsud.replace)((0, $aKsud.replace)((0, $aKsud.replace)(value, /(zoom-|grab)/, (0, $aKsud.WEBKIT) + '$1'), /(image-set)/, (0, $aKsud.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $aKsud.replace)(value, /(image-set\([^]*)/, (0, $aKsud.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $aKsud.replace)((0, $aKsud.replace)(value, /(.+:)(flex-)?(.*)/, (0, $aKsud.WEBKIT) + 'box-pack:$3' + (0, $aKsud.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $aKsud.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $aKsud.replace)(value, /(.+)-inline(.+)/, (0, $aKsud.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $aKsud.strlen)(value) - 1 - length > 6) switch((0, $aKsud.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $aKsud.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $aKsud.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $aKsud.WEBKIT) + '$2-$3' + '$1' + (0, $aKsud.MOZ) + ((0, $aKsud.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $aKsud.indexof)(value, 'stretch') ? $197ffc8ab1736a56$var$prefix((0, $aKsud.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $aKsud.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $aKsud.charat)(value, (0, $aKsud.strlen)(value) - 3 - (~(0, $aKsud.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $aKsud.replace)(value, ':', ':' + (0, $aKsud.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $aKsud.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $aKsud.WEBKIT) + ((0, $aKsud.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $aKsud.WEBKIT) + '$2$3' + '$1' + (0, $aKsud.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $aKsud.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $aKsud.WEBKIT) + value + (0, $aKsud.MS) + (0, $aKsud.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $aKsud.WEBKIT) + value + (0, $aKsud.MS) + (0, $aKsud.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $aKsud.WEBKIT) + value + (0, $aKsud.MS) + (0, $aKsud.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $aKsud.WEBKIT) + value + (0, $aKsud.MS) + value + value;
    }
    return value;
}
var $197ffc8ab1736a56$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $aKsud.DECLARATION:
                element["return"] = $197ffc8ab1736a56$var$prefix(element.value, element.length);
                break;
            case 0, $aKsud.KEYFRAMES:
                return (0, $aKsud.serialize)([
                    (0, $aKsud.copy)(element, {
                        value: (0, $aKsud.replace)(element.value, '@', '@' + (0, $aKsud.WEBKIT))
                    })
                ], callback);
            case 0, $aKsud.RULESET:
                if (element.length) return (0, $aKsud.combine)(element.props, function(value) {
                    switch((0, $aKsud.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $aKsud.serialize)([
                                (0, $aKsud.copy)(element, {
                                    props: [
                                        (0, $aKsud.replace)(value, /:(read-\w+)/, ':' + (0, $aKsud.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $aKsud.serialize)([
                                (0, $aKsud.copy)(element, {
                                    props: [
                                        (0, $aKsud.replace)(value, /:(plac\w+)/, ':' + (0, $aKsud.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $aKsud.copy)(element, {
                                    props: [
                                        (0, $aKsud.replace)(value, /:(plac\w+)/, ':' + (0, $aKsud.MOZ) + '$1')
                                    ]
                                }),
                                (0, $aKsud.copy)(element, {
                                    props: [
                                        (0, $aKsud.replace)(value, /:(plac\w+)/, (0, $aKsud.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $197ffc8ab1736a56$var$getServerStylisCache = $197ffc8ab1736a56$var$isBrowser ? undefined : (0, $2S6Ov.default)(function() {
    return (0, $9tDIK.default)(function() {
        return {};
    });
});
var $197ffc8ab1736a56$var$defaultStylisPlugins = [
    $197ffc8ab1736a56$var$prefixer
];
var $197ffc8ab1736a56$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($197ffc8ab1736a56$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $197ffc8ab1736a56$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($197ffc8ab1736a56$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $197ffc8ab1736a56$var$compat,
        $197ffc8ab1736a56$var$removeLabel
    ];
    if (!$197ffc8ab1736a56$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $aKsud.stringify),
            (0, $aKsud.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $aKsud.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $aKsud.serialize)((0, $aKsud.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $aKsud.stringify)
        ];
        var _serializer = (0, $aKsud.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $aKsud.serialize)((0, $aKsud.compile)(styles), _serializer);
        };
        var serverStylisCache = $197ffc8ab1736a56$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $cyxZI.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("cyxZI", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $9243079a466441f1$export$9d753cd7ae895cce; });
var $9243079a466441f1$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $9243079a466441f1$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $9243079a466441f1$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $9243079a466441f1$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$9243079a466441f1$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($9243079a466441f1$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $9243079a466441f1$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("aKsud", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $bfc86df931584ede$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $bfc86df931584ede$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $bfc86df931584ede$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $bfc86df931584ede$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $bfc86df931584ede$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $bfc86df931584ede$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $bfc86df931584ede$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $bfc86df931584ede$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $bfc86df931584ede$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $bfc86df931584ede$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $bfc86df931584ede$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $bfc86df931584ede$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $bfc86df931584ede$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $bfc86df931584ede$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $bfc86df931584ede$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $bfc86df931584ede$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $bfc86df931584ede$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $bfc86df931584ede$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $bfc86df931584ede$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $bfc86df931584ede$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $bfc86df931584ede$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $bfc86df931584ede$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $bfc86df931584ede$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $bfc86df931584ede$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $bfc86df931584ede$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $bfc86df931584ede$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $bfc86df931584ede$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $bfc86df931584ede$export$38bcb760f1d4871c; });
var $bfc86df931584ede$export$71ad59f2e432cfe8 = "-ms-";
var $bfc86df931584ede$export$2c0f367103c8d01c = "-moz-";
var $bfc86df931584ede$export$39dfd62a25e0fe93 = "-webkit-";
var $bfc86df931584ede$export$a29989082612d0d9 = "comm";
var $bfc86df931584ede$export$aa3a2e812ca8570d = "rule";
var $bfc86df931584ede$export$527d108ccf083c2b = "decl";
var $bfc86df931584ede$export$d3d35020fa5b54f0 = "@page";
var $bfc86df931584ede$export$500415a86c544f73 = "@media";
var $bfc86df931584ede$export$a763edbf796b780a = "@import";
var $bfc86df931584ede$export$2790aeb8b4e5c826 = "@charset";
var $bfc86df931584ede$export$1cc683e23b84b133 = "@viewport";
var $bfc86df931584ede$export$9447a5efea57e862 = "@supports";
var $bfc86df931584ede$export$ef011b4e114b1fba = "@document";
var $bfc86df931584ede$export$6aad947bda0f3f46 = "@namespace";
var $bfc86df931584ede$export$b44a8529a35fcb60 = "@keyframes";
var $bfc86df931584ede$export$2c16de31893252e6 = "@font-face";
var $bfc86df931584ede$export$3d846dd52e150c6f = "@counter-style";
var $bfc86df931584ede$export$22314bfbb57653fe = "@font-feature-values";
var $bfc86df931584ede$export$d773506282b3cfe6 = "@layer";
var $bfc86df931584ede$export$2335f513bbd82c6d = Math.abs;
var $bfc86df931584ede$export$6788812c4e6611e6 = String.fromCharCode;
var $bfc86df931584ede$export$e6e34fd1f2686227 = Object.assign;
function $bfc86df931584ede$export$d6af199866bfb566(e, r) {
    return $bfc86df931584ede$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $bfc86df931584ede$export$a9db5e087081082d(e, 0)) << 2 ^ $bfc86df931584ede$export$a9db5e087081082d(e, 1)) << 2 ^ $bfc86df931584ede$export$a9db5e087081082d(e, 2)) << 2 ^ $bfc86df931584ede$export$a9db5e087081082d(e, 3) : 0;
}
function $bfc86df931584ede$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $bfc86df931584ede$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $bfc86df931584ede$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $bfc86df931584ede$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $bfc86df931584ede$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $bfc86df931584ede$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $bfc86df931584ede$export$36776f635604f274(e) {
    return e.length;
}
function $bfc86df931584ede$export$f9084667e487ed46(e) {
    return e.length;
}
function $bfc86df931584ede$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $bfc86df931584ede$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $bfc86df931584ede$export$53f1d5ea8de3d7c = 1;
var $bfc86df931584ede$export$4e0c71f277ca26b3 = 1;
var $bfc86df931584ede$export$f24224f1c91d8156 = 0;
var $bfc86df931584ede$export$5880b8b5730aff45 = 0;
var $bfc86df931584ede$export$c0306caf338ac095 = 0;
var $bfc86df931584ede$export$30a86d91af8ff6e6 = "";
function $bfc86df931584ede$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $bfc86df931584ede$export$53f1d5ea8de3d7c,
        column: $bfc86df931584ede$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $bfc86df931584ede$export$784d13d8ee351f07(e, r) {
    return $bfc86df931584ede$export$e6e34fd1f2686227($bfc86df931584ede$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $bfc86df931584ede$export$eba6f6f03b0a92e7() {
    return $bfc86df931584ede$export$c0306caf338ac095;
}
function $bfc86df931584ede$export$232faf9add678146() {
    $bfc86df931584ede$export$c0306caf338ac095 = $bfc86df931584ede$export$5880b8b5730aff45 > 0 ? $bfc86df931584ede$export$a9db5e087081082d($bfc86df931584ede$export$30a86d91af8ff6e6, --$bfc86df931584ede$export$5880b8b5730aff45) : 0;
    if ($bfc86df931584ede$export$4e0c71f277ca26b3--, $bfc86df931584ede$export$c0306caf338ac095 === 10) $bfc86df931584ede$export$4e0c71f277ca26b3 = 1, $bfc86df931584ede$export$53f1d5ea8de3d7c--;
    return $bfc86df931584ede$export$c0306caf338ac095;
}
function $bfc86df931584ede$export$48cfd1e771a65c4f() {
    $bfc86df931584ede$export$c0306caf338ac095 = $bfc86df931584ede$export$5880b8b5730aff45 < $bfc86df931584ede$export$f24224f1c91d8156 ? $bfc86df931584ede$export$a9db5e087081082d($bfc86df931584ede$export$30a86d91af8ff6e6, $bfc86df931584ede$export$5880b8b5730aff45++) : 0;
    if ($bfc86df931584ede$export$4e0c71f277ca26b3++, $bfc86df931584ede$export$c0306caf338ac095 === 10) $bfc86df931584ede$export$4e0c71f277ca26b3 = 1, $bfc86df931584ede$export$53f1d5ea8de3d7c++;
    return $bfc86df931584ede$export$c0306caf338ac095;
}
function $bfc86df931584ede$export$4d3fb11e950abb9e() {
    return $bfc86df931584ede$export$a9db5e087081082d($bfc86df931584ede$export$30a86d91af8ff6e6, $bfc86df931584ede$export$5880b8b5730aff45);
}
function $bfc86df931584ede$export$e88cb2efb12ae807() {
    return $bfc86df931584ede$export$5880b8b5730aff45;
}
function $bfc86df931584ede$export$58adb3bec8346d0f(e, r) {
    return $bfc86df931584ede$export$2f35ab04d2335697($bfc86df931584ede$export$30a86d91af8ff6e6, e, r);
}
function $bfc86df931584ede$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $bfc86df931584ede$export$2de70f21292aac9e(e) {
    return $bfc86df931584ede$export$53f1d5ea8de3d7c = $bfc86df931584ede$export$4e0c71f277ca26b3 = 1, $bfc86df931584ede$export$f24224f1c91d8156 = $bfc86df931584ede$export$36776f635604f274($bfc86df931584ede$export$30a86d91af8ff6e6 = e), $bfc86df931584ede$export$5880b8b5730aff45 = 0, [];
}
function $bfc86df931584ede$export$45918ac1574455b1(e) {
    return $bfc86df931584ede$export$30a86d91af8ff6e6 = "", e;
}
function $bfc86df931584ede$export$410ac95b9ec204b8(e) {
    return $bfc86df931584ede$export$87c2784dc9fc4ab($bfc86df931584ede$export$58adb3bec8346d0f($bfc86df931584ede$export$5880b8b5730aff45 - 1, $bfc86df931584ede$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $bfc86df931584ede$export$660b2ee2d4fb4eff(e) {
    return $bfc86df931584ede$export$45918ac1574455b1($bfc86df931584ede$export$5f8c09e3ae6f64e1($bfc86df931584ede$export$2de70f21292aac9e(e)));
}
function $bfc86df931584ede$export$7af1228ff777d175(e) {
    while($bfc86df931584ede$export$c0306caf338ac095 = $bfc86df931584ede$export$4d3fb11e950abb9e())if ($bfc86df931584ede$export$c0306caf338ac095 < 33) $bfc86df931584ede$export$48cfd1e771a65c4f();
    else break;
    return $bfc86df931584ede$export$9e1725a4cfeada27(e) > 2 || $bfc86df931584ede$export$9e1725a4cfeada27($bfc86df931584ede$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $bfc86df931584ede$export$5f8c09e3ae6f64e1(e) {
    while($bfc86df931584ede$export$48cfd1e771a65c4f())switch($bfc86df931584ede$export$9e1725a4cfeada27($bfc86df931584ede$export$c0306caf338ac095)){
        case 0:
            $bfc86df931584ede$export$10d8903dec122b9d($bfc86df931584ede$export$c2ab62c7bf24634($bfc86df931584ede$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $bfc86df931584ede$export$10d8903dec122b9d($bfc86df931584ede$export$410ac95b9ec204b8($bfc86df931584ede$export$c0306caf338ac095), e);
            break;
        default:
            $bfc86df931584ede$export$10d8903dec122b9d($bfc86df931584ede$export$6788812c4e6611e6($bfc86df931584ede$export$c0306caf338ac095), e);
    }
    return e;
}
function $bfc86df931584ede$export$955ba06d119e085e(e, r) {
    while(--r && $bfc86df931584ede$export$48cfd1e771a65c4f())if ($bfc86df931584ede$export$c0306caf338ac095 < 48 || $bfc86df931584ede$export$c0306caf338ac095 > 102 || $bfc86df931584ede$export$c0306caf338ac095 > 57 && $bfc86df931584ede$export$c0306caf338ac095 < 65 || $bfc86df931584ede$export$c0306caf338ac095 > 70 && $bfc86df931584ede$export$c0306caf338ac095 < 97) break;
    return $bfc86df931584ede$export$58adb3bec8346d0f(e, $bfc86df931584ede$export$e88cb2efb12ae807() + (r < 6 && $bfc86df931584ede$export$4d3fb11e950abb9e() == 32 && $bfc86df931584ede$export$48cfd1e771a65c4f() == 32));
}
function $bfc86df931584ede$export$c889f2fcc19dbf12(e) {
    while($bfc86df931584ede$export$48cfd1e771a65c4f())switch($bfc86df931584ede$export$c0306caf338ac095){
        case e:
            return $bfc86df931584ede$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $bfc86df931584ede$export$c889f2fcc19dbf12($bfc86df931584ede$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $bfc86df931584ede$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $bfc86df931584ede$export$48cfd1e771a65c4f();
            break;
    }
    return $bfc86df931584ede$export$5880b8b5730aff45;
}
function $bfc86df931584ede$export$4254d4e2b3745c4c(e, r) {
    while($bfc86df931584ede$export$48cfd1e771a65c4f())if (e + $bfc86df931584ede$export$c0306caf338ac095 === 57) break;
    else if (e + $bfc86df931584ede$export$c0306caf338ac095 === 84 && $bfc86df931584ede$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $bfc86df931584ede$export$58adb3bec8346d0f(r, $bfc86df931584ede$export$5880b8b5730aff45 - 1) + "*" + $bfc86df931584ede$export$6788812c4e6611e6(e === 47 ? e : $bfc86df931584ede$export$48cfd1e771a65c4f());
}
function $bfc86df931584ede$export$c2ab62c7bf24634(e) {
    while(!$bfc86df931584ede$export$9e1725a4cfeada27($bfc86df931584ede$export$4d3fb11e950abb9e()))$bfc86df931584ede$export$48cfd1e771a65c4f();
    return $bfc86df931584ede$export$58adb3bec8346d0f(e, $bfc86df931584ede$export$5880b8b5730aff45);
}
function $bfc86df931584ede$export$ef7acd7185315e22(e) {
    return $bfc86df931584ede$export$45918ac1574455b1($bfc86df931584ede$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $bfc86df931584ede$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $bfc86df931584ede$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $bfc86df931584ede$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $bfc86df931584ede$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($bfc86df931584ede$export$f8e21b1e77979a08(j += $bfc86df931584ede$export$77ad94ebf1c2b9ed($bfc86df931584ede$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $bfc86df931584ede$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $bfc86df931584ede$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $bfc86df931584ede$export$955ba06d119e085e($bfc86df931584ede$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($bfc86df931584ede$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $bfc86df931584ede$export$10d8903dec122b9d($bfc86df931584ede$export$4a34f930e789283c($bfc86df931584ede$export$4254d4e2b3745c4c($bfc86df931584ede$export$48cfd1e771a65c4f(), $bfc86df931584ede$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $bfc86df931584ede$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $bfc86df931584ede$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $bfc86df931584ede$export$36776f635604f274(j) - l) $bfc86df931584ede$export$10d8903dec122b9d(p > 32 ? $bfc86df931584ede$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $bfc86df931584ede$export$f8483753829ec8f3($bfc86df931584ede$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $bfc86df931584ede$export$10d8903dec122b9d(y = $bfc86df931584ede$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $bfc86df931584ede$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $bfc86df931584ede$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $bfc86df931584ede$export$98e6a39c04603d36(e, y, y, n && $bfc86df931584ede$export$10d8903dec122b9d($bfc86df931584ede$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $bfc86df931584ede$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $bfc86df931584ede$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $bfc86df931584ede$export$232faf9add678146() == 125) continue;
            }
            switch(j += $bfc86df931584ede$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($bfc86df931584ede$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($bfc86df931584ede$export$4d3fb11e950abb9e() === 45) j += $bfc86df931584ede$export$410ac95b9ec204b8($bfc86df931584ede$export$48cfd1e771a65c4f());
                    v = $bfc86df931584ede$export$4d3fb11e950abb9e(), o = l = $bfc86df931584ede$export$36776f635604f274(g = j += $bfc86df931584ede$export$c2ab62c7bf24634($bfc86df931584ede$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $bfc86df931584ede$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $bfc86df931584ede$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $bfc86df931584ede$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $bfc86df931584ede$export$2f35ab04d2335697(e, v + 1, v = $bfc86df931584ede$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $bfc86df931584ede$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $bfc86df931584ede$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $bfc86df931584ede$export$35059013cd4a06db(e, r, a, s === 0 ? $bfc86df931584ede$export$aa3a2e812ca8570d : i, f, o, l);
}
function $bfc86df931584ede$export$4a34f930e789283c(e, r, a) {
    return $bfc86df931584ede$export$35059013cd4a06db(e, r, a, $bfc86df931584ede$export$a29989082612d0d9, $bfc86df931584ede$export$6788812c4e6611e6($bfc86df931584ede$export$eba6f6f03b0a92e7()), $bfc86df931584ede$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $bfc86df931584ede$export$f8483753829ec8f3(e, r, a, n) {
    return $bfc86df931584ede$export$35059013cd4a06db(e, r, a, $bfc86df931584ede$export$527d108ccf083c2b, $bfc86df931584ede$export$2f35ab04d2335697(e, 0, n), $bfc86df931584ede$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $bfc86df931584ede$export$82e9f45cca5ba907(n, c, s) {
    switch($bfc86df931584ede$export$d6af199866bfb566(n, c)){
        case 5103:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $bfc86df931584ede$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$2c0f367103c8d01c + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($bfc86df931584ede$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $bfc86df931584ede$export$39dfd62a25e0fe93 + "box-$1$2" + $bfc86df931584ede$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + "flex-item-" + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$bfc86df931584ede$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $bfc86df931584ede$export$71ad59f2e432cfe8 + "grid-row-" + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + "flex-line-pack" + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + "box-" + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, "-grow", "") + $bfc86df931584ede$export$39dfd62a25e0fe93 + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $bfc86df931584ede$export$39dfd62a25e0fe93 + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $bfc86df931584ede$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $bfc86df931584ede$export$77ad94ebf1c2b9ed($bfc86df931584ede$export$77ad94ebf1c2b9ed($bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $bfc86df931584ede$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $bfc86df931584ede$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $bfc86df931584ede$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $bfc86df931584ede$export$77ad94ebf1c2b9ed($bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $bfc86df931584ede$export$39dfd62a25e0fe93 + "box-pack:$3" + $bfc86df931584ede$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $bfc86df931584ede$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$bfc86df931584ede$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $bfc86df931584ede$export$71ad59f2e432cfe8 + "grid-column-align" + $bfc86df931584ede$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $bfc86df931584ede$export$71ad59f2e432cfe8 + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $bfc86df931584ede$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$bfc86df931584ede$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $bfc86df931584ede$export$71ad59f2e432cfe8 + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $bfc86df931584ede$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$bfc86df931584ede$export$f8e21b1e77979a08(s, "span") ? $bfc86df931584ede$export$4659b591c19bdf3d(s, /\d+/) : +$bfc86df931584ede$export$4659b591c19bdf3d(s, /\d+/) - +$bfc86df931584ede$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $bfc86df931584ede$export$71ad59f2e432cfe8 + $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $bfc86df931584ede$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $bfc86df931584ede$export$71ad59f2e432cfe8 + $bfc86df931584ede$export$77ad94ebf1c2b9ed($bfc86df931584ede$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $bfc86df931584ede$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($bfc86df931584ede$export$36776f635604f274(n) - 1 - c > 6) switch($bfc86df931584ede$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($bfc86df931584ede$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $bfc86df931584ede$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $bfc86df931584ede$export$2c0f367103c8d01c + ($bfc86df931584ede$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$bfc86df931584ede$export$f8e21b1e77979a08(n, "stretch") ? $bfc86df931584ede$export$82e9f45cca5ba907($bfc86df931584ede$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $bfc86df931584ede$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $bfc86df931584ede$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($bfc86df931584ede$export$a9db5e087081082d(n, c + 6) === 121) return $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, ":", ":" + $bfc86df931584ede$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($bfc86df931584ede$export$a9db5e087081082d(n, $bfc86df931584ede$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $bfc86df931584ede$export$39dfd62a25e0fe93 + ($bfc86df931584ede$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $bfc86df931584ede$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $bfc86df931584ede$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, ":", ":" + $bfc86df931584ede$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $bfc86df931584ede$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $bfc86df931584ede$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $bfc86df931584ede$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $bfc86df931584ede$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $bfc86df931584ede$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $bfc86df931584ede$export$a763edbf796b780a:
        case $bfc86df931584ede$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $bfc86df931584ede$export$a29989082612d0d9:
            return "";
        case $bfc86df931584ede$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $bfc86df931584ede$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $bfc86df931584ede$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $bfc86df931584ede$export$36776f635604f274(a = $bfc86df931584ede$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $bfc86df931584ede$export$5a7767152ae0305f(e) {
    var r = $bfc86df931584ede$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $bfc86df931584ede$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $bfc86df931584ede$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $bfc86df931584ede$export$527d108ccf083c2b:
                n.return = $bfc86df931584ede$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $bfc86df931584ede$export$b44a8529a35fcb60:
                return $bfc86df931584ede$export$dfdc1655ccc5b9cb([
                    $bfc86df931584ede$export$784d13d8ee351f07(n, {
                        value: $bfc86df931584ede$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $bfc86df931584ede$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $bfc86df931584ede$export$aa3a2e812ca8570d:
                if (n.length) return $bfc86df931584ede$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($bfc86df931584ede$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $bfc86df931584ede$export$dfdc1655ccc5b9cb([
                                $bfc86df931584ede$export$784d13d8ee351f07(n, {
                                    props: [
                                        $bfc86df931584ede$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $bfc86df931584ede$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $bfc86df931584ede$export$dfdc1655ccc5b9cb([
                                $bfc86df931584ede$export$784d13d8ee351f07(n, {
                                    props: [
                                        $bfc86df931584ede$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $bfc86df931584ede$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $bfc86df931584ede$export$784d13d8ee351f07(n, {
                                    props: [
                                        $bfc86df931584ede$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $bfc86df931584ede$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $bfc86df931584ede$export$784d13d8ee351f07(n, {
                                    props: [
                                        $bfc86df931584ede$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $bfc86df931584ede$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $bfc86df931584ede$export$76a88f7de6507443(e) {
    switch(e.type){
        case $bfc86df931584ede$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $bfc86df931584ede$export$1be1fc439b849fdf($bfc86df931584ede$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($bfc86df931584ede$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $bfc86df931584ede$export$2f35ab04d2335697(r, 1, $bfc86df931584ede$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $bfc86df931584ede$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $bfc86df931584ede$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $bfc86df931584ede$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("2S6Ov", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2175e8f4766d749f$export$2e2bcd8739ae039; });
var $2175e8f4766d749f$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9tDIK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e65a234b4952919$export$2e2bcd8739ae039; });
function $6e65a234b4952919$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("g1yNM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baa7bc40bd68f3ff$export$2e2bcd8739ae039; });

var $9AM9V = parcelRequire("9AM9V");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $baa7bc40bd68f3ff$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9AM9V)))(targetComponent, sourceComponent);
};

});
parcelRegister("9AM9V", function(module, exports) {
'use strict';

var $FN6Y5 = parcelRequire("FN6Y5");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $6fbcd53e233dd49a$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $6fbcd53e233dd49a$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $6fbcd53e233dd49a$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $6fbcd53e233dd49a$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $6fbcd53e233dd49a$var$TYPE_STATICS = {};
$6fbcd53e233dd49a$var$TYPE_STATICS[$FN6Y5.ForwardRef] = $6fbcd53e233dd49a$var$FORWARD_REF_STATICS;
$6fbcd53e233dd49a$var$TYPE_STATICS[$FN6Y5.Memo] = $6fbcd53e233dd49a$var$MEMO_STATICS;
function $6fbcd53e233dd49a$var$getStatics(component) {
    // React v16.11 and below
    if ($FN6Y5.isMemo(component)) return $6fbcd53e233dd49a$var$MEMO_STATICS;
     // React v16.12 and above
    return $6fbcd53e233dd49a$var$TYPE_STATICS[component['$$typeof']] || $6fbcd53e233dd49a$var$REACT_STATICS;
}
var $6fbcd53e233dd49a$var$defineProperty = Object.defineProperty;
var $6fbcd53e233dd49a$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $6fbcd53e233dd49a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6fbcd53e233dd49a$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $6fbcd53e233dd49a$var$getPrototypeOf = Object.getPrototypeOf;
var $6fbcd53e233dd49a$var$objectPrototype = Object.prototype;
function $6fbcd53e233dd49a$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($6fbcd53e233dd49a$var$objectPrototype) {
            var inheritedComponent = $6fbcd53e233dd49a$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $6fbcd53e233dd49a$var$objectPrototype) $6fbcd53e233dd49a$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $6fbcd53e233dd49a$var$getOwnPropertyNames(sourceComponent);
        if ($6fbcd53e233dd49a$var$getOwnPropertySymbols) keys = keys.concat($6fbcd53e233dd49a$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $6fbcd53e233dd49a$var$getStatics(targetComponent);
        var sourceStatics = $6fbcd53e233dd49a$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$6fbcd53e233dd49a$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $6fbcd53e233dd49a$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $6fbcd53e233dd49a$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $6fbcd53e233dd49a$var$hoistNonReactStatics;

});
parcelRegister("FN6Y5", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7Jm6X"));

});



parcelRegister("gMYkM", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $03277b95321149b7$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $03277b95321149b7$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $03277b95321149b7$export$6f077d94b33a01aa; });
var $03277b95321149b7$var$isBrowser = typeof document !== 'undefined';
function $03277b95321149b7$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $03277b95321149b7$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $03277b95321149b7$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $03277b95321149b7$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $03277b95321149b7$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$03277b95321149b7$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$03277b95321149b7$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("6DrM0", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $4d4bedcda704a326$export$6321afa313b251b5; });

var $4p9yQ = parcelRequire("4p9yQ");

var $15DlK = parcelRequire("15DlK");

var $9tDIK = parcelRequire("9tDIK");
var $4d4bedcda704a326$var$isDevelopment = false;
var $4d4bedcda704a326$var$hyphenateRegex = /[A-Z]|^ms/g;
var $4d4bedcda704a326$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $4d4bedcda704a326$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $4d4bedcda704a326$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $4d4bedcda704a326$var$processStyleName = /* #__PURE__ */ (0, $9tDIK.default)(function(styleName) {
    return $4d4bedcda704a326$var$isCustomProperty(styleName) ? styleName : styleName.replace($4d4bedcda704a326$var$hyphenateRegex, '-$&').toLowerCase();
});
var $4d4bedcda704a326$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($4d4bedcda704a326$var$animationRegex, function(match, p1, p2) {
                $4d4bedcda704a326$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $4d4bedcda704a326$var$cursor
                };
                return p1;
            });
    }
    if ((0, $15DlK.default)[key] !== 1 && !$4d4bedcda704a326$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $4d4bedcda704a326$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $4d4bedcda704a326$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $4d4bedcda704a326$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $4d4bedcda704a326$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $4d4bedcda704a326$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $4d4bedcda704a326$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $4d4bedcda704a326$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $4d4bedcda704a326$var$cursor;
                var result = interpolation(mergedProps);
                $4d4bedcda704a326$var$cursor = previousCursor;
                return $4d4bedcda704a326$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $4d4bedcda704a326$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $4d4bedcda704a326$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($4d4bedcda704a326$var$isProcessableValue(asString)) string += $4d4bedcda704a326$var$processStyleName(key) + ":" + $4d4bedcda704a326$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $4d4bedcda704a326$var$isDevelopment) throw new Error($4d4bedcda704a326$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($4d4bedcda704a326$var$isProcessableValue(value[_i])) string += $4d4bedcda704a326$var$processStyleName(key) + ":" + $4d4bedcda704a326$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $4d4bedcda704a326$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $4d4bedcda704a326$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $4d4bedcda704a326$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $4d4bedcda704a326$var$cursor;
function $4d4bedcda704a326$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $4d4bedcda704a326$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $4d4bedcda704a326$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $4d4bedcda704a326$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $4d4bedcda704a326$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $4d4bedcda704a326$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4p9yQ.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $4d4bedcda704a326$var$cursor
    };
}

});
parcelRegister("4p9yQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3350e9d4d5d6c602$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3350e9d4d5d6c602$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("15DlK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cb4c81bd8e8ba26$export$2e2bcd8739ae039; });
var $0cb4c81bd8e8ba26$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("kgAOu", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $ec11dba322969b96$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $ec11dba322969b96$export$811a713a7276cb9d; });

var $8dE9F = parcelRequire("8dE9F");
var $ec11dba322969b96$var$isBrowser = typeof document !== 'undefined';
var $ec11dba322969b96$var$syncFallback = function syncFallback(create) {
    return create();
};
var $ec11dba322969b96$var$useInsertionEffect = $8dE9F.useInsertionEffect ? $8dE9F.useInsertionEffect : false;
var $ec11dba322969b96$export$db21c7ffa21794e7 = !$ec11dba322969b96$var$isBrowser ? $ec11dba322969b96$var$syncFallback : $ec11dba322969b96$var$useInsertionEffect || $ec11dba322969b96$var$syncFallback;
var $ec11dba322969b96$export$811a713a7276cb9d = $ec11dba322969b96$var$useInsertionEffect || $8dE9F.useLayoutEffect;

});



parcelRegister("9UsnS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $736f5c880d062adf$export$2e2bcd8739ae039; });

var $9tDIK = parcelRequire("9tDIK");
// eslint-disable-next-line no-undef
var $736f5c880d062adf$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $736f5c880d062adf$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9tDIK.default)(function(prop) {
    return $736f5c880d062adf$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("iUv4u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc458f1d091369bd$export$2e2bcd8739ae039; });

var $8dE9F = parcelRequire("8dE9F");


var $47OeM = parcelRequire("47OeM");

var $2bJBJ = parcelRequire("2bJBJ");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
function $dc458f1d091369bd$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $2bJBJ.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $dc458f1d091369bd$var$cacheMap = new Map();
function $dc458f1d091369bd$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $8dE9F.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $dc458f1d091369bd$var$cacheMap.has(cacheKey)) return $dc458f1d091369bd$var$cacheMap.get(cacheKey);
        const fresh = $dc458f1d091369bd$var$getCache(injectFirst, enableCssLayer);
        $dc458f1d091369bd$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $47OeM.C), {
        value: cache,
        children: children
    });
    return children;
}

});
parcelRegister("dzbn0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dOhvT"));

});


parcelRegister("42HDs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f19326cc52701a3$export$2e2bcd8739ae039; });
parcelRequire("8dE9F");


var $311cM = parcelRequire("311cM");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
function $2f19326cc52701a3$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $2f19326cc52701a3$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($2f19326cc52701a3$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $311cM.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("6yIHG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("4T6WZ")).default; });

var $4T6WZ = parcelRequire("4T6WZ");

});
parcelRegister("4T6WZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38f1b0afdc24f996$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $38f1b0afdc24f996$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("f7kw6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1JswZ")).default; });

var $1JswZ = parcelRequire("1JswZ");

});
parcelRegister("1JswZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1430201e555b4ee5$export$2e2bcd8739ae039; });
function $1430201e555b4ee5$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $1430201e555b4ee5$export$2e2bcd8739ae039 = $1430201e555b4ee5$var$clamp;

});


parcelRegister("33Xhy", function(module, exports) {
function $23afa316c6a2bbbe$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $23afa316c6a2bbbe$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("i0zYw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("i3G15")).default; });

var $i3G15 = parcelRequire("i3G15");

});
parcelRegister("i3G15", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d259196382ea6524$export$2e2bcd8739ae039; });

var $4T6WZ = parcelRequire("4T6WZ");
function $d259196382ea6524$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $4T6WZ.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("hklVT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("kHQAI")).default; });

var $kHQAI = parcelRequire("kHQAI");
$parcel$exportWildcard(module.exports, $kHQAI);

});
parcelRegister("kHQAI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $f1309e4d08d0285d$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $f1309e4d08d0285d$export$2e2bcd8739ae039; });

var $lkwUC = parcelRequire("lkwUC");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $f1309e4d08d0285d$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $f1309e4d08d0285d$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($f1309e4d08d0285d$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $f1309e4d08d0285d$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $f1309e4d08d0285d$export$aad197c7121a6651(Component) || fallback;
}
function $f1309e4d08d0285d$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $f1309e4d08d0285d$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $f1309e4d08d0285d$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $f1309e4d08d0285d$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $lkwUC.ForwardRef:
            return $f1309e4d08d0285d$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $lkwUC.Memo:
            return $f1309e4d08d0285d$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("lkwUC", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3dGlq"));

});
parcelRegister("3dGlq", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $25836ebc568cff31$export$a7c73072b1a182ae; }, function (v) { return $25836ebc568cff31$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $25836ebc568cff31$export$9f27bc3417b4524d; }, function (v) { return $25836ebc568cff31$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $25836ebc568cff31$export$db77ccec0bb4ccac; }, function (v) { return $25836ebc568cff31$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $25836ebc568cff31$export$8392c0c9d3dcbd35; }, function (v) { return $25836ebc568cff31$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $25836ebc568cff31$export$ffb0004e005737fa; }, function (v) { return $25836ebc568cff31$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $25836ebc568cff31$export$b624eff549462981; }, function (v) { return $25836ebc568cff31$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $25836ebc568cff31$export$7897aa7841a5380c; }, function (v) { return $25836ebc568cff31$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $25836ebc568cff31$export$602eac185826482c; }, function (v) { return $25836ebc568cff31$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $25836ebc568cff31$export$e2c29f18771995cb; }, function (v) { return $25836ebc568cff31$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $25836ebc568cff31$export$5f8d39834fd61797; }, function (v) { return $25836ebc568cff31$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $25836ebc568cff31$export$74bf444e3cd11ea5; }, function (v) { return $25836ebc568cff31$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $25836ebc568cff31$export$998bcd577473dd93; }, function (v) { return $25836ebc568cff31$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $25836ebc568cff31$export$b706b080d889d2c9; }, function (v) { return $25836ebc568cff31$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $25836ebc568cff31$export$5be5a87408f70ddc; }, function (v) { return $25836ebc568cff31$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $25836ebc568cff31$export$45a5e7f76e0caa8d; }, function (v) { return $25836ebc568cff31$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $25836ebc568cff31$export$455c2e768291efa6; }, function (v) { return $25836ebc568cff31$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $25836ebc568cff31$export$9522e17588c12572; }, function (v) { return $25836ebc568cff31$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $25836ebc568cff31$export$2110ac352bb060b9; }, function (v) { return $25836ebc568cff31$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $25836ebc568cff31$export$56885ab8b9c456ab; }, function (v) { return $25836ebc568cff31$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $25836ebc568cff31$export$d927fcb6adf8f9de; }, function (v) { return $25836ebc568cff31$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $25836ebc568cff31$export$b82d16f27459e05a; }, function (v) { return $25836ebc568cff31$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $25836ebc568cff31$export$522c17b4f5e123e8; }, function (v) { return $25836ebc568cff31$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $25836ebc568cff31$export$1aabd8a0274ecfd6; }, function (v) { return $25836ebc568cff31$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $25836ebc568cff31$export$3d6c20d97e46b957; }, function (v) { return $25836ebc568cff31$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $25836ebc568cff31$export$9b621391a187a31a; }, function (v) { return $25836ebc568cff31$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $25836ebc568cff31$export$f5bbd400c2f4426f; }, function (v) { return $25836ebc568cff31$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $25836ebc568cff31$export$a7c73072b1a182ae;
var $25836ebc568cff31$export$9f27bc3417b4524d;
var $25836ebc568cff31$export$db77ccec0bb4ccac;
var $25836ebc568cff31$export$8392c0c9d3dcbd35;
var $25836ebc568cff31$export$ffb0004e005737fa;
var $25836ebc568cff31$export$b624eff549462981;
var $25836ebc568cff31$export$7897aa7841a5380c;
var $25836ebc568cff31$export$602eac185826482c;
var $25836ebc568cff31$export$e2c29f18771995cb;
var $25836ebc568cff31$export$5f8d39834fd61797;
var $25836ebc568cff31$export$74bf444e3cd11ea5;
var $25836ebc568cff31$export$998bcd577473dd93;
var $25836ebc568cff31$export$b706b080d889d2c9;
var $25836ebc568cff31$export$5be5a87408f70ddc;
var $25836ebc568cff31$export$45a5e7f76e0caa8d;
var $25836ebc568cff31$export$455c2e768291efa6;
var $25836ebc568cff31$export$9522e17588c12572;
var $25836ebc568cff31$export$2110ac352bb060b9;
var $25836ebc568cff31$export$56885ab8b9c456ab;
var $25836ebc568cff31$export$d927fcb6adf8f9de;
var $25836ebc568cff31$export$b82d16f27459e05a;
var $25836ebc568cff31$export$522c17b4f5e123e8;
var $25836ebc568cff31$export$1aabd8a0274ecfd6;
var $25836ebc568cff31$export$3d6c20d97e46b957;
var $25836ebc568cff31$export$9b621391a187a31a;
var $25836ebc568cff31$export$f5bbd400c2f4426f;
"use strict";
var $25836ebc568cff31$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $25836ebc568cff31$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $25836ebc568cff31$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $25836ebc568cff31$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $25836ebc568cff31$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $25836ebc568cff31$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $25836ebc568cff31$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $25836ebc568cff31$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $25836ebc568cff31$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $25836ebc568cff31$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $25836ebc568cff31$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $25836ebc568cff31$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $25836ebc568cff31$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $25836ebc568cff31$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $25836ebc568cff31$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $25836ebc568cff31$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $25836ebc568cff31$var$REACT_FRAGMENT_TYPE:
                    case $25836ebc568cff31$var$REACT_PROFILER_TYPE:
                    case $25836ebc568cff31$var$REACT_STRICT_MODE_TYPE:
                    case $25836ebc568cff31$var$REACT_SUSPENSE_TYPE:
                    case $25836ebc568cff31$var$REACT_SUSPENSE_LIST_TYPE:
                    case $25836ebc568cff31$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $25836ebc568cff31$var$REACT_CONTEXT_TYPE:
                            case $25836ebc568cff31$var$REACT_FORWARD_REF_TYPE:
                            case $25836ebc568cff31$var$REACT_LAZY_TYPE:
                            case $25836ebc568cff31$var$REACT_MEMO_TYPE:
                                return object;
                            case $25836ebc568cff31$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $25836ebc568cff31$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$25836ebc568cff31$export$a7c73072b1a182ae = $25836ebc568cff31$var$REACT_CONSUMER_TYPE;
$25836ebc568cff31$export$9f27bc3417b4524d = $25836ebc568cff31$var$REACT_CONTEXT_TYPE;
$25836ebc568cff31$export$db77ccec0bb4ccac = $25836ebc568cff31$var$REACT_ELEMENT_TYPE;
$25836ebc568cff31$export$8392c0c9d3dcbd35 = $25836ebc568cff31$var$REACT_FORWARD_REF_TYPE;
$25836ebc568cff31$export$ffb0004e005737fa = $25836ebc568cff31$var$REACT_FRAGMENT_TYPE;
$25836ebc568cff31$export$b624eff549462981 = $25836ebc568cff31$var$REACT_LAZY_TYPE;
$25836ebc568cff31$export$7897aa7841a5380c = $25836ebc568cff31$var$REACT_MEMO_TYPE;
$25836ebc568cff31$export$602eac185826482c = $25836ebc568cff31$var$REACT_PORTAL_TYPE;
$25836ebc568cff31$export$e2c29f18771995cb = $25836ebc568cff31$var$REACT_PROFILER_TYPE;
$25836ebc568cff31$export$5f8d39834fd61797 = $25836ebc568cff31$var$REACT_STRICT_MODE_TYPE;
$25836ebc568cff31$export$74bf444e3cd11ea5 = $25836ebc568cff31$var$REACT_SUSPENSE_TYPE;
$25836ebc568cff31$export$998bcd577473dd93 = $25836ebc568cff31$var$REACT_SUSPENSE_LIST_TYPE;
$25836ebc568cff31$export$b706b080d889d2c9 = function(object) {
    return $25836ebc568cff31$var$typeOf(object) === $25836ebc568cff31$var$REACT_CONSUMER_TYPE;
};
$25836ebc568cff31$export$5be5a87408f70ddc = function(object) {
    return $25836ebc568cff31$var$typeOf(object) === $25836ebc568cff31$var$REACT_CONTEXT_TYPE;
};
$25836ebc568cff31$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $25836ebc568cff31$var$REACT_ELEMENT_TYPE;
};
$25836ebc568cff31$export$455c2e768291efa6 = function(object) {
    return $25836ebc568cff31$var$typeOf(object) === $25836ebc568cff31$var$REACT_FORWARD_REF_TYPE;
};
$25836ebc568cff31$export$9522e17588c12572 = function(object) {
    return $25836ebc568cff31$var$typeOf(object) === $25836ebc568cff31$var$REACT_FRAGMENT_TYPE;
};
$25836ebc568cff31$export$2110ac352bb060b9 = function(object) {
    return $25836ebc568cff31$var$typeOf(object) === $25836ebc568cff31$var$REACT_LAZY_TYPE;
};
$25836ebc568cff31$export$56885ab8b9c456ab = function(object) {
    return $25836ebc568cff31$var$typeOf(object) === $25836ebc568cff31$var$REACT_MEMO_TYPE;
};
$25836ebc568cff31$export$d927fcb6adf8f9de = function(object) {
    return $25836ebc568cff31$var$typeOf(object) === $25836ebc568cff31$var$REACT_PORTAL_TYPE;
};
$25836ebc568cff31$export$b82d16f27459e05a = function(object) {
    return $25836ebc568cff31$var$typeOf(object) === $25836ebc568cff31$var$REACT_PROFILER_TYPE;
};
$25836ebc568cff31$export$522c17b4f5e123e8 = function(object) {
    return $25836ebc568cff31$var$typeOf(object) === $25836ebc568cff31$var$REACT_STRICT_MODE_TYPE;
};
$25836ebc568cff31$export$1aabd8a0274ecfd6 = function(object) {
    return $25836ebc568cff31$var$typeOf(object) === $25836ebc568cff31$var$REACT_SUSPENSE_TYPE;
};
$25836ebc568cff31$export$3d6c20d97e46b957 = function(object) {
    return $25836ebc568cff31$var$typeOf(object) === $25836ebc568cff31$var$REACT_SUSPENSE_LIST_TYPE;
};
$25836ebc568cff31$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $25836ebc568cff31$var$REACT_FRAGMENT_TYPE || type === $25836ebc568cff31$var$REACT_PROFILER_TYPE || type === $25836ebc568cff31$var$REACT_STRICT_MODE_TYPE || type === $25836ebc568cff31$var$REACT_SUSPENSE_TYPE || type === $25836ebc568cff31$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $25836ebc568cff31$var$REACT_LAZY_TYPE || type.$$typeof === $25836ebc568cff31$var$REACT_MEMO_TYPE || type.$$typeof === $25836ebc568cff31$var$REACT_CONTEXT_TYPE || type.$$typeof === $25836ebc568cff31$var$REACT_CONSUMER_TYPE || type.$$typeof === $25836ebc568cff31$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $25836ebc568cff31$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$25836ebc568cff31$export$f5bbd400c2f4426f = $25836ebc568cff31$var$typeOf;

});




parcelRegister("2I0Bt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("j4wF5")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("fZR3c")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("5JSnm")).default; });

var $j4wF5 = parcelRequire("j4wF5");

var $fZR3c = parcelRequire("fZR3c");

var $5JSnm = parcelRequire("5JSnm");

});
parcelRegister("j4wF5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de27b9fd89a19727$export$2e2bcd8739ae039; });

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $l9l4U = parcelRequire("l9l4U");

var $fZR3c = parcelRequire("fZR3c");

var $bfIEa = parcelRequire("bfIEa");

var $8vHvN = parcelRequire("8vHvN");

var $kbRRG = parcelRequire("kbRRG");

var $lLfu4 = parcelRequire("lLfu4");

var $5JSnm = parcelRequire("5JSnm");
const $de27b9fd89a19727$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $de27b9fd89a19727$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $1gVUU.default)(options, $de27b9fd89a19727$var$_excluded);
    const breakpoints = (0, $fZR3c.default)(breakpointsInput);
    const spacing = (0, $8vHvN.default)(spacingInput);
    let muiTheme = (0, $l9l4U.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $7TrLl.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $7TrLl.default)({}, (0, $bfIEa.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $5JSnm.default);
    muiTheme = args.reduce((acc, argument)=>(0, $l9l4U.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $7TrLl.default)({}, (0, $lLfu4.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $kbRRG.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $de27b9fd89a19727$export$2e2bcd8739ae039 = $de27b9fd89a19727$var$createTheme;

});
parcelRegister("1gVUU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ed43623e6fb8a44$export$2e2bcd8739ae039; });
function $0ed43623e6fb8a44$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("l9l4U", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $f65ac9f0732b6a6c$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $f65ac9f0732b6a6c$export$2e2bcd8739ae039; });

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");
function $f65ac9f0732b6a6c$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $f65ac9f0732b6a6c$var$deepClone(source) {
    if (/*#__PURE__*/ $8dE9F.isValidElement(source) || !$f65ac9f0732b6a6c$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $f65ac9f0732b6a6c$var$deepClone(source[key]);
    });
    return output;
}
function $f65ac9f0732b6a6c$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $7TrLl.default)({}, target) : target;
    if ($f65ac9f0732b6a6c$export$53b83ca8eaab0383(target) && $f65ac9f0732b6a6c$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $8dE9F.isValidElement(source[key])) output[key] = source[key];
        else if ($f65ac9f0732b6a6c$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $f65ac9f0732b6a6c$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $f65ac9f0732b6a6c$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $f65ac9f0732b6a6c$export$53b83ca8eaab0383(source[key]) ? $f65ac9f0732b6a6c$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("fZR3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba55b4435389e96a$export$2e2bcd8739ae039; });

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");
const $ba55b4435389e96a$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $ba55b4435389e96a$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $ba55b4435389e96a$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $7TrLl.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $ba55b4435389e96a$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $1gVUU.default)(breakpoints, $ba55b4435389e96a$var$_excluded);
    const sortedValues = $ba55b4435389e96a$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $7TrLl.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("bfIEa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8313ba61a9176fea$export$2e2bcd8739ae039; });
const $8313ba61a9176fea$var$shape = {
    borderRadius: 4
};
var $8313ba61a9176fea$export$2e2bcd8739ae039 = $8313ba61a9176fea$var$shape;

});

parcelRegister("8vHvN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6322f8822e5889e5$export$2e2bcd8739ae039; });

var $4WYBk = parcelRequire("4WYBk");
function $6322f8822e5889e5$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $4WYBk.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("4WYBk", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $39ab9650cc177aee$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $39ab9650cc177aee$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $39ab9650cc177aee$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $39ab9650cc177aee$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $39ab9650cc177aee$export$6f98e8eaf0be1996; });


var $vdlVD = parcelRequire("vdlVD");

var $bdcdf = parcelRequire("bdcdf");

var $6QRpL = parcelRequire("6QRpL");

var $gnQW2 = parcelRequire("gnQW2");
const $39ab9650cc177aee$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $39ab9650cc177aee$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $39ab9650cc177aee$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $39ab9650cc177aee$var$getCssProperties = (0, $gnQW2.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($39ab9650cc177aee$var$aliases[prop]) prop = $39ab9650cc177aee$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $39ab9650cc177aee$var$properties[a];
    const direction = $39ab9650cc177aee$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $39ab9650cc177aee$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $39ab9650cc177aee$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $39ab9650cc177aee$var$spacingKeys = [
    ...$39ab9650cc177aee$export$aab52a0dde05ad8a,
    ...$39ab9650cc177aee$export$f8397d44f03ab6ad
];
function $39ab9650cc177aee$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $bdcdf.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $39ab9650cc177aee$export$1def6f833384e3d1(theme) {
    return $39ab9650cc177aee$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $39ab9650cc177aee$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $39ab9650cc177aee$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $39ab9650cc177aee$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $39ab9650cc177aee$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $39ab9650cc177aee$var$getCssProperties(prop);
    const styleFromPropValue = $39ab9650cc177aee$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $vdlVD.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $39ab9650cc177aee$var$style(props, keys) {
    const transformer = $39ab9650cc177aee$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$39ab9650cc177aee$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $6QRpL.default), {});
}
function $39ab9650cc177aee$export$7ede87f9b603dd3c(props) {
    return $39ab9650cc177aee$var$style(props, $39ab9650cc177aee$export$aab52a0dde05ad8a);
}
$39ab9650cc177aee$export$7ede87f9b603dd3c.propTypes = {};
$39ab9650cc177aee$export$7ede87f9b603dd3c.filterProps = $39ab9650cc177aee$export$aab52a0dde05ad8a;
function $39ab9650cc177aee$export$6f98e8eaf0be1996(props) {
    return $39ab9650cc177aee$var$style(props, $39ab9650cc177aee$export$f8397d44f03ab6ad);
}
$39ab9650cc177aee$export$6f98e8eaf0be1996.propTypes = {};
$39ab9650cc177aee$export$6f98e8eaf0be1996.filterProps = $39ab9650cc177aee$export$f8397d44f03ab6ad;
function $39ab9650cc177aee$var$spacing(props) {
    return $39ab9650cc177aee$var$style(props, $39ab9650cc177aee$var$spacingKeys);
}
$39ab9650cc177aee$var$spacing.propTypes = {};
$39ab9650cc177aee$var$spacing.filterProps = $39ab9650cc177aee$var$spacingKeys;
var $39ab9650cc177aee$export$2e2bcd8739ae039 = $39ab9650cc177aee$var$spacing;

});
parcelRegister("vdlVD", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $05dd40ee3bdbc05a$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $05dd40ee3bdbc05a$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $05dd40ee3bdbc05a$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $05dd40ee3bdbc05a$export$8922c90b6e020726; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $05dd40ee3bdbc05a$export$980e6a259d807490; });

var $7TrLl = parcelRequire("7TrLl");


var $l9l4U = parcelRequire("l9l4U");

var $6QRpL = parcelRequire("6QRpL");
const $05dd40ee3bdbc05a$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $05dd40ee3bdbc05a$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$05dd40ee3bdbc05a$export$68c286be0e7e55b7[key]}px)`
};
function $05dd40ee3bdbc05a$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $05dd40ee3bdbc05a$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $05dd40ee3bdbc05a$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $05dd40ee3bdbc05a$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $05dd40ee3bdbc05a$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $05dd40ee3bdbc05a$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $7TrLl.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $6QRpL.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $05dd40ee3bdbc05a$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $05dd40ee3bdbc05a$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $05dd40ee3bdbc05a$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $05dd40ee3bdbc05a$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $l9l4U.default)(prev, next), {});
    return $05dd40ee3bdbc05a$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $05dd40ee3bdbc05a$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $05dd40ee3bdbc05a$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $05dd40ee3bdbc05a$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $05dd40ee3bdbc05a$export$2e2bcd8739ae039 = $05dd40ee3bdbc05a$var$breakpoints;

});
parcelRegister("6QRpL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fd1086a337dc322$export$2e2bcd8739ae039; });

var $l9l4U = parcelRequire("l9l4U");
function $4fd1086a337dc322$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $l9l4U.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $4fd1086a337dc322$export$2e2bcd8739ae039 = $4fd1086a337dc322$var$merge;

});


parcelRegister("bdcdf", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $829a61c7c050bf26$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $829a61c7c050bf26$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $829a61c7c050bf26$export$2e2bcd8739ae039; });

var $i3G15 = parcelRequire("i3G15");


var $vdlVD = parcelRequire("vdlVD");
function $829a61c7c050bf26$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $829a61c7c050bf26$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $829a61c7c050bf26$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $829a61c7c050bf26$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $829a61c7c050bf26$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $829a61c7c050bf26$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $829a61c7c050bf26$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $i3G15.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $vdlVD.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $829a61c7c050bf26$export$2e2bcd8739ae039 = $829a61c7c050bf26$var$style;

});

parcelRegister("gnQW2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bed7db1e7cc8eef2$export$2e2bcd8739ae039; });
function $bed7db1e7cc8eef2$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("kbRRG", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $eb2e9e25f6822a81$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $eb2e9e25f6822a81$export$2e2bcd8739ae039; });

var $i3G15 = parcelRequire("i3G15");

var $6QRpL = parcelRequire("6QRpL");

var $bdcdf = parcelRequire("bdcdf");

var $vdlVD = parcelRequire("vdlVD");

var $lLfu4 = parcelRequire("lLfu4");
function $eb2e9e25f6822a81$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $eb2e9e25f6822a81$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $eb2e9e25f6822a81$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $bdcdf.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $bdcdf.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $bdcdf.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $i3G15.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $vdlVD.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $lLfu4.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $vdlVD.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $eb2e9e25f6822a81$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $6QRpL.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $vdlVD.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($eb2e9e25f6822a81$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $6QRpL.default)(css, breakpointsValues);
                        }
                    } else css = (0, $6QRpL.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $vdlVD.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $vdlVD.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $eb2e9e25f6822a81$var$styleFunctionSx = $eb2e9e25f6822a81$export$7d53d8bf2911e013();
$eb2e9e25f6822a81$var$styleFunctionSx.filterProps = [
    'sx'
];
var $eb2e9e25f6822a81$export$2e2bcd8739ae039 = $eb2e9e25f6822a81$var$styleFunctionSx;

});
parcelRegister("lLfu4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd79ff8d4478c870$export$2e2bcd8739ae039; });

var $4WYBk = parcelRequire("4WYBk");

var $euId3 = parcelRequire("euId3");

var $jvQSZ = parcelRequire("jvQSZ");

var $1KRfZ = parcelRequire("1KRfZ");

var $fPd0m = parcelRequire("fPd0m");
const $fd79ff8d4478c870$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $euId3.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $euId3.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $euId3.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $euId3.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $euId3.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $euId3.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $euId3.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $1KRfZ.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $1KRfZ.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $1KRfZ.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $4WYBk.padding)
    },
    pt: {
        style: (0, $4WYBk.padding)
    },
    pr: {
        style: (0, $4WYBk.padding)
    },
    pb: {
        style: (0, $4WYBk.padding)
    },
    pl: {
        style: (0, $4WYBk.padding)
    },
    px: {
        style: (0, $4WYBk.padding)
    },
    py: {
        style: (0, $4WYBk.padding)
    },
    padding: {
        style: (0, $4WYBk.padding)
    },
    paddingTop: {
        style: (0, $4WYBk.padding)
    },
    paddingRight: {
        style: (0, $4WYBk.padding)
    },
    paddingBottom: {
        style: (0, $4WYBk.padding)
    },
    paddingLeft: {
        style: (0, $4WYBk.padding)
    },
    paddingX: {
        style: (0, $4WYBk.padding)
    },
    paddingY: {
        style: (0, $4WYBk.padding)
    },
    paddingInline: {
        style: (0, $4WYBk.padding)
    },
    paddingInlineStart: {
        style: (0, $4WYBk.padding)
    },
    paddingInlineEnd: {
        style: (0, $4WYBk.padding)
    },
    paddingBlock: {
        style: (0, $4WYBk.padding)
    },
    paddingBlockStart: {
        style: (0, $4WYBk.padding)
    },
    paddingBlockEnd: {
        style: (0, $4WYBk.padding)
    },
    m: {
        style: (0, $4WYBk.margin)
    },
    mt: {
        style: (0, $4WYBk.margin)
    },
    mr: {
        style: (0, $4WYBk.margin)
    },
    mb: {
        style: (0, $4WYBk.margin)
    },
    ml: {
        style: (0, $4WYBk.margin)
    },
    mx: {
        style: (0, $4WYBk.margin)
    },
    my: {
        style: (0, $4WYBk.margin)
    },
    margin: {
        style: (0, $4WYBk.margin)
    },
    marginTop: {
        style: (0, $4WYBk.margin)
    },
    marginRight: {
        style: (0, $4WYBk.margin)
    },
    marginBottom: {
        style: (0, $4WYBk.margin)
    },
    marginLeft: {
        style: (0, $4WYBk.margin)
    },
    marginX: {
        style: (0, $4WYBk.margin)
    },
    marginY: {
        style: (0, $4WYBk.margin)
    },
    marginInline: {
        style: (0, $4WYBk.margin)
    },
    marginInlineStart: {
        style: (0, $4WYBk.margin)
    },
    marginInlineEnd: {
        style: (0, $4WYBk.margin)
    },
    marginBlock: {
        style: (0, $4WYBk.margin)
    },
    marginBlockStart: {
        style: (0, $4WYBk.margin)
    },
    marginBlockEnd: {
        style: (0, $4WYBk.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $jvQSZ.gap)
    },
    rowGap: {
        style: (0, $jvQSZ.rowGap)
    },
    columnGap: {
        style: (0, $jvQSZ.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $fPd0m.sizingTransform)
    },
    maxWidth: {
        style: (0, $fPd0m.maxWidth)
    },
    minWidth: {
        transform: (0, $fPd0m.sizingTransform)
    },
    height: {
        transform: (0, $fPd0m.sizingTransform)
    },
    maxHeight: {
        transform: (0, $fPd0m.sizingTransform)
    },
    minHeight: {
        transform: (0, $fPd0m.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $fd79ff8d4478c870$export$2e2bcd8739ae039 = $fd79ff8d4478c870$var$defaultSxConfig;

});
parcelRegister("euId3", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $a8d6291ef0fbb8e2$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $a8d6291ef0fbb8e2$export$7a57f79000377ca2; });


var $bdcdf = parcelRequire("bdcdf");

var $4XPhC = parcelRequire("4XPhC");

var $4WYBk = parcelRequire("4WYBk");

var $vdlVD = parcelRequire("vdlVD");
function $a8d6291ef0fbb8e2$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $a8d6291ef0fbb8e2$var$createBorderStyle(prop, transform) {
    return (0, $bdcdf.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $a8d6291ef0fbb8e2$export$1edee58a52776cd9 = $a8d6291ef0fbb8e2$var$createBorderStyle('border', $a8d6291ef0fbb8e2$export$34e2febe53ae29cc);
const $a8d6291ef0fbb8e2$export$f9a7b6bd24892946 = $a8d6291ef0fbb8e2$var$createBorderStyle('borderTop', $a8d6291ef0fbb8e2$export$34e2febe53ae29cc);
const $a8d6291ef0fbb8e2$export$5abca33e6be905d2 = $a8d6291ef0fbb8e2$var$createBorderStyle('borderRight', $a8d6291ef0fbb8e2$export$34e2febe53ae29cc);
const $a8d6291ef0fbb8e2$export$e2ce9f12a980a822 = $a8d6291ef0fbb8e2$var$createBorderStyle('borderBottom', $a8d6291ef0fbb8e2$export$34e2febe53ae29cc);
const $a8d6291ef0fbb8e2$export$47658cca1a909427 = $a8d6291ef0fbb8e2$var$createBorderStyle('borderLeft', $a8d6291ef0fbb8e2$export$34e2febe53ae29cc);
const $a8d6291ef0fbb8e2$export$e7fb0694ba2404fc = $a8d6291ef0fbb8e2$var$createBorderStyle('borderColor');
const $a8d6291ef0fbb8e2$export$126a92c968acdb85 = $a8d6291ef0fbb8e2$var$createBorderStyle('borderTopColor');
const $a8d6291ef0fbb8e2$export$85cc51cb8fbb8c0e = $a8d6291ef0fbb8e2$var$createBorderStyle('borderRightColor');
const $a8d6291ef0fbb8e2$export$340b0327727f6d1a = $a8d6291ef0fbb8e2$var$createBorderStyle('borderBottomColor');
const $a8d6291ef0fbb8e2$export$60beef91a985b4bf = $a8d6291ef0fbb8e2$var$createBorderStyle('borderLeftColor');
const $a8d6291ef0fbb8e2$export$f9258c55612cbed7 = $a8d6291ef0fbb8e2$var$createBorderStyle('outline', $a8d6291ef0fbb8e2$export$34e2febe53ae29cc);
const $a8d6291ef0fbb8e2$export$621fe586efeb64b9 = $a8d6291ef0fbb8e2$var$createBorderStyle('outlineColor');
const $a8d6291ef0fbb8e2$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $4WYBk.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $4WYBk.getValue)(transformer, propValue)
            });
        return (0, $vdlVD.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$a8d6291ef0fbb8e2$export$7a57f79000377ca2.propTypes = {};
$a8d6291ef0fbb8e2$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $a8d6291ef0fbb8e2$var$borders = (0, $4XPhC.default)($a8d6291ef0fbb8e2$export$1edee58a52776cd9, $a8d6291ef0fbb8e2$export$f9a7b6bd24892946, $a8d6291ef0fbb8e2$export$5abca33e6be905d2, $a8d6291ef0fbb8e2$export$e2ce9f12a980a822, $a8d6291ef0fbb8e2$export$47658cca1a909427, $a8d6291ef0fbb8e2$export$e7fb0694ba2404fc, $a8d6291ef0fbb8e2$export$126a92c968acdb85, $a8d6291ef0fbb8e2$export$85cc51cb8fbb8c0e, $a8d6291ef0fbb8e2$export$340b0327727f6d1a, $a8d6291ef0fbb8e2$export$60beef91a985b4bf, $a8d6291ef0fbb8e2$export$7a57f79000377ca2, $a8d6291ef0fbb8e2$export$f9258c55612cbed7, $a8d6291ef0fbb8e2$export$621fe586efeb64b9);
var $a8d6291ef0fbb8e2$export$2e2bcd8739ae039 = $a8d6291ef0fbb8e2$var$borders;

});
parcelRegister("4XPhC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39d473e4a08ce0f9$export$2e2bcd8739ae039; });

var $6QRpL = parcelRequire("6QRpL");
function $39d473e4a08ce0f9$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $6QRpL.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $39d473e4a08ce0f9$export$2e2bcd8739ae039 = $39d473e4a08ce0f9$var$compose;

});


parcelRegister("jvQSZ", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $e349ef9d4098208b$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $e349ef9d4098208b$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $e349ef9d4098208b$export$8a833ffa5f5dbeda; });

var $bdcdf = parcelRequire("bdcdf");

var $4XPhC = parcelRequire("4XPhC");

var $4WYBk = parcelRequire("4WYBk");

var $vdlVD = parcelRequire("vdlVD");

const $e349ef9d4098208b$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $4WYBk.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $4WYBk.getValue)(transformer, propValue)
            });
        return (0, $vdlVD.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$e349ef9d4098208b$export$5df9adcb0db95e1e.propTypes = {};
$e349ef9d4098208b$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $e349ef9d4098208b$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $4WYBk.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $4WYBk.getValue)(transformer, propValue)
            });
        return (0, $vdlVD.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$e349ef9d4098208b$export$ec60d70ff941a580.propTypes = {};
$e349ef9d4098208b$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $e349ef9d4098208b$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $4WYBk.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $4WYBk.getValue)(transformer, propValue)
            });
        return (0, $vdlVD.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$e349ef9d4098208b$export$8a833ffa5f5dbeda.propTypes = {};
$e349ef9d4098208b$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $e349ef9d4098208b$export$baf44164ca3a34e8 = (0, $bdcdf.default)({
    prop: 'gridColumn'
});
const $e349ef9d4098208b$export$8f7213a1cd01e832 = (0, $bdcdf.default)({
    prop: 'gridRow'
});
const $e349ef9d4098208b$export$b0e0abbc49ba668 = (0, $bdcdf.default)({
    prop: 'gridAutoFlow'
});
const $e349ef9d4098208b$export$bcd8b929d4b4142 = (0, $bdcdf.default)({
    prop: 'gridAutoColumns'
});
const $e349ef9d4098208b$export$e5039a674e14c828 = (0, $bdcdf.default)({
    prop: 'gridAutoRows'
});
const $e349ef9d4098208b$export$42bd9088661ffb03 = (0, $bdcdf.default)({
    prop: 'gridTemplateColumns'
});
const $e349ef9d4098208b$export$920682ae05b999bc = (0, $bdcdf.default)({
    prop: 'gridTemplateRows'
});
const $e349ef9d4098208b$export$1b88fbdd482fd33a = (0, $bdcdf.default)({
    prop: 'gridTemplateAreas'
});
const $e349ef9d4098208b$export$bdb486e40d52d26f = (0, $bdcdf.default)({
    prop: 'gridArea'
});
const $e349ef9d4098208b$var$grid = (0, $4XPhC.default)($e349ef9d4098208b$export$5df9adcb0db95e1e, $e349ef9d4098208b$export$ec60d70ff941a580, $e349ef9d4098208b$export$8a833ffa5f5dbeda, $e349ef9d4098208b$export$baf44164ca3a34e8, $e349ef9d4098208b$export$8f7213a1cd01e832, $e349ef9d4098208b$export$b0e0abbc49ba668, $e349ef9d4098208b$export$bcd8b929d4b4142, $e349ef9d4098208b$export$e5039a674e14c828, $e349ef9d4098208b$export$42bd9088661ffb03, $e349ef9d4098208b$export$920682ae05b999bc, $e349ef9d4098208b$export$1b88fbdd482fd33a, $e349ef9d4098208b$export$bdb486e40d52d26f);
var $e349ef9d4098208b$export$2e2bcd8739ae039 = $e349ef9d4098208b$var$grid;

});

parcelRegister("1KRfZ", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $1473660718979085$export$dbaffd4420ea0ac6; });

var $bdcdf = parcelRequire("bdcdf");

var $4XPhC = parcelRequire("4XPhC");
function $1473660718979085$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $1473660718979085$export$35e9368ef982300f = (0, $bdcdf.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $1473660718979085$export$dbaffd4420ea0ac6
});
const $1473660718979085$export$2506f56c10355b33 = (0, $bdcdf.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $1473660718979085$export$dbaffd4420ea0ac6
});
const $1473660718979085$export$8c5a050822fd698c = (0, $bdcdf.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $1473660718979085$export$dbaffd4420ea0ac6
});
const $1473660718979085$var$palette = (0, $4XPhC.default)($1473660718979085$export$35e9368ef982300f, $1473660718979085$export$2506f56c10355b33, $1473660718979085$export$8c5a050822fd698c);
var $1473660718979085$export$2e2bcd8739ae039 = $1473660718979085$var$palette;

});

parcelRegister("fPd0m", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $b855b4f19ab4689b$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $b855b4f19ab4689b$export$488fda99655ff65a; });

var $bdcdf = parcelRequire("bdcdf");

var $4XPhC = parcelRequire("4XPhC");

var $vdlVD = parcelRequire("vdlVD");
function $b855b4f19ab4689b$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $b855b4f19ab4689b$export$7e3df82ee760448c = (0, $bdcdf.default)({
    prop: 'width',
    transform: $b855b4f19ab4689b$export$8afece71750ec241
});
const $b855b4f19ab4689b$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $vdlVD.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $b855b4f19ab4689b$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $vdlVD.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$b855b4f19ab4689b$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $b855b4f19ab4689b$export$ee148fbbe8357dd2 = (0, $bdcdf.default)({
    prop: 'minWidth',
    transform: $b855b4f19ab4689b$export$8afece71750ec241
});
const $b855b4f19ab4689b$export$ac607276a8fe9f0a = (0, $bdcdf.default)({
    prop: 'height',
    transform: $b855b4f19ab4689b$export$8afece71750ec241
});
const $b855b4f19ab4689b$export$dc0d8bd0b94f8570 = (0, $bdcdf.default)({
    prop: 'maxHeight',
    transform: $b855b4f19ab4689b$export$8afece71750ec241
});
const $b855b4f19ab4689b$export$a43cf604e12f3b17 = (0, $bdcdf.default)({
    prop: 'minHeight',
    transform: $b855b4f19ab4689b$export$8afece71750ec241
});
const $b855b4f19ab4689b$export$ffed9f14fb65e276 = (0, $bdcdf.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $b855b4f19ab4689b$export$8afece71750ec241
});
const $b855b4f19ab4689b$export$905076ed6620e671 = (0, $bdcdf.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $b855b4f19ab4689b$export$8afece71750ec241
});
const $b855b4f19ab4689b$export$6ccc93f785106a58 = (0, $bdcdf.default)({
    prop: 'boxSizing'
});
const $b855b4f19ab4689b$var$sizing = (0, $4XPhC.default)($b855b4f19ab4689b$export$7e3df82ee760448c, $b855b4f19ab4689b$export$488fda99655ff65a, $b855b4f19ab4689b$export$ee148fbbe8357dd2, $b855b4f19ab4689b$export$ac607276a8fe9f0a, $b855b4f19ab4689b$export$dc0d8bd0b94f8570, $b855b4f19ab4689b$export$a43cf604e12f3b17, $b855b4f19ab4689b$export$6ccc93f785106a58);
var $b855b4f19ab4689b$export$2e2bcd8739ae039 = $b855b4f19ab4689b$var$sizing;

});



parcelRegister("5JSnm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42db55a108bd9d64$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $42db55a108bd9d64$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("cSlvx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("kbRRG")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("kbRRG")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("apGt5")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("lLfu4")).default; });

var $kbRRG = parcelRequire("kbRRG");

var $apGt5 = parcelRequire("apGt5");

var $lLfu4 = parcelRequire("lLfu4");

});
parcelRegister("apGt5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $794d2e741cbe80c0$export$2e2bcd8739ae039; });

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $l9l4U = parcelRequire("l9l4U");

var $lLfu4 = parcelRequire("lLfu4");
const $794d2e741cbe80c0$var$_excluded = [
    "sx"
];
const $794d2e741cbe80c0$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $lLfu4.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $794d2e741cbe80c0$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $1gVUU.default)(props, $794d2e741cbe80c0$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $794d2e741cbe80c0$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $l9l4U.isPlainObject)(result)) return systemProps;
        return (0, $7TrLl.default)({}, systemProps, result);
    };
    else finalSx = (0, $7TrLl.default)({}, systemProps, inSx);
    return (0, $7TrLl.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("4tgii", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $58054.default;
    }
});

var $58054 = parcelRequire("58054");

});
parcelRegister("58054", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bbdc3231743e8fe$export$2e2bcd8739ae039; });

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");

var $i60vX = parcelRequire("i60vX");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
function $3bbdc3231743e8fe$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $i60vX.default), (0, $7TrLl.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $i60vX.default).muiName;
    return /*#__PURE__*/ $8dE9F.memo(/*#__PURE__*/ $8dE9F.forwardRef(Component));
}

});
parcelRegister("i60vX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2c92fab8b3210a5$export$2e2bcd8739ae039; });

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $8DPw0 = parcelRequire("8DPw0");

var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $kdlF1 = parcelRequire("kdlF1");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $d2c92fab8b3210a5$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $d2c92fab8b3210a5$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $8DPw0.default)(color)}`,
            `fontSize${(0, $8DPw0.default)(fontSize)}`
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $kdlF1.getSvgIconUtilityClass), classes);
};
const $d2c92fab8b3210a5$var$SvgIconRoot = (0, $e5aV5.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $8DPw0.default)(ownerState.color)}`],
            styles[`fontSize${(0, $8DPw0.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $d2c92fab8b3210a5$var$SvgIcon = /*#__PURE__*/ $8dE9F.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $1gVUU.default)(props, $d2c92fab8b3210a5$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $8dE9F.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $7TrLl.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $d2c92fab8b3210a5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($d2c92fab8b3210a5$var$SvgIconRoot, (0, $7TrLl.default)({
        as: component,
        className: (0, $72F5q.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $dzbn0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$d2c92fab8b3210a5$var$SvgIcon.muiName = 'SvgIcon';
var $d2c92fab8b3210a5$export$2e2bcd8739ae039 = $d2c92fab8b3210a5$var$SvgIcon;

});
parcelRegister("72F5q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7f0f70baa513979$export$2e2bcd8739ae039; });
function $a7f0f70baa513979$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $a7f0f70baa513979$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $a7f0f70baa513979$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $a7f0f70baa513979$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $a7f0f70baa513979$export$2e2bcd8739ae039 = $a7f0f70baa513979$export$4f5d2d50c9deca37;

});

parcelRegister("fgPD6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1e066335d4f3b56$export$2e2bcd8739ae039; });
function $b1e066335d4f3b56$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("8DPw0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64a9ed1cdc8c9144$export$2e2bcd8739ae039; });

var $i3G15 = parcelRequire("i3G15");
var $64a9ed1cdc8c9144$export$2e2bcd8739ae039 = (0, $i3G15.default);

});

parcelRegister("lE3rX", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $fc20027e940358b5$export$2440da353cedad43; });

var $7TrLl = parcelRequire("7TrLl");
parcelRequire("8dE9F");


var $70tHe = parcelRequire("70tHe");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
function $fc20027e940358b5$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $70tHe.default), (0, $7TrLl.default)({}, props));
}
var $fc20027e940358b5$export$2e2bcd8739ae039 = $fc20027e940358b5$var$DefaultPropsProvider;
function $fc20027e940358b5$export$2440da353cedad43(params) {
    return (0, $70tHe.useDefaultProps)(params);
}

});
parcelRegister("70tHe", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $519f9193234a7262$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $519f9193234a7262$export$2e2bcd8739ae039; });

var $8dE9F = parcelRequire("8dE9F");


var $i1zjM = parcelRequire("i1zjM");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $519f9193234a7262$var$PropsContext = /*#__PURE__*/ $8dE9F.createContext(undefined);
function $519f9193234a7262$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $dzbn0.jsx)($519f9193234a7262$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $519f9193234a7262$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $i1zjM.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $i1zjM.default)(config, props);
    return props;
}
function $519f9193234a7262$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $8dE9F.useContext($519f9193234a7262$var$PropsContext);
    return $519f9193234a7262$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $519f9193234a7262$export$2e2bcd8739ae039 = $519f9193234a7262$var$DefaultPropsProvider;

});
parcelRegister("i1zjM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1f3b767984a08a2$export$2e2bcd8739ae039; });

var $7TrLl = parcelRequire("7TrLl");
function $d1f3b767984a08a2$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $7TrLl.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $7TrLl.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $7TrLl.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $d1f3b767984a08a2$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("e5aV5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a40a00bd0e0f4c8e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("6xVVB")).default; });

var $d7lWC = parcelRequire("d7lWC");

var $687FO = parcelRequire("687FO");

var $aYzJA = parcelRequire("aYzJA");

var $6xVVB = parcelRequire("6xVVB");

var $2MBRn = parcelRequire("2MBRn");
'use client';
const $a40a00bd0e0f4c8e$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($d7lWC)))({
    themeId: (0, $aYzJA.default),
    defaultTheme: $687FO.default,
    rootShouldForwardProp: $6xVVB.default
});
var $a40a00bd0e0f4c8e$export$2e2bcd8739ae039 = $a40a00bd0e0f4c8e$var$styled;

});
parcelRegister("d7lWC", function(module, exports) {
"use strict";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98ccf38353b5665d$var$createStyled;
module.exports.shouldForwardProp = $98ccf38353b5665d$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $98ccf38353b5665d$var$_extends2 = $btGXk((parcelRequire("i8bOW")));

var $98ccf38353b5665d$var$_objectWithoutPropertiesLoose2 = $btGXk((parcelRequire("33Xhy")));

var $98ccf38353b5665d$var$_styledEngine = $98ccf38353b5665d$var$_interopRequireWildcard((parcelRequire("gEeCx")));

var $l9l4U = parcelRequire("l9l4U");

var $98ccf38353b5665d$var$_capitalize = $btGXk((parcelRequire("i0zYw")));

var $98ccf38353b5665d$var$_getDisplayName = $btGXk((parcelRequire("hklVT")));

var $98ccf38353b5665d$var$_createTheme = $btGXk((parcelRequire("2I0Bt")));

var $98ccf38353b5665d$var$_styleFunctionSx = $btGXk((parcelRequire("cSlvx")));
const $98ccf38353b5665d$var$_excluded = [
    "ownerState"
], $98ccf38353b5665d$var$_excluded2 = [
    "variants"
], $98ccf38353b5665d$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $98ccf38353b5665d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($98ccf38353b5665d$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $98ccf38353b5665d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $98ccf38353b5665d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $98ccf38353b5665d$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $98ccf38353b5665d$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $98ccf38353b5665d$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $98ccf38353b5665d$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $98ccf38353b5665d$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $98ccf38353b5665d$var$_createTheme.default)();
const $98ccf38353b5665d$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $98ccf38353b5665d$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $98ccf38353b5665d$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $98ccf38353b5665d$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $98ccf38353b5665d$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $98ccf38353b5665d$var$_objectWithoutPropertiesLoose2.default)(_ref, $98ccf38353b5665d$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $98ccf38353b5665d$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$98ccf38353b5665d$var$processStyleArg(resolvedStyle, (0, $98ccf38353b5665d$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $98ccf38353b5665d$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $98ccf38353b5665d$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $98ccf38353b5665d$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $98ccf38353b5665d$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $98ccf38353b5665d$var$shallowLayer((0, $98ccf38353b5665d$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $98ccf38353b5665d$var$shallowLayer((0, $98ccf38353b5665d$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $98ccf38353b5665d$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $98ccf38353b5665d$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $98ccf38353b5665d$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $98ccf38353b5665d$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $98ccf38353b5665d$var$_styleFunctionSx.default)((0, $98ccf38353b5665d$var$_extends2.default)({}, props, {
            theme: $98ccf38353b5665d$var$resolveTheme((0, $98ccf38353b5665d$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $98ccf38353b5665d$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $98ccf38353b5665d$var$defaultOverridesResolver($98ccf38353b5665d$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $98ccf38353b5665d$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $98ccf38353b5665d$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $98ccf38353b5665d$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($98ccf38353b5665d$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $98ccf38353b5665d$var$_styledEngine.default)(tag, (0, $98ccf38353b5665d$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $l9l4U.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $98ccf38353b5665d$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $98ccf38353b5665d$var$processStyleArg(stylesArg, (0, $98ccf38353b5665d$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $98ccf38353b5665d$var$resolveTheme((0, $98ccf38353b5665d$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $98ccf38353b5665d$var$processStyleArg(slotStyle, (0, $98ccf38353b5665d$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $98ccf38353b5665d$var$resolveTheme((0, $98ccf38353b5665d$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $98ccf38353b5665d$var$processStyleArg({
                    variants: themeVariants
                }, (0, $98ccf38353b5665d$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("btGXk", function(module, exports) {
function $85b3b948c75517ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $85b3b948c75517ca$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("687FO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4769713b5e4d30b2$export$2e2bcd8739ae039; });

var $aeVxa = parcelRequire("aeVxa");
'use client';
const $4769713b5e4d30b2$var$defaultTheme = (0, $aeVxa.default)();
var $4769713b5e4d30b2$export$2e2bcd8739ae039 = $4769713b5e4d30b2$var$defaultTheme;

});
parcelRegister("aeVxa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7747d73fc5bd2dda$export$2e2bcd8739ae039; });

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $4T6WZ = parcelRequire("4T6WZ");

var $l9l4U = parcelRequire("l9l4U");

var $kbRRG = parcelRequire("kbRRG");
var $lLfu4 = parcelRequire("lLfu4");

var $j4wF5 = parcelRequire("j4wF5");


var $cEFig = parcelRequire("cEFig");

var $3Fyw1 = parcelRequire("3Fyw1");

var $7V4O6 = parcelRequire("7V4O6");

var $9AGEM = parcelRequire("9AGEM");

var $5pwy0 = parcelRequire("5pwy0");

var $6Hu4u = parcelRequire("6Hu4u");
const $7747d73fc5bd2dda$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $7747d73fc5bd2dda$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $1gVUU.default)(options, $7747d73fc5bd2dda$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $4T6WZ.default)(18));
    const palette = (0, $3Fyw1.default)(paletteInput);
    const systemTheme = (0, $j4wF5.default)(options);
    let muiTheme = (0, $l9l4U.default)(systemTheme, {
        mixins: (0, $cEFig.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $9AGEM.default).slice(),
        typography: (0, $7V4O6.default)(palette, typographyInput),
        transitions: (0, $5pwy0.default)(transitionsInput),
        zIndex: (0, $7TrLl.default)({}, (0, $6Hu4u.default))
    });
    muiTheme = (0, $l9l4U.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $l9l4U.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $7TrLl.default)({}, (0, $lLfu4.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $kbRRG.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $7747d73fc5bd2dda$var$warnedOnce = false;
function $7747d73fc5bd2dda$export$c469355549431d9b(...args) {
    return $7747d73fc5bd2dda$var$createTheme(...args);
}
var $7747d73fc5bd2dda$export$2e2bcd8739ae039 = $7747d73fc5bd2dda$var$createTheme;

});
parcelRegister("cEFig", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9369407eeef4af0f$export$2e2bcd8739ae039; });

var $7TrLl = parcelRequire("7TrLl");
function $9369407eeef4af0f$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $7TrLl.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("3Fyw1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2abff982f90c4a54$export$2e2bcd8739ae039; });

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $4T6WZ = parcelRequire("4T6WZ");

var $l9l4U = parcelRequire("l9l4U");

var $kTR6J = parcelRequire("kTR6J");

var $d9kTN = parcelRequire("d9kTN");

var $fuS6y = parcelRequire("fuS6y");

var $eMjLr = parcelRequire("eMjLr");

var $2cTIV = parcelRequire("2cTIV");

var $YB56R = parcelRequire("YB56R");

var $9rMBB = parcelRequire("9rMBB");

var $9cLRw = parcelRequire("9cLRw");

var $hhoTf = parcelRequire("hhoTf");
const $2abff982f90c4a54$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $2abff982f90c4a54$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $d9kTN.default).white,
        default: (0, $d9kTN.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $2abff982f90c4a54$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $d9kTN.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $d9kTN.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $2abff982f90c4a54$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $kTR6J.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $kTR6J.darken)(intent.main, tonalOffsetDark);
    }
}
function $2abff982f90c4a54$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9rMBB.default)[200],
        light: (0, $9rMBB.default)[50],
        dark: (0, $9rMBB.default)[400]
    };
    return {
        main: (0, $9rMBB.default)[700],
        light: (0, $9rMBB.default)[400],
        dark: (0, $9rMBB.default)[800]
    };
}
function $2abff982f90c4a54$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $eMjLr.default)[200],
        light: (0, $eMjLr.default)[50],
        dark: (0, $eMjLr.default)[400]
    };
    return {
        main: (0, $eMjLr.default)[500],
        light: (0, $eMjLr.default)[300],
        dark: (0, $eMjLr.default)[700]
    };
}
function $2abff982f90c4a54$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $2cTIV.default)[500],
        light: (0, $2cTIV.default)[300],
        dark: (0, $2cTIV.default)[700]
    };
    return {
        main: (0, $2cTIV.default)[700],
        light: (0, $2cTIV.default)[400],
        dark: (0, $2cTIV.default)[800]
    };
}
function $2abff982f90c4a54$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9cLRw.default)[400],
        light: (0, $9cLRw.default)[300],
        dark: (0, $9cLRw.default)[700]
    };
    return {
        main: (0, $9cLRw.default)[700],
        light: (0, $9cLRw.default)[500],
        dark: (0, $9cLRw.default)[900]
    };
}
function $2abff982f90c4a54$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $hhoTf.default)[400],
        light: (0, $hhoTf.default)[300],
        dark: (0, $hhoTf.default)[700]
    };
    return {
        main: (0, $hhoTf.default)[800],
        light: (0, $hhoTf.default)[500],
        dark: (0, $hhoTf.default)[900]
    };
}
function $2abff982f90c4a54$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $YB56R.default)[400],
        light: (0, $YB56R.default)[300],
        dark: (0, $YB56R.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $YB56R.default)[500],
        dark: (0, $YB56R.default)[900]
    };
}
function $2abff982f90c4a54$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $1gVUU.default)(palette, $2abff982f90c4a54$var$_excluded);
    const primary = palette.primary || $2abff982f90c4a54$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $2abff982f90c4a54$var$getDefaultSecondary(mode);
    const error = palette.error || $2abff982f90c4a54$var$getDefaultError(mode);
    const info = palette.info || $2abff982f90c4a54$var$getDefaultInfo(mode);
    const success = palette.success || $2abff982f90c4a54$var$getDefaultSuccess(mode);
    const warning = palette.warning || $2abff982f90c4a54$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kTR6J.getContrastRatio)(background, $2abff982f90c4a54$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $2abff982f90c4a54$export$55ce6f3a06c59543.text.primary : $2abff982f90c4a54$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $7TrLl.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $4T6WZ.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $4T6WZ.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $2abff982f90c4a54$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $2abff982f90c4a54$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $2abff982f90c4a54$export$55ce6f3a06c59543,
        light: $2abff982f90c4a54$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $l9l4U.default)((0, $7TrLl.default)({
        // A collection of common colors.
        common: (0, $7TrLl.default)({}, (0, $d9kTN.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $fuS6y.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("kTR6J", function(module, exports) {
"use strict";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $f37223bf231bbbda$var$alpha;
module.exports.blend = $f37223bf231bbbda$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $f37223bf231bbbda$var$darken;
module.exports.decomposeColor = $f37223bf231bbbda$var$decomposeColor;
module.exports.emphasize = $f37223bf231bbbda$var$emphasize;
module.exports.getContrastRatio = $f37223bf231bbbda$var$getContrastRatio;
module.exports.getLuminance = $f37223bf231bbbda$var$getLuminance;
module.exports.hexToRgb = $f37223bf231bbbda$var$hexToRgb;
module.exports.hslToRgb = $f37223bf231bbbda$var$hslToRgb;
module.exports.lighten = $f37223bf231bbbda$var$lighten;
module.exports.private_safeAlpha = $f37223bf231bbbda$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $f37223bf231bbbda$var$private_safeDarken;
module.exports.private_safeEmphasize = $f37223bf231bbbda$var$private_safeEmphasize;
module.exports.private_safeLighten = $f37223bf231bbbda$var$private_safeLighten;
module.exports.recomposeColor = $f37223bf231bbbda$var$recomposeColor;
module.exports.rgbToHex = $f37223bf231bbbda$var$rgbToHex;

var $f37223bf231bbbda$var$_formatMuiErrorMessage2 = $btGXk((parcelRequire("6yIHG")));

var $f37223bf231bbbda$var$_clamp = $btGXk((parcelRequire("f7kw6")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f37223bf231bbbda$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $f37223bf231bbbda$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $f37223bf231bbbda$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $f37223bf231bbbda$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $f37223bf231bbbda$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $f37223bf231bbbda$var$decomposeColor($f37223bf231bbbda$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $f37223bf231bbbda$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $f37223bf231bbbda$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $f37223bf231bbbda$var$colorChannel = (color)=>{
    const decomposedColor = $f37223bf231bbbda$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $f37223bf231bbbda$var$colorChannel;
const $f37223bf231bbbda$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $f37223bf231bbbda$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $f37223bf231bbbda$var$private_safeColorChannel;
function $f37223bf231bbbda$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $f37223bf231bbbda$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $f37223bf231bbbda$var$decomposeColor(color);
    return `#${values.map((n, i)=>$f37223bf231bbbda$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $f37223bf231bbbda$var$hslToRgb(color) {
    color = $f37223bf231bbbda$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $f37223bf231bbbda$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $f37223bf231bbbda$var$getLuminance(color) {
    color = $f37223bf231bbbda$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $f37223bf231bbbda$var$decomposeColor($f37223bf231bbbda$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $f37223bf231bbbda$var$getContrastRatio(foreground, background) {
    const lumA = $f37223bf231bbbda$var$getLuminance(foreground);
    const lumB = $f37223bf231bbbda$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f37223bf231bbbda$var$alpha(color, value) {
    color = $f37223bf231bbbda$var$decomposeColor(color);
    value = $f37223bf231bbbda$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $f37223bf231bbbda$var$recomposeColor(color);
}
function $f37223bf231bbbda$var$private_safeAlpha(color, value, warning) {
    try {
        return $f37223bf231bbbda$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f37223bf231bbbda$var$darken(color, coefficient) {
    color = $f37223bf231bbbda$var$decomposeColor(color);
    coefficient = $f37223bf231bbbda$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f37223bf231bbbda$var$recomposeColor(color);
}
function $f37223bf231bbbda$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $f37223bf231bbbda$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f37223bf231bbbda$var$lighten(color, coefficient) {
    color = $f37223bf231bbbda$var$decomposeColor(color);
    coefficient = $f37223bf231bbbda$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $f37223bf231bbbda$var$recomposeColor(color);
}
function $f37223bf231bbbda$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $f37223bf231bbbda$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f37223bf231bbbda$var$emphasize(color, coefficient = 0.15) {
    return $f37223bf231bbbda$var$getLuminance(color) > 0.5 ? $f37223bf231bbbda$var$darken(color, coefficient) : $f37223bf231bbbda$var$lighten(color, coefficient);
}
function $f37223bf231bbbda$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $f37223bf231bbbda$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $f37223bf231bbbda$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $f37223bf231bbbda$var$decomposeColor(background);
    const overlayColor = $f37223bf231bbbda$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $f37223bf231bbbda$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("d9kTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $992c53b86c4c57dd$export$2e2bcd8739ae039; });
const $992c53b86c4c57dd$var$common = {
    black: '#000',
    white: '#fff'
};
var $992c53b86c4c57dd$export$2e2bcd8739ae039 = $992c53b86c4c57dd$var$common;

});

parcelRegister("fuS6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b483a06f58d266fa$export$2e2bcd8739ae039; });
const $b483a06f58d266fa$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $b483a06f58d266fa$export$2e2bcd8739ae039 = $b483a06f58d266fa$var$grey;

});

parcelRegister("eMjLr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac24e12187c06e1e$export$2e2bcd8739ae039; });
const $ac24e12187c06e1e$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $ac24e12187c06e1e$export$2e2bcd8739ae039 = $ac24e12187c06e1e$var$purple;

});

parcelRegister("2cTIV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19b7ed51a825c89d$export$2e2bcd8739ae039; });
const $19b7ed51a825c89d$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $19b7ed51a825c89d$export$2e2bcd8739ae039 = $19b7ed51a825c89d$var$red;

});

parcelRegister("YB56R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b625e4ebf519e29$export$2e2bcd8739ae039; });
const $0b625e4ebf519e29$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $0b625e4ebf519e29$export$2e2bcd8739ae039 = $0b625e4ebf519e29$var$orange;

});

parcelRegister("9rMBB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e0c56b7bb285d3c$export$2e2bcd8739ae039; });
const $6e0c56b7bb285d3c$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $6e0c56b7bb285d3c$export$2e2bcd8739ae039 = $6e0c56b7bb285d3c$var$blue;

});

parcelRegister("9cLRw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b3a5c7a4b0fa74a$export$2e2bcd8739ae039; });
const $6b3a5c7a4b0fa74a$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $6b3a5c7a4b0fa74a$export$2e2bcd8739ae039 = $6b3a5c7a4b0fa74a$var$lightBlue;

});

parcelRegister("hhoTf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c94754ddd08c1319$export$2e2bcd8739ae039; });
const $c94754ddd08c1319$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $c94754ddd08c1319$export$2e2bcd8739ae039 = $c94754ddd08c1319$var$green;

});


parcelRegister("7V4O6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c4195d81ee95a15$export$2e2bcd8739ae039; });

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $l9l4U = parcelRequire("l9l4U");
const $5c4195d81ee95a15$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $5c4195d81ee95a15$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $5c4195d81ee95a15$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $5c4195d81ee95a15$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $5c4195d81ee95a15$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $5c4195d81ee95a15$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $1gVUU.default)(_ref, $5c4195d81ee95a15$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $7TrLl.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $5c4195d81ee95a15$var$defaultFontFamily ? {
            letterSpacing: `${$5c4195d81ee95a15$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $5c4195d81ee95a15$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $5c4195d81ee95a15$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $l9l4U.default)((0, $7TrLl.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("9AGEM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fb8909649f722a6$export$2e2bcd8739ae039; });
const $6fb8909649f722a6$var$shadowKeyUmbraOpacity = 0.2;
const $6fb8909649f722a6$var$shadowKeyPenumbraOpacity = 0.14;
const $6fb8909649f722a6$var$shadowAmbientShadowOpacity = 0.12;
function $6fb8909649f722a6$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$6fb8909649f722a6$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$6fb8909649f722a6$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$6fb8909649f722a6$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $6fb8909649f722a6$var$shadows = [
    'none',
    $6fb8909649f722a6$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $6fb8909649f722a6$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $6fb8909649f722a6$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $6fb8909649f722a6$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $6fb8909649f722a6$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $6fb8909649f722a6$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $6fb8909649f722a6$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $6fb8909649f722a6$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $6fb8909649f722a6$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $6fb8909649f722a6$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $6fb8909649f722a6$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $6fb8909649f722a6$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $6fb8909649f722a6$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $6fb8909649f722a6$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $6fb8909649f722a6$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $6fb8909649f722a6$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $6fb8909649f722a6$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $6fb8909649f722a6$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $6fb8909649f722a6$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $6fb8909649f722a6$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $6fb8909649f722a6$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $6fb8909649f722a6$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $6fb8909649f722a6$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $6fb8909649f722a6$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $6fb8909649f722a6$export$2e2bcd8739ae039 = $6fb8909649f722a6$var$shadows;

});

parcelRegister("5pwy0", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $3f0888d24d73593b$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $3f0888d24d73593b$export$2e2bcd8739ae039; });

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");
const $3f0888d24d73593b$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $3f0888d24d73593b$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $3f0888d24d73593b$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $3f0888d24d73593b$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $3f0888d24d73593b$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $3f0888d24d73593b$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $7TrLl.default)({}, $3f0888d24d73593b$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $7TrLl.default)({}, $3f0888d24d73593b$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $1gVUU.default)(options, $3f0888d24d73593b$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $3f0888d24d73593b$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $3f0888d24d73593b$var$formatMs(delay)}`).join(',');
    };
    return (0, $7TrLl.default)({
        getAutoHeightDuration: $3f0888d24d73593b$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("6Hu4u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e0e15cd4ba602de$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $4e0e15cd4ba602de$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $4e0e15cd4ba602de$export$2e2bcd8739ae039 = $4e0e15cd4ba602de$var$zIndex;

});



parcelRegister("aYzJA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fdb3a14b434749d$export$2e2bcd8739ae039; });
var $7fdb3a14b434749d$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("6xVVB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c42c26e06e3ef2a$export$2e2bcd8739ae039; });

var $2MBRn = parcelRequire("2MBRn");
const $4c42c26e06e3ef2a$var$rootShouldForwardProp = (prop)=>(0, $2MBRn.default)(prop) && prop !== 'classes';
var $4c42c26e06e3ef2a$export$2e2bcd8739ae039 = $4c42c26e06e3ef2a$var$rootShouldForwardProp;

});
parcelRegister("2MBRn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $206d6ea4d8e68f2d$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $206d6ea4d8e68f2d$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $206d6ea4d8e68f2d$export$2e2bcd8739ae039 = $206d6ea4d8e68f2d$var$slotShouldForwardProp;

});



parcelRegister("kdlF1", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $eb75d2e8d2ebf3c5$export$c7c50641356bdfa5; });

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $eb75d2e8d2ebf3c5$export$c7c50641356bdfa5(slot) {
    return (0, $iobM3.default)('MuiSvgIcon', slot);
}
const $eb75d2e8d2ebf3c5$var$svgIconClasses = (0, $5rH1e.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $eb75d2e8d2ebf3c5$export$2e2bcd8739ae039 = $eb75d2e8d2ebf3c5$var$svgIconClasses;

});
parcelRegister("5rH1e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f70d805d505c74f$export$2e2bcd8739ae039; });

var $iobM3 = parcelRequire("iobM3");
function $3f70d805d505c74f$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $iobM3.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("iobM3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d63399f6d4fbb2fd$export$2e2bcd8739ae039; });

var $guV7E = parcelRequire("guV7E");
const $d63399f6d4fbb2fd$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $d63399f6d4fbb2fd$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $d63399f6d4fbb2fd$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $guV7E.default).generate(componentName)}-${slot}`;
}
function $d63399f6d4fbb2fd$export$34c0130b1f3e8ae3(slot) {
    return $d63399f6d4fbb2fd$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("guV7E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c02bc1fc9849de7f$export$2e2bcd8739ae039; });
const $c02bc1fc9849de7f$var$defaultGenerator = (componentName)=>componentName;
const $c02bc1fc9849de7f$var$createClassNameGenerator = ()=>{
    let generate = $c02bc1fc9849de7f$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $c02bc1fc9849de7f$var$defaultGenerator;
        }
    };
};
const $c02bc1fc9849de7f$var$ClassNameGenerator = $c02bc1fc9849de7f$var$createClassNameGenerator();
var $c02bc1fc9849de7f$export$2e2bcd8739ae039 = $c02bc1fc9849de7f$var$ClassNameGenerator;

});







parcelRegister("8p6fT", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("agf0O", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $77870b1db843a973$var$ReactIs, $77870b1db843a973$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("ciD6D"))();

});

var $64a0bb1d35809f47$exports = {};
$parcel$extendImportMap({
    "9GsQk": "nitro.d95b0ced.webp"
});


var $dzbn0 = parcelRequire("dzbn0");

var $47OeM = parcelRequire("47OeM");
parcelRequire("8dE9F");
parcelRequire("2bJBJ");
parcelRequire("i8bOW");
parcelRequire("2S6Ov");

parcelRequire("9AM9V");
parcelRequire("gMYkM");
parcelRequire("6DrM0");
parcelRequire("kgAOu");
var $28c3d1989808f867$export$ffb0004e005737fa = $dzbn0.Fragment;
var $28c3d1989808f867$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $47OeM.h).call(props, 'css')) return $dzbn0.jsx(type, props, key);
    return $dzbn0.jsx((0, $47OeM.E), (0, $47OeM.c)(type, props), key);
};
var $28c3d1989808f867$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $47OeM.h).call(props, 'css')) return $dzbn0.jsxs(type, props, key);
    return $dzbn0.jsxs((0, $47OeM.E), (0, $47OeM.c)(type, props), key);
};


parcelRequire("8dE9F");


var $f22ac357d192a259$exports = {};
'use strict';
function $f22ac357d192a259$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f22ac357d192a259$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f22ac357d192a259$var$checkDCE();

$f22ac357d192a259$exports = (parcelRequire("3KM02"));




var $8dE9F = parcelRequire("8dE9F");
/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8dE9F = parcelRequire("8dE9F");

/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $7322c26355bb01e6$var$_extends() {
    $7322c26355bb01e6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7322c26355bb01e6$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $7322c26355bb01e6$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($7322c26355bb01e6$export$e19cd5f9376f8cee || ($7322c26355bb01e6$export$e19cd5f9376f8cee = {}));
const $7322c26355bb01e6$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $7322c26355bb01e6$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $7322c26355bb01e6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $7322c26355bb01e6$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $7322c26355bb01e6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $7322c26355bb01e6$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $7322c26355bb01e6$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $7322c26355bb01e6$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $7322c26355bb01e6$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $7322c26355bb01e6$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $7322c26355bb01e6$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $7322c26355bb01e6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $7322c26355bb01e6$export$fe53371bee54353d(to);
    }
    return $7322c26355bb01e6$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $7322c26355bb01e6$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $7322c26355bb01e6$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $7322c26355bb01e6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $7322c26355bb01e6$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $7322c26355bb01e6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $7322c26355bb01e6$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $7322c26355bb01e6$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $7322c26355bb01e6$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $7322c26355bb01e6$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $7322c26355bb01e6$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $7322c26355bb01e6$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $7322c26355bb01e6$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $7322c26355bb01e6$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $7322c26355bb01e6$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $7322c26355bb01e6$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $7322c26355bb01e6$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $7322c26355bb01e6$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $7322c26355bb01e6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($7322c26355bb01e6$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $7322c26355bb01e6$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $7322c26355bb01e6$export$e19cd5f9376f8cee.Push;
        let location = $7322c26355bb01e6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $7322c26355bb01e6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $7322c26355bb01e6$export$e19cd5f9376f8cee.Replace;
        let location = $7322c26355bb01e6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $7322c26355bb01e6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $7322c26355bb01e6$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $7322c26355bb01e6$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($7322c26355bb01e6$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($7322c26355bb01e6$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $7322c26355bb01e6$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($7322c26355bb01e6$var$ResultType || ($7322c26355bb01e6$var$ResultType = {}));
const $7322c26355bb01e6$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $7322c26355bb01e6$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $7322c26355bb01e6$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $7322c26355bb01e6$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $7322c26355bb01e6$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($7322c26355bb01e6$var$isIndexRoute(route)) {
            let indexRoute = $7322c26355bb01e6$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $7322c26355bb01e6$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $7322c26355bb01e6$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $7322c26355bb01e6$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $7322c26355bb01e6$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $7322c26355bb01e6$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $7322c26355bb01e6$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $7322c26355bb01e6$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $7322c26355bb01e6$var$flattenRoutes(routes);
    $7322c26355bb01e6$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $7322c26355bb01e6$export$30d21fd6d7295f52(pathname);
        matches = $7322c26355bb01e6$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $7322c26355bb01e6$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $7322c26355bb01e6$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $7322c26355bb01e6$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $7322c26355bb01e6$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $7322c26355bb01e6$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $7322c26355bb01e6$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $7322c26355bb01e6$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $7322c26355bb01e6$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $7322c26355bb01e6$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $7322c26355bb01e6$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $7322c26355bb01e6$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $7322c26355bb01e6$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $7322c26355bb01e6$var$paramRe = /^:[\w-]+$/;
const $7322c26355bb01e6$var$dynamicSegmentValue = 3;
const $7322c26355bb01e6$var$indexRouteValue = 2;
const $7322c26355bb01e6$var$emptySegmentValue = 1;
const $7322c26355bb01e6$var$staticSegmentValue = 10;
const $7322c26355bb01e6$var$splatPenalty = -2;
const $7322c26355bb01e6$var$isSplat = (s)=>s === "*";
function $7322c26355bb01e6$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($7322c26355bb01e6$var$isSplat)) initialScore += $7322c26355bb01e6$var$splatPenalty;
    if (index) initialScore += $7322c26355bb01e6$var$indexRouteValue;
    return segments.filter((s)=>!$7322c26355bb01e6$var$isSplat(s)).reduce((score, segment)=>score + ($7322c26355bb01e6$var$paramRe.test(segment) ? $7322c26355bb01e6$var$dynamicSegmentValue : segment === "" ? $7322c26355bb01e6$var$emptySegmentValue : $7322c26355bb01e6$var$staticSegmentValue), initialScore);
}
function $7322c26355bb01e6$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $7322c26355bb01e6$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $7322c26355bb01e6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $7322c26355bb01e6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $7322c26355bb01e6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $7322c26355bb01e6$export$a5c6d149b50c1d86($7322c26355bb01e6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $7322c26355bb01e6$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $7322c26355bb01e6$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $7322c26355bb01e6$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $7322c26355bb01e6$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $7322c26355bb01e6$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $7322c26355bb01e6$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $7322c26355bb01e6$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $7322c26355bb01e6$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $7322c26355bb01e6$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $7322c26355bb01e6$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $7322c26355bb01e6$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $7322c26355bb01e6$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $7322c26355bb01e6$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $7322c26355bb01e6$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $7322c26355bb01e6$var$normalizeSearch(search),
        hash: $7322c26355bb01e6$var$normalizeHash(hash)
    };
}
function $7322c26355bb01e6$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $7322c26355bb01e6$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $7322c26355bb01e6$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $7322c26355bb01e6$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $7322c26355bb01e6$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $7322c26355bb01e6$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $7322c26355bb01e6$export$8ccf933b0513f8d0(toArg);
    else {
        to = $7322c26355bb01e6$var$_extends({}, toArg);
        $7322c26355bb01e6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $7322c26355bb01e6$var$getInvalidPathError("?", "pathname", "search", to));
        $7322c26355bb01e6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $7322c26355bb01e6$var$getInvalidPathError("#", "pathname", "hash", to));
        $7322c26355bb01e6$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $7322c26355bb01e6$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $7322c26355bb01e6$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $7322c26355bb01e6$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $7322c26355bb01e6$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $7322c26355bb01e6$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $7322c26355bb01e6$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $7322c26355bb01e6$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $7322c26355bb01e6$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $7322c26355bb01e6$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $7322c26355bb01e6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $7322c26355bb01e6$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $7322c26355bb01e6$export$4051a07651545597(data, init) {
    return new $7322c26355bb01e6$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $7322c26355bb01e6$export$42a99a7a4bc0e76a extends Error {
}
class $7322c26355bb01e6$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $7322c26355bb01e6$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $7322c26355bb01e6$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $7322c26355bb01e6$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $7322c26355bb01e6$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $7322c26355bb01e6$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $7322c26355bb01e6$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $7322c26355bb01e6$var$unwrapTrackedPromise(value) {
    if (!$7322c26355bb01e6$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $7322c26355bb01e6$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $7322c26355bb01e6$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $7322c26355bb01e6$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $7322c26355bb01e6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $7322c26355bb01e6$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $7322c26355bb01e6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $7322c26355bb01e6$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $7322c26355bb01e6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $7322c26355bb01e6$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $7322c26355bb01e6$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $7322c26355bb01e6$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $7322c26355bb01e6$var$validMutationMethods = new Set($7322c26355bb01e6$var$validMutationMethodsArr);
const $7322c26355bb01e6$var$validRequestMethodsArr = [
    "get",
    ...$7322c26355bb01e6$var$validMutationMethodsArr
];
const $7322c26355bb01e6$var$validRequestMethods = new Set($7322c26355bb01e6$var$validRequestMethodsArr);
const $7322c26355bb01e6$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $7322c26355bb01e6$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $7322c26355bb01e6$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $7322c26355bb01e6$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $7322c26355bb01e6$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $7322c26355bb01e6$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $7322c26355bb01e6$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $7322c26355bb01e6$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $7322c26355bb01e6$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $7322c26355bb01e6$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $7322c26355bb01e6$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $7322c26355bb01e6$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $7322c26355bb01e6$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $7322c26355bb01e6$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $7322c26355bb01e6$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $7322c26355bb01e6$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $7322c26355bb01e6$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$7322c26355bb01e6$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$7322c26355bb01e6$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $7322c26355bb01e6$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $7322c26355bb01e6$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $7322c26355bb01e6$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $7322c26355bb01e6$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $7322c26355bb01e6$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$7322c26355bb01e6$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($7322c26355bb01e6$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $7322c26355bb01e6$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $7322c26355bb01e6$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $7322c26355bb01e6$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $7322c26355bb01e6$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $7322c26355bb01e6$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $7322c26355bb01e6$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $7322c26355bb01e6$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $7322c26355bb01e6$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $7322c26355bb01e6$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($7322c26355bb01e6$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $7322c26355bb01e6$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $7322c26355bb01e6$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $7322c26355bb01e6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $7322c26355bb01e6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $7322c26355bb01e6$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $7322c26355bb01e6$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $7322c26355bb01e6$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $7322c26355bb01e6$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $7322c26355bb01e6$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $7322c26355bb01e6$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $7322c26355bb01e6$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $7322c26355bb01e6$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $7322c26355bb01e6$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $7322c26355bb01e6$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $7322c26355bb01e6$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $7322c26355bb01e6$var$findNearestBoundary(matches).route.id,
            {
                type: $7322c26355bb01e6$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $7322c26355bb01e6$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($7322c26355bb01e6$var$isErrorResult(result) && $7322c26355bb01e6$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $7322c26355bb01e6$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $7322c26355bb01e6$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $7322c26355bb01e6$var$_extends({
            matches: updatedMatches || matches
        }, $7322c26355bb01e6$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $7322c26355bb01e6$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $7322c26355bb01e6$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $7322c26355bb01e6$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $7322c26355bb01e6$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $7322c26355bb01e6$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $7322c26355bb01e6$var$ResultType.error,
            error: $7322c26355bb01e6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($7322c26355bb01e6$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $7322c26355bb01e6$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($7322c26355bb01e6$var$isDeferredResult(result)) throw $7322c26355bb01e6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($7322c26355bb01e6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $7322c26355bb01e6$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $7322c26355bb01e6$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $7322c26355bb01e6$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $7322c26355bb01e6$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($7322c26355bb01e6$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $7322c26355bb01e6$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $7322c26355bb01e6$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $7322c26355bb01e6$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $7322c26355bb01e6$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $7322c26355bb01e6$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $7322c26355bb01e6$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $7322c26355bb01e6$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $7322c26355bb01e6$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $7322c26355bb01e6$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $7322c26355bb01e6$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$7322c26355bb01e6$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $7322c26355bb01e6$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $7322c26355bb01e6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $7322c26355bb01e6$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $7322c26355bb01e6$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $7322c26355bb01e6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $7322c26355bb01e6$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $7322c26355bb01e6$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $7322c26355bb01e6$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $7322c26355bb01e6$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $7322c26355bb01e6$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $7322c26355bb01e6$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $7322c26355bb01e6$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($7322c26355bb01e6$var$isRedirectResult(actionResult) || $7322c26355bb01e6$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $7322c26355bb01e6$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($7322c26355bb01e6$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $7322c26355bb01e6$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $7322c26355bb01e6$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($7322c26355bb01e6$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($7322c26355bb01e6$var$isDeferredResult(actionResult)) throw $7322c26355bb01e6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $7322c26355bb01e6$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $7322c26355bb01e6$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $7322c26355bb01e6$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $7322c26355bb01e6$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $7322c26355bb01e6$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $7322c26355bb01e6$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $7322c26355bb01e6$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $7322c26355bb01e6$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $7322c26355bb01e6$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $7322c26355bb01e6$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $7322c26355bb01e6$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $7322c26355bb01e6$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $7322c26355bb01e6$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $7322c26355bb01e6$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $7322c26355bb01e6$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $7322c26355bb01e6$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($7322c26355bb01e6$var$isDeferredResult(result)) result = await $7322c26355bb01e6$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $7322c26355bb01e6$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($7322c26355bb01e6$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $7322c26355bb01e6$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($7322c26355bb01e6$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $7322c26355bb01e6$export$3e9cee6b33872309(!$7322c26355bb01e6$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $7322c26355bb01e6$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $7322c26355bb01e6$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $7322c26355bb01e6$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $7322c26355bb01e6$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($7322c26355bb01e6$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $7322c26355bb01e6$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $7322c26355bb01e6$export$e19cd5f9376f8cee.Replace : $7322c26355bb01e6$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $7322c26355bb01e6$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($7322c26355bb01e6$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $7322c26355bb01e6$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $7322c26355bb01e6$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $7322c26355bb01e6$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $7322c26355bb01e6$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $7322c26355bb01e6$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($7322c26355bb01e6$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $7322c26355bb01e6$var$ResultType.redirect,
                response: $7322c26355bb01e6$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $7322c26355bb01e6$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $7322c26355bb01e6$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $7322c26355bb01e6$var$ResultType.error,
                    error: $7322c26355bb01e6$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $7322c26355bb01e6$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $7322c26355bb01e6$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $7322c26355bb01e6$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $7322c26355bb01e6$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $7322c26355bb01e6$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $7322c26355bb01e6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $7322c26355bb01e6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $7322c26355bb01e6$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $7322c26355bb01e6$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $7322c26355bb01e6$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $7322c26355bb01e6$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $7322c26355bb01e6$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $7322c26355bb01e6$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $7322c26355bb01e6$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$7322c26355bb01e6$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $7322c26355bb01e6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $7322c26355bb01e6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $7322c26355bb01e6$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $7322c26355bb01e6$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $7322c26355bb01e6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $7322c26355bb01e6$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $7322c26355bb01e6$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $7322c26355bb01e6$export$4d0306f8f6a4585b = Symbol("deferred");
function $7322c26355bb01e6$export$3336b097a6fbc59a(routes, opts) {
    $7322c26355bb01e6$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $7322c26355bb01e6$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $7322c26355bb01e6$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $7322c26355bb01e6$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $7322c26355bb01e6$var$createLocation("", $7322c26355bb01e6$export$fe53371bee54353d(url), null, "default");
        let matches = $7322c26355bb01e6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$7322c26355bb01e6$var$isValidMethod(method) && method !== "HEAD") {
            let error = $7322c26355bb01e6$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $7322c26355bb01e6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $7322c26355bb01e6$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $7322c26355bb01e6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($7322c26355bb01e6$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $7322c26355bb01e6$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $7322c26355bb01e6$var$createLocation("", $7322c26355bb01e6$export$fe53371bee54353d(url), null, "default");
        let matches = $7322c26355bb01e6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$7322c26355bb01e6$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $7322c26355bb01e6$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $7322c26355bb01e6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $7322c26355bb01e6$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $7322c26355bb01e6$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $7322c26355bb01e6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($7322c26355bb01e6$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$7322c26355bb01e6$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $7322c26355bb01e6$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($7322c26355bb01e6$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $7322c26355bb01e6$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $7322c26355bb01e6$var$isResponse(result) ? result : $7322c26355bb01e6$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($7322c26355bb01e6$var$isDataStrategyResult(e) && $7322c26355bb01e6$var$isResponse(e.result)) {
                if (e.type === $7322c26355bb01e6$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($7322c26355bb01e6$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $7322c26355bb01e6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $7322c26355bb01e6$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $7322c26355bb01e6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($7322c26355bb01e6$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($7322c26355bb01e6$var$isDeferredResult(result)) {
            let error = $7322c26355bb01e6$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $7322c26355bb01e6$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($7322c26355bb01e6$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($7322c26355bb01e6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $7322c26355bb01e6$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $7322c26355bb01e6$var$_extends({}, context, {
                statusCode: $7322c26355bb01e6$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $7322c26355bb01e6$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $7322c26355bb01e6$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $7322c26355bb01e6$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $7322c26355bb01e6$var$isErrorResult(pendingActionResult[1]) ? $7322c26355bb01e6$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $7322c26355bb01e6$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $7322c26355bb01e6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $7322c26355bb01e6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $7322c26355bb01e6$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $7322c26355bb01e6$var$callDataStrategyImpl(dataStrategy || $7322c26355bb01e6$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($7322c26355bb01e6$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $7322c26355bb01e6$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($7322c26355bb01e6$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $7322c26355bb01e6$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $7322c26355bb01e6$export$fec11da027c70692(routes, context, error) {
    let newContext = $7322c26355bb01e6$var$_extends({}, context, {
        statusCode: $7322c26355bb01e6$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $7322c26355bb01e6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $7322c26355bb01e6$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $7322c26355bb01e6$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $7322c26355bb01e6$export$cae722b0cc860f13(to ? to : ".", $7322c26355bb01e6$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $7322c26355bb01e6$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $7322c26355bb01e6$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $7322c26355bb01e6$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $7322c26355bb01e6$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $7322c26355bb01e6$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$7322c26355bb01e6$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$7322c26355bb01e6$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $7322c26355bb01e6$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $7322c26355bb01e6$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $7322c26355bb01e6$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$7322c26355bb01e6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$7322c26355bb01e6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $7322c26355bb01e6$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $7322c26355bb01e6$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $7322c26355bb01e6$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $7322c26355bb01e6$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $7322c26355bb01e6$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($7322c26355bb01e6$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $7322c26355bb01e6$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $7322c26355bb01e6$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $7322c26355bb01e6$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $7322c26355bb01e6$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $7322c26355bb01e6$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $7322c26355bb01e6$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $7322c26355bb01e6$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $7322c26355bb01e6$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $7322c26355bb01e6$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $7322c26355bb01e6$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($7322c26355bb01e6$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $7322c26355bb01e6$var$shouldRevalidateLoader(match, $7322c26355bb01e6$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $7322c26355bb01e6$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $7322c26355bb01e6$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $7322c26355bb01e6$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $7322c26355bb01e6$var$shouldRevalidateLoader(fetcherMatch, $7322c26355bb01e6$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $7322c26355bb01e6$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $7322c26355bb01e6$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $7322c26355bb01e6$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $7322c26355bb01e6$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $7322c26355bb01e6$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $7322c26355bb01e6$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$7322c26355bb01e6$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $7322c26355bb01e6$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $7322c26355bb01e6$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$7322c26355bb01e6$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $7322c26355bb01e6$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $7322c26355bb01e6$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $7322c26355bb01e6$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$7322c26355bb01e6$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $7322c26355bb01e6$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $7322c26355bb01e6$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $7322c26355bb01e6$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $7322c26355bb01e6$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $7322c26355bb01e6$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $7322c26355bb01e6$var$ResultType.data,
                result: undefined
            });
        };
        return $7322c26355bb01e6$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $7322c26355bb01e6$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $7322c26355bb01e6$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $7322c26355bb01e6$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $7322c26355bb01e6$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $7322c26355bb01e6$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $7322c26355bb01e6$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $7322c26355bb01e6$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($7322c26355bb01e6$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $7322c26355bb01e6$var$ResultType.error,
                error: e
            };
        }
        if (type === $7322c26355bb01e6$var$ResultType.error) return {
            type: $7322c26355bb01e6$var$ResultType.error,
            error: new $7322c26355bb01e6$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $7322c26355bb01e6$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $7322c26355bb01e6$var$ResultType.error) {
        if ($7322c26355bb01e6$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $7322c26355bb01e6$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $7322c26355bb01e6$var$ResultType.error,
                error: new $7322c26355bb01e6$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $7322c26355bb01e6$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $7322c26355bb01e6$var$ResultType.error,
            error: result,
            statusCode: $7322c26355bb01e6$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($7322c26355bb01e6$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $7322c26355bb01e6$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($7322c26355bb01e6$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $7322c26355bb01e6$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $7322c26355bb01e6$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $7322c26355bb01e6$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $7322c26355bb01e6$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$7322c26355bb01e6$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $7322c26355bb01e6$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $7322c26355bb01e6$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($7322c26355bb01e6$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $7322c26355bb01e6$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $7322c26355bb01e6$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($7322c26355bb01e6$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $7322c26355bb01e6$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $7322c26355bb01e6$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $7322c26355bb01e6$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $7322c26355bb01e6$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $7322c26355bb01e6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $7322c26355bb01e6$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $7322c26355bb01e6$export$3e9cee6b33872309(!$7322c26355bb01e6$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($7322c26355bb01e6$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $7322c26355bb01e6$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $7322c26355bb01e6$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($7322c26355bb01e6$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $7322c26355bb01e6$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $7322c26355bb01e6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $7322c26355bb01e6$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($7322c26355bb01e6$var$isErrorResult(result)) {
            let boundaryMatch = $7322c26355bb01e6$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $7322c26355bb01e6$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($7322c26355bb01e6$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $7322c26355bb01e6$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($7322c26355bb01e6$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $7322c26355bb01e6$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $7322c26355bb01e6$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $7322c26355bb01e6$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $7322c26355bb01e6$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $7322c26355bb01e6$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $7322c26355bb01e6$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $7322c26355bb01e6$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $7322c26355bb01e6$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $7322c26355bb01e6$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $7322c26355bb01e6$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $7322c26355bb01e6$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($7322c26355bb01e6$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $7322c26355bb01e6$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $7322c26355bb01e6$export$8ccf933b0513f8d0(path) : path;
    return $7322c26355bb01e6$export$fe53371bee54353d($7322c26355bb01e6$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $7322c26355bb01e6$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $7322c26355bb01e6$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $7322c26355bb01e6$var$ResultType.data || result.type === $7322c26355bb01e6$var$ResultType.error);
}
function $7322c26355bb01e6$var$isRedirectDataStrategyResultResult(result) {
    return $7322c26355bb01e6$var$isResponse(result.result) && $7322c26355bb01e6$var$redirectStatusCodes.has(result.result.status);
}
function $7322c26355bb01e6$var$isDeferredResult(result) {
    return result.type === $7322c26355bb01e6$var$ResultType.deferred;
}
function $7322c26355bb01e6$var$isErrorResult(result) {
    return result.type === $7322c26355bb01e6$var$ResultType.error;
}
function $7322c26355bb01e6$var$isRedirectResult(result) {
    return (result && result.type) === $7322c26355bb01e6$var$ResultType.redirect;
}
function $7322c26355bb01e6$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $7322c26355bb01e6$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $7322c26355bb01e6$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $7322c26355bb01e6$var$isRedirectResponse(result) {
    if (!$7322c26355bb01e6$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $7322c26355bb01e6$var$isValidMethod(method) {
    return $7322c26355bb01e6$var$validRequestMethods.has(method.toLowerCase());
}
function $7322c26355bb01e6$var$isMutationMethod(method) {
    return $7322c26355bb01e6$var$validMutationMethods.has(method.toLowerCase());
}
async function $7322c26355bb01e6$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$7322c26355bb01e6$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($7322c26355bb01e6$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $7322c26355bb01e6$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $7322c26355bb01e6$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($7322c26355bb01e6$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $7322c26355bb01e6$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $7322c26355bb01e6$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $7322c26355bb01e6$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $7322c26355bb01e6$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $7322c26355bb01e6$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $7322c26355bb01e6$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $7322c26355bb01e6$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $7322c26355bb01e6$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $7322c26355bb01e6$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $7322c26355bb01e6$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $7322c26355bb01e6$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $7322c26355bb01e6$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $7322c26355bb01e6$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $7322c26355bb01e6$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $7322c26355bb01e6$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $7322c26355bb01e6$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $7322c26355bb01e6$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $7322c26355bb01e6$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($7322c26355bb01e6$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $7322c26355bb01e6$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($7322c26355bb01e6$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $7322c26355bb01e6$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8dE9F = parcelRequire("8dE9F");

function $aa49d4a669bfa59a$var$_extends() {
    $aa49d4a669bfa59a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aa49d4a669bfa59a$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $aa49d4a669bfa59a$export$3add0d5dce533e2e = /*#__PURE__*/ $8dE9F.createContext(null);
const $aa49d4a669bfa59a$export$145dfa71566a64dc = /*#__PURE__*/ $8dE9F.createContext(null);
const $aa49d4a669bfa59a$var$AwaitContext = /*#__PURE__*/ $8dE9F.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $aa49d4a669bfa59a$export$26749e8557646306 = /*#__PURE__*/ $8dE9F.createContext(null);
const $aa49d4a669bfa59a$export$c7914228fb69b0f5 = /*#__PURE__*/ $8dE9F.createContext(null);
const $aa49d4a669bfa59a$export$9072aa6dd1f93057 = /*#__PURE__*/ $8dE9F.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $aa49d4a669bfa59a$var$RouteErrorContext = /*#__PURE__*/ $8dE9F.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $aa49d4a669bfa59a$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$aa49d4a669bfa59a$export$9c954a9d03d32f4a() && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8dE9F.useContext($aa49d4a669bfa59a$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $aa49d4a669bfa59a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $7322c26355bb01e6$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $aa49d4a669bfa59a$export$9c954a9d03d32f4a() {
    return $8dE9F.useContext($aa49d4a669bfa59a$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $aa49d4a669bfa59a$export$45d76561a5302f2b() {
    !$aa49d4a669bfa59a$export$9c954a9d03d32f4a() && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    return $8dE9F.useContext($aa49d4a669bfa59a$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $aa49d4a669bfa59a$export$1b3f31771c5d07c() {
    return $8dE9F.useContext($aa49d4a669bfa59a$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $aa49d4a669bfa59a$export$6c330e8992e8a295(pattern) {
    !$aa49d4a669bfa59a$export$9c954a9d03d32f4a() && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $aa49d4a669bfa59a$export$45d76561a5302f2b();
    return $8dE9F.useMemo(()=>(0, $7322c26355bb01e6$export$81336c211d5ff295)(pattern, (0, $7322c26355bb01e6$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $aa49d4a669bfa59a$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $aa49d4a669bfa59a$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8dE9F.useContext($aa49d4a669bfa59a$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8dE9F.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $aa49d4a669bfa59a$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8dE9F.useContext($aa49d4a669bfa59a$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $aa49d4a669bfa59a$var$useNavigateStable() : $aa49d4a669bfa59a$var$useNavigateUnstable();
}
function $aa49d4a669bfa59a$var$useNavigateUnstable() {
    !$aa49d4a669bfa59a$export$9c954a9d03d32f4a() && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8dE9F.useContext($aa49d4a669bfa59a$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8dE9F.useContext($aa49d4a669bfa59a$export$26749e8557646306);
    let { matches: matches } = $8dE9F.useContext($aa49d4a669bfa59a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $aa49d4a669bfa59a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7322c26355bb01e6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8dE9F.useRef(false);
    $aa49d4a669bfa59a$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8dE9F.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $7322c26355bb01e6$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7322c26355bb01e6$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $aa49d4a669bfa59a$var$OutletContext = /*#__PURE__*/ $8dE9F.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $aa49d4a669bfa59a$export$4138103a3ae699cc() {
    return $8dE9F.useContext($aa49d4a669bfa59a$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $aa49d4a669bfa59a$export$a3be3530d8e40d0b(context) {
    let outlet = $8dE9F.useContext($aa49d4a669bfa59a$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $aa49d4a669bfa59a$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8dE9F.useContext($aa49d4a669bfa59a$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $aa49d4a669bfa59a$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8dE9F.useContext($aa49d4a669bfa59a$export$26749e8557646306);
    let { matches: matches } = $8dE9F.useContext($aa49d4a669bfa59a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $aa49d4a669bfa59a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7322c26355bb01e6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8dE9F.useMemo(()=>(0, $7322c26355bb01e6$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $aa49d4a669bfa59a$export$5d3fca4a98652595(routes, locationArg) {
    return $aa49d4a669bfa59a$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $aa49d4a669bfa59a$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$aa49d4a669bfa59a$export$9c954a9d03d32f4a() && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $8dE9F.useContext($aa49d4a669bfa59a$export$26749e8557646306);
    let { matches: parentMatches } = $8dE9F.useContext($aa49d4a669bfa59a$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $aa49d4a669bfa59a$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $7322c26355bb01e6$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $7322c26355bb01e6$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $aa49d4a669bfa59a$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $7322c26355bb01e6$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $7322c26355bb01e6$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $aa49d4a669bfa59a$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $7322c26355bb01e6$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $aa49d4a669bfa59a$var$DefaultErrorComponent() {
    let error = $aa49d4a669bfa59a$export$ed527bf60f6e05f2();
    let message = (0, $7322c26355bb01e6$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8dE9F.createElement($8dE9F.Fragment, null, /*#__PURE__*/ $8dE9F.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8dE9F.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8dE9F.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $aa49d4a669bfa59a$var$defaultErrorElement = /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$var$DefaultErrorComponent, null);
class $aa49d4a669bfa59a$var$RenderErrorBoundary extends $8dE9F.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $aa49d4a669bfa59a$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8dE9F.useContext($aa49d4a669bfa59a$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $aa49d4a669bfa59a$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $aa49d4a669bfa59a$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $aa49d4a669bfa59a$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8dE9F.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $aa49d4a669bfa59a$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($aa49d4a669bfa59a$var$DataRouterHook || {});
var $aa49d4a669bfa59a$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($aa49d4a669bfa59a$var$DataRouterStateHook || {});
function $aa49d4a669bfa59a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $aa49d4a669bfa59a$var$useDataRouterContext(hookName) {
    let ctx = $8dE9F.useContext($aa49d4a669bfa59a$export$3add0d5dce533e2e);
    !ctx && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    return ctx;
}
function $aa49d4a669bfa59a$var$useDataRouterState(hookName) {
    let state = $8dE9F.useContext($aa49d4a669bfa59a$export$145dfa71566a64dc);
    !state && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    return state;
}
function $aa49d4a669bfa59a$var$useRouteContext(hookName) {
    let route = $8dE9F.useContext($aa49d4a669bfa59a$export$9072aa6dd1f93057);
    !route && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $aa49d4a669bfa59a$var$useCurrentRouteId(hookName) {
    let route = $aa49d4a669bfa59a$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $aa49d4a669bfa59a$export$5fc8298006ad9e58() {
    return $aa49d4a669bfa59a$var$useCurrentRouteId($aa49d4a669bfa59a$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $aa49d4a669bfa59a$export$d0fd4b7106de2769() {
    let state = $aa49d4a669bfa59a$var$useDataRouterState($aa49d4a669bfa59a$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $aa49d4a669bfa59a$export$600dc272ed516c15() {
    let dataRouterContext = $aa49d4a669bfa59a$var$useDataRouterContext($aa49d4a669bfa59a$var$DataRouterHook.UseRevalidator);
    let state = $aa49d4a669bfa59a$var$useDataRouterState($aa49d4a669bfa59a$var$DataRouterStateHook.UseRevalidator);
    return $8dE9F.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $aa49d4a669bfa59a$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $aa49d4a669bfa59a$var$useDataRouterState($aa49d4a669bfa59a$var$DataRouterStateHook.UseMatches);
    return $8dE9F.useMemo(()=>matches.map((m)=>(0, $7322c26355bb01e6$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $aa49d4a669bfa59a$export$1448a5050d252c4d() {
    let state = $aa49d4a669bfa59a$var$useDataRouterState($aa49d4a669bfa59a$var$DataRouterStateHook.UseLoaderData);
    let routeId = $aa49d4a669bfa59a$var$useCurrentRouteId($aa49d4a669bfa59a$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $aa49d4a669bfa59a$export$fd5d37484eab868d(routeId) {
    let state = $aa49d4a669bfa59a$var$useDataRouterState($aa49d4a669bfa59a$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $aa49d4a669bfa59a$export$fdc00f3f26066d5e() {
    let state = $aa49d4a669bfa59a$var$useDataRouterState($aa49d4a669bfa59a$var$DataRouterStateHook.UseActionData);
    let routeId = $aa49d4a669bfa59a$var$useCurrentRouteId($aa49d4a669bfa59a$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $aa49d4a669bfa59a$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8dE9F.useContext($aa49d4a669bfa59a$var$RouteErrorContext);
    let state = $aa49d4a669bfa59a$var$useDataRouterState($aa49d4a669bfa59a$var$DataRouterStateHook.UseRouteError);
    let routeId = $aa49d4a669bfa59a$var$useCurrentRouteId($aa49d4a669bfa59a$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $aa49d4a669bfa59a$export$78a72ddb39bdd145() {
    let value = $8dE9F.useContext($aa49d4a669bfa59a$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $aa49d4a669bfa59a$export$17f53340677d5831() {
    let value = $8dE9F.useContext($aa49d4a669bfa59a$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $aa49d4a669bfa59a$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $aa49d4a669bfa59a$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $aa49d4a669bfa59a$var$useDataRouterContext($aa49d4a669bfa59a$var$DataRouterHook.UseBlocker);
    let state = $aa49d4a669bfa59a$var$useDataRouterState($aa49d4a669bfa59a$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8dE9F.useState("");
    let blockerFunction = $8dE9F.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $aa49d4a669bfa59a$var$_extends({}, currentLocation, {
                pathname: (0, $7322c26355bb01e6$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $aa49d4a669bfa59a$var$_extends({}, nextLocation, {
                pathname: (0, $7322c26355bb01e6$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8dE9F.useEffect(()=>{
        let key = String(++$aa49d4a669bfa59a$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8dE9F.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $7322c26355bb01e6$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $aa49d4a669bfa59a$var$useNavigateStable() {
    let { router: router } = $aa49d4a669bfa59a$var$useDataRouterContext($aa49d4a669bfa59a$var$DataRouterHook.UseNavigateStable);
    let id = $aa49d4a669bfa59a$var$useCurrentRouteId($aa49d4a669bfa59a$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8dE9F.useRef(false);
    $aa49d4a669bfa59a$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8dE9F.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $aa49d4a669bfa59a$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $aa49d4a669bfa59a$var$alreadyWarned$1 = {};
function $aa49d4a669bfa59a$var$warningOnce(key, cond, message) {
    if (!cond && !$aa49d4a669bfa59a$var$alreadyWarned$1[key]) $aa49d4a669bfa59a$var$alreadyWarned$1[key] = true;
}
const $aa49d4a669bfa59a$var$alreadyWarned = {};
function $aa49d4a669bfa59a$var$warnOnce(key, message) {}
const $aa49d4a669bfa59a$var$logDeprecation = (flag, msg, link)=>$aa49d4a669bfa59a$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $aa49d4a669bfa59a$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $aa49d4a669bfa59a$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $aa49d4a669bfa59a$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $aa49d4a669bfa59a$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $aa49d4a669bfa59a$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $aa49d4a669bfa59a$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $aa49d4a669bfa59a$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $aa49d4a669bfa59a$var$START_TRANSITION = "startTransition";
const $aa49d4a669bfa59a$var$startTransitionImpl = $8dE9F[$aa49d4a669bfa59a$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $aa49d4a669bfa59a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8dE9F.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8dE9F.useCallback((newState)=>{
        if (v7_startTransition && $aa49d4a669bfa59a$var$startTransitionImpl) $aa49d4a669bfa59a$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8dE9F.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8dE9F.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8dE9F.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8dE9F.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $8dE9F.useEffect(()=>$aa49d4a669bfa59a$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8dE9F.createElement($8dE9F.Fragment, null, /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $aa49d4a669bfa59a$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $aa49d4a669bfa59a$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $aa49d4a669bfa59a$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8dE9F.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7322c26355bb01e6$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8dE9F.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8dE9F.useCallback((newState)=>{
        v7_startTransition && $aa49d4a669bfa59a$var$startTransitionImpl ? $aa49d4a669bfa59a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8dE9F.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8dE9F.useEffect(()=>$aa49d4a669bfa59a$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $aa49d4a669bfa59a$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$aa49d4a669bfa59a$export$9c954a9d03d32f4a() && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8dE9F.useContext($aa49d4a669bfa59a$export$26749e8557646306);
    let { matches: matches } = $8dE9F.useContext($aa49d4a669bfa59a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $aa49d4a669bfa59a$export$45d76561a5302f2b();
    let navigate = $aa49d4a669bfa59a$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $7322c26355bb01e6$export$cae722b0cc860f13)(to, (0, $7322c26355bb01e6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8dE9F.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $aa49d4a669bfa59a$export$910ae8079b2c2852(props) {
    return $aa49d4a669bfa59a$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $aa49d4a669bfa59a$export$e7b0ac011bb776c6(_props) {
    (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $aa49d4a669bfa59a$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $7322c26355bb01e6$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$aa49d4a669bfa59a$export$9c954a9d03d32f4a() && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8dE9F.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $aa49d4a669bfa59a$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $7322c26355bb01e6$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8dE9F.useMemo(()=>{
        let trailingPathname = (0, $7322c26355bb01e6$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $aa49d4a669bfa59a$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $aa49d4a669bfa59a$export$5d3fca4a98652595($aa49d4a669bfa59a$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $aa49d4a669bfa59a$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$var$ResolveAwait, null, children));
}
var $aa49d4a669bfa59a$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($aa49d4a669bfa59a$var$AwaitRenderStatus || {});
const $aa49d4a669bfa59a$var$neverSettledPromise = new Promise(()=>{});
class $aa49d4a669bfa59a$var$AwaitErrorBoundary extends $8dE9F.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $aa49d4a669bfa59a$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $aa49d4a669bfa59a$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $aa49d4a669bfa59a$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $aa49d4a669bfa59a$var$AwaitRenderStatus.error : "_data" in promise ? $aa49d4a669bfa59a$var$AwaitRenderStatus.success : $aa49d4a669bfa59a$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $aa49d4a669bfa59a$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $aa49d4a669bfa59a$var$AwaitRenderStatus.error && promise._error instanceof (0, $7322c26355bb01e6$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $aa49d4a669bfa59a$var$neverSettledPromise;
        if (status === $aa49d4a669bfa59a$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $aa49d4a669bfa59a$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $aa49d4a669bfa59a$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8dE9F.createElement($aa49d4a669bfa59a$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $aa49d4a669bfa59a$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $aa49d4a669bfa59a$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8dE9F.createElement($8dE9F.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $aa49d4a669bfa59a$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8dE9F.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8dE9F.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8dE9F.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $aa49d4a669bfa59a$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $aa49d4a669bfa59a$export$e7b0ac011bb776c6) && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $aa49d4a669bfa59a$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $aa49d4a669bfa59a$export$daf73786167a7f72(matches) {
    return $aa49d4a669bfa59a$var$_renderMatches(matches);
}
function $aa49d4a669bfa59a$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8dE9F.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8dE9F.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8dE9F.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $aa49d4a669bfa59a$export$f30f7e456d254e83(routes, opts) {
    return (0, $7322c26355bb01e6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $aa49d4a669bfa59a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7322c26355bb01e6$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $aa49d4a669bfa59a$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $701be91339cf6054$var$_extends() {
    $701be91339cf6054$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $701be91339cf6054$var$_extends.apply(this, arguments);
}
function $701be91339cf6054$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $701be91339cf6054$var$defaultMethod = "get";
const $701be91339cf6054$var$defaultEncType = "application/x-www-form-urlencoded";
function $701be91339cf6054$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $701be91339cf6054$var$isButtonElement(object) {
    return $701be91339cf6054$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $701be91339cf6054$var$isFormElement(object) {
    return $701be91339cf6054$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $701be91339cf6054$var$isInputElement(object) {
    return $701be91339cf6054$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $701be91339cf6054$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $701be91339cf6054$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$701be91339cf6054$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $701be91339cf6054$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $701be91339cf6054$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $701be91339cf6054$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $701be91339cf6054$var$_formDataSupportsSubmitter = null;
function $701be91339cf6054$var$isFormDataSubmitterSupported() {
    if ($701be91339cf6054$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $701be91339cf6054$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $701be91339cf6054$var$_formDataSupportsSubmitter = true;
    }
    return $701be91339cf6054$var$_formDataSupportsSubmitter;
}
const $701be91339cf6054$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $701be91339cf6054$var$getFormEncType(encType) {
    if (encType != null && !$701be91339cf6054$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $701be91339cf6054$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($701be91339cf6054$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $7322c26355bb01e6$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $701be91339cf6054$var$defaultMethod;
        encType = $701be91339cf6054$var$getFormEncType(target.getAttribute("enctype")) || $701be91339cf6054$var$defaultEncType;
        formData = new FormData(target);
    } else if ($701be91339cf6054$var$isButtonElement(target) || $701be91339cf6054$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $7322c26355bb01e6$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $701be91339cf6054$var$defaultMethod;
        encType = $701be91339cf6054$var$getFormEncType(target.getAttribute("formenctype")) || $701be91339cf6054$var$getFormEncType(form.getAttribute("enctype")) || $701be91339cf6054$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$701be91339cf6054$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($701be91339cf6054$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $701be91339cf6054$var$defaultMethod;
        action = null;
        encType = $701be91339cf6054$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $701be91339cf6054$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $701be91339cf6054$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $701be91339cf6054$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $701be91339cf6054$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $701be91339cf6054$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $701be91339cf6054$export$1f3f55432a00e06d(routes, opts) {
    return (0, $7322c26355bb01e6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $701be91339cf6054$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7322c26355bb01e6$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $701be91339cf6054$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aa49d4a669bfa59a$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $701be91339cf6054$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $7322c26355bb01e6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $701be91339cf6054$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7322c26355bb01e6$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $701be91339cf6054$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aa49d4a669bfa59a$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $701be91339cf6054$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $701be91339cf6054$var$_extends({}, state, {
        errors: $701be91339cf6054$var$deserializeErrors(state.errors)
    });
    return state;
}
function $701be91339cf6054$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $7322c26355bb01e6$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $701be91339cf6054$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8dE9F.createContext({
    isTransitioning: false
});
const $701be91339cf6054$export$148fd98d095596d4 = /*#__PURE__*/ $8dE9F.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $701be91339cf6054$var$START_TRANSITION = "startTransition";
const $701be91339cf6054$var$startTransitionImpl = $8dE9F[$701be91339cf6054$var$START_TRANSITION];
const $701be91339cf6054$var$FLUSH_SYNC = "flushSync";
const $701be91339cf6054$var$flushSyncImpl = $f22ac357d192a259$exports[$701be91339cf6054$var$FLUSH_SYNC];
const $701be91339cf6054$var$USE_ID = "useId";
const $701be91339cf6054$var$useIdImpl = $8dE9F[$701be91339cf6054$var$USE_ID];
function $701be91339cf6054$var$startTransitionSafe(cb) {
    if ($701be91339cf6054$var$startTransitionImpl) $701be91339cf6054$var$startTransitionImpl(cb);
    else cb();
}
function $701be91339cf6054$var$flushSyncSafe(cb) {
    if ($701be91339cf6054$var$flushSyncImpl) $701be91339cf6054$var$flushSyncImpl(cb);
    else cb();
}
class $701be91339cf6054$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $701be91339cf6054$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8dE9F.useState(router.state);
    let [pendingState, setPendingState] = $8dE9F.useState();
    let [vtContext, setVtContext] = $8dE9F.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8dE9F.useState();
    let [transition, setTransition] = $8dE9F.useState();
    let [interruption, setInterruption] = $8dE9F.useState();
    let fetcherData = $8dE9F.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8dE9F.useCallback((cb)=>{
        if (v7_startTransition) $701be91339cf6054$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8dE9F.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $701be91339cf6054$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $701be91339cf6054$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $701be91339cf6054$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $701be91339cf6054$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $701be91339cf6054$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8dE9F.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8dE9F.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $701be91339cf6054$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8dE9F.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8dE9F.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8dE9F.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8dE9F.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8dE9F.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8dE9F.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8dE9F.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $8dE9F.useEffect(()=>(0, $aa49d4a669bfa59a$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8dE9F.createElement($8dE9F.Fragment, null, /*#__PURE__*/ $8dE9F.createElement((0, $aa49d4a669bfa59a$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8dE9F.createElement((0, $aa49d4a669bfa59a$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8dE9F.createElement($701be91339cf6054$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8dE9F.createElement($701be91339cf6054$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8dE9F.createElement((0, $aa49d4a669bfa59a$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8dE9F.createElement($701be91339cf6054$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $701be91339cf6054$var$MemoizedDataRoutes = /*#__PURE__*/ $8dE9F.memo($701be91339cf6054$var$DataRoutes);
function $701be91339cf6054$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aa49d4a669bfa59a$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $701be91339cf6054$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8dE9F.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7322c26355bb01e6$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8dE9F.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8dE9F.useCallback((newState)=>{
        v7_startTransition && $701be91339cf6054$var$startTransitionImpl ? $701be91339cf6054$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8dE9F.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8dE9F.useEffect(()=>(0, $aa49d4a669bfa59a$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8dE9F.createElement((0, $aa49d4a669bfa59a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $701be91339cf6054$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8dE9F.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7322c26355bb01e6$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8dE9F.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8dE9F.useCallback((newState)=>{
        v7_startTransition && $701be91339cf6054$var$startTransitionImpl ? $701be91339cf6054$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8dE9F.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8dE9F.useEffect(()=>(0, $aa49d4a669bfa59a$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8dE9F.createElement((0, $aa49d4a669bfa59a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $701be91339cf6054$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8dE9F.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8dE9F.useCallback((newState)=>{
        v7_startTransition && $701be91339cf6054$var$startTransitionImpl ? $701be91339cf6054$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8dE9F.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8dE9F.useEffect(()=>(0, $aa49d4a669bfa59a$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8dE9F.createElement((0, $aa49d4a669bfa59a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $701be91339cf6054$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $701be91339cf6054$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $701be91339cf6054$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8dE9F.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $701be91339cf6054$var$_objectWithoutPropertiesLoose(_ref7, $701be91339cf6054$var$_excluded);
    let { basename: basename } = $8dE9F.useContext((0, $aa49d4a669bfa59a$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $701be91339cf6054$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($701be91339cf6054$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $7322c26355bb01e6$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aa49d4a669bfa59a$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $701be91339cf6054$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8dE9F.createElement("a", $701be91339cf6054$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $701be91339cf6054$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8dE9F.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $701be91339cf6054$var$_objectWithoutPropertiesLoose(_ref8, $701be91339cf6054$var$_excluded2);
    let path = (0, $aa49d4a669bfa59a$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $aa49d4a669bfa59a$export$45d76561a5302f2b)();
    let routerState = $8dE9F.useContext((0, $aa49d4a669bfa59a$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8dE9F.useContext((0, $aa49d4a669bfa59a$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $701be91339cf6054$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $7322c26355bb01e6$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8dE9F.createElement($701be91339cf6054$export$a6c7ac8248d6e38a, $701be91339cf6054$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $701be91339cf6054$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8dE9F.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $701be91339cf6054$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $701be91339cf6054$var$_objectWithoutPropertiesLoose(_ref9, $701be91339cf6054$var$_excluded3);
    let submit = $701be91339cf6054$export$47c85c6e3a081d3();
    let formAction = $701be91339cf6054$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8dE9F.createElement("form", $701be91339cf6054$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $701be91339cf6054$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $701be91339cf6054$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $701be91339cf6054$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($701be91339cf6054$var$DataRouterHook || ($701be91339cf6054$var$DataRouterHook = {}));
var $701be91339cf6054$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($701be91339cf6054$var$DataRouterStateHook || ($701be91339cf6054$var$DataRouterStateHook = {}));
// Internal hooks
function $701be91339cf6054$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $701be91339cf6054$var$useDataRouterContext(hookName) {
    let ctx = $8dE9F.useContext((0, $aa49d4a669bfa59a$export$3add0d5dce533e2e));
    !ctx && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    return ctx;
}
function $701be91339cf6054$var$useDataRouterState(hookName) {
    let state = $8dE9F.useContext((0, $aa49d4a669bfa59a$export$145dfa71566a64dc));
    !state && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $701be91339cf6054$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aa49d4a669bfa59a$export$9770f232ac06a008)();
    let location = (0, $aa49d4a669bfa59a$export$45d76561a5302f2b)();
    let path = (0, $aa49d4a669bfa59a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8dE9F.useCallback((event)=>{
        if ($701be91339cf6054$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $7322c26355bb01e6$export$fe53371bee54353d)(location) === (0, $7322c26355bb01e6$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $701be91339cf6054$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8dE9F.useRef($701be91339cf6054$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8dE9F.useRef(false);
    let location = (0, $aa49d4a669bfa59a$export$45d76561a5302f2b)();
    let searchParams = $8dE9F.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $701be91339cf6054$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aa49d4a669bfa59a$export$9770f232ac06a008)();
    let setSearchParams = $8dE9F.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $701be91339cf6054$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $701be91339cf6054$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $701be91339cf6054$var$fetcherId = 0;
let $701be91339cf6054$var$getUniqueFetcherId = ()=>"__" + String(++$701be91339cf6054$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $701be91339cf6054$export$47c85c6e3a081d3() {
    let { router: router } = $701be91339cf6054$var$useDataRouterContext($701be91339cf6054$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8dE9F.useContext((0, $aa49d4a669bfa59a$export$26749e8557646306));
    let currentRouteId = (0, $aa49d4a669bfa59a$export$5fc8298006ad9e58)();
    return $8dE9F.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $701be91339cf6054$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $701be91339cf6054$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $701be91339cf6054$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $701be91339cf6054$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8dE9F.useContext((0, $aa49d4a669bfa59a$export$26749e8557646306));
    let routeContext = $8dE9F.useContext((0, $aa49d4a669bfa59a$export$9072aa6dd1f93057));
    !routeContext && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $701be91339cf6054$var$_extends({}, (0, $aa49d4a669bfa59a$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aa49d4a669bfa59a$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7322c26355bb01e6$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $7322c26355bb01e6$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $701be91339cf6054$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $701be91339cf6054$var$useDataRouterContext($701be91339cf6054$var$DataRouterHook.UseFetcher);
    let state = $701be91339cf6054$var$useDataRouterState($701be91339cf6054$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8dE9F.useContext($701be91339cf6054$export$148fd98d095596d4);
    let route = $8dE9F.useContext((0, $aa49d4a669bfa59a$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    !route && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $701be91339cf6054$var$useIdImpl ? $701be91339cf6054$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8dE9F.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($701be91339cf6054$var$getUniqueFetcherId());
    // Registration/cleanup
    $8dE9F.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8dE9F.useCallback((href, opts)=>{
        !routeId && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $701be91339cf6054$export$47c85c6e3a081d3();
    let submit = $8dE9F.useCallback((target, opts)=>{
        submitImpl(target, $701be91339cf6054$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8dE9F.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8dE9F.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8dE9F.createElement($701be91339cf6054$export$a7fed597f4b8afd8, $701be91339cf6054$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $7322c26355bb01e6$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8dE9F.useMemo(()=>$701be91339cf6054$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $701be91339cf6054$export$fa996778a3a31087() {
    let state = $701be91339cf6054$var$useDataRouterState($701be91339cf6054$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $701be91339cf6054$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $701be91339cf6054$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $701be91339cf6054$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $701be91339cf6054$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $701be91339cf6054$var$useDataRouterContext($701be91339cf6054$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $701be91339cf6054$var$useDataRouterState($701be91339cf6054$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8dE9F.useContext((0, $aa49d4a669bfa59a$export$26749e8557646306));
    let location = (0, $aa49d4a669bfa59a$export$45d76561a5302f2b)();
    let matches = (0, $aa49d4a669bfa59a$export$2378eb7f5ff86053)();
    let navigation = (0, $aa49d4a669bfa59a$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8dE9F.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $701be91339cf6054$var$usePageHide($8dE9F.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $701be91339cf6054$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $701be91339cf6054$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($701be91339cf6054$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8dE9F.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $701be91339cf6054$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $701be91339cf6054$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8dE9F.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($701be91339cf6054$var$_extends({}, location, {
                    pathname: (0, $7322c26355bb01e6$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($701be91339cf6054$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8dE9F.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $701be91339cf6054$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8dE9F.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $701be91339cf6054$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8dE9F.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $701be91339cf6054$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aa49d4a669bfa59a$export$b273b3273281a049)(when);
    $8dE9F.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8dE9F.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $701be91339cf6054$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8dE9F.useContext($701be91339cf6054$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $7322c26355bb01e6$export$3e9cee6b33872309)(false);
    let { basename: basename } = $701be91339cf6054$var$useDataRouterContext($701be91339cf6054$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aa49d4a669bfa59a$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $7322c26355bb01e6$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $7322c26355bb01e6$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $7322c26355bb01e6$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $7322c26355bb01e6$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $iUv4u = parcelRequire("iUv4u");
var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");
parcelRequire("8dE9F");


var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");



var $8dE9F = parcelRequire("8dE9F");
const $bc88ce53b6394ab6$var$ThemeContext = /*#__PURE__*/ $8dE9F.createContext(null);
var $bc88ce53b6394ab6$export$2e2bcd8739ae039 = $bc88ce53b6394ab6$var$ThemeContext;



var $8dE9F = parcelRequire("8dE9F");

function $5e38ba0319d8228c$export$2e2bcd8739ae039() {
    const theme = $8dE9F.useContext((0, $bc88ce53b6394ab6$export$2e2bcd8739ae039));
    return theme;
}


const $22fbf29e71288426$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $22fbf29e71288426$export$2e2bcd8739ae039 = $22fbf29e71288426$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $dzbn0 = parcelRequire("dzbn0");
function $1f0c2527496a512e$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $7TrLl.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $1f0c2527496a512e$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $5e38ba0319d8228c$export$2e2bcd8739ae039)();
    const theme = $8dE9F.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $1f0c2527496a512e$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $22fbf29e71288426$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $bc88ce53b6394ab6$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $1f0c2527496a512e$export$2e2bcd8739ae039 = $1f0c2527496a512e$var$ThemeProvider;



parcelRequire("311cM");
var $47OeM = parcelRequire("47OeM");

var $8dE9F = parcelRequire("8dE9F");
parcelRequire("311cM");
var $47OeM = parcelRequire("47OeM");
'use client';
function $e6fd8e44c7111210$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $e6fd8e44c7111210$var$useTheme(defaultTheme = null) {
    const contextTheme = $8dE9F.useContext((0, $47OeM.T));
    return !contextTheme || $e6fd8e44c7111210$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $e6fd8e44c7111210$export$2e2bcd8739ae039 = $e6fd8e44c7111210$var$useTheme;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $dzbn0 = parcelRequire("dzbn0");
const $ac3075ed8f266354$var$_excluded = [
    "value"
];
const $ac3075ed8f266354$var$RtlContext = /*#__PURE__*/ $8dE9F.createContext();
function $ac3075ed8f266354$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $1gVUU.default)(_ref, $ac3075ed8f266354$var$_excluded);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($ac3075ed8f266354$var$RtlContext.Provider, (0, $7TrLl.default)({
        value: value != null ? value : true
    }, props));
}
const $ac3075ed8f266354$export$b2dd014b6c321cb = ()=>{
    const value = $8dE9F.useContext($ac3075ed8f266354$var$RtlContext);
    return value != null ? value : false;
};
var $ac3075ed8f266354$export$2e2bcd8739ae039 = $ac3075ed8f266354$var$RtlProvider;



var $70tHe = parcelRequire("70tHe");
parcelRequire("8dE9F");

var $8dE9F = parcelRequire("8dE9F");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $0b33b5af51106e3b$var$useEnhancedEffect = typeof window !== 'undefined' ? $8dE9F.useLayoutEffect : $8dE9F.useEffect;
var $0b33b5af51106e3b$export$2e2bcd8739ae039 = $0b33b5af51106e3b$var$useEnhancedEffect;



var $8dE9F = parcelRequire("8dE9F");
'use client';
let $02833fc3ddd87b8f$var$globalId = 0;
function $02833fc3ddd87b8f$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $8dE9F.useState(idOverride);
    const id = idOverride || defaultId;
    $8dE9F.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $02833fc3ddd87b8f$var$globalId += 1;
            setDefaultId(`mui-${$02833fc3ddd87b8f$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $02833fc3ddd87b8f$var$maybeReactUseId = $8dE9F['useId'.toString()];
function $02833fc3ddd87b8f$export$2e2bcd8739ae039(idOverride) {
    if ($02833fc3ddd87b8f$var$maybeReactUseId !== undefined) {
        const reactId = $02833fc3ddd87b8f$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $02833fc3ddd87b8f$var$useGlobalId(idOverride);
}


parcelRequire("8dE9F");


var $42HDs = parcelRequire("42HDs");
var $gEeCx = parcelRequire("gEeCx");

var $j4wF5 = parcelRequire("j4wF5");

'use client';
const $335979e65c94143f$export$35e57303dbd8a66 = (0, $j4wF5.default)();
function $335979e65c94143f$var$useTheme(defaultTheme = $335979e65c94143f$export$35e57303dbd8a66) {
    return (0, $e6fd8e44c7111210$export$2e2bcd8739ae039)(defaultTheme);
}
var $335979e65c94143f$export$2e2bcd8739ae039 = $335979e65c94143f$var$useTheme;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
function $8919177b6d1ecda5$var$wrapGlobalLayer(styles) {
    const serialized = (0, $gEeCx.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $8919177b6d1ecda5$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $335979e65c94143f$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $8919177b6d1ecda5$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $8919177b6d1ecda5$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $8919177b6d1ecda5$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $42HDs.default), {
        styles: globalStyles
    });
}
var $8919177b6d1ecda5$export$2e2bcd8739ae039 = $8919177b6d1ecda5$var$GlobalStyles;




var $dzbn0 = parcelRequire("dzbn0");
'use client';
function $b5e58b788f9b1ede$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $e6fd8e44c7111210$export$2e2bcd8739ae039)();
    const id = (0, $02833fc3ddd87b8f$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $0b33b5af51106e3b$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $8919177b6d1ecda5$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $64590c74d4b2b749$var$EMPTY_THEME = {};
function $64590c74d4b2b749$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $8dE9F.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $7TrLl.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $7TrLl.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $7TrLl.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $64590c74d4b2b749$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $e6fd8e44c7111210$export$2e2bcd8739ae039)($64590c74d4b2b749$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $5e38ba0319d8228c$export$2e2bcd8739ae039)() || $64590c74d4b2b749$var$EMPTY_THEME;
    const engineTheme = $64590c74d4b2b749$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $64590c74d4b2b749$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $b5e58b788f9b1ede$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $1f0c2527496a512e$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $dzbn0.jsx)((0, $47OeM.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $dzbn0.jsx)((0, $ac3075ed8f266354$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $dzbn0.jsxs)((0, $70tHe.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $64590c74d4b2b749$export$2e2bcd8739ae039 = $64590c74d4b2b749$var$ThemeProvider;



var $aYzJA = parcelRequire("aYzJA");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $d9e6dd7c4d4efd87$var$_excluded = [
    "theme"
];
function $d9e6dd7c4d4efd87$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $1gVUU.default)(_ref, $d9e6dd7c4d4efd87$var$_excluded);
    const scopedTheme = themeInput[0, $aYzJA.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $7TrLl.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $7TrLl.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $64590c74d4b2b749$export$2e2bcd8739ae039), (0, $7TrLl.default)({}, props, {
        themeId: scopedTheme ? (0, $aYzJA.default) : undefined,
        theme: finalTheme
    }));
}



var $aeVxa = parcelRequire("aeVxa");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $lE3rX = parcelRequire("lE3rX");

var $7TrLl = parcelRequire("7TrLl");
parcelRequire("8dE9F");



var $687FO = parcelRequire("687FO");

var $aYzJA = parcelRequire("aYzJA");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
function $533ee5a2e3df2fc8$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $8919177b6d1ecda5$export$2e2bcd8739ae039), (0, $7TrLl.default)({}, props, {
        defaultTheme: (0, $687FO.default),
        themeId: (0, $aYzJA.default)
    }));
}
var $533ee5a2e3df2fc8$export$2e2bcd8739ae039 = $533ee5a2e3df2fc8$var$GlobalStyles;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $468ce5e67b745614$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $7TrLl.default)({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%'
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $468ce5e67b745614$export$32180ef41b15b513 = (theme)=>(0, $7TrLl.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $468ce5e67b745614$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, '')] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $7TrLl.default)({
        html: $468ce5e67b745614$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $7TrLl.default)({
            margin: 0
        }, $468ce5e67b745614$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $468ce5e67b745614$var$CssBaseline(inProps) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($8dE9F.Fragment, {
        children: [
            /*#__PURE__*/ (0, $dzbn0.jsx)((0, $533ee5a2e3df2fc8$export$2e2bcd8739ae039), {
                styles: (theme)=>$468ce5e67b745614$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $468ce5e67b745614$export$2e2bcd8739ae039 = $468ce5e67b745614$var$CssBaseline;




var $8dE9F = parcelRequire("8dE9F");


var $8dE9F = parcelRequire("8dE9F");

var $agf0O = parcelRequire("agf0O");

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $apGt5 = parcelRequire("apGt5");

var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $8DPw0 = parcelRequire("8DPw0");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $738ded848ebbbce7$export$24c1f8f60cbac79e(slot) {
    return (0, $iobM3.default)('MuiTypography', slot);
}
const $738ded848ebbbce7$var$typographyClasses = (0, $5rH1e.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $738ded848ebbbce7$export$2e2bcd8739ae039 = $738ded848ebbbce7$var$typographyClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $9b24571cedf3c6d4$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $9b24571cedf3c6d4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $8DPw0.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $738ded848ebbbce7$export$24c1f8f60cbac79e), classes);
};
const $9b24571cedf3c6d4$export$140e2f5526d3cad8 = (0, $e5aV5.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $8DPw0.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $9b24571cedf3c6d4$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $9b24571cedf3c6d4$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $9b24571cedf3c6d4$var$transformDeprecatedColors = (color)=>{
    return $9b24571cedf3c6d4$var$colorTransformations[color] || color;
};
const $9b24571cedf3c6d4$var$Typography = /*#__PURE__*/ $8dE9F.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $9b24571cedf3c6d4$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $apGt5.default)((0, $7TrLl.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $9b24571cedf3c6d4$var$defaultVariantMapping } = props, other = (0, $1gVUU.default)(props, $9b24571cedf3c6d4$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $9b24571cedf3c6d4$var$defaultVariantMapping[variant]) || 'span';
    const classes = $9b24571cedf3c6d4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($9b24571cedf3c6d4$export$140e2f5526d3cad8, (0, $7TrLl.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $72F5q.default)(classes.root, className)
    }, other));
});
var $9b24571cedf3c6d4$export$2e2bcd8739ae039 = $9b24571cedf3c6d4$var$Typography;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");


var $fgPD6 = parcelRequire("fgPD6");

var $8DPw0 = parcelRequire("8DPw0");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $8dE9F = parcelRequire("8dE9F");

var $8dE9F = parcelRequire("8dE9F");
'use client';
const $7a1a2f950b9f66bc$var$UNINITIALIZED = {};
function $7a1a2f950b9f66bc$export$2e2bcd8739ae039(init, initArg) {
    const ref = $8dE9F.useRef($7a1a2f950b9f66bc$var$UNINITIALIZED);
    if (ref.current === $7a1a2f950b9f66bc$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $8dE9F = parcelRequire("8dE9F");
'use client';
const $742197b2b29bbfbb$var$EMPTY = [];
function $742197b2b29bbfbb$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $8dE9F.useEffect(fn, $742197b2b29bbfbb$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $49b369574eb65270$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $49b369574eb65270$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $49b369574eb65270$export$2e2bcd8739ae039() {
    const timeout = (0, $7a1a2f950b9f66bc$export$2e2bcd8739ae039)($49b369574eb65270$export$786b4da70f00938b.create).current;
    (0, $742197b2b29bbfbb$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $963c42c4f6b9b968$var$hadKeyboardEvent = true;
let $963c42c4f6b9b968$var$hadFocusVisibleRecently = false;
const $963c42c4f6b9b968$var$hadFocusVisibleRecentlyTimeout = new (0, $49b369574eb65270$export$786b4da70f00938b)();
const $963c42c4f6b9b968$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $963c42c4f6b9b968$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $963c42c4f6b9b968$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $963c42c4f6b9b968$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $963c42c4f6b9b968$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $963c42c4f6b9b968$var$handlePointerDown() {
    $963c42c4f6b9b968$var$hadKeyboardEvent = false;
}
function $963c42c4f6b9b968$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($963c42c4f6b9b968$var$hadFocusVisibleRecently) $963c42c4f6b9b968$var$hadKeyboardEvent = true;
    }
}
function $963c42c4f6b9b968$var$prepare(doc) {
    doc.addEventListener('keydown', $963c42c4f6b9b968$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $963c42c4f6b9b968$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $963c42c4f6b9b968$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $963c42c4f6b9b968$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $963c42c4f6b9b968$var$handleVisibilityChange, true);
}
function $963c42c4f6b9b968$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $963c42c4f6b9b968$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $963c42c4f6b9b968$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $963c42c4f6b9b968$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $963c42c4f6b9b968$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $963c42c4f6b9b968$var$handleVisibilityChange, true);
}
function $963c42c4f6b9b968$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $963c42c4f6b9b968$var$hadKeyboardEvent || $963c42c4f6b9b968$var$focusTriggersKeyboardModality(target);
}
function $963c42c4f6b9b968$export$2e2bcd8739ae039() {
    const ref = $8dE9F.useCallback((node)=>{
        if (node != null) $963c42c4f6b9b968$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $8dE9F.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $963c42c4f6b9b968$var$hadFocusVisibleRecently = true;
            $963c42c4f6b9b968$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $963c42c4f6b9b968$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($963c42c4f6b9b968$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $06219ff18c9fb489$export$2e2bcd8739ae039 = (0, $963c42c4f6b9b968$export$2e2bcd8739ae039);



var $8dE9F = parcelRequire("8dE9F");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $dd9f62e582bcda60$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $6a01c40fbbc90587$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $8dE9F.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $dd9f62e582bcda60$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $2b5ed6ec4169216c$export$2e2bcd8739ae039 = (0, $6a01c40fbbc90587$export$2e2bcd8739ae039);




var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $e4dfa97534e58efa$export$d6efab9620b78fec(slot) {
    return (0, $iobM3.default)('MuiLink', slot);
}
const $e4dfa97534e58efa$var$linkClasses = (0, $5rH1e.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $e4dfa97534e58efa$export$2e2bcd8739ae039 = $e4dfa97534e58efa$var$linkClasses;



var $bdcdf = parcelRequire("bdcdf");

var $kTR6J = parcelRequire("kTR6J");
const $7f01b9f99d4cc2f4$export$c4e140d5d351182b = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $7f01b9f99d4cc2f4$var$transformDeprecatedColors = (color)=>{
    return $7f01b9f99d4cc2f4$export$c4e140d5d351182b[color] || color;
};
const $7f01b9f99d4cc2f4$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $7f01b9f99d4cc2f4$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $bdcdf.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $bdcdf.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $kTR6J.alpha)(color, 0.4);
};
var $7f01b9f99d4cc2f4$export$2e2bcd8739ae039 = $7f01b9f99d4cc2f4$var$getTextDecoration;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $6c8eeadba1a98c1a$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $6c8eeadba1a98c1a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $8DPw0.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $e4dfa97534e58efa$export$d6efab9620b78fec), classes);
};
const $6c8eeadba1a98c1a$var$LinkRoot = (0, $e5aV5.default)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $8DPw0.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $7TrLl.default)({}, ownerState.underline === 'none' && {
        textDecoration: 'none'
    }, ownerState.underline === 'hover' && {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }, ownerState.underline === 'always' && (0, $7TrLl.default)({
        textDecoration: 'underline'
    }, ownerState.color !== 'inherit' && {
        textDecorationColor: (0, $7f01b9f99d4cc2f4$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        '&:hover': {
            textDecorationColor: 'inherit'
        }
    }), ownerState.component === 'button' && {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $e4dfa97534e58efa$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: 'auto'
        }
    });
});
const $6c8eeadba1a98c1a$var$Link = /*#__PURE__*/ $8dE9F.forwardRef(function Link(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx } = props, other = (0, $1gVUU.default)(props, $6c8eeadba1a98c1a$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $06219ff18c9fb489$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $8dE9F.useState(false);
    const handlerRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $7TrLl.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $6c8eeadba1a98c1a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($6c8eeadba1a98c1a$var$LinkRoot, (0, $7TrLl.default)({
        color: color,
        className: (0, $72F5q.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $7f01b9f99d4cc2f4$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $6c8eeadba1a98c1a$export$2e2bcd8739ae039 = $6c8eeadba1a98c1a$var$Link;




var $8dE9F = parcelRequire("8dE9F");

var $agf0O = parcelRequire("agf0O");

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $vdlVD = parcelRequire("vdlVD");

var $apGt5 = parcelRequire("apGt5");

var $fgPD6 = parcelRequire("fgPD6");


var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");
parcelRequire("8dE9F");


var $687FO = parcelRequire("687FO");

var $aYzJA = parcelRequire("aYzJA");
'use client';
function $88f720b0aa3cee5b$export$2e2bcd8739ae039() {
    const theme = (0, $335979e65c94143f$export$2e2bcd8739ae039)((0, $687FO.default));
    return theme[0, $aYzJA.default] || theme;
}



var $8dE9F = parcelRequire("8dE9F");
'use client';
/**
 * @ignore - internal component.
 */ const $5d836125badc5fe7$var$GridContext = /*#__PURE__*/ $8dE9F.createContext();
var $5d836125badc5fe7$export$2e2bcd8739ae039 = $5d836125badc5fe7$var$GridContext;



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $860d10ccf8fa6ac6$export$9973ac5fd0181f33(slot) {
    return (0, $iobM3.default)('MuiGrid', slot);
}
const $860d10ccf8fa6ac6$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $860d10ccf8fa6ac6$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $860d10ccf8fa6ac6$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $860d10ccf8fa6ac6$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $860d10ccf8fa6ac6$var$gridClasses = (0, $5rH1e.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$860d10ccf8fa6ac6$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$860d10ccf8fa6ac6$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$860d10ccf8fa6ac6$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$860d10ccf8fa6ac6$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$860d10ccf8fa6ac6$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$860d10ccf8fa6ac6$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$860d10ccf8fa6ac6$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$860d10ccf8fa6ac6$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $860d10ccf8fa6ac6$export$2e2bcd8739ae039 = $860d10ccf8fa6ac6$var$gridClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $6d6c7872fb88c6b4$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $6d6c7872fb88c6b4$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $6d6c7872fb88c6b4$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $vdlVD.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$6d6c7872fb88c6b4$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $7TrLl.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $6d6c7872fb88c6b4$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $vdlVD.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $vdlVD.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $860d10ccf8fa6ac6$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $6d6c7872fb88c6b4$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $6d6c7872fb88c6b4$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $vdlVD.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $6d6c7872fb88c6b4$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $vdlVD.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$6d6c7872fb88c6b4$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $860d10ccf8fa6ac6$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $6d6c7872fb88c6b4$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $860d10ccf8fa6ac6$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $6d6c7872fb88c6b4$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $vdlVD.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $6d6c7872fb88c6b4$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $vdlVD.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$6d6c7872fb88c6b4$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$6d6c7872fb88c6b4$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $860d10ccf8fa6ac6$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $6d6c7872fb88c6b4$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $860d10ccf8fa6ac6$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $6d6c7872fb88c6b4$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $6d6c7872fb88c6b4$var$GridRoot = (0, $e5aV5.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $6d6c7872fb88c6b4$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $7TrLl.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $6d6c7872fb88c6b4$export$71d4225eeb1bc13e, $6d6c7872fb88c6b4$export$380604d7c79f9e8f, $6d6c7872fb88c6b4$export$4315fba5128fb4a1, $6d6c7872fb88c6b4$export$ca2a698f6020fda);
function $6d6c7872fb88c6b4$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $6d6c7872fb88c6b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $6d6c7872fb88c6b4$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $860d10ccf8fa6ac6$export$9973ac5fd0181f33), classes);
};
const $6d6c7872fb88c6b4$var$Grid = /*#__PURE__*/ $8dE9F.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $88f720b0aa3cee5b$export$2e2bcd8739ae039)();
    const props = (0, $apGt5.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $1gVUU.default)(props, $6d6c7872fb88c6b4$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $8dE9F.useContext((0, $5d836125badc5fe7$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $7TrLl.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $7TrLl.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $6d6c7872fb88c6b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $5d836125badc5fe7$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($6d6c7872fb88c6b4$var$GridRoot, (0, $7TrLl.default)({
            ownerState: ownerState,
            className: (0, $72F5q.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $6d6c7872fb88c6b4$export$2e2bcd8739ae039 = $6d6c7872fb88c6b4$var$Grid;



var $8dE9F = parcelRequire("8dE9F");
function $87cdd9a4ef227e74$export$887fcf96538e29f7(callback, threshold = window.innerHeight / 2) {
    (0, $8dE9F.useEffect)(()=>{
        function listener() {
            // The total scroll height of the page, minus the height of the screen.
            const ending = document.body.scrollHeight - window.innerHeight;
            // `window.scrollY` refers to the distance from the top of the page of
            // the upper border of the viewport.
            if (ending - window.scrollY <= threshold) callback();
        }
        window.addEventListener("scroll", listener);
        return ()=>{
            window.removeEventListener("scroll", listener);
        };
    });
}




var $f8iEm = parcelRequire("f8iEm");

var $8dE9F = parcelRequire("8dE9F");


var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");


var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $9c2cae8a64cc8e5d$export$f54c8b0d04b67946(slot) {
    return (0, $iobM3.default)('MuiCardHeader', slot);
}
const $9c2cae8a64cc8e5d$var$cardHeaderClasses = (0, $5rH1e.default)('MuiCardHeader', [
    'root',
    'avatar',
    'action',
    'content',
    'title',
    'subheader'
]);
var $9c2cae8a64cc8e5d$export$2e2bcd8739ae039 = $9c2cae8a64cc8e5d$var$cardHeaderClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $4bc03b18bc47d0d1$var$_excluded = [
    "action",
    "avatar",
    "className",
    "component",
    "disableTypography",
    "subheader",
    "subheaderTypographyProps",
    "title",
    "titleTypographyProps"
];
const $4bc03b18bc47d0d1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ],
        action: [
            'action'
        ],
        content: [
            'content'
        ],
        title: [
            'title'
        ],
        subheader: [
            'subheader'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $9c2cae8a64cc8e5d$export$f54c8b0d04b67946), classes);
};
const $4bc03b18bc47d0d1$var$CardHeaderRoot = (0, $e5aV5.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: (props, styles)=>(0, $7TrLl.default)({
            [`& .${(0, $9c2cae8a64cc8e5d$export$2e2bcd8739ae039).title}`]: styles.title,
            [`& .${(0, $9c2cae8a64cc8e5d$export$2e2bcd8739ae039).subheader}`]: styles.subheader
        }, styles.root)
})({
    display: 'flex',
    alignItems: 'center',
    padding: 16
});
const $4bc03b18bc47d0d1$var$CardHeaderAvatar = (0, $e5aV5.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar',
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
});
const $4bc03b18bc47d0d1$var$CardHeaderAction = (0, $e5aV5.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $4bc03b18bc47d0d1$var$CardHeaderContent = (0, $e5aV5.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})({
    flex: '1 1 auto'
});
const $4bc03b18bc47d0d1$var$CardHeader = /*#__PURE__*/ $8dE9F.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiCardHeader'
    });
    const { action: action, avatar: avatar, className: className, component: component = 'div', disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps } = props, other = (0, $1gVUU.default)(props, $4bc03b18bc47d0d1$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component,
        disableTypography: disableTypography
    });
    const classes = $4bc03b18bc47d0d1$var$useUtilityClasses(ownerState);
    let title = titleProp;
    if (title != null && title.type !== (0, $9b24571cedf3c6d4$export$2e2bcd8739ae039) && !disableTypography) title = /*#__PURE__*/ (0, $dzbn0.jsx)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), (0, $7TrLl.default)({
        variant: avatar ? 'body2' : 'h5',
        className: classes.title,
        component: "span",
        display: "block"
    }, titleTypographyProps, {
        children: title
    }));
    let subheader = subheaderProp;
    if (subheader != null && subheader.type !== (0, $9b24571cedf3c6d4$export$2e2bcd8739ae039) && !disableTypography) subheader = /*#__PURE__*/ (0, $dzbn0.jsx)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), (0, $7TrLl.default)({
        variant: avatar ? 'body2' : 'body1',
        className: classes.subheader,
        color: "text.secondary",
        component: "span",
        display: "block"
    }, subheaderTypographyProps, {
        children: subheader
    }));
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($4bc03b18bc47d0d1$var$CardHeaderRoot, (0, $7TrLl.default)({
        className: (0, $72F5q.default)(classes.root, className),
        as: component,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            avatar && /*#__PURE__*/ (0, $dzbn0.jsx)($4bc03b18bc47d0d1$var$CardHeaderAvatar, {
                className: classes.avatar,
                ownerState: ownerState,
                children: avatar
            }),
            /*#__PURE__*/ (0, $dzbn0.jsxs)($4bc03b18bc47d0d1$var$CardHeaderContent, {
                className: classes.content,
                ownerState: ownerState,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $dzbn0.jsx)($4bc03b18bc47d0d1$var$CardHeaderAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            })
        ]
    }));
});
var $4bc03b18bc47d0d1$export$2e2bcd8739ae039 = $4bc03b18bc47d0d1$var$CardHeader;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");


var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");



var $fgPD6 = parcelRequire("fgPD6");

var $kTR6J = parcelRequire("kTR6J");

var $e5aV5 = parcelRequire("e5aV5");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $0df00e3350c20538$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $0df00e3350c20538$export$2e2bcd8739ae039 = $0df00e3350c20538$var$getOverlayAlpha;



var $lE3rX = parcelRequire("lE3rX");


var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $b7bf9b1eba4fee70$export$29cdb466b9b6f20b(slot) {
    return (0, $iobM3.default)('MuiPaper', slot);
}
const $b7bf9b1eba4fee70$var$paperClasses = (0, $5rH1e.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $b7bf9b1eba4fee70$export$2e2bcd8739ae039 = $b7bf9b1eba4fee70$var$paperClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $d04b0e428813fc1b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $d04b0e428813fc1b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $b7bf9b1eba4fee70$export$29cdb466b9b6f20b), classes);
};
const $d04b0e428813fc1b$var$PaperRoot = (0, $e5aV5.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $7TrLl.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $7TrLl.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $kTR6J.alpha)('#fff', (0, $0df00e3350c20538$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $kTR6J.alpha)('#fff', (0, $0df00e3350c20538$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $d04b0e428813fc1b$var$Paper = /*#__PURE__*/ $8dE9F.forwardRef(function Paper(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $1gVUU.default)(props, $d04b0e428813fc1b$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $d04b0e428813fc1b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($d04b0e428813fc1b$var$PaperRoot, (0, $7TrLl.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $72F5q.default)(classes.root, className),
        ref: ref
    }, other));
});
var $d04b0e428813fc1b$export$2e2bcd8739ae039 = $d04b0e428813fc1b$var$Paper;



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $8dff50ed93b58592$export$f3b76d2cce458caa(slot) {
    return (0, $iobM3.default)('MuiCard', slot);
}
const $8dff50ed93b58592$var$cardClasses = (0, $5rH1e.default)('MuiCard', [
    'root'
]);
var $8dff50ed93b58592$export$2e2bcd8739ae039 = $8dff50ed93b58592$var$cardClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $c5c4f9daaf31609f$var$_excluded = [
    "className",
    "raised"
];
const $c5c4f9daaf31609f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $8dff50ed93b58592$export$f3b76d2cce458caa), classes);
};
const $c5c4f9daaf31609f$var$CardRoot = (0, $e5aV5.default)((0, $d04b0e428813fc1b$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $c5c4f9daaf31609f$var$Card = /*#__PURE__*/ $8dE9F.forwardRef(function Card(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $1gVUU.default)(props, $c5c4f9daaf31609f$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        raised: raised
    });
    const classes = $c5c4f9daaf31609f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($c5c4f9daaf31609f$var$CardRoot, (0, $7TrLl.default)({
        className: (0, $72F5q.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $c5c4f9daaf31609f$export$2e2bcd8739ae039 = $c5c4f9daaf31609f$var$Card;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");

var $72F5q = parcelRequire("72F5q");


var $311cM = parcelRequire("311cM");

var $fgPD6 = parcelRequire("fgPD6");

var $4T6WZ = parcelRequire("4T6WZ");

var $1JswZ = parcelRequire("1JswZ");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $27f3efa2ce541753$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $1JswZ.default)(value, min, max);
}
function $27f3efa2ce541753$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $27f3efa2ce541753$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $27f3efa2ce541753$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $27f3efa2ce541753$export$677b39864803984e($27f3efa2ce541753$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $4T6WZ.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $4T6WZ.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $27f3efa2ce541753$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $27f3efa2ce541753$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $27f3efa2ce541753$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $27f3efa2ce541753$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $27f3efa2ce541753$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $27f3efa2ce541753$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $27f3efa2ce541753$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$27f3efa2ce541753$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $27f3efa2ce541753$export$29fb7152bd3f781a(color) {
    color = $27f3efa2ce541753$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $27f3efa2ce541753$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $27f3efa2ce541753$export$c852d90bf7403b62(color) {
    color = $27f3efa2ce541753$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $27f3efa2ce541753$export$677b39864803984e($27f3efa2ce541753$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $27f3efa2ce541753$export$d061e26956a60b0a(foreground, background) {
    const lumA = $27f3efa2ce541753$export$c852d90bf7403b62(foreground);
    const lumB = $27f3efa2ce541753$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $27f3efa2ce541753$export$58f0f39f63f3cf42(color, value) {
    color = $27f3efa2ce541753$export$677b39864803984e(color);
    value = $27f3efa2ce541753$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $27f3efa2ce541753$export$211a73f2b8c10ce4(color);
}
function $27f3efa2ce541753$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $27f3efa2ce541753$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $27f3efa2ce541753$export$4b073707ff63303(color, coefficient) {
    color = $27f3efa2ce541753$export$677b39864803984e(color);
    coefficient = $27f3efa2ce541753$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $27f3efa2ce541753$export$211a73f2b8c10ce4(color);
}
function $27f3efa2ce541753$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $27f3efa2ce541753$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $27f3efa2ce541753$export$c0816ed86df316af(color, coefficient) {
    color = $27f3efa2ce541753$export$677b39864803984e(color);
    coefficient = $27f3efa2ce541753$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $27f3efa2ce541753$export$211a73f2b8c10ce4(color);
}
function $27f3efa2ce541753$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $27f3efa2ce541753$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $27f3efa2ce541753$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $27f3efa2ce541753$export$c852d90bf7403b62(color) > 0.5 ? $27f3efa2ce541753$export$4b073707ff63303(color, coefficient) : $27f3efa2ce541753$export$c0816ed86df316af(color, coefficient);
}
function $27f3efa2ce541753$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $27f3efa2ce541753$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $27f3efa2ce541753$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $27f3efa2ce541753$export$677b39864803984e(background);
    const overlayColor = $27f3efa2ce541753$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $27f3efa2ce541753$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

function $b19fe008fbdc6dab$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $b19fe008fbdc6dab$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $b19fe008fbdc6dab$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $b19fe008fbdc6dab$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $b19fe008fbdc6dab$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $b19fe008fbdc6dab$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $b19fe008fbdc6dab$export$8af1d214c6c2f0f1(length) * $b19fe008fbdc6dab$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $b19fe008fbdc6dab$export$8af1d214c6c2f0f1(length) * $b19fe008fbdc6dab$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $b19fe008fbdc6dab$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $b19fe008fbdc6dab$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $b19fe008fbdc6dab$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $b19fe008fbdc6dab$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $b19fe008fbdc6dab$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $5ff2103f2ed75c3a$export$c987db9fc844f86(slot) {
    return (0, $iobM3.default)('MuiSkeleton', slot);
}
const $5ff2103f2ed75c3a$var$skeletonClasses = (0, $5rH1e.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $5ff2103f2ed75c3a$export$2e2bcd8739ae039 = $5ff2103f2ed75c3a$var$skeletonClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $2c9c61712604a1ae$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $2c9c61712604a1ae$var$_ = (t)=>t, $2c9c61712604a1ae$var$_t, $2c9c61712604a1ae$var$_t2, $2c9c61712604a1ae$var$_t3, $2c9c61712604a1ae$var$_t4;
const $2c9c61712604a1ae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $5ff2103f2ed75c3a$export$c987db9fc844f86), classes);
};
const $2c9c61712604a1ae$var$pulseKeyframe = (0, $311cM.keyframes)($2c9c61712604a1ae$var$_t || ($2c9c61712604a1ae$var$_t = $2c9c61712604a1ae$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $2c9c61712604a1ae$var$waveKeyframe = (0, $311cM.keyframes)($2c9c61712604a1ae$var$_t2 || ($2c9c61712604a1ae$var$_t2 = $2c9c61712604a1ae$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $2c9c61712604a1ae$var$SkeletonRoot = (0, $e5aV5.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $b19fe008fbdc6dab$export$65f2564e9a9b9222)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $b19fe008fbdc6dab$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $7TrLl.default)({
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $27f3efa2ce541753$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em'
    }, ownerState.variant === 'text' && {
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        transformOrigin: '0 55%',
        transform: 'scale(1, 0.60)',
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        '&:empty:before': {
            content: '"\\00a0"'
        }
    }, ownerState.variant === 'circular' && {
        borderRadius: '50%'
    }, ownerState.variant === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        '& > *': {
            visibility: 'hidden'
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: 'fit-content'
    }, ownerState.hasChildren && !ownerState.height && {
        height: 'auto'
    });
}, ({ ownerState: ownerState })=>ownerState.animation === 'pulse' && (0, $311cM.css)($2c9c61712604a1ae$var$_t3 || ($2c9c61712604a1ae$var$_t3 = $2c9c61712604a1ae$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $2c9c61712604a1ae$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === 'wave' && (0, $311cM.css)($2c9c61712604a1ae$var$_t4 || ($2c9c61712604a1ae$var$_t4 = $2c9c61712604a1ae$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $2c9c61712604a1ae$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $2c9c61712604a1ae$var$Skeleton = /*#__PURE__*/ $8dE9F.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width } = props, other = (0, $1gVUU.default)(props, $2c9c61712604a1ae$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $2c9c61712604a1ae$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($2c9c61712604a1ae$var$SkeletonRoot, (0, $7TrLl.default)({
        as: component,
        ref: ref,
        className: (0, $72F5q.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $7TrLl.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $2c9c61712604a1ae$export$2e2bcd8739ae039 = $2c9c61712604a1ae$var$Skeleton;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $7797c6a70bfcdc55$export$2a5c27c211442e3c(slot) {
    return (0, $iobM3.default)('MuiCardActions', slot);
}
const $7797c6a70bfcdc55$var$cardActionsClasses = (0, $5rH1e.default)('MuiCardActions', [
    'root',
    'spacing'
]);
var $7797c6a70bfcdc55$export$2e2bcd8739ae039 = $7797c6a70bfcdc55$var$cardActionsClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $2b0521d5e364edce$var$_excluded = [
    "disableSpacing",
    "className"
];
const $2b0521d5e364edce$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $7797c6a70bfcdc55$export$2a5c27c211442e3c), classes);
};
const $2b0521d5e364edce$var$CardActionsRoot = (0, $e5aV5.default)('div', {
    name: 'MuiCardActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $7TrLl.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $2b0521d5e364edce$var$CardActions = /*#__PURE__*/ $8dE9F.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActions'
    });
    const { disableSpacing: disableSpacing = false, className: className } = props, other = (0, $1gVUU.default)(props, $2b0521d5e364edce$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $2b0521d5e364edce$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($2b0521d5e364edce$var$CardActionsRoot, (0, $7TrLl.default)({
        className: (0, $72F5q.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $2b0521d5e364edce$export$2e2bcd8739ae039 = $2b0521d5e364edce$var$CardActions;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $6974e08b8df5ba5a$export$964336739a8c7119(slot) {
    return (0, $iobM3.default)('MuiCardContent', slot);
}
const $6974e08b8df5ba5a$var$cardContentClasses = (0, $5rH1e.default)('MuiCardContent', [
    'root'
]);
var $6974e08b8df5ba5a$export$2e2bcd8739ae039 = $6974e08b8df5ba5a$var$cardContentClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $1e8366f3baede695$var$_excluded = [
    "className",
    "component"
];
const $1e8366f3baede695$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $6974e08b8df5ba5a$export$964336739a8c7119), classes);
};
const $1e8366f3baede695$var$CardContentRoot = (0, $e5aV5.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    };
});
const $1e8366f3baede695$var$CardContent = /*#__PURE__*/ $8dE9F.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $1gVUU.default)(props, $1e8366f3baede695$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component
    });
    const classes = $1e8366f3baede695$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($1e8366f3baede695$var$CardContentRoot, (0, $7TrLl.default)({
        as: component,
        className: (0, $72F5q.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $1e8366f3baede695$export$2e2bcd8739ae039 = $1e8366f3baede695$var$CardContent;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");


var $fgPD6 = parcelRequire("fgPD6");

var $kTR6J = parcelRequire("kTR6J");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");



var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");


var $8dE9F = parcelRequire("8dE9F");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $086d9802984ea6c0$var$useEventCallback(fn) {
    const ref = $8dE9F.useRef(fn);
    (0, $0b33b5af51106e3b$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $8dE9F.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $086d9802984ea6c0$export$2e2bcd8739ae039 = $086d9802984ea6c0$var$useEventCallback;


'use client';
var $135c0cabe3c25245$export$2e2bcd8739ae039 = (0, $086d9802984ea6c0$export$2e2bcd8739ae039);




var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");
function $1d1fa2e0f8d36349$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $4d4ef1a026ba9a56$export$2e2bcd8739ae039(t, e) {
    return $4d4ef1a026ba9a56$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $4d4ef1a026ba9a56$export$2e2bcd8739ae039(t, e);
}


function $9da59868f8a94fbb$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $4d4ef1a026ba9a56$export$2e2bcd8739ae039)(t, o);
}




var $8dE9F = parcelRequire("8dE9F");

var $8dE9F = parcelRequire("8dE9F");
var $7263592ccd560a13$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).createContext(null);



var $8dE9F = parcelRequire("8dE9F");
function $750a35f04449a745$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $8dE9F.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $8dE9F.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $750a35f04449a745$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $750a35f04449a745$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $750a35f04449a745$export$fa71e2345c31d7a2(props, onExited) {
    return $750a35f04449a745$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $8dE9F.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $750a35f04449a745$var$getProp(child, 'appear', props),
            enter: $750a35f04449a745$var$getProp(child, 'enter', props),
            exit: $750a35f04449a745$var$getProp(child, 'exit', props)
        });
    });
}
function $750a35f04449a745$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $750a35f04449a745$export$bbc8a025727ea824(nextProps.children);
    var children = $750a35f04449a745$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $8dE9F.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $8dE9F.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $8dE9F.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $750a35f04449a745$var$getProp(child, 'exit', nextProps),
            enter: $750a35f04449a745$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $8dE9F.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $8dE9F.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $8dE9F.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $750a35f04449a745$var$getProp(child, 'exit', nextProps),
            enter: $750a35f04449a745$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $a0725fc18a9c44fa$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $a0725fc18a9c44fa$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $a0725fc18a9c44fa$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $9da59868f8a94fbb$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $1d1fa2e0f8d36349$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $750a35f04449a745$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $750a35f04449a745$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $750a35f04449a745$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $7TrLl.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1gVUU.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $a0725fc18a9c44fa$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).createElement((0, $7263592ccd560a13$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).createElement((0, $7263592ccd560a13$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).Component);
$a0725fc18a9c44fa$var$TransitionGroup.propTypes = {};
$a0725fc18a9c44fa$var$TransitionGroup.defaultProps = $a0725fc18a9c44fa$var$defaultProps;
var $a0725fc18a9c44fa$export$2e2bcd8739ae039 = $a0725fc18a9c44fa$var$TransitionGroup;



var $72F5q = parcelRequire("72F5q");

var $311cM = parcelRequire("311cM");


var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
function $50eaaad077eb5ef2$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $8dE9F.useState(false);
    const rippleClassName = (0, $72F5q.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $72F5q.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $8dE9F.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $dzbn0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $dzbn0.jsx)("span", {
            className: childClassName
        })
    });
}
var $50eaaad077eb5ef2$export$2e2bcd8739ae039 = $50eaaad077eb5ef2$var$Ripple;



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $e217a19f0bb610ca$export$b464606f735ab902(slot) {
    return (0, $iobM3.default)('MuiTouchRipple', slot);
}
const $e217a19f0bb610ca$var$touchRippleClasses = (0, $5rH1e.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $e217a19f0bb610ca$export$2e2bcd8739ae039 = $e217a19f0bb610ca$var$touchRippleClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $2a0f687b9278ecad$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $2a0f687b9278ecad$var$_ = (t)=>t, $2a0f687b9278ecad$var$_t, $2a0f687b9278ecad$var$_t2, $2a0f687b9278ecad$var$_t3, $2a0f687b9278ecad$var$_t4;
const $2a0f687b9278ecad$var$DURATION = 550;
const $2a0f687b9278ecad$export$95d0c9356b2231a3 = 80;
const $2a0f687b9278ecad$var$enterKeyframe = (0, $311cM.keyframes)($2a0f687b9278ecad$var$_t || ($2a0f687b9278ecad$var$_t = $2a0f687b9278ecad$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $2a0f687b9278ecad$var$exitKeyframe = (0, $311cM.keyframes)($2a0f687b9278ecad$var$_t2 || ($2a0f687b9278ecad$var$_t2 = $2a0f687b9278ecad$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $2a0f687b9278ecad$var$pulsateKeyframe = (0, $311cM.keyframes)($2a0f687b9278ecad$var$_t3 || ($2a0f687b9278ecad$var$_t3 = $2a0f687b9278ecad$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $2a0f687b9278ecad$export$f6b7418508c72c25 = (0, $e5aV5.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $2a0f687b9278ecad$export$676cfe7b12693c4b = (0, $e5aV5.default)((0, $50eaaad077eb5ef2$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($2a0f687b9278ecad$var$_t4 || ($2a0f687b9278ecad$var$_t4 = $2a0f687b9278ecad$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $e217a19f0bb610ca$export$2e2bcd8739ae039).rippleVisible, $2a0f687b9278ecad$var$enterKeyframe, $2a0f687b9278ecad$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $e217a19f0bb610ca$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $e217a19f0bb610ca$export$2e2bcd8739ae039).child, (0, $e217a19f0bb610ca$export$2e2bcd8739ae039).childLeaving, $2a0f687b9278ecad$var$exitKeyframe, $2a0f687b9278ecad$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $e217a19f0bb610ca$export$2e2bcd8739ae039).childPulsate, $2a0f687b9278ecad$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $2a0f687b9278ecad$var$TouchRipple = /*#__PURE__*/ $8dE9F.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $1gVUU.default)(props, $2a0f687b9278ecad$var$_excluded);
    const [ripples, setRipples] = $8dE9F.useState([]);
    const nextKey = $8dE9F.useRef(0);
    const rippleCallback = $8dE9F.useRef(null);
    $8dE9F.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $8dE9F.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $49b369574eb65270$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $8dE9F.useRef(null);
    const container = $8dE9F.useRef(null);
    const startCommit = $8dE9F.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $dzbn0.jsx)($2a0f687b9278ecad$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $72F5q.default)(classes.ripple, (0, $e217a19f0bb610ca$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $72F5q.default)(classes.rippleVisible, (0, $e217a19f0bb610ca$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $72F5q.default)(classes.ripplePulsate, (0, $e217a19f0bb610ca$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $72F5q.default)(classes.child, (0, $e217a19f0bb610ca$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $72F5q.default)(classes.childLeaving, (0, $e217a19f0bb610ca$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $72F5q.default)(classes.childPulsate, (0, $e217a19f0bb610ca$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $2a0f687b9278ecad$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $8dE9F.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($2a0f687b9278ecad$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $8dE9F.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $8dE9F.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $8dE9F.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($2a0f687b9278ecad$export$f6b7418508c72c25, (0, $7TrLl.default)({
        className: (0, $72F5q.default)((0, $e217a19f0bb610ca$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $dzbn0.jsx)((0, $a0725fc18a9c44fa$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $2a0f687b9278ecad$export$2e2bcd8739ae039 = $2a0f687b9278ecad$var$TouchRipple;



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $228fd26bc82b4697$export$fccb0498dcd99783(slot) {
    return (0, $iobM3.default)('MuiButtonBase', slot);
}
const $228fd26bc82b4697$var$buttonBaseClasses = (0, $5rH1e.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $228fd26bc82b4697$export$2e2bcd8739ae039 = $228fd26bc82b4697$var$buttonBaseClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $66635f5fba848ee5$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $66635f5fba848ee5$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $fgPD6.default)(slots, (0, $228fd26bc82b4697$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $66635f5fba848ee5$export$7ec0dcc5e3cdcd36 = (0, $e5aV5.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $228fd26bc82b4697$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $66635f5fba848ee5$var$ButtonBase = /*#__PURE__*/ $8dE9F.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $1gVUU.default)(props, $66635f5fba848ee5$var$_excluded);
    const buttonRef = $8dE9F.useRef(null);
    const rippleRef = $8dE9F.useRef(null);
    const handleRippleRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $06219ff18c9fb489$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $8dE9F.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $8dE9F.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $8dE9F.useState(false);
    $8dE9F.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $8dE9F.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $135c0cabe3c25245$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $135c0cabe3c25245$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $8dE9F.useRef(false);
    const handleKeyDown = (0, $135c0cabe3c25245$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $135c0cabe3c25245$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $7TrLl.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $66635f5fba848ee5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($66635f5fba848ee5$export$7ec0dcc5e3cdcd36, (0, $7TrLl.default)({
        as: ComponentProp,
        className: (0, $72F5q.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $dzbn0.jsx)((0, $2a0f687b9278ecad$export$2e2bcd8739ae039), (0, $7TrLl.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $66635f5fba848ee5$export$2e2bcd8739ae039 = $66635f5fba848ee5$var$ButtonBase;



var $8DPw0 = parcelRequire("8DPw0");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $00858880954e79e4$export$5e8702d71474f093(slot) {
    return (0, $iobM3.default)('MuiIconButton', slot);
}
const $00858880954e79e4$var$iconButtonClasses = (0, $5rH1e.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $00858880954e79e4$export$2e2bcd8739ae039 = $00858880954e79e4$var$iconButtonClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $bc55b9c9c616a23b$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $bc55b9c9c616a23b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $8DPw0.default)(color)}`,
            edge && `edge${(0, $8DPw0.default)(edge)}`,
            `size${(0, $8DPw0.default)(size)}`
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $00858880954e79e4$export$5e8702d71474f093), classes);
};
const $bc55b9c9c616a23b$var$IconButtonRoot = (0, $e5aV5.default)((0, $66635f5fba848ee5$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $8DPw0.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $8DPw0.default)(ownerState.edge)}`],
            styles[`size${(0, $8DPw0.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTR6J.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $7TrLl.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $7TrLl.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $7TrLl.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTR6J.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $00858880954e79e4$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $bc55b9c9c616a23b$var$IconButton = /*#__PURE__*/ $8dE9F.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $1gVUU.default)(props, $bc55b9c9c616a23b$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $bc55b9c9c616a23b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($bc55b9c9c616a23b$var$IconButtonRoot, (0, $7TrLl.default)({
        className: (0, $72F5q.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $bc55b9c9c616a23b$export$2e2bcd8739ae039 = $bc55b9c9c616a23b$var$IconButton;


function $25c3986dfc17a41c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $25c3986dfc17a41c$export$1f3d6ca653b5063d = /*#__PURE__*/ (0, $8dE9F.memo)(function SkeletonEmojiRow() {
    const SkeletonEmojiRowContainer = /*#__PURE__*/ (0, $f8iEm.default)("div", {
        target: "elpd5ss0"
    })({
        name: "4pivy7",
        styles: "display:grid;grid-template-columns:repeat(7, 1fr);margin:0 0.3rem;gap:0.6rem 0.3rem;justify-items:center"
    });
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)(SkeletonEmojiRowContainer, {
        children: Array.from({
            length: 7
        }, (_, index)=>/*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                variant: "circular",
                width: 32,
                height: 32
            }, index))
    });
});
const $25c3986dfc17a41c$var$SkeletonGuild = /*#__PURE__*/ (0, $8dE9F.memo)(function SkeletonGuild() {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6d6c7872fb88c6b4$export$2e2bcd8739ae039), {
        item: true,
        xs: 12,
        sm: 6,
        md: 4,
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $c5c4f9daaf31609f$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $4bc03b18bc47d0d1$export$2e2bcd8739ae039), {
                    avatar: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                        variant: "circular",
                        width: 40,
                        height: 40
                    }),
                    title: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                        height: 22,
                        width: "80%"
                    }),
                    action: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $bc55b9c9c616a23b$export$2e2bcd8739ae039), {
                        disabled: true,
                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                            variant: "circular",
                            width: 24,
                            height: 24
                        })
                    })
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $1e8366f3baede695$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($25c3986dfc17a41c$export$1f3d6ca653b5063d, {})
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2b0521d5e364edce$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                        height: 31,
                        width: "25%"
                    })
                })
            ]
        })
    });
});
var $25c3986dfc17a41c$export$2e2bcd8739ae039 = $25c3986dfc17a41c$var$SkeletonGuild;




var $f8iEm = parcelRequire("f8iEm");

var $8dE9F = parcelRequire("8dE9F");

var $agf0O = parcelRequire("agf0O");


var $agf0O = parcelRequire("agf0O");

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");
parcelRequire("8dE9F");

var $58054 = parcelRequire("58054");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
var $afcc16424b54d1bf$export$2e2bcd8739ae039 = (0, $58054.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $fd5594265b6d8ec6$export$ffd560f22c0ecf04(slot) {
    return (0, $iobM3.default)('MuiAvatar', slot);
}
const $fd5594265b6d8ec6$var$avatarClasses = (0, $5rH1e.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $fd5594265b6d8ec6$export$2e2bcd8739ae039 = $fd5594265b6d8ec6$var$avatarClasses;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");


var $7TrLl = parcelRequire("7TrLl");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $8a867bdc54f45d1c$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $8a867bdc54f45d1c$export$2e2bcd8739ae039 = $8a867bdc54f45d1c$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $15f5a4201997a338$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $8a867bdc54f45d1c$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $7TrLl.default)({}, otherProps, {
        ownerState: (0, $7TrLl.default)({}, otherProps.ownerState, ownerState)
    });
}
var $15f5a4201997a338$export$2e2bcd8739ae039 = $15f5a4201997a338$var$appendOwnerState;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $4429dadbb603dba7$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $4429dadbb603dba7$export$2e2bcd8739ae039 = $4429dadbb603dba7$var$resolveComponentProps;



var $7TrLl = parcelRequire("7TrLl");

var $72F5q = parcelRequire("72F5q");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $569062248ada2576$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $569062248ada2576$export$2e2bcd8739ae039 = $569062248ada2576$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $1c027848f5977e88$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $1c027848f5977e88$export$2e2bcd8739ae039 = $1c027848f5977e88$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $70bd352c98092697$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $72F5q.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $7TrLl.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $7TrLl.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $569062248ada2576$export$2e2bcd8739ae039)((0, $7TrLl.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $1c027848f5977e88$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $1c027848f5977e88$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $72F5q.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $7TrLl.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $7TrLl.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $70bd352c98092697$export$2e2bcd8739ae039 = $70bd352c98092697$var$mergeSlotProps;


'use client';
const $2405878f1c8488b6$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $2405878f1c8488b6$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $2405878f1c8488b6$var$_excluded3 = [
    "component"
];
function $2405878f1c8488b6$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $1gVUU.default)(parameters, $2405878f1c8488b6$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $1gVUU.default)(externalForwardedProps, $2405878f1c8488b6$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $4429dadbb603dba7$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $70bd352c98092697$export$2e2bcd8739ae039)((0, $7TrLl.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $1gVUU.default)(_mergeSlotProps.props, $2405878f1c8488b6$var$_excluded3);
    const ref = (0, $6a01c40fbbc90587$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $7TrLl.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $15f5a4201997a338$export$2e2bcd8739ae039)(elementType, (0, $7TrLl.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $aab3ebb6ea9060fa$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $aab3ebb6ea9060fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $fd5594265b6d8ec6$export$ffd560f22c0ecf04), classes);
};
const $aab3ebb6ea9060fa$var$AvatarRoot = (0, $e5aV5.default)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $7TrLl.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $7TrLl.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles('dark', {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $aab3ebb6ea9060fa$var$AvatarImg = (0, $e5aV5.default)('img', {
    name: 'MuiAvatar',
    slot: 'Img',
    overridesResolver: (props, styles)=>styles.img
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $aab3ebb6ea9060fa$var$AvatarFallback = (0, $e5aV5.default)((0, $afcc16424b54d1bf$export$2e2bcd8739ae039), {
    name: 'MuiAvatar',
    slot: 'Fallback',
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: '75%',
    height: '75%'
});
function $aab3ebb6ea9060fa$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $8dE9F.useState(false);
    $8dE9F.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $aab3ebb6ea9060fa$var$Avatar = /*#__PURE__*/ $8dE9F.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular' } = props, other = (0, $1gVUU.default)(props, $aab3ebb6ea9060fa$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $aab3ebb6ea9060fa$var$useLoaded((0, $7TrLl.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    const ownerState = (0, $7TrLl.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $aab3ebb6ea9060fa$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $2405878f1c8488b6$export$2e2bcd8739ae039)('img', {
        className: classes.img,
        elementType: $aab3ebb6ea9060fa$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: (0, $7TrLl.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $dzbn0.jsx)(ImgSlot, (0, $7TrLl.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $dzbn0.jsx)($aab3ebb6ea9060fa$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $dzbn0.jsx)($aab3ebb6ea9060fa$var$AvatarRoot, (0, $7TrLl.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $72F5q.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $aab3ebb6ea9060fa$export$2e2bcd8739ae039 = $aab3ebb6ea9060fa$var$Avatar;


var $1304614f3a2f3730$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($1304614f3a2f3730$exports, "__esModule", {
    value: true
});
$1304614f3a2f3730$exports.default = void 0;

var $1304614f3a2f3730$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $1304614f3a2f3730$var$_default = $1304614f3a2f3730$exports.default = (0, $1304614f3a2f3730$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');



var $2cTIV = parcelRequire("2cTIV");
var $2e39f08f68e94a83$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($2e39f08f68e94a83$exports, "__esModule", {
    value: true
});
$2e39f08f68e94a83$exports.default = void 0;

var $2e39f08f68e94a83$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $2e39f08f68e94a83$var$_default = $2e39f08f68e94a83$exports.default = (0, $2e39f08f68e94a83$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');



var $hhoTf = parcelRequire("hhoTf");
var $6868445c157ddfb4$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($6868445c157ddfb4$exports, "__esModule", {
    value: true
});
$6868445c157ddfb4$exports.default = void 0;

var $6868445c157ddfb4$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $6868445c157ddfb4$var$_default = $6868445c157ddfb4$exports.default = (0, $6868445c157ddfb4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "m14.06 9.02.92.92L5.92 19H5v-.92zM17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z"
}), 'EditOutlined');



var $9cLRw = parcelRequire("9cLRw");
var $dff16c6c3ca234ae$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($dff16c6c3ca234ae$exports, "__esModule", {
    value: true
});
$dff16c6c3ca234ae$exports.default = void 0;

var $dff16c6c3ca234ae$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $dff16c6c3ca234ae$var$_default = $dff16c6c3ca234ae$exports.default = (0, $dff16c6c3ca234ae$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3m13.71-9.37-1.34-1.34a.9959.9959 0 0 0-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41"
}), 'Brush');



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");



var $fgPD6 = parcelRequire("fgPD6");

var $kTR6J = parcelRequire("kTR6J");



var $8dE9F = parcelRequire("8dE9F");
function $4c7d3b0e8ad54c21$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($8dE9F.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}



var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $8DPw0 = parcelRequire("8DPw0");

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");





var $1gVUU = parcelRequire("1gVUU");



var $8dE9F = parcelRequire("8dE9F");

var $efecfac8b5731e5d$export$2e2bcd8739ae039 = {
    disabled: false
};




var $c5501725b6c38d8f$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $6e41a3c5e4c6a6e2$export$bb38bb9a1161268 = 'unmounted';
var $6e41a3c5e4c6a6e2$export$84cbff306f539230 = 'exited';
var $6e41a3c5e4c6a6e2$export$df38205c966be359 = 'entering';
var $6e41a3c5e4c6a6e2$export$78e9e6e3e014d60a = 'entered';
var $6e41a3c5e4c6a6e2$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $6e41a3c5e4c6a6e2$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $9da59868f8a94fbb$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $6e41a3c5e4c6a6e2$export$84cbff306f539230;
                _this.appearStatus = $6e41a3c5e4c6a6e2$export$df38205c966be359;
            } else initialStatus = $6e41a3c5e4c6a6e2$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $6e41a3c5e4c6a6e2$export$bb38bb9a1161268;
        else initialStatus = $6e41a3c5e4c6a6e2$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $6e41a3c5e4c6a6e2$export$bb38bb9a1161268) return {
            status: $6e41a3c5e4c6a6e2$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $6e41a3c5e4c6a6e2$export$df38205c966be359 && status !== $6e41a3c5e4c6a6e2$export$78e9e6e3e014d60a) nextStatus = $6e41a3c5e4c6a6e2$export$df38205c966be359;
            } else if (status === $6e41a3c5e4c6a6e2$export$df38205c966be359 || status === $6e41a3c5e4c6a6e2$export$78e9e6e3e014d60a) nextStatus = $6e41a3c5e4c6a6e2$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $6e41a3c5e4c6a6e2$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($f22ac357d192a259$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $c5501725b6c38d8f$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $6e41a3c5e4c6a6e2$export$84cbff306f539230) this.setState({
            status: $6e41a3c5e4c6a6e2$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($f22ac357d192a259$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $efecfac8b5731e5d$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $6e41a3c5e4c6a6e2$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $6e41a3c5e4c6a6e2$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $6e41a3c5e4c6a6e2$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($f22ac357d192a259$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $efecfac8b5731e5d$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $6e41a3c5e4c6a6e2$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $6e41a3c5e4c6a6e2$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $6e41a3c5e4c6a6e2$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($f22ac357d192a259$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $6e41a3c5e4c6a6e2$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1gVUU.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).createElement((0, $7263592ccd560a13$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).Component);
$6e41a3c5e4c6a6e2$var$Transition.contextType = (0, $7263592ccd560a13$export$2e2bcd8739ae039);
$6e41a3c5e4c6a6e2$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $6e41a3c5e4c6a6e2$var$noop() {}
$6e41a3c5e4c6a6e2$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $6e41a3c5e4c6a6e2$var$noop,
    onEntering: $6e41a3c5e4c6a6e2$var$noop,
    onEntered: $6e41a3c5e4c6a6e2$var$noop,
    onExit: $6e41a3c5e4c6a6e2$var$noop,
    onExiting: $6e41a3c5e4c6a6e2$var$noop,
    onExited: $6e41a3c5e4c6a6e2$var$noop
};
$6e41a3c5e4c6a6e2$var$Transition.UNMOUNTED = $6e41a3c5e4c6a6e2$export$bb38bb9a1161268;
$6e41a3c5e4c6a6e2$var$Transition.EXITED = $6e41a3c5e4c6a6e2$export$84cbff306f539230;
$6e41a3c5e4c6a6e2$var$Transition.ENTERING = $6e41a3c5e4c6a6e2$export$df38205c966be359;
$6e41a3c5e4c6a6e2$var$Transition.ENTERED = $6e41a3c5e4c6a6e2$export$78e9e6e3e014d60a;
$6e41a3c5e4c6a6e2$var$Transition.EXITING = $6e41a3c5e4c6a6e2$export$4aacc83d4d59139f;
var $6e41a3c5e4c6a6e2$export$2e2bcd8739ae039 = $6e41a3c5e4c6a6e2$var$Transition;



const $51002b2756b6e7b3$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $51002b2756b6e7b3$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $8e28753d4354f9ab$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $8e28753d4354f9ab$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $8e28753d4354f9ab$var$styles = {
    entering: {
        opacity: 1,
        transform: $8e28753d4354f9ab$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $8e28753d4354f9ab$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $8e28753d4354f9ab$var$Grow = /*#__PURE__*/ $8dE9F.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $6e41a3c5e4c6a6e2$export$2e2bcd8739ae039) } = props, other = (0, $1gVUU.default)(props, $8e28753d4354f9ab$var$_excluded);
    const timer = (0, $49b369574eb65270$export$2e2bcd8739ae039)();
    const autoTimeout = $8dE9F.useRef();
    const theme = (0, $88f720b0aa3cee5b$export$2e2bcd8739ae039)();
    const nodeRef = $8dE9F.useRef(null);
    const handleRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(nodeRef, (0, $4c7d3b0e8ad54c21$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $51002b2756b6e7b3$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $51002b2756b6e7b3$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $8e28753d4354f9ab$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $51002b2756b6e7b3$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $8e28753d4354f9ab$var$isWebKit154 ? duration : duration * 0.666,
                delay: $8e28753d4354f9ab$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $8e28753d4354f9ab$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $dzbn0.jsx)(TransitionComponent, (0, $7TrLl.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $8dE9F.cloneElement(children, (0, $7TrLl.default)({
                style: (0, $7TrLl.default)({
                    opacity: 0,
                    transform: $8e28753d4354f9ab$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $8e28753d4354f9ab$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$8e28753d4354f9ab$var$Grow.muiSupportAuto = true;
var $8e28753d4354f9ab$export$2e2bcd8739ae039 = $8e28753d4354f9ab$var$Grow;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");
var $81de0f40f091d664$exports = {};
"use strict";
'use client';
Object.defineProperty($81de0f40f091d664$exports, "__esModule", {
    value: true
});
$81de0f40f091d664$exports.default = void 0;

var $81de0f40f091d664$var$React = $81de0f40f091d664$var$_interopRequireWildcard((parcelRequire("8dE9F")));
parcelRequire("311cM");
var $47OeM = parcelRequire("47OeM");
function $81de0f40f091d664$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($81de0f40f091d664$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $81de0f40f091d664$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $81de0f40f091d664$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $81de0f40f091d664$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $81de0f40f091d664$var$useTheme(defaultTheme = null) {
    const contextTheme = $81de0f40f091d664$var$React.useContext($47OeM.T);
    return !contextTheme || $81de0f40f091d664$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $81de0f40f091d664$var$_default = $81de0f40f091d664$exports.default = $81de0f40f091d664$var$useTheme;






var $8dE9F = parcelRequire("8dE9F");

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");
function $12c8925c44da80e4$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $6ebd6b45acae37eb$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $34b353ddbeea96bc$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $34b353ddbeea96bc$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $34b353ddbeea96bc$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $a0b0d65acd6e6535$export$8960430cfd85939f = Math.max;
var $a0b0d65acd6e6535$export$96ec731ed4dcb222 = Math.min;
var $a0b0d65acd6e6535$export$2077e0241d6afd3c = Math.round;



function $c21819d1905af7c2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $eea660cf28a92304$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $c21819d1905af7c2$export$2e2bcd8739ae039)());
}


function $a8648680ef76da9f$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $a0b0d65acd6e6535$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $a0b0d65acd6e6535$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $34b353ddbeea96bc$export$45a5e7f76e0caa8d)(element) ? (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $eea660cf28a92304$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $62a26e61dc7a7d5e$export$2e2bcd8739ae039(node) {
    var win = (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $f928793e6f12a3ed$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $56c2baaf44777010$export$2e2bcd8739ae039(node) {
    if (node === (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(node) || !(0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(node)) return (0, $62a26e61dc7a7d5e$export$2e2bcd8739ae039)(node);
    else return (0, $f928793e6f12a3ed$export$2e2bcd8739ae039)(node);
}


function $2407cae52a3a06c1$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $4937437c2b26d9e5$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $34b353ddbeea96bc$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $0a3d931274c28caf$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $a8648680ef76da9f$export$2e2bcd8739ae039)((0, $4937437c2b26d9e5$export$2e2bcd8739ae039)(element)).left + (0, $62a26e61dc7a7d5e$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $0caa6b08169cb77d$export$2e2bcd8739ae039(element) {
    return (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $5c6199c9c42f8500$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $0caa6b08169cb77d$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $be78df43dd94f974$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $a0b0d65acd6e6535$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $a0b0d65acd6e6535$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $be78df43dd94f974$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(offsetParent) && $be78df43dd94f974$var$isElementScaled(offsetParent);
    var documentElement = (0, $4937437c2b26d9e5$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $a8648680ef76da9f$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $2407cae52a3a06c1$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $5c6199c9c42f8500$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $56c2baaf44777010$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $a8648680ef76da9f$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $0a3d931274c28caf$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $47acdff6f41193ca$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $a8648680ef76da9f$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $3af83a02b1f14628$export$2e2bcd8739ae039(element) {
    if ((0, $2407cae52a3a06c1$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $34b353ddbeea96bc$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $4937437c2b26d9e5$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $df3d9c75ddc23860$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $2407cae52a3a06c1$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(node) && (0, $5c6199c9c42f8500$export$2e2bcd8739ae039)(node)) return node;
    return $df3d9c75ddc23860$export$2e2bcd8739ae039((0, $3af83a02b1f14628$export$2e2bcd8739ae039)(node));
}





function $97098eb0df0d0546$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $df3d9c75ddc23860$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $5c6199c9c42f8500$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($97098eb0df0d0546$export$2e2bcd8739ae039((0, $3af83a02b1f14628$export$2e2bcd8739ae039)(target)));
}







function $ec44dbc5f024d7cf$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $2407cae52a3a06c1$export$2e2bcd8739ae039)(element)) >= 0;
}




function $c57678596a7690f3$var$getTrueOffsetParent(element) {
    if (!(0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $0caa6b08169cb77d$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $c57678596a7690f3$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $c21819d1905af7c2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $c21819d1905af7c2$export$2e2bcd8739ae039)());
    if (isIE && (0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $0caa6b08169cb77d$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $3af83a02b1f14628$export$2e2bcd8739ae039)(element);
    if ((0, $34b353ddbeea96bc$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $2407cae52a3a06c1$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $0caa6b08169cb77d$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $c57678596a7690f3$export$2e2bcd8739ae039(element) {
    var window = (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(element);
    var offsetParent = $c57678596a7690f3$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $ec44dbc5f024d7cf$export$2e2bcd8739ae039)(offsetParent) && (0, $0caa6b08169cb77d$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $c57678596a7690f3$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $2407cae52a3a06c1$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $2407cae52a3a06c1$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $0caa6b08169cb77d$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $c57678596a7690f3$var$getContainingBlock(element) || window;
}


var $ec09cb85641e43d1$export$1e95b668f3b82d = 'top';
var $ec09cb85641e43d1$export$40e543e69a8b3fbb = 'bottom';
var $ec09cb85641e43d1$export$79ffe56a765070d2 = 'right';
var $ec09cb85641e43d1$export$eabcd2c8791e7bf4 = 'left';
var $ec09cb85641e43d1$export$dfb5619354ba860 = 'auto';
var $ec09cb85641e43d1$export$aec2ce47c367b8c3 = [
    $ec09cb85641e43d1$export$1e95b668f3b82d,
    $ec09cb85641e43d1$export$40e543e69a8b3fbb,
    $ec09cb85641e43d1$export$79ffe56a765070d2,
    $ec09cb85641e43d1$export$eabcd2c8791e7bf4
];
var $ec09cb85641e43d1$export$b3571188c770cc5a = 'start';
var $ec09cb85641e43d1$export$bd5df0f255a350f8 = 'end';
var $ec09cb85641e43d1$export$390fd549c5303b4d = 'clippingParents';
var $ec09cb85641e43d1$export$d7b7311ec04a3e8f = 'viewport';
var $ec09cb85641e43d1$export$ae5ab1c730825774 = 'popper';
var $ec09cb85641e43d1$export$ca50aac9f3ba507f = 'reference';
var $ec09cb85641e43d1$export$368f9a87e87fa4e1 = /*#__PURE__*/ $ec09cb85641e43d1$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $ec09cb85641e43d1$export$b3571188c770cc5a,
        placement + "-" + $ec09cb85641e43d1$export$bd5df0f255a350f8
    ]);
}, []);
var $ec09cb85641e43d1$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($ec09cb85641e43d1$export$aec2ce47c367b8c3, [
    $ec09cb85641e43d1$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $ec09cb85641e43d1$export$b3571188c770cc5a,
        placement + "-" + $ec09cb85641e43d1$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $ec09cb85641e43d1$export$421679a7c3d56e = 'beforeRead';
var $ec09cb85641e43d1$export$aafa59e2e03f2942 = 'read';
var $ec09cb85641e43d1$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $ec09cb85641e43d1$export$c65e99957a05207c = 'beforeMain';
var $ec09cb85641e43d1$export$f22da7240b7add18 = 'main';
var $ec09cb85641e43d1$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $ec09cb85641e43d1$export$8d4d2d70e7d46032 = 'beforeWrite';
var $ec09cb85641e43d1$export$68d8715fc104d294 = 'write';
var $ec09cb85641e43d1$export$70a6e5159acce2e6 = 'afterWrite';
var $ec09cb85641e43d1$export$d087d3878fdf71d5 = [
    $ec09cb85641e43d1$export$421679a7c3d56e,
    $ec09cb85641e43d1$export$aafa59e2e03f2942,
    $ec09cb85641e43d1$export$6964f6c886723980,
    $ec09cb85641e43d1$export$c65e99957a05207c,
    $ec09cb85641e43d1$export$f22da7240b7add18,
    $ec09cb85641e43d1$export$bab79516f2d662fe,
    $ec09cb85641e43d1$export$8d4d2d70e7d46032,
    $ec09cb85641e43d1$export$68d8715fc104d294,
    $ec09cb85641e43d1$export$70a6e5159acce2e6
];


function $8a9cb1680e7b0ef9$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $8a9cb1680e7b0ef9$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $8a9cb1680e7b0ef9$var$order(modifiers); // order based on phase
    return (0, $ec09cb85641e43d1$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $4d3bcc224ee33ec6$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $33b6e4f1ce808883$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $e99adebae737fbd6$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $e99adebae737fbd6$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $e99adebae737fbd6$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $e99adebae737fbd6$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $e99adebae737fbd6$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $34b353ddbeea96bc$export$45a5e7f76e0caa8d)(reference) ? (0, $97098eb0df0d0546$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $97098eb0df0d0546$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $97098eb0df0d0546$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $8a9cb1680e7b0ef9$export$2e2bcd8739ae039)((0, $33b6e4f1ce808883$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$e99adebae737fbd6$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $be78df43dd94f974$export$2e2bcd8739ae039)(reference, (0, $c57678596a7690f3$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $47acdff6f41193ca$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4d3bcc224ee33ec6$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$e99adebae737fbd6$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $e99adebae737fbd6$export$8f7491d57c8f97a9 = /*#__PURE__*/ $e99adebae737fbd6$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $0458fe584184719b$var$passive = {
    passive: true
};
function $0458fe584184719b$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $0458fe584184719b$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $0458fe584184719b$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $0458fe584184719b$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $0458fe584184719b$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $0458fe584184719b$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $0458fe584184719b$var$effect,
    data: {}
};



function $3f658478d2bace55$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $221d62d9766aa4e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $e9fb3cb95af970e8$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $a6e3726b16d3a266$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3f658478d2bace55$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $221d62d9766aa4e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $ec09cb85641e43d1$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $ec09cb85641e43d1$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $ec09cb85641e43d1$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $e9fb3cb95af970e8$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $ec09cb85641e43d1$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $ec09cb85641e43d1$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $845d4a211d05604e$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $a6e3726b16d3a266$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $845d4a211d05604e$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $845d4a211d05604e$var$popperOffsets,
    data: {}
};










var $76b8f3b64f9a6440$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $76b8f3b64f9a6440$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $a0b0d65acd6e6535$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $a0b0d65acd6e6535$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $76b8f3b64f9a6440$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4);
    var sideY = (0, $ec09cb85641e43d1$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $c57678596a7690f3$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $4937437c2b26d9e5$export$2e2bcd8739ae039)(popper);
            if ((0, $0caa6b08169cb77d$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $ec09cb85641e43d1$export$1e95b668f3b82d) || (placement === (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4) || placement === (0, $ec09cb85641e43d1$export$79ffe56a765070d2)) && variation === (0, $ec09cb85641e43d1$export$bd5df0f255a350f8)) {
            sideY = (0, $ec09cb85641e43d1$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4) || (placement === (0, $ec09cb85641e43d1$export$1e95b668f3b82d) || placement === (0, $ec09cb85641e43d1$export$40e543e69a8b3fbb)) && variation === (0, $ec09cb85641e43d1$export$bd5df0f255a350f8)) {
            sideX = (0, $ec09cb85641e43d1$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $76b8f3b64f9a6440$var$unsetSides);
    var _ref4 = roundOffsets === true ? $76b8f3b64f9a6440$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $76b8f3b64f9a6440$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3f658478d2bace55$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $221d62d9766aa4e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $76b8f3b64f9a6440$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $76b8f3b64f9a6440$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $76b8f3b64f9a6440$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $76b8f3b64f9a6440$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $2838b0dbc2858876$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(element) || !(0, $2407cae52a3a06c1$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $2838b0dbc2858876$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(element) || !(0, $2407cae52a3a06c1$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $2838b0dbc2858876$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $2838b0dbc2858876$var$applyStyles,
    effect: $2838b0dbc2858876$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $5aca567be304e26f$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3f658478d2bace55$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4),
        (0, $ec09cb85641e43d1$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4),
        (0, $ec09cb85641e43d1$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $5aca567be304e26f$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $ec09cb85641e43d1$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $5aca567be304e26f$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $5aca567be304e26f$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $5aca567be304e26f$var$offset
};


var $097ddc7b4c73e2e6$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $097ddc7b4c73e2e6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $097ddc7b4c73e2e6$var$hash[matched];
    });
}



var $843eaec0f12157c9$var$hash = {
    start: 'end',
    end: 'start'
};
function $843eaec0f12157c9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $843eaec0f12157c9$var$hash[matched];
    });
}







function $9be1196c53ab20ad$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6ebd6b45acae37eb$export$2e2bcd8739ae039)(element);
    var html = (0, $4937437c2b26d9e5$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $eea660cf28a92304$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $0a3d931274c28caf$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $efa7bdee4d8a8753$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $4937437c2b26d9e5$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $62a26e61dc7a7d5e$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $a0b0d65acd6e6535$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $a0b0d65acd6e6535$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $0a3d931274c28caf$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $0caa6b08169cb77d$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $a0b0d65acd6e6535$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $f4c194c3ac410c7a$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $34b353ddbeea96bc$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $f7bc985aa1557f30$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $2276f6acdb31973c$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $a8648680ef76da9f$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $2276f6acdb31973c$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $ec09cb85641e43d1$export$d7b7311ec04a3e8f) ? (0, $f7bc985aa1557f30$export$2e2bcd8739ae039)((0, $9be1196c53ab20ad$export$2e2bcd8739ae039)(element, strategy)) : (0, $34b353ddbeea96bc$export$45a5e7f76e0caa8d)(clippingParent) ? $2276f6acdb31973c$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $f7bc985aa1557f30$export$2e2bcd8739ae039)((0, $efa7bdee4d8a8753$export$2e2bcd8739ae039)((0, $4937437c2b26d9e5$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $2276f6acdb31973c$var$getClippingParents(element) {
    var clippingParents = (0, $97098eb0df0d0546$export$2e2bcd8739ae039)((0, $3af83a02b1f14628$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $0caa6b08169cb77d$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $34b353ddbeea96bc$export$1b3bfaa9684536aa)(element) ? (0, $c57678596a7690f3$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $34b353ddbeea96bc$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $34b353ddbeea96bc$export$45a5e7f76e0caa8d)(clippingParent) && (0, $f4c194c3ac410c7a$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $2407cae52a3a06c1$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $2276f6acdb31973c$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $2276f6acdb31973c$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $2276f6acdb31973c$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $a0b0d65acd6e6535$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $a0b0d65acd6e6535$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $a0b0d65acd6e6535$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $a0b0d65acd6e6535$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $2276f6acdb31973c$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $e1213167ecd58b43$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $03fbbdba1b70527d$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $e1213167ecd58b43$export$2e2bcd8739ae039)(), paddingObject);
}


function $e25c16dd73478f23$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $86414bb7361472c6$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $ec09cb85641e43d1$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $ec09cb85641e43d1$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $ec09cb85641e43d1$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $03fbbdba1b70527d$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e25c16dd73478f23$export$2e2bcd8739ae039)(padding, (0, $ec09cb85641e43d1$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $ec09cb85641e43d1$export$ae5ab1c730825774) ? (0, $ec09cb85641e43d1$export$ca50aac9f3ba507f) : (0, $ec09cb85641e43d1$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $2276f6acdb31973c$export$2e2bcd8739ae039)((0, $34b353ddbeea96bc$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $4937437c2b26d9e5$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $a8648680ef76da9f$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $a6e3726b16d3a266$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $f7bc985aa1557f30$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $ec09cb85641e43d1$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $ec09cb85641e43d1$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $ec09cb85641e43d1$export$79ffe56a765070d2),
                (0, $ec09cb85641e43d1$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $ec09cb85641e43d1$export$1e95b668f3b82d),
                (0, $ec09cb85641e43d1$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $c45bf12279c9a7fc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $ec09cb85641e43d1$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $221d62d9766aa4e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $ec09cb85641e43d1$export$368f9a87e87fa4e1) : (0, $ec09cb85641e43d1$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $221d62d9766aa4e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $ec09cb85641e43d1$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $86414bb7361472c6$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3f658478d2bace55$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $c30ec680ab2b3d8d$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3f658478d2bace55$export$2e2bcd8739ae039)(placement) === (0, $ec09cb85641e43d1$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $097ddc7b4c73e2e6$export$2e2bcd8739ae039)(placement);
    return [
        (0, $843eaec0f12157c9$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $843eaec0f12157c9$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $c30ec680ab2b3d8d$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3f658478d2bace55$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $097ddc7b4c73e2e6$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $c30ec680ab2b3d8d$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3f658478d2bace55$export$2e2bcd8739ae039)(placement) === (0, $ec09cb85641e43d1$export$dfb5619354ba860) ? (0, $c45bf12279c9a7fc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3f658478d2bace55$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $221d62d9766aa4e3$export$2e2bcd8739ae039)(placement) === (0, $ec09cb85641e43d1$export$b3571188c770cc5a);
        var isVertical = [
            (0, $ec09cb85641e43d1$export$1e95b668f3b82d),
            (0, $ec09cb85641e43d1$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $86414bb7361472c6$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $ec09cb85641e43d1$export$79ffe56a765070d2) : (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $ec09cb85641e43d1$export$40e543e69a8b3fbb) : (0, $ec09cb85641e43d1$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $097ddc7b4c73e2e6$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $097ddc7b4c73e2e6$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $c30ec680ab2b3d8d$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $c30ec680ab2b3d8d$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $185ccd0e5be6439f$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $6fe85b59045bd980$export$f28d906d67a997f3(min, value, max) {
    return (0, $a0b0d65acd6e6535$export$8960430cfd85939f)(min, (0, $a0b0d65acd6e6535$export$96ec731ed4dcb222)(value, max));
}
function $6fe85b59045bd980$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $6fe85b59045bd980$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $d614e3daee4e7122$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $86414bb7361472c6$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3f658478d2bace55$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $221d62d9766aa4e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $e9fb3cb95af970e8$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $185ccd0e5be6439f$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $ec09cb85641e43d1$export$1e95b668f3b82d) : (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $ec09cb85641e43d1$export$40e543e69a8b3fbb) : (0, $ec09cb85641e43d1$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $ec09cb85641e43d1$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $ec09cb85641e43d1$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $47acdff6f41193ca$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $e1213167ecd58b43$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $6fe85b59045bd980$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $c57678596a7690f3$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $6fe85b59045bd980$export$f28d906d67a997f3)(tether ? (0, $a0b0d65acd6e6535$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $a0b0d65acd6e6535$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $ec09cb85641e43d1$export$1e95b668f3b82d) : (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $ec09cb85641e43d1$export$40e543e69a8b3fbb) : (0, $ec09cb85641e43d1$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $ec09cb85641e43d1$export$1e95b668f3b82d),
            (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $6fe85b59045bd980$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $6fe85b59045bd980$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d614e3daee4e7122$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $d614e3daee4e7122$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $3f67d3ab9bd15310$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $03fbbdba1b70527d$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e25c16dd73478f23$export$2e2bcd8739ae039)(padding, (0, $ec09cb85641e43d1$export$aec2ce47c367b8c3)));
};
function $3f67d3ab9bd15310$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3f658478d2bace55$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $e9fb3cb95af970e8$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4),
        (0, $ec09cb85641e43d1$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $3f67d3ab9bd15310$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $47acdff6f41193ca$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $ec09cb85641e43d1$export$1e95b668f3b82d) : (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $ec09cb85641e43d1$export$40e543e69a8b3fbb) : (0, $ec09cb85641e43d1$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $c57678596a7690f3$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $6fe85b59045bd980$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $3f67d3ab9bd15310$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $f4c194c3ac410c7a$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $3f67d3ab9bd15310$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $3f67d3ab9bd15310$var$arrow,
    effect: $3f67d3ab9bd15310$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $b7f3c0505754fdff$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $b7f3c0505754fdff$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $ec09cb85641e43d1$export$1e95b668f3b82d),
        (0, $ec09cb85641e43d1$export$79ffe56a765070d2),
        (0, $ec09cb85641e43d1$export$40e543e69a8b3fbb),
        (0, $ec09cb85641e43d1$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $b7f3c0505754fdff$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $86414bb7361472c6$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $86414bb7361472c6$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $b7f3c0505754fdff$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $b7f3c0505754fdff$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $b7f3c0505754fdff$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $b7f3c0505754fdff$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $b7f3c0505754fdff$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $b7f3c0505754fdff$var$hide
};




var $d57c3ca937e005fc$export$d34966752335dd47 = [
    (0, $0458fe584184719b$export$2e2bcd8739ae039),
    (0, $845d4a211d05604e$export$2e2bcd8739ae039),
    (0, $76b8f3b64f9a6440$export$2e2bcd8739ae039),
    (0, $2838b0dbc2858876$export$2e2bcd8739ae039),
    (0, $5aca567be304e26f$export$2e2bcd8739ae039),
    (0, $c30ec680ab2b3d8d$export$2e2bcd8739ae039),
    (0, $d614e3daee4e7122$export$2e2bcd8739ae039),
    (0, $3f67d3ab9bd15310$export$2e2bcd8739ae039),
    (0, $b7f3c0505754fdff$export$2e2bcd8739ae039)
];
var $d57c3ca937e005fc$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $e99adebae737fbd6$export$ed5e13716264f202)({
    defaultModifiers: $d57c3ca937e005fc$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $fgPD6 = parcelRequire("fgPD6");

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");




'use client';
const $0d839d5f574f1d1c$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $0d839d5f574f1d1c$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $1gVUU.default)(parameters, $0d839d5f574f1d1c$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $4429dadbb603dba7$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $70bd352c98092697$export$2e2bcd8739ae039)((0, $7TrLl.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $6a01c40fbbc90587$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $15f5a4201997a338$export$2e2bcd8739ae039)(elementType, (0, $7TrLl.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $0d839d5f574f1d1c$export$2e2bcd8739ae039 = $0d839d5f574f1d1c$var$useSlotProps;



var $8dE9F = parcelRequire("8dE9F");




var $dzbn0 = parcelRequire("dzbn0");
'use client';
function $2ef375666a6c21bf$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $2ef375666a6c21bf$var$Portal = /*#__PURE__*/ $8dE9F.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $8dE9F.useState(null);
    const handleRef = (0, $6a01c40fbbc90587$export$2e2bcd8739ae039)(/*#__PURE__*/ $8dE9F.isValidElement(children) ? (0, $4c7d3b0e8ad54c21$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $0b33b5af51106e3b$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($2ef375666a6c21bf$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $0b33b5af51106e3b$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $dd9f62e582bcda60$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $dd9f62e582bcda60$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $8dE9F.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $8dE9F.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $dzbn0.jsx)($8dE9F.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $dzbn0.jsx)($8dE9F.Fragment, {
        children: mountNode ? /*#__PURE__*/ $f22ac357d192a259$exports.createPortal(children, mountNode) : mountNode
    });
});
var $2ef375666a6c21bf$export$2e2bcd8739ae039 = $2ef375666a6c21bf$var$Portal;



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $91bf4bcb9b1db7e3$export$1b69b6cd0fa638a1(slot) {
    return (0, $iobM3.default)('MuiPopper', slot);
}
const $91bf4bcb9b1db7e3$var$popperClasses = (0, $5rH1e.default)('MuiPopper', [
    'root'
]);
var $91bf4bcb9b1db7e3$export$2e2bcd8739ae039 = $91bf4bcb9b1db7e3$var$popperClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $406c9aece5397520$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $406c9aece5397520$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $406c9aece5397520$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $406c9aece5397520$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $406c9aece5397520$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $406c9aece5397520$var$isVirtualElement(element) {
    return !$406c9aece5397520$var$isHTMLElement(element);
}
const $406c9aece5397520$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $91bf4bcb9b1db7e3$export$1b69b6cd0fa638a1), classes);
};
const $406c9aece5397520$var$defaultPopperOptions = {};
const $406c9aece5397520$var$PopperTooltip = /*#__PURE__*/ $8dE9F.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $1gVUU.default)(props, $406c9aece5397520$var$_excluded);
    const tooltipRef = $8dE9F.useRef(null);
    const ownRef = (0, $6a01c40fbbc90587$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $8dE9F.useRef(null);
    const handlePopperRef = (0, $6a01c40fbbc90587$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $8dE9F.useRef(handlePopperRef);
    (0, $0b33b5af51106e3b$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $8dE9F.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $406c9aece5397520$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $8dE9F.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $8dE9F.useState($406c9aece5397520$var$resolveAnchorEl(anchorEl));
    $8dE9F.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $8dE9F.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($406c9aece5397520$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $0b33b5af51106e3b$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $d57c3ca937e005fc$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $7TrLl.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $406c9aece5397520$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $0d839d5f574f1d1c$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $dzbn0.jsx)(Root, (0, $7TrLl.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $406c9aece5397520$var$Popper = /*#__PURE__*/ $8dE9F.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $406c9aece5397520$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $1gVUU.default)(props, $406c9aece5397520$var$_excluded2);
    const [exited, setExited] = $8dE9F.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $406c9aece5397520$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $406c9aece5397520$var$isHTMLElement(resolvedAnchorEl) ? (0, $12c8925c44da80e4$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $12c8925c44da80e4$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $2ef375666a6c21bf$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($406c9aece5397520$var$PopperTooltip, (0, $7TrLl.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $7TrLl.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $406c9aece5397520$export$2e2bcd8739ae039 = $406c9aece5397520$var$Popper;



var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $49c033e91183662e$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $49c033e91183662e$var$PopperRoot = (0, $e5aV5.default)((0, $406c9aece5397520$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $49c033e91183662e$var$Popper = /*#__PURE__*/ $8dE9F.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($81de0f40f091d664$exports)))();
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $1gVUU.default)(props, $49c033e91183662e$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $7TrLl.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($49c033e91183662e$var$PopperRoot, (0, $7TrLl.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $49c033e91183662e$export$2e2bcd8739ae039 = $49c033e91183662e$var$Popper;





'use client';
var $62f8ae4be57878ff$export$2e2bcd8739ae039 = (0, $02833fc3ddd87b8f$export$2e2bcd8739ae039);




var $8dE9F = parcelRequire("8dE9F");
'use client';
function $f9e439188be57646$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $8dE9F.useRef(controlled !== undefined);
    const [valueState, setValue] = $8dE9F.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $8dE9F.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $c26a14c4024304e6$export$2e2bcd8739ae039 = (0, $f9e439188be57646$export$2e2bcd8739ae039);



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $d5db4b05edf4ced8$export$837848f5f6cee923(slot) {
    return (0, $iobM3.default)('MuiTooltip', slot);
}
const $d5db4b05edf4ced8$var$tooltipClasses = (0, $5rH1e.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $d5db4b05edf4ced8$export$2e2bcd8739ae039 = $d5db4b05edf4ced8$var$tooltipClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $95ab773eed618108$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $95ab773eed618108$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $95ab773eed618108$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $8DPw0.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $d5db4b05edf4ced8$export$837848f5f6cee923), classes);
};
const $95ab773eed618108$var$TooltipPopper = (0, $e5aV5.default)((0, $49c033e91183662e$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $7TrLl.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $d5db4b05edf4ced8$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $d5db4b05edf4ced8$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $d5db4b05edf4ced8$export$2e2bcd8739ae039).arrow}`]: (0, $7TrLl.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $d5db4b05edf4ced8$export$2e2bcd8739ae039).arrow}`]: (0, $7TrLl.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $95ab773eed618108$var$TooltipTooltip = (0, $e5aV5.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $8DPw0.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kTR6J.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$95ab773eed618108$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $d5db4b05edf4ced8$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $7TrLl.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $7TrLl.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $7TrLl.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $d5db4b05edf4ced8$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $7TrLl.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $7TrLl.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $7TrLl.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $d5db4b05edf4ced8$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $7TrLl.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $d5db4b05edf4ced8$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $7TrLl.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $95ab773eed618108$var$TooltipArrow = (0, $e5aV5.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kTR6J.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $95ab773eed618108$var$hystersisOpen = false;
const $95ab773eed618108$var$hystersisTimer = new (0, $49b369574eb65270$export$786b4da70f00938b)();
let $95ab773eed618108$var$cursorPosition = {
    x: 0,
    y: 0
};
function $95ab773eed618108$export$b9ee5a7ace0541f8() {
    $95ab773eed618108$var$hystersisOpen = false;
    $95ab773eed618108$var$hystersisTimer.clear();
}
function $95ab773eed618108$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $95ab773eed618108$var$Tooltip = /*#__PURE__*/ $8dE9F.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $8e28753d4354f9ab$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $1gVUU.default)(props, $95ab773eed618108$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $8dE9F.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $dzbn0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $88f720b0aa3cee5b$export$2e2bcd8739ae039)();
    const isRtl = (0, $ac3075ed8f266354$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $8dE9F.useState();
    const [arrowRef, setArrowRef] = $8dE9F.useState(null);
    const ignoreNonTouchEvents = $8dE9F.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $49b369574eb65270$export$2e2bcd8739ae039)();
    const enterTimer = (0, $49b369574eb65270$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $49b369574eb65270$export$2e2bcd8739ae039)();
    const touchTimer = (0, $49b369574eb65270$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $c26a14c4024304e6$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $62f8ae4be57878ff$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $8dE9F.useRef();
    const stopTouchInteraction = (0, $135c0cabe3c25245$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $8dE9F.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $95ab773eed618108$var$hystersisTimer.clear();
        $95ab773eed618108$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $135c0cabe3c25245$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $95ab773eed618108$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $95ab773eed618108$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $95ab773eed618108$var$hystersisOpen && enterNextDelay) enterTimer.start($95ab773eed618108$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $06219ff18c9fb489$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $8dE9F.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $8dE9F.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)((0, $4c7d3b0e8ad54c21$export$2e2bcd8739ae039)(children), focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $8dE9F.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $95ab773eed618108$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $7TrLl.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $72F5q.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $95ab773eed618108$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $95ab773eed618108$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $95ab773eed618108$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $95ab773eed618108$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $8dE9F.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $7TrLl.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $7TrLl.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $95ab773eed618108$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $95ab773eed618108$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $8e28753d4354f9ab$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $95ab773eed618108$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $95ab773eed618108$var$TooltipArrow;
    const popperProps = (0, $15f5a4201997a338$export$2e2bcd8739ae039)(PopperComponent, (0, $7TrLl.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $72F5q.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $15f5a4201997a338$export$2e2bcd8739ae039)(TransitionComponent, (0, $7TrLl.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $15f5a4201997a338$export$2e2bcd8739ae039)(TooltipComponent, (0, $7TrLl.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $72F5q.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $15f5a4201997a338$export$2e2bcd8739ae039)(ArrowComponent, (0, $7TrLl.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $72F5q.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($8dE9F.Fragment, {
        children: [
            /*#__PURE__*/ $8dE9F.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $dzbn0.jsx)(PopperComponent, (0, $7TrLl.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $49c033e91183662e$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $95ab773eed618108$var$cursorPosition.y,
                            left: $95ab773eed618108$var$cursorPosition.x,
                            right: $95ab773eed618108$var$cursorPosition.x,
                            bottom: $95ab773eed618108$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $dzbn0.jsx)(TransitionComponent, (0, $7TrLl.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $dzbn0.jsxs)(TooltipComponent, (0, $7TrLl.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $dzbn0.jsx)(ArrowComponent, (0, $7TrLl.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $95ab773eed618108$export$2e2bcd8739ae039 = $95ab773eed618108$var$Tooltip;


function $7e88e947352f534a$export$ae00754399a30376(props) {
    const { name: name, src: src } = props;
    const { id: id, icon: icon } = src;
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
        title: name,
        arrow: true,
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $aab3ebb6ea9060fa$export$2e2bcd8739ae039), {
            alt: name,
            src: `https://cdn.discordapp.com/icons/${id}/${icon}.webp?size=64`
        })
    });
}
$7e88e947352f534a$export$ae00754399a30376.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string.isRequired,
    src: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object.isRequired
};
const $7e88e947352f534a$var$changelogAvatarStyle = {
    verticalAlign: "middle"
};
function $7e88e947352f534a$export$28f4ed0fbb491ba9() {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1304614f3a2f3730$exports))), {
        fontSize: "large",
        css: [
            {
                color: (0, $2cTIV.default)[500]
            },
            $7e88e947352f534a$var$changelogAvatarStyle,
            "",
            ""
        ]
    });
}
function $7e88e947352f534a$export$709605cc0aa8b94d() {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2e39f08f68e94a83$exports))), {
        fontSize: "large",
        css: [
            {
                color: (0, $hhoTf.default)[500]
            },
            $7e88e947352f534a$var$changelogAvatarStyle,
            "",
            ""
        ]
    });
}
function $7e88e947352f534a$export$f0ebbad5a430052f() {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6868445c157ddfb4$exports))), {
        fontSize: "large",
        css: [
            {
                color: (0, $9cLRw.default)[500]
            },
            $7e88e947352f534a$var$changelogAvatarStyle,
            "",
            ""
        ]
    });
}
function $7e88e947352f534a$export$6d2ba9a7d1a1164b() {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($dff16c6c3ca234ae$exports))), {
        fontSize: "large",
        css: [
            {
                color: (0, $9cLRw.default)[500]
            },
            $7e88e947352f534a$var$changelogAvatarStyle,
            "",
            ""
        ]
    });
}


function $46ae9d0281ece1ca$export$bef1f36f5486a6a3(...info) {
    console.log("%c[blobs.gg]%c", "color: lightgreen; font-weight: bold", "color: inherit; font-weight: inherit", ...info);
}
function $46ae9d0281ece1ca$export$c106dd0671a0fc2d(...info) {
    console.log("%c[blobs.gg]%c", "color: red; font-weight: bold", "color: inherit; font-weight: inherit", ...info);
}
function $46ae9d0281ece1ca$export$7ac3a88d34a76e7(source) {
    // Copy the source array.
    let array = [
        ...source
    ];
    let length = array.length;
    let index;
    // While there remain elements to shuffle…
    while(length){
        // Pick a remaining element…
        index = Math.floor(Math.random() * length--);
        // And swap it with the current element.
        [array[length], array[index]] = [
            array[index],
            array[length]
        ];
    }
    return array;
}
function $46ae9d0281ece1ca$export$348afa8c9ff47183(sourceString) {
    return sourceString[0].toUpperCase() + sourceString.slice(1).toLowerCase();
}
const $46ae9d0281ece1ca$var$hour12Format = {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "numeric"
};
const $46ae9d0281ece1ca$export$3245e15bf4cbdd6c = new Intl.DateTimeFormat("en-US", $46ae9d0281ece1ca$var$hour12Format);
const $46ae9d0281ece1ca$export$48340dcdf262189 = new Intl.DateTimeFormat("en-US", Object.assign($46ae9d0281ece1ca$var$hour12Format, {
    hour12: false
}));
function $46ae9d0281ece1ca$export$e9c7d7ddfc1ce9b2() {
    const date = new Intl.DateTimeFormat("default", {
        hour: "numeric",
        minute: "numeric"
    }).resolvedOptions();
    return date.hour12;
}
function $46ae9d0281ece1ca$export$3f1985e3ee38d114(type) {
    let storage;
    try {
        storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" || // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}
function $46ae9d0281ece1ca$export$644a9299e733daa1(data) {
    let count = 0;
    // Using nested `for` loops here instead of `Array.prototype.reduce` for
    // the sake of readability.
    for (const guilds of Object.values(data))for (const guild of Object.values(guilds))count += guild.emoji.length;
    return count;
}
function $46ae9d0281ece1ca$export$23814f3b7812d940(count) {
    return new Intl.NumberFormat().format(count);
}
function $46ae9d0281ece1ca$export$4151c234cb00b329(inputArray, chunkSize = 6) {
    return inputArray.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / chunkSize);
        if (!resultArray[chunkIndex]) resultArray[chunkIndex] = []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
function $46ae9d0281ece1ca$export$d913c0256eaa9b04(key, value) {
    const trans = {
        1: true,
        2: false,
        3: "automated"
    };
    // If I can use LS then use it
    if ($46ae9d0281ece1ca$export$3f1985e3ee38d114("localStorage")) {
        const keyCheck = localStorage.getItem(key);
        // If it is automated
        if (keyCheck === "3") return [
            value,
            false
        ];
        else if (Object.keys(trans).includes(keyCheck)) // Return the fetched value as something useful
        return [
            trans[keyCheck],
            true
        ];
        // If key not in DB
        $46ae9d0281ece1ca$export$c106dd0671a0fc2d(`Setting key for ${key}`);
        if ($46ae9d0281ece1ca$export$3f1985e3ee38d114("localStorage")) localStorage.setItem(key, "3");
        return [
            value,
            false
        ];
    }
    // Can't use LS, have whatever I'm given
    return [
        value,
        false
    ];
}
function $46ae9d0281ece1ca$export$8b2e40e2dbb7b3f1() {
    return $46ae9d0281ece1ca$export$d913c0256eaa9b04("prefers12Hour", $46ae9d0281ece1ca$export$e9c7d7ddfc1ce9b2())[0];
}
function $46ae9d0281ece1ca$export$22d2985352acd646() {
    if ($46ae9d0281ece1ca$export$8b2e40e2dbb7b3f1()) return $46ae9d0281ece1ca$export$3245e15bf4cbdd6c;
    return $46ae9d0281ece1ca$export$48340dcdf262189;
}
function $46ae9d0281ece1ca$export$dda5fc2d183b5cbd(min, max) {
    return [
        ...Array(max - min + 1).keys()
    ].map((i)=>i + min);
}





var $616e5a9b4d3469e1$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($616e5a9b4d3469e1$exports, "__esModule", {
    value: true
});
$616e5a9b4d3469e1$exports.default = void 0;

var $616e5a9b4d3469e1$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $616e5a9b4d3469e1$var$_default = $616e5a9b4d3469e1$exports.default = (0, $616e5a9b4d3469e1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDown');





var $311cM = parcelRequire("311cM");

var $8dE9F = parcelRequire("8dE9F");

var $agf0O = parcelRequire("agf0O");



function $7f50bfc76ce34f6e$var$emojiUrl(id, animated, size) {
    const sizeParam = size == null ? "" : `&size=${size}`;
    return `https://cdn.discordapp.com/emojis/${id}.webp?animated=${animated}${sizeParam}`;
}
const $7f50bfc76ce34f6e$var$ConditionalLink = /*#__PURE__*/ (0, $8dE9F.forwardRef)(function ConditionalLink(props, ref) {
    return props.link ? props.wrapper(props.children, ref) : props.children;
});
$7f50bfc76ce34f6e$var$ConditionalLink.propTypes = {
    link: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).node.isRequired,
    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).any.isRequired
};
function $7f50bfc76ce34f6e$var$Emoji(props) {
    const { id: id, animated: animated, name: name, guild: guild, baseSize: baseSize, showGuild: showGuild, invite: invite, externalContainerStyle: externalContainerStyle, enlarge: enlarge, disableTooltip: disableTooltip } = props;
    let alt = `:${name}:`;
    if (guild != null && showGuild) alt += ` (${guild.name})`;
    const srcSet = `
    ${$7f50bfc76ce34f6e$var$emojiUrl(id, animated, baseSize)},
    ${$7f50bfc76ce34f6e$var$emojiUrl(id, animated, baseSize * 2)} 2x
  `;
    function wrapper(children) {
        return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6c8eeadba1a98c1a$export$2e2bcd8739ae039), {
            href: guild.invite,
            target: "_blank",
            rel: "noopener",
            children: children
        });
    }
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("div", {
        css: [
            "display:inline-block;vertical-align:middle;",
            invite && {
                margin: "1rem"
            },
            externalContainerStyle,
            "",
            ""
        ],
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($7f50bfc76ce34f6e$var$ConditionalLink, {
            link: invite,
            wrapper: wrapper,
            children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                title: disableTooltip ? "" : alt,
                arrow: true,
                children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $aab3ebb6ea9060fa$export$2e2bcd8739ae039), {
                    alt: name,
                    css: (0, $311cM.css)({
                        width: enlarge ? 64 : 32,
                        height: enlarge ? 64 : 32,
                        img: {
                            objectFit: "contain"
                        }
                    }, "", ""),
                    srcSet: srcSet,
                    src: $7f50bfc76ce34f6e$var$emojiUrl(id, animated, baseSize),
                    variant: "square"
                })
            })
        })
    });
}
$7f50bfc76ce34f6e$var$Emoji.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string.isRequired,
    animated: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string.isRequired,
    guild: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object,
    baseSize: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).number,
    showGuild: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool,
    invite: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool,
    externalContainerStyle: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object,
    enlarge: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool,
    disableTooltip: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool
};
$7f50bfc76ce34f6e$var$Emoji.defaultProps = {
    invite: false,
    baseSize: 64,
    showGuild: false,
    enlarge: false,
    disableTooltip: false
};
var $7f50bfc76ce34f6e$export$2e2bcd8739ae039 = $7f50bfc76ce34f6e$var$Emoji;





var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $i1zjM = parcelRequire("i1zjM");

var $fgPD6 = parcelRequire("fgPD6");

var $kTR6J = parcelRequire("kTR6J");

var $e5aV5 = parcelRequire("e5aV5");
var $6xVVB = parcelRequire("6xVVB");

var $lE3rX = parcelRequire("lE3rX");


var $8DPw0 = parcelRequire("8DPw0");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $f89a81806def1454$export$5a6f9035944c8119(slot) {
    return (0, $iobM3.default)('MuiButton', slot);
}
const $f89a81806def1454$var$buttonClasses = (0, $5rH1e.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $f89a81806def1454$export$2e2bcd8739ae039 = $f89a81806def1454$var$buttonClasses;



var $8dE9F = parcelRequire("8dE9F");
/**
 * @ignore - internal component.
 */ const $e18da3b8c8c2faf2$var$ButtonGroupContext = /*#__PURE__*/ $8dE9F.createContext({});
var $e18da3b8c8c2faf2$export$2e2bcd8739ae039 = $e18da3b8c8c2faf2$var$ButtonGroupContext;



var $8dE9F = parcelRequire("8dE9F");
/**
 * @ignore - internal component.
 */ const $c45a3e9e0d77257b$var$ButtonGroupButtonContext = /*#__PURE__*/ $8dE9F.createContext(undefined);
var $c45a3e9e0d77257b$export$2e2bcd8739ae039 = $c45a3e9e0d77257b$var$ButtonGroupButtonContext;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $05d7b3c76bb6d720$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $05d7b3c76bb6d720$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $8DPw0.default)(color)}`,
            `size${(0, $8DPw0.default)(size)}`,
            `${variant}Size${(0, $8DPw0.default)(size)}`,
            `color${(0, $8DPw0.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $8DPw0.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $8DPw0.default)(size)}`
        ]
    };
    const composedClasses = (0, $fgPD6.default)(slots, (0, $f89a81806def1454$export$5a6f9035944c8119), classes);
    return (0, $7TrLl.default)({}, classes, composedClasses);
};
const $05d7b3c76bb6d720$var$commonIconStyles = (ownerState)=>(0, $7TrLl.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $05d7b3c76bb6d720$var$ButtonRoot = (0, $e5aV5.default)((0, $66635f5fba848ee5$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $6xVVB.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $8DPw0.default)(ownerState.color)}`],
            styles[`size${(0, $8DPw0.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $8DPw0.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $7TrLl.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $7TrLl.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTR6J.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTR6J.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTR6J.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $7TrLl.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $f89a81806def1454$export$2e2bcd8739ae039).focusVisible}`]: (0, $7TrLl.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $f89a81806def1454$export$2e2bcd8739ae039).disabled}`]: (0, $7TrLl.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $kTR6J.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $f89a81806def1454$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $f89a81806def1454$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $05d7b3c76bb6d720$var$ButtonStartIcon = (0, $e5aV5.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $8DPw0.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $7TrLl.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $05d7b3c76bb6d720$var$commonIconStyles(ownerState)));
const $05d7b3c76bb6d720$var$ButtonEndIcon = (0, $e5aV5.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $8DPw0.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $7TrLl.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $05d7b3c76bb6d720$var$commonIconStyles(ownerState)));
const $05d7b3c76bb6d720$var$Button = /*#__PURE__*/ $8dE9F.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $8dE9F.useContext((0, $e18da3b8c8c2faf2$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $8dE9F.useContext((0, $c45a3e9e0d77257b$export$2e2bcd8739ae039));
    const resolvedProps = (0, $i1zjM.default)(contextProps, inProps);
    const props = (0, $lE3rX.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $1gVUU.default)(props, $05d7b3c76bb6d720$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $05d7b3c76bb6d720$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $dzbn0.jsx)($05d7b3c76bb6d720$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $dzbn0.jsx)($05d7b3c76bb6d720$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($05d7b3c76bb6d720$var$ButtonRoot, (0, $7TrLl.default)({
        ownerState: ownerState,
        className: (0, $72F5q.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $72F5q.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $05d7b3c76bb6d720$export$2e2bcd8739ae039 = $05d7b3c76bb6d720$var$Button;




var $8dE9F = parcelRequire("8dE9F");
"use client";
var $e405c78b511fc182$var$__defProp = Object.defineProperty;
var $e405c78b511fc182$var$__defNormalProp = (obj, key, value)=>key in obj ? $e405c78b511fc182$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e405c78b511fc182$var$__publicField = (obj, key, value)=>$e405c78b511fc182$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/observe.ts
var $e405c78b511fc182$var$observerMap = /* @__PURE__ */ new Map();
var $e405c78b511fc182$var$RootIds = /* @__PURE__ */ new WeakMap();
var $e405c78b511fc182$var$rootId = 0;
var $e405c78b511fc182$var$unsupportedValue = void 0;
function $e405c78b511fc182$export$2ef3a60ee1f37bec(inView) {
    $e405c78b511fc182$var$unsupportedValue = inView;
}
function $e405c78b511fc182$var$getRootId(root) {
    if (!root) return "0";
    if ($e405c78b511fc182$var$RootIds.has(root)) return $e405c78b511fc182$var$RootIds.get(root);
    $e405c78b511fc182$var$rootId += 1;
    $e405c78b511fc182$var$RootIds.set(root, $e405c78b511fc182$var$rootId.toString());
    return $e405c78b511fc182$var$RootIds.get(root);
}
function $e405c78b511fc182$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $e405c78b511fc182$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $e405c78b511fc182$var$createObserver(options) {
    const id = $e405c78b511fc182$var$optionsToId(options);
    let instance = $e405c78b511fc182$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $e405c78b511fc182$var$observerMap.set(id, instance);
    }
    return instance;
}
function $e405c78b511fc182$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $e405c78b511fc182$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $e405c78b511fc182$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $e405c78b511fc182$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $e405c78b511fc182$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $e405c78b511fc182$export$a62107ca74432f44 = class extends $8dE9F.Component {
    constructor(props){
        super(props);
        $e405c78b511fc182$var$__publicField(this, "node", null);
        $e405c78b511fc182$var$__publicField(this, "_unobserveCb", null);
        $e405c78b511fc182$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $e405c78b511fc182$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$e405c78b511fc182$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $e405c78b511fc182$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $8dE9F.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $e405c78b511fc182$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $8dE9F.useState(null);
    const callback = $8dE9F.useRef(onChange);
    const [state, setState] = $8dE9F.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $8dE9F.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $e405c78b511fc182$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $8dE9F.useRef(void 0);
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}
 //# sourceMappingURL=index.mjs.map




var $311cM = parcelRequire("311cM");
function $08670b22a836d326$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $08670b22a836d326$var$RANDOM_SAMPLE_SIZE = 7;
const $08670b22a836d326$var$expandStyle = (theme)=>/*#__PURE__*/ (0, $311cM.css)({
        transform: "rotate(0deg)",
        marginLeft: "auto",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        })
    }, "", "");
const $08670b22a836d326$var$expandOpenStyle = {
    transform: "rotate(180deg)"
};
function $08670b22a836d326$var$EmojiRow(props) {
    return props.emoji.map((emoji)=>/*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7f50bfc76ce34f6e$export$2e2bcd8739ae039), {
            baseSize: emoji.animated ? 64 : 32,
            ...emoji
        }, emoji.id));
}
$08670b22a836d326$var$EmojiRow.propTypes = {
    emoji: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).array.isRequired
};
var $08670b22a836d326$var$_ref = {
    name: "pyy4kw",
    styles: "text-transform:none;color:white"
};
function $08670b22a836d326$var$JoinServer(props) {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $05d7b3c76bb6d720$export$2e2bcd8739ae039), {
        size: "small",
        variant: "contained",
        css: $08670b22a836d326$var$_ref,
        component: (0, $6c8eeadba1a98c1a$export$2e2bcd8739ae039),
        href: props.invite,
        target: "_blank",
        rel: "noopener",
        children: "Join Server"
    });
}
$08670b22a836d326$var$JoinServer.propTypes = {
    invite: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string.isRequired
};
function $08670b22a836d326$var$ShowMore(props) {
    const { expanded: expanded, emojiCount: emojiCount } = props;
    if (emojiCount <= $08670b22a836d326$var$RANDOM_SAMPLE_SIZE) return null;
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $bc55b9c9c616a23b$export$2e2bcd8739ae039), {
        onClick: props.handleClick,
        css: [
            (theme)=>$08670b22a836d326$var$expandStyle(theme),
            expanded && $08670b22a836d326$var$expandOpenStyle,
            "",
            ""
        ],
        name: "Show More Emoji",
        "aria-label": "Show More Emoji",
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($616e5a9b4d3469e1$exports))), {})
    });
}
$08670b22a836d326$var$ShowMore.propTypes = {
    expanded: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool.isRequired,
    emojiCount: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).number,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).func.isRequired
};
class $08670b22a836d326$var$GuildWrapper extends (0, $8dE9F.PureComponent) {
    static whyDidYouRender = true;
    render() {
        return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($08670b22a836d326$var$Guild, {
            ...this.props
        });
    }
}
$08670b22a836d326$var$GuildWrapper.propTypes = {
    guild: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object.isRequired,
    communityRender: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).func
};
var $08670b22a836d326$var$_ref2 = {
    name: "v6ppy3",
    styles: "cursor:pointer;user-select:none"
};
function $08670b22a836d326$var$Guild({ guild: guild, communityRender: communityRender }) {
    const [randomSample, setRandomSample] = (0, $8dE9F.useState)([]);
    const [expanded, setExpanded] = (0, $8dE9F.useState)(false);
    const [checkedCommunityRender, setCheckedCommunityRender] = (0, $8dE9F.useState)(false);
    const quarterScreenHeightInPx = window.innerHeight * 25 / 100;
    const [ref, inView, entry] = (0, $e405c78b511fc182$export$2f62ee6831462844)({
        triggerOnce: true,
        rootMargin: `0px 0px ${quarterScreenHeightInPx}px 0px`
    });
    const EmojiRowContainer = /*#__PURE__*/ (0, $f8iEm.default)("div", {
        target: "e3uz43d0"
    })({
        name: "4pivy7",
        styles: "display:grid;grid-template-columns:repeat(7, 1fr);margin:0 0.3rem;gap:0.6rem 0.3rem;justify-items:center"
    });
    (0, $8dE9F.useEffect)(()=>{
        if (randomSample.length === 0) setRandomSample((0, $46ae9d0281ece1ca$export$7ac3a88d34a76e7)(guild.emoji).slice(0, $08670b22a836d326$var$RANDOM_SAMPLE_SIZE));
    });
    const handleClick = ()=>{
        setExpanded(!expanded);
    };
    (0, $8dE9F.useEffect)(()=>{
        if (!checkedCommunityRender) {
            if (communityRender) communityRender();
            setCheckedCommunityRender(true);
        }
    });
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6d6c7872fb88c6b4$export$2e2bcd8739ae039), {
        item: true,
        xs: 12,
        sm: 6,
        md: 4,
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $c5c4f9daaf31609f$export$2e2bcd8739ae039), {
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $4bc03b18bc47d0d1$export$2e2bcd8739ae039), {
                    avatar: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7e88e947352f534a$export$ae00754399a30376), {
                        name: guild.name,
                        src: guild
                    }),
                    title: guild.name,
                    onClick: handleClick,
                    css: $08670b22a836d326$var$_ref2,
                    action: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($08670b22a836d326$var$ShowMore, {
                        handleClick: handleClick,
                        expanded: expanded,
                        emojiCount: guild.emoji.length
                    }),
                    titleTypographyProps: {
                        style: {
                            fontSize: "1em"
                        }
                    }
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $1e8366f3baede695$export$2e2bcd8739ae039), {
                    children: inView ? /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)(EmojiRowContainer, {
                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($08670b22a836d326$var$EmojiRow, {
                            emoji: expanded ? guild.emoji : randomSample
                        })
                    }) : /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $25c3986dfc17a41c$export$1f3d6ca653b5063d), {})
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2b0521d5e364edce$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($08670b22a836d326$var$JoinServer, {
                        invite: guild.invite
                    })
                })
            ]
        })
    });
}
$08670b22a836d326$var$Guild.propTypes = {
    guild: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object.isRequired,
    communityRender: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).func
};
$08670b22a836d326$var$Guild.whyDidYouRender = true;
var $08670b22a836d326$export$2e2bcd8739ae039 = $08670b22a836d326$var$GuildWrapper;


class $44ab75aea268ad5d$var$GuildsWrapper extends (0, $8dE9F.PureComponent) {
    static whyDidYouRender = true;
    render() {
        return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($44ab75aea268ad5d$var$Guilds, {
            ...this.props
        });
    }
}
function $44ab75aea268ad5d$var$Guilds(props) {
    const { guilds: guilds, perPage: perPage, slice: slice, className: className } = props;
    const [upTo, setUpTo] = (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).useState(perPage);
    let newGuilds = slice ? guilds.slice(0, upTo) : guilds;
    (0, $87cdd9a4ef227e74$export$887fcf96538e29f7)(()=>{
        if (!slice) return;
        if (upTo < guilds.length) setUpTo((prev)=>Math.min(prev + perPage, guilds.length));
    });
    if (guilds.length === 0) return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6d6c7872fb88c6b4$export$2e2bcd8739ae039), {
        container: true,
        spacing: 3,
        className: className,
        children: Array.from({
            length: props.skeletonCount
        }, (_, index)=>/*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $25c3986dfc17a41c$export$2e2bcd8739ae039), {}, index))
    });
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6d6c7872fb88c6b4$export$2e2bcd8739ae039), {
        container: true,
        spacing: 3,
        className: className,
        children: newGuilds.map((guild)=>/*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $08670b22a836d326$export$2e2bcd8739ae039), {
                guild: guild,
                communityRender: props.communityRender
            }, guild.id))
    });
}
$44ab75aea268ad5d$var$Guilds.defaultProps = {
    slice: false,
    perPage: 9
};
$44ab75aea268ad5d$var$Guilds.propTypes = {
    guilds: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).array.isRequired,
    slice: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool,
    perPage: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).number,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string,
    skeletonCount: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).number.isRequired,
    communityRender: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).func
};
$44ab75aea268ad5d$var$GuildsWrapper.defaultProps = {
    slice: false,
    perPage: 9
};
$44ab75aea268ad5d$var$GuildsWrapper.propTypes = {
    guilds: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).array.isRequired,
    slice: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool,
    perPage: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).number,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string,
    skeletonCount: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).number.isRequired,
    communityRender: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).func
};
$44ab75aea268ad5d$var$Guilds.whyDidYouRender = true;
var $44ab75aea268ad5d$export$2e2bcd8739ae039 = $44ab75aea268ad5d$var$GuildsWrapper;


function $b7bc2af3477c0f39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b7bc2af3477c0f39$var$_ref = {
    name: "k82dzb",
    styles: "margin:2rem 0"
};
class $b7bc2af3477c0f39$var$OfficialServers extends (0, $8dE9F.PureComponent) {
    static whyDidYouRender = true;
    render() {
        const { emojis: emojis, communityRender: communityRender } = this.props;
        return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $28c3d1989808f867$export$ffb0004e005737fa), {
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                    variant: "h5",
                    children: "The Official Blob Emoji Servers"
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $44ab75aea268ad5d$export$2e2bcd8739ae039), {
                    guilds: emojis.guilds,
                    skeletonCount: 6,
                    communityRender: communityRender
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)("div", {
                    css: $b7bc2af3477c0f39$var$_ref,
                    children: [
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                            variant: "body2",
                            children: [
                                "All blobs that are uploaded to official Blob Emoji servers are licensed under the",
                                " ",
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6c8eeadba1a98c1a$export$2e2bcd8739ae039), {
                                    href: "https://www.apache.org/licenses/LICENSE-2.0.html",
                                    children: "Apache License 2.0"
                                }),
                                ", the same license that",
                                " ",
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6c8eeadba1a98c1a$export$2e2bcd8739ae039), {
                                    href: "https://www.google.com/get/noto/help/emoji/",
                                    children: "Noto Emoji"
                                }),
                                " ",
                                "by Google are licensed under."
                            ]
                        }),
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                            variant: "body2",
                            children: [
                                "All blobs from the official servers can be downloaded",
                                " ",
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6c8eeadba1a98c1a$export$2e2bcd8739ae039), {
                                    href: "https://files.lostluma.net/blobs.zip",
                                    children: "here"
                                }),
                                ". Make sure to follow the license."
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
$b7bc2af3477c0f39$var$OfficialServers.propTypes = {
    emojis: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object.isRequired,
    communityRender: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).func.isRequired
};
$b7bc2af3477c0f39$var$OfficialServers.whyDidYouRender = true;
var $b7bc2af3477c0f39$export$2e2bcd8739ae039 = $b7bc2af3477c0f39$var$OfficialServers;




var $8dE9F = parcelRequire("8dE9F");

var $agf0O = parcelRequire("agf0O");





var $311cM = parcelRequire("311cM");
function $44b3e118602e10ca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e1cf4900e272d772$exports = {};
$e1cf4900e272d772$exports = $parcel$resolve("9GsQk");


const $44b3e118602e10ca$var$nitro = new URL($e1cf4900e272d772$exports);
const $44b3e118602e10ca$var$inlineIconStyle = (theme)=>/*#__PURE__*/ (0, $311cM.css)({
        height: "0.8em",
        width: "auto",
        margin: "0 0.25em",
        filter: theme.palette.mode === "light" && "invert(1)"
    }, "", "");
var $44b3e118602e10ca$var$_ref = {
    name: "8dk3vg",
    styles: "margin-bottom:1rem"
};
class $44b3e118602e10ca$var$CommunityServers extends (0, $8dE9F.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            shuffledGuilds: []
        };
    }
    static whyDidYouRender = true;
    componentDidMount() {
        const { shuffledGuilds: shuffledGuilds } = this.state;
        const { waiting: waiting, emojis: emojis } = this.props;
        if (shuffledGuilds.length === 0) {
            if (!waiting) this.setState({
                shuffledGuilds: (0, $46ae9d0281ece1ca$export$7ac3a88d34a76e7)(emojis.guilds)
            });
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.waiting !== this.props.waiting) this.setState({
            shuffledGuilds: (0, $46ae9d0281ece1ca$export$7ac3a88d34a76e7)(this.props.emojis.guilds)
        });
    }
    render() {
        const { emojis: emojis, waiting: waiting } = this.props;
        const { shuffledGuilds: shuffledGuilds } = this.state;
        return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $28c3d1989808f867$export$ffb0004e005737fa), {
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)("div", {
                    css: $44b3e118602e10ca$var$_ref,
                    children: [
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                            variant: "h5",
                            children: "Community Blob Servers"
                        }),
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                            variant: "body2",
                            children: [
                                "To add your Blob Server to our Community Servers section, join the official",
                                " ",
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6c8eeadba1a98c1a$export$2e2bcd8739ae039), {
                                    href: "https://1.blobs.gg",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Blob Emoji server"
                                }),
                                " ",
                                "and message our Blob Mail bot."
                            ]
                        }),
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                            variant: "body2",
                            children: [
                                "In order to use custom emoji in other Discord Servers you need an active",
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("img", {
                                    css: $44b3e118602e10ca$var$inlineIconStyle,
                                    src: $44b3e118602e10ca$var$nitro.href,
                                    alt: "Discord Nitro icon",
                                    height: 11,
                                    width: 16
                                }),
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6c8eeadba1a98c1a$export$2e2bcd8739ae039), {
                                    href: "https://discord.com/nitro",
                                    target: "_blank",
                                    rel: "noopener",
                                    children: "Discord Nitro"
                                }),
                                " ",
                                "subscription."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $44ab75aea268ad5d$export$2e2bcd8739ae039), {
                    guilds: shuffledGuilds,
                    slice: true,
                    skeletonCount: 9
                })
            ]
        });
    }
}
$44b3e118602e10ca$var$CommunityServers.propTypes = {
    emojis: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object.isRequired,
    waiting: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool.isRequired
};
var $44b3e118602e10ca$export$2e2bcd8739ae039 = $44b3e118602e10ca$var$CommunityServers;


/* eslint-disable max-classes-per-file */ class $846f7192f54abc44$export$56cc48506ff790a {
    constructor(guild, data){
        this.guild = guild;
        Object.assign(this, data);
    }
}
class $846f7192f54abc44$export$85e439e10eca0e6b {
    constructor(id, guild){
        this.id = id;
        this.name = guild.name;
        this.invite = guild.invite;
        this.icon = guild.icon;
        this.emoji = guild.emoji.map((emoji)=>new $846f7192f54abc44$export$56cc48506ff790a(this, emoji));
    }
}
class $846f7192f54abc44$export$a4543fa87a427f1b {
    constructor(guildMapping){
        this.guilds = Object.entries(guildMapping).map(([guildId, guild])=>new $846f7192f54abc44$export$85e439e10eca0e6b(guildId, guild));
    }
}
class $846f7192f54abc44$export$57244dfe9a4da758 {
    constructor(data){
        this.groups = {};
        for (const [groupName, guildMapping] of Object.entries(data))this.groups[groupName] = new $846f7192f54abc44$export$a4543fa87a427f1b(guildMapping);
    }
    /**
   * Returns all guilds across all groups.
   * @return {Guild[]} All guilds.
   */ getAllGuilds() {
        return [
            ...Object.values(this.groups).flatMap((group)=>group.guilds)
        ];
    }
    /**
   * Returns all emoji across all guilds across all groups.
   * @return {Emoji[]} All emoji.
   */ getAllEmoji() {
        return this.getAllGuilds().flatMap((guild)=>guild.emoji);
    }
}





var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $iobM3 = parcelRequire("iobM3");

var $fgPD6 = parcelRequire("fgPD6");

var $i3G15 = parcelRequire("i3G15");

var $i1zjM = parcelRequire("i1zjM");
function $a5cb072d8a15407b$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $i1zjM.default)(theme.components[name].defaultProps, props);
}



'use client';
function $31871ce4f28e7a09$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $335979e65c94143f$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $a5cb072d8a15407b$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $gEeCx = parcelRequire("gEeCx");

var $l9l4U = parcelRequire("l9l4U");



var $j4wF5 = parcelRequire("j4wF5");

var $kbRRG = parcelRequire("kbRRG");
const $d0334ed53b1279b5$var$_excluded = [
    "ownerState"
], $d0334ed53b1279b5$var$_excluded2 = [
    "variants"
], $d0334ed53b1279b5$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $d0334ed53b1279b5$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $d0334ed53b1279b5$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $d0334ed53b1279b5$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $d0334ed53b1279b5$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $d0334ed53b1279b5$export$35e57303dbd8a66 = (0, $j4wF5.default)();
const $d0334ed53b1279b5$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $d0334ed53b1279b5$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $d0334ed53b1279b5$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $d0334ed53b1279b5$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $d0334ed53b1279b5$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $1gVUU.default)(_ref, $d0334ed53b1279b5$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $7TrLl.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$d0334ed53b1279b5$var$processStyleArg(resolvedStyle, (0, $7TrLl.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $1gVUU.default)(resolvedStylesArg, $d0334ed53b1279b5$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $7TrLl.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $7TrLl.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $d0334ed53b1279b5$var$shallowLayer((0, $gEeCx.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $d0334ed53b1279b5$var$shallowLayer((0, $gEeCx.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $d0334ed53b1279b5$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $d0334ed53b1279b5$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $d0334ed53b1279b5$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $d0334ed53b1279b5$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $kbRRG.default)((0, $7TrLl.default)({}, props, {
            theme: $d0334ed53b1279b5$var$resolveTheme((0, $7TrLl.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $gEeCx.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $d0334ed53b1279b5$var$defaultOverridesResolver($d0334ed53b1279b5$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $1gVUU.default)(inputOptions, $d0334ed53b1279b5$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $d0334ed53b1279b5$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($d0334ed53b1279b5$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $gEeCx.default)(tag, (0, $7TrLl.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $l9l4U.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $d0334ed53b1279b5$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $d0334ed53b1279b5$var$processStyleArg(stylesArg, (0, $7TrLl.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $d0334ed53b1279b5$var$resolveTheme((0, $7TrLl.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $d0334ed53b1279b5$var$processStyleArg(slotStyle, (0, $7TrLl.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $d0334ed53b1279b5$var$resolveTheme((0, $7TrLl.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $d0334ed53b1279b5$var$processStyleArg({
                    variants: themeVariants
                }, (0, $7TrLl.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $e7c2aa0842a16249$var$styled = (0, $d0334ed53b1279b5$export$2e2bcd8739ae039)();
var $e7c2aa0842a16249$export$2e2bcd8739ae039 = $e7c2aa0842a16249$var$styled;



var $j4wF5 = parcelRequire("j4wF5");

var $dzbn0 = parcelRequire("dzbn0");
const $9ebd3e2c71f67c94$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $9ebd3e2c71f67c94$var$defaultTheme = (0, $j4wF5.default)();
const $9ebd3e2c71f67c94$var$defaultCreateStyledComponent = (0, $e7c2aa0842a16249$export$2e2bcd8739ae039)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $i3G15.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $9ebd3e2c71f67c94$var$useThemePropsDefault = (inProps)=>(0, $31871ce4f28e7a09$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $9ebd3e2c71f67c94$var$defaultTheme
    });
const $9ebd3e2c71f67c94$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $iobM3.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $i3G15.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $fgPD6.default)(slots, getContainerUtilityClass, classes);
};
function $9ebd3e2c71f67c94$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $9ebd3e2c71f67c94$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $9ebd3e2c71f67c94$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            display: 'block'
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('sm')]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({}, ownerState.maxWidth === 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('xs')]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $8dE9F.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg' } = props, other = (0, $1gVUU.default)(props, $9ebd3e2c71f67c94$var$_excluded);
        const ownerState = (0, $7TrLl.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $9ebd3e2c71f67c94$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $dzbn0.jsx)(ContainerRoot, (0, $7TrLl.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $72F5q.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $8DPw0 = parcelRequire("8DPw0");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");
'use client';
const $b00a3330140623b7$var$Container = (0, $9ebd3e2c71f67c94$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $e5aV5.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $8DPw0.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $lE3rX.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $b00a3330140623b7$export$2e2bcd8739ae039 = $b00a3330140623b7$var$Container;





var $8dE9F = parcelRequire("8dE9F");

var $agf0O = parcelRequire("agf0O");
var $484b7258b6fb40f9$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $484b7258b6fb40f9$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $484b7258b6fb40f9$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $484b7258b6fb40f9$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $484b7258b6fb40f9$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $484b7258b6fb40f9$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $484b7258b6fb40f9$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $484b7258b6fb40f9$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $484b7258b6fb40f9$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $484b7258b6fb40f9$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $484b7258b6fb40f9$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $484b7258b6fb40f9$var$root = $484b7258b6fb40f9$var$freeGlobal || $484b7258b6fb40f9$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $484b7258b6fb40f9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $484b7258b6fb40f9$var$objectToString = $484b7258b6fb40f9$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $484b7258b6fb40f9$var$nativeMax = Math.max, $484b7258b6fb40f9$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $484b7258b6fb40f9$var$now = function() {
    return $484b7258b6fb40f9$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $484b7258b6fb40f9$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($484b7258b6fb40f9$var$FUNC_ERROR_TEXT);
    wait = $484b7258b6fb40f9$var$toNumber(wait) || 0;
    if ($484b7258b6fb40f9$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $484b7258b6fb40f9$var$nativeMax($484b7258b6fb40f9$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $484b7258b6fb40f9$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $484b7258b6fb40f9$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($484b7258b6fb40f9$var$now());
    }
    function debounced() {
        var time = $484b7258b6fb40f9$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $484b7258b6fb40f9$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $484b7258b6fb40f9$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $484b7258b6fb40f9$var$isSymbol(value) {
    return typeof value == 'symbol' || $484b7258b6fb40f9$var$isObjectLike(value) && $484b7258b6fb40f9$var$objectToString.call(value) == $484b7258b6fb40f9$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $484b7258b6fb40f9$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($484b7258b6fb40f9$var$isSymbol(value)) return $484b7258b6fb40f9$var$NAN;
    if ($484b7258b6fb40f9$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $484b7258b6fb40f9$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($484b7258b6fb40f9$var$reTrim, '');
    var isBinary = $484b7258b6fb40f9$var$reIsBinary.test(value);
    return isBinary || $484b7258b6fb40f9$var$reIsOctal.test(value) ? $484b7258b6fb40f9$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $484b7258b6fb40f9$var$reIsBadHex.test(value) ? $484b7258b6fb40f9$var$NAN : +value;
}
$484b7258b6fb40f9$exports = $484b7258b6fb40f9$var$debounce;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");



var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $fgPD6 = parcelRequire("fgPD6");

var $l9l4U = parcelRequire("l9l4U");


var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $4T6WZ = parcelRequire("4T6WZ");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");



var $fgPD6 = parcelRequire("fgPD6");


var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7a14744ae9383dde$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


function $7039a4d480b5b24a$export$2e2bcd8739ae039(node) {
    const doc = (0, $12c8925c44da80e4$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $4493f66cfd7c2957$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $4493f66cfd7c2957$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $4493f66cfd7c2957$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $4493f66cfd7c2957$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $4493f66cfd7c2957$var$isEmpty(obj) {
    return $4493f66cfd7c2957$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $4493f66cfd7c2957$var$TextareaAutosize = /*#__PURE__*/ $8dE9F.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $1gVUU.default)(props, $4493f66cfd7c2957$var$_excluded);
    const { current: isControlled } = $8dE9F.useRef(value != null);
    const textareaRef = $8dE9F.useRef(null);
    const handleRef = (0, $6a01c40fbbc90587$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $8dE9F.useRef(null);
    const hiddenTextareaRef = $8dE9F.useRef(null);
    const calculateTextareaStyles = $8dE9F.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $7039a4d480b5b24a$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $4493f66cfd7c2957$var$getStyleValue(computedStyle.paddingBottom) + $4493f66cfd7c2957$var$getStyleValue(computedStyle.paddingTop);
        const border = $4493f66cfd7c2957$var$getStyleValue(computedStyle.borderBottomWidth) + $4493f66cfd7c2957$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $086d9802984ea6c0$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $4493f66cfd7c2957$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $8dE9F.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $4493f66cfd7c2957$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $8dE9F.useRef(-1);
    (0, $0b33b5af51106e3b$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $7a14744ae9383dde$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $7039a4d480b5b24a$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $0b33b5af51106e3b$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($8dE9F.Fragment, {
        children: [
            /*#__PURE__*/ (0, $dzbn0.jsx)("textarea", (0, $7TrLl.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $dzbn0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $7TrLl.default)({}, $4493f66cfd7c2957$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $4493f66cfd7c2957$export$2e2bcd8739ae039 = $4493f66cfd7c2957$var$TextareaAutosize;


function $2c621e0eb593769c$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $8dE9F = parcelRequire("8dE9F");
/**
 * @ignore - internal component.
 */ const $49ce0c570a89f67e$var$FormControlContext = /*#__PURE__*/ $8dE9F.createContext(undefined);
var $49ce0c570a89f67e$export$2e2bcd8739ae039 = $49ce0c570a89f67e$var$FormControlContext;



var $8dE9F = parcelRequire("8dE9F");

'use client';
function $f8b97bdab202086e$export$2e2bcd8739ae039() {
    return $8dE9F.useContext((0, $49ce0c570a89f67e$export$2e2bcd8739ae039));
}



var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $8DPw0 = parcelRequire("8DPw0");


'use client';
var $3e8372e8c01b34b9$export$2e2bcd8739ae039 = (0, $0b33b5af51106e3b$export$2e2bcd8739ae039);



// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $f9cce8e0f0520b30$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $f9cce8e0f0520b30$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($f9cce8e0f0520b30$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $f9cce8e0f0520b30$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $f9cce8e0f0520b30$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $ba6f9afd9e162611$export$ef57d5c8ca2278f6(slot) {
    return (0, $iobM3.default)('MuiInputBase', slot);
}
const $ba6f9afd9e162611$var$inputBaseClasses = (0, $5rH1e.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $ba6f9afd9e162611$export$2e2bcd8739ae039 = $ba6f9afd9e162611$var$inputBaseClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $3ab6481a2221105b$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $3ab6481a2221105b$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $8DPw0.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $3ab6481a2221105b$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $3ab6481a2221105b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $8DPw0.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $8DPw0.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $ba6f9afd9e162611$export$ef57d5c8ca2278f6), classes);
};
const $3ab6481a2221105b$export$298a043133d72a38 = (0, $e5aV5.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $3ab6481a2221105b$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $ba6f9afd9e162611$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $7TrLl.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $3ab6481a2221105b$export$a1ad29c901026019 = (0, $e5aV5.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $3ab6481a2221105b$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $7TrLl.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $7TrLl.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $ba6f9afd9e162611$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $ba6f9afd9e162611$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $3ab6481a2221105b$var$inputGlobalStyles = /*#__PURE__*/ (0, $dzbn0.jsx)((0, $533ee5a2e3df2fc8$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $3ab6481a2221105b$var$InputBase = /*#__PURE__*/ $8dE9F.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $1gVUU.default)(props, $3ab6481a2221105b$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $8dE9F.useRef(value != null);
    const inputRef = $8dE9F.useRef();
    const handleInputRefWarning = $8dE9F.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $8dE9F.useState(false);
    const muiFormControl = (0, $f8b97bdab202086e$export$2e2bcd8739ae039)();
    const fcs = (0, $2c621e0eb593769c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $8dE9F.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $8dE9F.useCallback((obj)=>{
        if ((0, $f9cce8e0f0520b30$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $3e8372e8c01b34b9$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $4T6WZ.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $8dE9F.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $7TrLl.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $7TrLl.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $4493f66cfd7c2957$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $8dE9F.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $7TrLl.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $3ab6481a2221105b$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $3ab6481a2221105b$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $3ab6481a2221105b$export$a1ad29c901026019;
    inputProps = (0, $7TrLl.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($8dE9F.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $3ab6481a2221105b$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $dzbn0.jsxs)(Root, (0, $7TrLl.default)({}, rootProps, !(0, $8a867bdc54f45d1c$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $7TrLl.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $72F5q.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $dzbn0.jsx)((0, $49ce0c570a89f67e$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $dzbn0.jsx)(Input, (0, $7TrLl.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $8a867bdc54f45d1c$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $7TrLl.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $72F5q.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $7TrLl.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $3ab6481a2221105b$export$2e2bcd8739ae039 = $3ab6481a2221105b$var$InputBase;



var $e5aV5 = parcelRequire("e5aV5");
var $6xVVB = parcelRequire("6xVVB");

var $lE3rX = parcelRequire("lE3rX");

var $7TrLl = parcelRequire("7TrLl");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");

function $f798d5b09ed4eb2c$export$cdb270390122322b(slot) {
    return (0, $iobM3.default)('MuiInput', slot);
}
const $f798d5b09ed4eb2c$var$inputClasses = (0, $7TrLl.default)({}, (0, $ba6f9afd9e162611$export$2e2bcd8739ae039), (0, $5rH1e.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $f798d5b09ed4eb2c$export$2e2bcd8739ae039 = $f798d5b09ed4eb2c$var$inputClasses;




var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $a01e9240383c3553$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $a01e9240383c3553$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $fgPD6.default)(slots, (0, $f798d5b09ed4eb2c$export$cdb270390122322b), classes);
    return (0, $7TrLl.default)({}, classes, composedClasses);
};
const $a01e9240383c3553$var$InputRoot = (0, $e5aV5.default)((0, $3ab6481a2221105b$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $6xVVB.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $3ab6481a2221105b$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $7TrLl.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $f798d5b09ed4eb2c$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $f798d5b09ed4eb2c$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $f798d5b09ed4eb2c$export$2e2bcd8739ae039).disabled}, .${(0, $f798d5b09ed4eb2c$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $f798d5b09ed4eb2c$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $a01e9240383c3553$var$InputInput = (0, $e5aV5.default)((0, $3ab6481a2221105b$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $3ab6481a2221105b$export$cf507b112810e72d)
})({});
const $a01e9240383c3553$var$Input = /*#__PURE__*/ $8dE9F.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1gVUU.default)(props, $a01e9240383c3553$var$_excluded);
    const classes = $a01e9240383c3553$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $l9l4U.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a01e9240383c3553$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $a01e9240383c3553$var$InputInput;
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $3ab6481a2221105b$export$2e2bcd8739ae039), (0, $7TrLl.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$a01e9240383c3553$var$Input.muiName = 'Input';
var $a01e9240383c3553$export$2e2bcd8739ae039 = $a01e9240383c3553$var$Input;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");

var $l9l4U = parcelRequire("l9l4U");



var $fgPD6 = parcelRequire("fgPD6");


var $e5aV5 = parcelRequire("e5aV5");
var $6xVVB = parcelRequire("6xVVB");

var $lE3rX = parcelRequire("lE3rX");

var $7TrLl = parcelRequire("7TrLl");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");

function $7911c4cc6d73855b$export$3331e419f1a48437(slot) {
    return (0, $iobM3.default)('MuiFilledInput', slot);
}
const $7911c4cc6d73855b$var$filledInputClasses = (0, $7TrLl.default)({}, (0, $ba6f9afd9e162611$export$2e2bcd8739ae039), (0, $5rH1e.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $7911c4cc6d73855b$export$2e2bcd8739ae039 = $7911c4cc6d73855b$var$filledInputClasses;




var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $0eb77c61efa01311$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $0eb77c61efa01311$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $fgPD6.default)(slots, (0, $7911c4cc6d73855b$export$3331e419f1a48437), classes);
    return (0, $7TrLl.default)({}, classes, composedClasses);
};
const $0eb77c61efa01311$var$FilledInputRoot = (0, $e5aV5.default)((0, $3ab6481a2221105b$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $6xVVB.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $3ab6481a2221105b$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $7TrLl.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $7911c4cc6d73855b$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $7911c4cc6d73855b$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $7911c4cc6d73855b$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $7911c4cc6d73855b$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $7911c4cc6d73855b$export$2e2bcd8739ae039).disabled}, .${(0, $7911c4cc6d73855b$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $7911c4cc6d73855b$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $7TrLl.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $0eb77c61efa01311$var$FilledInputInput = (0, $e5aV5.default)((0, $3ab6481a2221105b$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $3ab6481a2221105b$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $0eb77c61efa01311$var$FilledInput = /*#__PURE__*/ $8dE9F.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1gVUU.default)(props, $0eb77c61efa01311$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $0eb77c61efa01311$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $l9l4U.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $0eb77c61efa01311$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $0eb77c61efa01311$var$FilledInputInput;
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $3ab6481a2221105b$export$2e2bcd8739ae039), (0, $7TrLl.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$0eb77c61efa01311$var$FilledInput.muiName = 'Input';
var $0eb77c61efa01311$export$2e2bcd8739ae039 = $0eb77c61efa01311$var$FilledInput;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");



var $fgPD6 = parcelRequire("fgPD6");

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");
parcelRequire("8dE9F");


var $e5aV5 = parcelRequire("e5aV5");
var $6xVVB = parcelRequire("6xVVB");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
var $3806f834c3663851$var$_span;
const $3806f834c3663851$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $3806f834c3663851$var$NotchedOutlineRoot = (0, $e5aV5.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $6xVVB.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $3806f834c3663851$var$NotchedOutlineLegend = (0, $e5aV5.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $6xVVB.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $7TrLl.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $7TrLl.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $3806f834c3663851$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $1gVUU.default)(props, $3806f834c3663851$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $7TrLl.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $dzbn0.jsx)($3806f834c3663851$var$NotchedOutlineRoot, (0, $7TrLl.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($3806f834c3663851$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $dzbn0.jsx)("span", {
                children: label
            }) : $3806f834c3663851$var$_span || ($3806f834c3663851$var$_span = /*#__PURE__*/ (0, $dzbn0.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $e5aV5 = parcelRequire("e5aV5");
var $6xVVB = parcelRequire("6xVVB");

var $7TrLl = parcelRequire("7TrLl");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");

function $70f27517fbd407c7$export$89922944c7227687(slot) {
    return (0, $iobM3.default)('MuiOutlinedInput', slot);
}
const $70f27517fbd407c7$var$outlinedInputClasses = (0, $7TrLl.default)({}, (0, $ba6f9afd9e162611$export$2e2bcd8739ae039), (0, $5rH1e.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $70f27517fbd407c7$export$2e2bcd8739ae039 = $70f27517fbd407c7$var$outlinedInputClasses;




var $lE3rX = parcelRequire("lE3rX");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $e7bb5dc177819c9b$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $e7bb5dc177819c9b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $fgPD6.default)(slots, (0, $70f27517fbd407c7$export$89922944c7227687), classes);
    return (0, $7TrLl.default)({}, classes, composedClasses);
};
const $e7bb5dc177819c9b$var$OutlinedInputRoot = (0, $e5aV5.default)((0, $3ab6481a2221105b$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $6xVVB.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $3ab6481a2221105b$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $7TrLl.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $70f27517fbd407c7$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $70f27517fbd407c7$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $70f27517fbd407c7$export$2e2bcd8739ae039).focused} .${(0, $70f27517fbd407c7$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $70f27517fbd407c7$export$2e2bcd8739ae039).error} .${(0, $70f27517fbd407c7$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $70f27517fbd407c7$export$2e2bcd8739ae039).disabled} .${(0, $70f27517fbd407c7$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $7TrLl.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $e7bb5dc177819c9b$var$NotchedOutlineRoot = (0, $e5aV5.default)((0, $3806f834c3663851$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $e7bb5dc177819c9b$var$OutlinedInputInput = (0, $e5aV5.default)((0, $3ab6481a2221105b$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $3ab6481a2221105b$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $e7bb5dc177819c9b$var$OutlinedInput = /*#__PURE__*/ $8dE9F.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $1gVUU.default)(props, $e7bb5dc177819c9b$var$_excluded);
    const classes = $e7bb5dc177819c9b$var$useUtilityClasses(props);
    const muiFormControl = (0, $f8b97bdab202086e$export$2e2bcd8739ae039)();
    const fcs = (0, $2c621e0eb593769c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $7TrLl.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e7bb5dc177819c9b$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e7bb5dc177819c9b$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $3ab6481a2221105b$export$2e2bcd8739ae039), (0, $7TrLl.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $dzbn0.jsx)($e7bb5dc177819c9b$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $dzbn0.jsxs)($8dE9F.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $7TrLl.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$e7bb5dc177819c9b$var$OutlinedInput.muiName = 'Input';
var $e7bb5dc177819c9b$export$2e2bcd8739ae039 = $e7bb5dc177819c9b$var$OutlinedInput;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $fgPD6 = parcelRequire("fgPD6");

var $72F5q = parcelRequire("72F5q");



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");



var $8DPw0 = parcelRequire("8DPw0");

var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $704fd18a93d261c1$export$f7d501e40371cd17(slot) {
    return (0, $iobM3.default)('MuiFormLabel', slot);
}
const $704fd18a93d261c1$var$formLabelClasses = (0, $5rH1e.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $704fd18a93d261c1$export$2e2bcd8739ae039 = $704fd18a93d261c1$var$formLabelClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $4e7aa9500b7aba0e$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $4e7aa9500b7aba0e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $8DPw0.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $704fd18a93d261c1$export$f7d501e40371cd17), classes);
};
const $4e7aa9500b7aba0e$export$aa5bc7f8a4705b27 = (0, $e5aV5.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $7TrLl.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $704fd18a93d261c1$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $704fd18a93d261c1$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $704fd18a93d261c1$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $4e7aa9500b7aba0e$var$AsteriskComponent = (0, $e5aV5.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $704fd18a93d261c1$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $4e7aa9500b7aba0e$var$FormLabel = /*#__PURE__*/ $8dE9F.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $1gVUU.default)(props, $4e7aa9500b7aba0e$var$_excluded);
    const muiFormControl = (0, $f8b97bdab202086e$export$2e2bcd8739ae039)();
    const fcs = (0, $2c621e0eb593769c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $7TrLl.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $4e7aa9500b7aba0e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($4e7aa9500b7aba0e$export$aa5bc7f8a4705b27, (0, $7TrLl.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $72F5q.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $dzbn0.jsxs)($4e7aa9500b7aba0e$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $4e7aa9500b7aba0e$export$2e2bcd8739ae039 = $4e7aa9500b7aba0e$var$FormLabel;



var $lE3rX = parcelRequire("lE3rX");

var $8DPw0 = parcelRequire("8DPw0");

var $e5aV5 = parcelRequire("e5aV5");
var $6xVVB = parcelRequire("6xVVB");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $f9f6a19e9d1ef37e$export$c1c4b4545ad2ea5f(slot) {
    return (0, $iobM3.default)('MuiInputLabel', slot);
}
const $f9f6a19e9d1ef37e$var$inputLabelClasses = (0, $5rH1e.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $f9f6a19e9d1ef37e$export$2e2bcd8739ae039 = $f9f6a19e9d1ef37e$var$inputLabelClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $0cd21a5ef517ec8d$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $0cd21a5ef517ec8d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $8DPw0.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $fgPD6.default)(slots, (0, $f9f6a19e9d1ef37e$export$c1c4b4545ad2ea5f), classes);
    return (0, $7TrLl.default)({}, classes, composedClasses);
};
const $0cd21a5ef517ec8d$var$InputLabelRoot = (0, $e5aV5.default)((0, $4e7aa9500b7aba0e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $6xVVB.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $704fd18a93d261c1$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $7TrLl.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $7TrLl.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $7TrLl.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $0cd21a5ef517ec8d$var$InputLabel = /*#__PURE__*/ $8dE9F.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $1gVUU.default)(props, $0cd21a5ef517ec8d$var$_excluded);
    const muiFormControl = (0, $f8b97bdab202086e$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $2c621e0eb593769c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $7TrLl.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $0cd21a5ef517ec8d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($0cd21a5ef517ec8d$var$InputLabelRoot, (0, $7TrLl.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $72F5q.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $0cd21a5ef517ec8d$export$2e2bcd8739ae039 = $0cd21a5ef517ec8d$var$InputLabel;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");


var $8DPw0 = parcelRequire("8DPw0");

var $8dE9F = parcelRequire("8dE9F");
function $7429830c03d33198$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $8dE9F.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $3edeedaa138546de$export$2e2bcd8739ae039 = (0, $7429830c03d33198$export$2e2bcd8739ae039);




var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $7b667f0054459486$export$149c8b8bab2289d1(slot) {
    return (0, $iobM3.default)('MuiFormControl', slot);
}
const $7b667f0054459486$var$formControlClasses = (0, $5rH1e.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $7b667f0054459486$export$2e2bcd8739ae039 = $7b667f0054459486$var$formControlClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $3bcc750a7e2cf40f$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $3bcc750a7e2cf40f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $8DPw0.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $7b667f0054459486$export$149c8b8bab2289d1), classes);
};
const $3bcc750a7e2cf40f$var$FormControlRoot = (0, $e5aV5.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $7TrLl.default)({}, styles.root, styles[`margin${(0, $8DPw0.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $7TrLl.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $3bcc750a7e2cf40f$var$FormControl = /*#__PURE__*/ $8dE9F.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $1gVUU.default)(props, $3bcc750a7e2cf40f$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $3bcc750a7e2cf40f$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $8dE9F.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $8dE9F.Children.forEach(children, (child)=>{
            if (!(0, $3edeedaa138546de$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $3edeedaa138546de$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $f9cce8e0f0520b30$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $8dE9F.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $8dE9F.Children.forEach(children, (child)=>{
            if (!(0, $3edeedaa138546de$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $f9cce8e0f0520b30$export$d652b828d7fdeff8)(child.props, true) || (0, $f9cce8e0f0520b30$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $8dE9F.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $8dE9F.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $49ce0c570a89f67e$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($3bcc750a7e2cf40f$var$FormControlRoot, (0, $7TrLl.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $72F5q.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $3bcc750a7e2cf40f$export$2e2bcd8739ae039 = $3bcc750a7e2cf40f$var$FormControl;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");



var $e5aV5 = parcelRequire("e5aV5");

var $8DPw0 = parcelRequire("8DPw0");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $5fd17631290187bf$export$a394fa61b1d583a9(slot) {
    return (0, $iobM3.default)('MuiFormHelperText', slot);
}
const $5fd17631290187bf$var$formHelperTextClasses = (0, $5rH1e.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $5fd17631290187bf$export$2e2bcd8739ae039 = $5fd17631290187bf$var$formHelperTextClasses;



var $lE3rX = parcelRequire("lE3rX");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
var $4041d998fd60d708$var$_span;
const $4041d998fd60d708$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $4041d998fd60d708$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $8DPw0.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $5fd17631290187bf$export$a394fa61b1d583a9), classes);
};
const $4041d998fd60d708$var$FormHelperTextRoot = (0, $e5aV5.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $8DPw0.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $5fd17631290187bf$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $5fd17631290187bf$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $4041d998fd60d708$var$FormHelperText = /*#__PURE__*/ $8dE9F.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $1gVUU.default)(props, $4041d998fd60d708$var$_excluded);
    const muiFormControl = (0, $f8b97bdab202086e$export$2e2bcd8739ae039)();
    const fcs = (0, $2c621e0eb593769c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $4041d998fd60d708$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($4041d998fd60d708$var$FormHelperTextRoot, (0, $7TrLl.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $72F5q.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $4041d998fd60d708$var$_span || ($4041d998fd60d708$var$_span = /*#__PURE__*/ (0, $dzbn0.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $4041d998fd60d708$export$2e2bcd8739ae039 = $4041d998fd60d708$var$FormHelperText;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $l9l4U = parcelRequire("l9l4U");


var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $4T6WZ = parcelRequire("4T6WZ");

var $8dE9F = parcelRequire("8dE9F");



var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");



var $21772fe70b17020c$export$2e2bcd8739ae039 = (0, $12c8925c44da80e4$export$2e2bcd8739ae039);



var $8DPw0 = parcelRequire("8DPw0");

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");



var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");




var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");




var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $8dE9F = parcelRequire("8dE9F");
'use client';
/**
 * @ignore - internal component.
 */ const $c33079d8c78fcbfe$var$ListContext = /*#__PURE__*/ $8dE9F.createContext({});
var $c33079d8c78fcbfe$export$2e2bcd8739ae039 = $c33079d8c78fcbfe$var$ListContext;



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $15e81a923f6e2d8f$export$c6bd6795ed6e3203(slot) {
    return (0, $iobM3.default)('MuiList', slot);
}
const $15e81a923f6e2d8f$var$listClasses = (0, $5rH1e.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $15e81a923f6e2d8f$export$2e2bcd8739ae039 = $15e81a923f6e2d8f$var$listClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $c49724f140af25e2$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $c49724f140af25e2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $15e81a923f6e2d8f$export$c6bd6795ed6e3203), classes);
};
const $c49724f140af25e2$var$ListRoot = (0, $e5aV5.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $7TrLl.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $c49724f140af25e2$var$List = /*#__PURE__*/ $8dE9F.forwardRef(function List(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $1gVUU.default)(props, $c49724f140af25e2$var$_excluded);
    const context = $8dE9F.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $c49724f140af25e2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $c33079d8c78fcbfe$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $dzbn0.jsxs)($c49724f140af25e2$var$ListRoot, (0, $7TrLl.default)({
            as: component,
            className: (0, $72F5q.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $c49724f140af25e2$export$2e2bcd8739ae039 = $c49724f140af25e2$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $09aaf32a5f0f62cf$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $7d6140bc63fc0026$export$2e2bcd8739ae039 = (0, $09aaf32a5f0f62cf$export$2e2bcd8739ae039);





var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $62044ea015c761b9$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $62044ea015c761b9$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $62044ea015c761b9$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $62044ea015c761b9$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $62044ea015c761b9$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$62044ea015c761b9$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $62044ea015c761b9$var$MenuList = /*#__PURE__*/ $8dE9F.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $1gVUU.default)(props, $62044ea015c761b9$var$_excluded);
    const listRef = $8dE9F.useRef(null);
    const textCriteriaRef = $8dE9F.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $3e8372e8c01b34b9$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $8dE9F.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $7d6140bc63fc0026$export$2e2bcd8739ae039)((0, $21772fe70b17020c$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $21772fe70b17020c$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $62044ea015c761b9$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $62044ea015c761b9$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $62044ea015c761b9$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $62044ea015c761b9$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $62044ea015c761b9$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $62044ea015c761b9$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $62044ea015c761b9$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $62044ea015c761b9$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $62044ea015c761b9$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $62044ea015c761b9$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $62044ea015c761b9$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $8dE9F.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $8dE9F.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $8dE9F.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $8dE9F.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $c49724f140af25e2$export$2e2bcd8739ae039), (0, $7TrLl.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $62044ea015c761b9$export$2e2bcd8739ae039 = $62044ea015c761b9$var$MenuList;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");








var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $00b34e9a0144a8d4$export$2e2bcd8739ae039 = (0, $7a14744ae9383dde$export$2e2bcd8739ae039);




var $612bef6ea8252ebe$export$2e2bcd8739ae039 = (0, $7039a4d480b5b24a$export$2e2bcd8739ae039);





var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");



var $fgPD6 = parcelRequire("fgPD6");


var $8dE9F = parcelRequire("8dE9F");



var $dzbn0 = parcelRequire("dzbn0");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $bb32239f927d7ba3$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $bb32239f927d7ba3$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $bb32239f927d7ba3$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $bb32239f927d7ba3$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $bb32239f927d7ba3$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $bb32239f927d7ba3$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($bb32239f927d7ba3$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $bb32239f927d7ba3$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$bb32239f927d7ba3$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $bb32239f927d7ba3$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $bb32239f927d7ba3$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $bb32239f927d7ba3$var$defaultGetTabbable, isEnabled: isEnabled = $bb32239f927d7ba3$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $8dE9F.useRef(false);
    const sentinelStart = $8dE9F.useRef(null);
    const sentinelEnd = $8dE9F.useRef(null);
    const nodeToRestore = $8dE9F.useRef(null);
    const reactFocusEventTarget = $8dE9F.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $8dE9F.useRef(false);
    const rootRef = $8dE9F.useRef(null);
    const handleRef = (0, $6a01c40fbbc90587$export$2e2bcd8739ae039)((0, $4c7d3b0e8ad54c21$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $8dE9F.useRef(null);
    $8dE9F.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $8dE9F.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $12c8925c44da80e4$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $8dE9F.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $12c8925c44da80e4$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($8dE9F.Fragment, {
        children: [
            /*#__PURE__*/ (0, $dzbn0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $8dE9F.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $dzbn0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $bb32239f927d7ba3$export$2e2bcd8739ae039 = $bb32239f927d7ba3$var$FocusTrap;




var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");








var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $489f51878043e5a2$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $489f51878043e5a2$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $489f51878043e5a2$var$Fade = /*#__PURE__*/ $8dE9F.forwardRef(function Fade(props, ref) {
    const theme = (0, $88f720b0aa3cee5b$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $6e41a3c5e4c6a6e2$export$2e2bcd8739ae039) } = props, other = (0, $1gVUU.default)(props, $489f51878043e5a2$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $8dE9F.useRef(null);
    const handleRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(nodeRef, (0, $4c7d3b0e8ad54c21$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $51002b2756b6e7b3$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $51002b2756b6e7b3$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $51002b2756b6e7b3$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $dzbn0.jsx)(TransitionComponent, (0, $7TrLl.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $8dE9F.cloneElement(children, (0, $7TrLl.default)({
                style: (0, $7TrLl.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $489f51878043e5a2$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $489f51878043e5a2$export$2e2bcd8739ae039 = $489f51878043e5a2$var$Fade;



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $2684103dab162175$export$9927a91fd93152bd(slot) {
    return (0, $iobM3.default)('MuiBackdrop', slot);
}
const $2684103dab162175$var$backdropClasses = (0, $5rH1e.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $2684103dab162175$export$2e2bcd8739ae039 = $2684103dab162175$var$backdropClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $7d9e1f2500321019$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $7d9e1f2500321019$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $2684103dab162175$export$9927a91fd93152bd), classes);
};
const $7d9e1f2500321019$var$BackdropRoot = (0, $e5aV5.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $7TrLl.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $7d9e1f2500321019$var$Backdrop = /*#__PURE__*/ $8dE9F.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $489f51878043e5a2$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $1gVUU.default)(props, $7d9e1f2500321019$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $7d9e1f2500321019$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $dzbn0.jsx)(TransitionComponent, (0, $7TrLl.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($7d9e1f2500321019$var$BackdropRoot, (0, $7TrLl.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $72F5q.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $7TrLl.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $7d9e1f2500321019$export$2e2bcd8739ae039 = $7d9e1f2500321019$var$Backdrop;



var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $50e0f89060d6ca00$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $1ff5e1f736b5a498$var$isOverflowing(container) {
    const doc = (0, $12c8925c44da80e4$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $7039a4d480b5b24a$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $1ff5e1f736b5a498$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $1ff5e1f736b5a498$var$getPaddingRight(element) {
    return parseInt((0, $7039a4d480b5b24a$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $1ff5e1f736b5a498$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $1ff5e1f736b5a498$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$1ff5e1f736b5a498$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $1ff5e1f736b5a498$export$e1bd0c6150f13d96(element, show);
    });
}
function $1ff5e1f736b5a498$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $1ff5e1f736b5a498$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($1ff5e1f736b5a498$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $09aaf32a5f0f62cf$export$2e2bcd8739ae039)((0, $12c8925c44da80e4$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$1ff5e1f736b5a498$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $12c8925c44da80e4$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$1ff5e1f736b5a498$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $12c8925c44da80e4$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $7039a4d480b5b24a$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $1ff5e1f736b5a498$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $1ff5e1f736b5a498$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $1ff5e1f736b5a498$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $1ff5e1f736b5a498$var$getHiddenSiblings(container);
        $1ff5e1f736b5a498$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $1ff5e1f736b5a498$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $1ff5e1f736b5a498$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $1ff5e1f736b5a498$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $1ff5e1f736b5a498$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $1ff5e1f736b5a498$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $1ff5e1f736b5a498$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $1ff5e1f736b5a498$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $397bb4d119484db9$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $397bb4d119484db9$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $397bb4d119484db9$var$defaultManager = new (0, $1ff5e1f736b5a498$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $397bb4d119484db9$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $397bb4d119484db9$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $8dE9F.useRef({});
    const mountNodeRef = $8dE9F.useRef(null);
    const modalRef = $8dE9F.useRef(null);
    const handleRef = (0, $6a01c40fbbc90587$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $8dE9F.useState(!open);
    const hasTransition = $397bb4d119484db9$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $12c8925c44da80e4$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $086d9802984ea6c0$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $397bb4d119484db9$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $8dE9F.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $086d9802984ea6c0$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $1ff5e1f736b5a498$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $8dE9F.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $8dE9F.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $8dE9F.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $569062248ada2576$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $7TrLl.default)({}, propsEventHandlers, otherHandlers);
        return (0, $7TrLl.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $7TrLl.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $50e0f89060d6ca00$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $50e0f89060d6ca00$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $397bb4d119484db9$export$2e2bcd8739ae039 = $397bb4d119484db9$var$useModal;



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $b0e3537bf6f5381b$export$67960e22b12a638d(slot) {
    return (0, $iobM3.default)('MuiModal', slot);
}
const $b0e3537bf6f5381b$var$modalClasses = (0, $5rH1e.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $b0e3537bf6f5381b$export$2e2bcd8739ae039 = $b0e3537bf6f5381b$var$modalClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $dedc4b31f1d2deed$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $dedc4b31f1d2deed$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $b0e3537bf6f5381b$export$67960e22b12a638d), classes);
};
const $dedc4b31f1d2deed$var$ModalRoot = (0, $e5aV5.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $dedc4b31f1d2deed$var$ModalBackdrop = (0, $e5aV5.default)((0, $7d9e1f2500321019$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $dedc4b31f1d2deed$var$Modal = /*#__PURE__*/ $8dE9F.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $lE3rX.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $dedc4b31f1d2deed$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $1gVUU.default)(props, $dedc4b31f1d2deed$var$_excluded);
    const propsWithDefaults = (0, $7TrLl.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $397bb4d119484db9$export$2e2bcd8739ae039)((0, $7TrLl.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $7TrLl.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $dedc4b31f1d2deed$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $dedc4b31f1d2deed$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $0d839d5f574f1d1c$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $72F5q.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $0d839d5f574f1d1c$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $7TrLl.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $72F5q.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $2ef375666a6c21bf$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $dzbn0.jsxs)(RootSlot, (0, $7TrLl.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $dzbn0.jsx)(BackdropSlot, (0, $7TrLl.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $dzbn0.jsx)((0, $bb32239f927d7ba3$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $8dE9F.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $dedc4b31f1d2deed$export$2e2bcd8739ae039 = $dedc4b31f1d2deed$var$Modal;




var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $d0d0c3331e2cbc8a$export$88f455dd56c95edb(slot) {
    return (0, $iobM3.default)('MuiPopover', slot);
}
const $d0d0c3331e2cbc8a$var$popoverClasses = (0, $5rH1e.default)('MuiPopover', [
    'root',
    'paper'
]);
var $d0d0c3331e2cbc8a$export$2e2bcd8739ae039 = $d0d0c3331e2cbc8a$var$popoverClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $79fb989e95768028$var$_excluded = [
    "onEntering"
], $79fb989e95768028$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $79fb989e95768028$var$_excluded3 = [
    "slotProps"
];
function $79fb989e95768028$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $79fb989e95768028$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $79fb989e95768028$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $79fb989e95768028$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $79fb989e95768028$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $d0d0c3331e2cbc8a$export$88f455dd56c95edb), classes);
};
const $79fb989e95768028$export$bcce13685275fc99 = (0, $e5aV5.default)((0, $dedc4b31f1d2deed$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $79fb989e95768028$export$821346c38a2d9390 = (0, $e5aV5.default)((0, $d04b0e428813fc1b$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $79fb989e95768028$var$Popover = /*#__PURE__*/ $8dE9F.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $8e28753d4354f9ab$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $1gVUU.default)(props.TransitionProps, $79fb989e95768028$var$_excluded), other = (0, $1gVUU.default)(props, $79fb989e95768028$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $8dE9F.useRef();
    const handlePaperRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $7TrLl.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $79fb989e95768028$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $8dE9F.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $79fb989e95768028$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $21772fe70b17020c$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $79fb989e95768028$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $79fb989e95768028$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $8dE9F.useCallback((elemRect)=>{
        return {
            vertical: $79fb989e95768028$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $79fb989e95768028$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $8dE9F.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $79fb989e95768028$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $612bef6ea8252ebe$export$2e2bcd8739ae039)($79fb989e95768028$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $79fb989e95768028$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $8dE9F.useState(open);
    const setPositioningStyles = $8dE9F.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $8dE9F.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $8dE9F.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $8dE9F.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $8dE9F.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $00b34e9a0144a8d4$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $612bef6ea8252ebe$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $21772fe70b17020c$export$2e2bcd8739ae039)($79fb989e95768028$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $79fb989e95768028$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $79fb989e95768028$export$821346c38a2d9390;
    const paperProps = (0, $0d839d5f574f1d1c$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $7TrLl.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $7TrLl.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $72F5q.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $0d839d5f574f1d1c$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $72F5q.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $1gVUU.default)(_useSlotProps, $79fb989e95768028$var$_excluded3);
    return /*#__PURE__*/ (0, $dzbn0.jsx)(RootSlot, (0, $7TrLl.default)({}, rootProps, !(0, $8a867bdc54f45d1c$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $dzbn0.jsx)(TransitionComponent, (0, $7TrLl.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $dzbn0.jsx)(PaperSlot, (0, $7TrLl.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $79fb989e95768028$export$2e2bcd8739ae039 = $79fb989e95768028$var$Popover;



var $e5aV5 = parcelRequire("e5aV5");
var $6xVVB = parcelRequire("6xVVB");

var $lE3rX = parcelRequire("lE3rX");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $2c4af4e10a200903$export$2cf86a63a84fe23d(slot) {
    return (0, $iobM3.default)('MuiMenu', slot);
}
const $2c4af4e10a200903$var$menuClasses = (0, $5rH1e.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $2c4af4e10a200903$export$2e2bcd8739ae039 = $2c4af4e10a200903$var$menuClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $acd9301457667507$var$_excluded = [
    "onEntering"
], $acd9301457667507$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $acd9301457667507$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $acd9301457667507$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $acd9301457667507$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $2c4af4e10a200903$export$2cf86a63a84fe23d), classes);
};
const $acd9301457667507$var$MenuRoot = (0, $e5aV5.default)((0, $79fb989e95768028$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $6xVVB.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $acd9301457667507$export$4f7c51a5920c9f33 = (0, $e5aV5.default)((0, $79fb989e95768028$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $acd9301457667507$var$MenuMenuList = (0, $e5aV5.default)((0, $62044ea015c761b9$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $acd9301457667507$var$Menu = /*#__PURE__*/ $8dE9F.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $1gVUU.default)(props.TransitionProps, $acd9301457667507$var$_excluded), other = (0, $1gVUU.default)(props, $acd9301457667507$var$_excluded2);
    const isRtl = (0, $ac3075ed8f266354$export$b2dd014b6c321cb)();
    const ownerState = (0, $7TrLl.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $acd9301457667507$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $8dE9F.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $8dE9F.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $8dE9F.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $acd9301457667507$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $0d839d5f574f1d1c$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $0d839d5f574f1d1c$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $dzbn0.jsx)($acd9301457667507$var$MenuRoot, (0, $7TrLl.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $acd9301457667507$var$RTL_ORIGIN : $acd9301457667507$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $7TrLl.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($acd9301457667507$var$MenuMenuList, (0, $7TrLl.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $72F5q.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $acd9301457667507$export$2e2bcd8739ae039 = $acd9301457667507$var$Menu;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");


var $fgPD6 = parcelRequire("fgPD6");

var $8DPw0 = parcelRequire("8DPw0");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $e34b053bbb445c86$export$1ee13051fd9e2ab5(slot) {
    return (0, $iobM3.default)('MuiNativeSelect', slot);
}
const $e34b053bbb445c86$var$nativeSelectClasses = (0, $5rH1e.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $e34b053bbb445c86$export$2e2bcd8739ae039 = $e34b053bbb445c86$var$nativeSelectClasses;



var $e5aV5 = parcelRequire("e5aV5");
var $6xVVB = parcelRequire("6xVVB");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $8f022d4b2e83e1a5$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $8f022d4b2e83e1a5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $8DPw0.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $e34b053bbb445c86$export$1ee13051fd9e2ab5), classes);
};
const $8f022d4b2e83e1a5$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $7TrLl.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $7TrLl.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $e34b053bbb445c86$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $8f022d4b2e83e1a5$var$NativeSelectSelect = (0, $e5aV5.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $6xVVB.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $e34b053bbb445c86$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($8f022d4b2e83e1a5$export$c1eccd1617458c87);
const $8f022d4b2e83e1a5$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $7TrLl.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $e34b053bbb445c86$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $8f022d4b2e83e1a5$var$NativeSelectIcon = (0, $e5aV5.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $8DPw0.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($8f022d4b2e83e1a5$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $8f022d4b2e83e1a5$var$NativeSelectInput = /*#__PURE__*/ $8dE9F.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $1gVUU.default)(props, $8f022d4b2e83e1a5$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $8f022d4b2e83e1a5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($8dE9F.Fragment, {
        children: [
            /*#__PURE__*/ (0, $dzbn0.jsx)($8f022d4b2e83e1a5$var$NativeSelectSelect, (0, $7TrLl.default)({
                ownerState: ownerState,
                className: (0, $72F5q.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $dzbn0.jsx)($8f022d4b2e83e1a5$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $8f022d4b2e83e1a5$export$2e2bcd8739ae039 = $8f022d4b2e83e1a5$var$NativeSelectInput;




var $e5aV5 = parcelRequire("e5aV5");
var $2MBRn = parcelRequire("2MBRn");



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $087479bbc4b4949b$export$2c0c1ee5a3392e(slot) {
    return (0, $iobM3.default)('MuiSelect', slot);
}
const $087479bbc4b4949b$var$selectClasses = (0, $5rH1e.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $087479bbc4b4949b$export$2e2bcd8739ae039 = $087479bbc4b4949b$var$selectClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
var $bed5f4dfa9a9b14c$var$_span;
const $bed5f4dfa9a9b14c$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $bed5f4dfa9a9b14c$var$SelectSelect = (0, $e5aV5.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $087479bbc4b4949b$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $087479bbc4b4949b$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $087479bbc4b4949b$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $087479bbc4b4949b$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $8f022d4b2e83e1a5$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $087479bbc4b4949b$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $bed5f4dfa9a9b14c$var$SelectIcon = (0, $e5aV5.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $8DPw0.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $8f022d4b2e83e1a5$export$e7a817afd12a40d0));
const $bed5f4dfa9a9b14c$var$SelectNativeInput = (0, $e5aV5.default)('input', {
    shouldForwardProp: (prop)=>(0, $2MBRn.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $bed5f4dfa9a9b14c$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $bed5f4dfa9a9b14c$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $bed5f4dfa9a9b14c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $8DPw0.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $087479bbc4b4949b$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $bed5f4dfa9a9b14c$var$SelectInput = /*#__PURE__*/ $8dE9F.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $1gVUU.default)(props, $bed5f4dfa9a9b14c$var$_excluded);
    const [value, setValueState] = (0, $c26a14c4024304e6$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $c26a14c4024304e6$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $8dE9F.useRef(null);
    const displayRef = $8dE9F.useRef(null);
    const [displayNode, setDisplayNode] = $8dE9F.useState(null);
    const { current: isOpenControlled } = $8dE9F.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $8dE9F.useState();
    const handleRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $8dE9F.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $8dE9F.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $8dE9F.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $8dE9F.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $8dE9F.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $21772fe70b17020c$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $8dE9F.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $f9cce8e0f0520b30$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $8dE9F.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $4T6WZ.default)(2));
            selected = value.some((v)=>$bed5f4dfa9a9b14c$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $bed5f4dfa9a9b14c$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $8dE9F.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $7TrLl.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $bed5f4dfa9a9b14c$var$useUtilityClasses(ownerState);
    const paperProps = (0, $7TrLl.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $02833fc3ddd87b8f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($8dE9F.Fragment, {
        children: [
            /*#__PURE__*/ (0, $dzbn0.jsx)($bed5f4dfa9a9b14c$var$SelectSelect, (0, $7TrLl.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $72F5q.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $bed5f4dfa9a9b14c$var$isEmpty(display) ? $bed5f4dfa9a9b14c$var$_span || ($bed5f4dfa9a9b14c$var$_span = /*#__PURE__*/ (0, $dzbn0.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $dzbn0.jsx)($bed5f4dfa9a9b14c$var$SelectNativeInput, (0, $7TrLl.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $dzbn0.jsx)($bed5f4dfa9a9b14c$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $dzbn0.jsx)((0, $acd9301457667507$export$2e2bcd8739ae039), (0, $7TrLl.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $7TrLl.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $7TrLl.default)({}, MenuProps.slotProps, {
                    paper: (0, $7TrLl.default)({}, paperProps, {
                        style: (0, $7TrLl.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $bed5f4dfa9a9b14c$export$2e2bcd8739ae039 = $bed5f4dfa9a9b14c$var$SelectInput;




parcelRequire("8dE9F");

var $58054 = parcelRequire("58054");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
var $3c5e70b48ddae660$export$2e2bcd8739ae039 = (0, $58054.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







var $lE3rX = parcelRequire("lE3rX");


var $e5aV5 = parcelRequire("e5aV5");
var $6xVVB = parcelRequire("6xVVB");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $43cc0350d2f04951$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $43cc0350d2f04951$var$_excluded2 = [
    "root"
];
const $43cc0350d2f04951$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $43cc0350d2f04951$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $6xVVB.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $43cc0350d2f04951$var$StyledInput = (0, $e5aV5.default)((0, $a01e9240383c3553$export$2e2bcd8739ae039), $43cc0350d2f04951$var$styledRootConfig)('');
const $43cc0350d2f04951$var$StyledOutlinedInput = (0, $e5aV5.default)((0, $e7bb5dc177819c9b$export$2e2bcd8739ae039), $43cc0350d2f04951$var$styledRootConfig)('');
const $43cc0350d2f04951$var$StyledFilledInput = (0, $e5aV5.default)((0, $0eb77c61efa01311$export$2e2bcd8739ae039), $43cc0350d2f04951$var$styledRootConfig)('');
const $43cc0350d2f04951$var$Select = /*#__PURE__*/ $8dE9F.forwardRef(function Select(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $3c5e70b48ddae660$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $1gVUU.default)(props, $43cc0350d2f04951$var$_excluded);
    const inputComponent = native ? (0, $8f022d4b2e83e1a5$export$2e2bcd8739ae039) : (0, $bed5f4dfa9a9b14c$export$2e2bcd8739ae039);
    const muiFormControl = (0, $f8b97bdab202086e$export$2e2bcd8739ae039)();
    const fcs = (0, $2c621e0eb593769c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $7TrLl.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $43cc0350d2f04951$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $1gVUU.default)(classes, $43cc0350d2f04951$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $dzbn0.jsx)($43cc0350d2f04951$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $dzbn0.jsx)($43cc0350d2f04951$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $dzbn0.jsx)($43cc0350d2f04951$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(ref, (0, $4c7d3b0e8ad54c21$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $dzbn0.jsx)($8dE9F.Fragment, {
        children: /*#__PURE__*/ $8dE9F.cloneElement(InputComponent, (0, $7TrLl.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $7TrLl.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $7TrLl.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $l9l4U.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $72F5q.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$43cc0350d2f04951$var$Select.muiName = 'Select';
var $43cc0350d2f04951$export$2e2bcd8739ae039 = $43cc0350d2f04951$var$Select;



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $d51acd69db647813$export$c1bdcbaf0596aeda(slot) {
    return (0, $iobM3.default)('MuiTextField', slot);
}
const $d51acd69db647813$var$textFieldClasses = (0, $5rH1e.default)('MuiTextField', [
    'root'
]);
var $d51acd69db647813$export$2e2bcd8739ae039 = $d51acd69db647813$var$textFieldClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $82487243438c141c$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $82487243438c141c$var$variantComponent = {
    standard: (0, $a01e9240383c3553$export$2e2bcd8739ae039),
    filled: (0, $0eb77c61efa01311$export$2e2bcd8739ae039),
    outlined: (0, $e7bb5dc177819c9b$export$2e2bcd8739ae039)
};
const $82487243438c141c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $d51acd69db647813$export$c1bdcbaf0596aeda), classes);
};
const $82487243438c141c$var$TextFieldRoot = (0, $e5aV5.default)((0, $3bcc750a7e2cf40f$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $82487243438c141c$var$TextField = /*#__PURE__*/ $8dE9F.forwardRef(function TextField(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $1gVUU.default)(props, $82487243438c141c$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $82487243438c141c$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $02833fc3ddd87b8f$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $82487243438c141c$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $dzbn0.jsx)(InputComponent, (0, $7TrLl.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($82487243438c141c$var$TextFieldRoot, (0, $7TrLl.default)({
        className: (0, $72F5q.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $dzbn0.jsx)((0, $0cd21a5ef517ec8d$export$2e2bcd8739ae039), (0, $7TrLl.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $dzbn0.jsx)((0, $43cc0350d2f04951$export$2e2bcd8739ae039), (0, $7TrLl.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $dzbn0.jsx)((0, $4041d998fd60d708$export$2e2bcd8739ae039), (0, $7TrLl.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $82487243438c141c$export$2e2bcd8739ae039 = $82487243438c141c$var$TextField;





var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");


var $fgPD6 = parcelRequire("fgPD6");

var $311cM = parcelRequire("311cM");

var $8DPw0 = parcelRequire("8DPw0");

var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $d77ff9ea356882b4$export$29cad1383b3f235d(slot) {
    return (0, $iobM3.default)('MuiCircularProgress', slot);
}
const $d77ff9ea356882b4$var$circularProgressClasses = (0, $5rH1e.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $d77ff9ea356882b4$export$2e2bcd8739ae039 = $d77ff9ea356882b4$var$circularProgressClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $82e614f1d31a4829$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $82e614f1d31a4829$var$_ = (t)=>t, $82e614f1d31a4829$var$_t, $82e614f1d31a4829$var$_t2, $82e614f1d31a4829$var$_t3, $82e614f1d31a4829$var$_t4;
const $82e614f1d31a4829$var$SIZE = 44;
const $82e614f1d31a4829$var$circularRotateKeyframe = (0, $311cM.keyframes)($82e614f1d31a4829$var$_t || ($82e614f1d31a4829$var$_t = $82e614f1d31a4829$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $82e614f1d31a4829$var$circularDashKeyframe = (0, $311cM.keyframes)($82e614f1d31a4829$var$_t2 || ($82e614f1d31a4829$var$_t2 = $82e614f1d31a4829$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $82e614f1d31a4829$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $8DPw0.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $8DPw0.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $d77ff9ea356882b4$export$29cad1383b3f235d), classes);
};
const $82e614f1d31a4829$var$CircularProgressRoot = (0, $e5aV5.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $8DPw0.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $7TrLl.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $311cM.css)($82e614f1d31a4829$var$_t3 || ($82e614f1d31a4829$var$_t3 = $82e614f1d31a4829$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $82e614f1d31a4829$var$circularRotateKeyframe));
const $82e614f1d31a4829$var$CircularProgressSVG = (0, $e5aV5.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $82e614f1d31a4829$var$CircularProgressCircle = (0, $e5aV5.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $8DPw0.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $7TrLl.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $311cM.css)($82e614f1d31a4829$var$_t4 || ($82e614f1d31a4829$var$_t4 = $82e614f1d31a4829$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $82e614f1d31a4829$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $82e614f1d31a4829$var$CircularProgress = /*#__PURE__*/ $8dE9F.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $1gVUU.default)(props, $82e614f1d31a4829$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $82e614f1d31a4829$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($82e614f1d31a4829$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $dzbn0.jsx)($82e614f1d31a4829$var$CircularProgressRoot, (0, $7TrLl.default)({
        className: (0, $72F5q.default)(classes.root, className),
        style: (0, $7TrLl.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($82e614f1d31a4829$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$82e614f1d31a4829$var$SIZE / 2} ${$82e614f1d31a4829$var$SIZE / 2} ${$82e614f1d31a4829$var$SIZE} ${$82e614f1d31a4829$var$SIZE}`,
            children: /*#__PURE__*/ (0, $dzbn0.jsx)($82e614f1d31a4829$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $82e614f1d31a4829$var$SIZE,
                cy: $82e614f1d31a4829$var$SIZE,
                r: ($82e614f1d31a4829$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $82e614f1d31a4829$export$2e2bcd8739ae039 = $82e614f1d31a4829$var$CircularProgress;




var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");


var $lE3rX = parcelRequire("lE3rX");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $7f9e8c59ffef217f$export$427f1c1e2e839f85(slot) {
    return (0, $iobM3.default)('MuiPagination', slot);
}
const $7f9e8c59ffef217f$var$paginationClasses = (0, $5rH1e.default)('MuiPagination', [
    'root',
    'ul',
    'outlined',
    'text'
]);
var $7f9e8c59ffef217f$export$2e2bcd8739ae039 = $7f9e8c59ffef217f$var$paginationClasses;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

'use client';
const $c81cfb8ba4e0808d$var$_excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function $c81cfb8ba4e0808d$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = 'usePagination', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1 } = props, other = (0, $1gVUU.default)(props, $c81cfb8ba4e0808d$var$_excluded);
    const [page, setPageState] = (0, $f9e439188be57646$export$2e2bcd8739ae039)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: 'page'
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            'first'
        ] : [],
        ...hidePrevButton ? [] : [
            'previous'
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            'start-ellipsis'
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            'end-ellipsis'
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            'next'
        ],
        ...showLastButton ? [
            'last'
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case 'first':
                return 1;
            case 'previous':
                return page - 1;
            case 'next':
                return page + 1;
            case 'last':
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === 'number' ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: 'page',
            page: item,
            selected: item === page,
            disabled: disabled,
            'aria-current': item === page ? 'true' : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
        };
    });
    return (0, $7TrLl.default)({
        items: items
    }, other);
}



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $kTR6J = parcelRequire("kTR6J");


var $lE3rX = parcelRequire("lE3rX");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $31b06590a20092ef$export$e4ce0a775adf2f74(slot) {
    return (0, $iobM3.default)('MuiPaginationItem', slot);
}
const $31b06590a20092ef$var$paginationItemClasses = (0, $5rH1e.default)('MuiPaginationItem', [
    'root',
    'page',
    'sizeSmall',
    'sizeLarge',
    'text',
    'textPrimary',
    'textSecondary',
    'outlined',
    'outlinedPrimary',
    'outlinedSecondary',
    'rounded',
    'ellipsis',
    'firstLast',
    'previousNext',
    'focusVisible',
    'disabled',
    'selected',
    'icon',
    'colorPrimary',
    'colorSecondary'
]);
var $31b06590a20092ef$export$2e2bcd8739ae039 = $31b06590a20092ef$var$paginationItemClasses;




var $8DPw0 = parcelRequire("8DPw0");
parcelRequire("8dE9F");

var $58054 = parcelRequire("58054");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
var $43cc33761a7ee566$export$2e2bcd8739ae039 = (0, $58054.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');


parcelRequire("8dE9F");

var $58054 = parcelRequire("58054");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
var $c9e0ba18c1c6c4e8$export$2e2bcd8739ae039 = (0, $58054.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


parcelRequire("8dE9F");

var $58054 = parcelRequire("58054");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
var $b1c96604b8fa1cf5$export$2e2bcd8739ae039 = (0, $58054.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');


parcelRequire("8dE9F");

var $58054 = parcelRequire("58054");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
var $84d7d3bb2243bad1$export$2e2bcd8739ae039 = (0, $58054.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');



var $e5aV5 = parcelRequire("e5aV5");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $8eb1f5be6d999f5f$var$_excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const $8eb1f5be6d999f5f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $8DPw0.default)(ownerState.size)}`],
        ownerState.variant === 'text' && styles[`text${(0, $8DPw0.default)(ownerState.color)}`],
        ownerState.variant === 'outlined' && styles[`outlined${(0, $8DPw0.default)(ownerState.color)}`],
        ownerState.shape === 'rounded' && styles.rounded,
        ownerState.type === 'page' && styles.page,
        (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis,
        (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext,
        (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast
    ];
};
const $8eb1f5be6d999f5f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $8DPw0.default)(size)}`,
            variant,
            shape,
            color !== 'standard' && `color${(0, $8DPw0.default)(color)}`,
            color !== 'standard' && `${variant}${(0, $8DPw0.default)(color)}`,
            disabled && 'disabled',
            selected && 'selected',
            {
                page: 'page',
                first: 'firstLast',
                last: 'firstLast',
                'start-ellipsis': 'ellipsis',
                'end-ellipsis': 'ellipsis',
                previous: 'previousNext',
                next: 'previousNext'
            }[type]
        ],
        icon: [
            'icon'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $31b06590a20092ef$export$e4ce0a775adf2f74), classes);
};
const $8eb1f5be6d999f5f$var$PaginationItemEllipsis = (0, $e5aV5.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $8eb1f5be6d999f5f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        height: 'auto',
        [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }));
const $8eb1f5be6d999f5f$var$PaginationItemPage = (0, $e5aV5.default)((0, $66635f5fba848ee5$export$2e2bcd8739ae039), {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $8eb1f5be6d999f5f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        height: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            'color',
            'background-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTR6J.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTR6J.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({}, ownerState.variant === 'text' && {
        [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).selected}`]: (0, $7TrLl.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            '&:hover': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === 'outlined' && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
        [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).selected}`]: (0, $7TrLl.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $kTR6J.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, $kTR6J.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTR6J.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTR6J.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, $31b06590a20092ef$export$2e2bcd8739ae039).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const $8eb1f5be6d999f5f$var$PaginationItemPageIcon = (0, $e5aV5.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: '0 -8px'
    }, ownerState.size === 'small' && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        fontSize: theme.typography.pxToRem(22)
    }));
const $8eb1f5be6d999f5f$var$PaginationItem = /*#__PURE__*/ $8dE9F.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiPaginationItem'
    });
    const { className: className, color: color = 'standard', component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = 'circular', size: size = 'medium', slots: slots = {}, type: type = 'page', variant: variant = 'text' } = props, other = (0, $1gVUU.default)(props, $8eb1f5be6d999f5f$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    const isRtl = (0, $ac3075ed8f266354$export$b2dd014b6c321cb)();
    const classes = $8eb1f5be6d999f5f$var$useUtilityClasses(ownerState);
    const normalizedIcons = isRtl ? {
        previous: slots.next || components.next || (0, $84d7d3bb2243bad1$export$2e2bcd8739ae039),
        next: slots.previous || components.previous || (0, $b1c96604b8fa1cf5$export$2e2bcd8739ae039),
        last: slots.first || components.first || (0, $43cc33761a7ee566$export$2e2bcd8739ae039),
        first: slots.last || components.last || (0, $c9e0ba18c1c6c4e8$export$2e2bcd8739ae039)
    } : {
        previous: slots.previous || components.previous || (0, $b1c96604b8fa1cf5$export$2e2bcd8739ae039),
        next: slots.next || components.next || (0, $84d7d3bb2243bad1$export$2e2bcd8739ae039),
        first: slots.first || components.first || (0, $43cc33761a7ee566$export$2e2bcd8739ae039),
        last: slots.last || components.last || (0, $c9e0ba18c1c6c4e8$export$2e2bcd8739ae039)
    };
    const Icon = normalizedIcons[type];
    return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/ (0, $dzbn0.jsx)($8eb1f5be6d999f5f$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $72F5q.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $dzbn0.jsxs)($8eb1f5be6d999f5f$var$PaginationItemPage, (0, $7TrLl.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $72F5q.default)(classes.root, className)
    }, other, {
        children: [
            type === 'page' && page,
            Icon ? /*#__PURE__*/ (0, $dzbn0.jsx)($8eb1f5be6d999f5f$var$PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
var $8eb1f5be6d999f5f$export$2e2bcd8739ae039 = $8eb1f5be6d999f5f$var$PaginationItem;



var $e5aV5 = parcelRequire("e5aV5");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $10c4d7a128fd1953$var$_excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const $10c4d7a128fd1953$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        ul: [
            'ul'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $7f9e8c59ffef217f$export$427f1c1e2e839f85), classes);
};
const $10c4d7a128fd1953$var$PaginationRoot = (0, $e5aV5.default)('nav', {
    name: 'MuiPagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $10c4d7a128fd1953$var$PaginationUl = (0, $e5aV5.default)('ul', {
    name: 'MuiPagination',
    slot: 'Ul',
    overridesResolver: (props, styles)=>styles.ul
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
function $10c4d7a128fd1953$var$defaultGetAriaLabel(type, page, selected) {
    if (type === 'page') return `${selected ? '' : 'Go to '}page ${page}`;
    return `Go to ${type} page`;
}
const $10c4d7a128fd1953$var$Pagination = /*#__PURE__*/ $8dE9F.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiPagination'
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = 'standard', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $10c4d7a128fd1953$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $dzbn0.jsx)((0, $8eb1f5be6d999f5f$export$2e2bcd8739ae039), (0, $7TrLl.default)({}, item)), shape: shape = 'circular', showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = 'medium', variant: variant = 'text' } = props, other = (0, $1gVUU.default)(props, $10c4d7a128fd1953$var$_excluded);
    const { items: items } = (0, $c81cfb8ba4e0808d$export$2e2bcd8739ae039)((0, $7TrLl.default)({}, props, {
        componentName: 'Pagination'
    }));
    const ownerState = (0, $7TrLl.default)({}, props, {
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    });
    const classes = $10c4d7a128fd1953$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($10c4d7a128fd1953$var$PaginationRoot, (0, $7TrLl.default)({
        "aria-label": "pagination navigation",
        className: (0, $72F5q.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($10c4d7a128fd1953$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $dzbn0.jsx)("li", {
                    children: renderItem((0, $7TrLl.default)({}, item, {
                        color: color,
                        'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    }))
                }, index))
        })
    }));
});
var $10c4d7a128fd1953$export$2e2bcd8739ae039 = $10c4d7a128fd1953$var$Pagination;


function $20d311333dc41e5f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $20d311333dc41e5f$var$insensitiveIncludes(haystack, needle) {
    return haystack.toLowerCase().includes(needle.toLowerCase());
}
var $20d311333dc41e5f$var$_ref = {
    name: "akdqam",
    styles: "margin-top:1rem"
};
var $20d311333dc41e5f$var$_ref2 = {
    name: "pfsf60",
    styles: "display:grid;justify-content:space-between;grid-template-columns:repeat(auto-fill, 96px)"
};
var $20d311333dc41e5f$var$_ref3 = {
    name: "aeft2n",
    styles: "display:flex;justify-content:center;margin-top:1rem"
};
var $20d311333dc41e5f$var$_ref4 = {
    name: "s64lyq",
    styles: "margin:3rem 0;text-align:center"
};
function $20d311333dc41e5f$var$Contents(props) {
    if (props.hasResults) return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $28c3d1989808f867$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $44ab75aea268ad5d$export$2e2bcd8739ae039), {
                guilds: props.filteredGuilds,
                css: $20d311333dc41e5f$var$_ref,
                skeletonCount: 0
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("div", {
                css: $20d311333dc41e5f$var$_ref2,
                children: props.filteredBlobs.map((blob)=>/*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7f50bfc76ce34f6e$export$2e2bcd8739ae039), {
                        invite: true,
                        showGuild: true,
                        ...blob,
                        enlarge: true
                    }, blob.id))
            }),
            props.totalPages > 1 && /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $10c4d7a128fd1953$export$2e2bcd8739ae039), {
                css: $20d311333dc41e5f$var$_ref3,
                count: props.totalPages,
                page: props.page,
                onChange: props.onPageChange
            })
        ]
    });
    if (props.hideNoResults) return null;
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)("div", {
        css: $20d311333dc41e5f$var$_ref4,
        children: [
            "No results. ",
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7f50bfc76ce34f6e$export$2e2bcd8739ae039), {
                baseSize: 32,
                ...props.sadBlob
            })
        ]
    });
}
$20d311333dc41e5f$var$Contents.propTypes = {
    hasResults: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool.isRequired,
    filteredGuilds: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).array.isRequired,
    filteredBlobs: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).array.isRequired,
    hideNoResults: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool.isRequired,
    sadBlob: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object.isRequired,
    page: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).number.isRequired,
    totalPages: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).number.isRequired,
    onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).func.isRequired
};
class $20d311333dc41e5f$var$Search extends (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).Component {
    constructor(props){
        super(props);
        this.state = {
            query: "",
            page: 1,
            totalPages: 1,
            isDebouncing: false,
            filteredBlobs: [],
            filteredGuilds: [],
            allEmoji: [],
            allGuilds: [],
            loading: true
        };
    }
    getSadBlob() {
        const sadBlob = this.state.allEmoji.find((emoji)=>emoji.guild.id === "272885620769161216" && emoji.name === "blobsad");
        return sadBlob == null ? null : sadBlob;
    }
    calculateResultsDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($484b7258b6fb40f9$exports)))(this.calculateResults, 150);
    handlePageChange = (event, newPage)=>{
        const { query: query } = this.state;
        this.handleQueryChange(event, query, newPage);
    };
    handleQueryChange = (event, querySearch, newPage)=>{
        const value = querySearch ? querySearch : event.currentTarget.value;
        const page = newPage ? newPage : 1;
        this.setState({
            query: value,
            page: page,
            isDebouncing: true
        });
        if (value.length <= 3) this.calculateResultsDebounced();
        else this.calculateResults();
    };
    calculateResults() {
        this.setState(({ query: query, page: page })=>{
            if (query === "") return {
                page: 1,
                totalPages: 1,
                filteredBlobs: [],
                filteredGuilds: [],
                isDebouncing: false
            };
            return {
                filteredBlobs: this.filterBlobs(query, page),
                filteredGuilds: this.filterGuilds(query, page),
                totalPages: this.getTotalPages(query),
                isDebouncing: false
            };
        });
    }
    filterBlobs(query, page) {
        return this.state.allEmoji.filter((blob)=>$20d311333dc41e5f$var$insensitiveIncludes(blob.name, query)).sort(({ name: a }, { name: b })=>a.length - b.length).slice(40 * (page - 1), 40 * page);
    }
    filterGuilds(query, page) {
        return this.state.allGuilds.filter((guild)=>$20d311333dc41e5f$var$insensitiveIncludes(guild.name, query)).slice(3 * (page - 1), 3 * page);
    }
    getTotalPages(query) {
        const totalEmojiPages = Math.ceil(this.state.allEmoji.filter((blob)=>$20d311333dc41e5f$var$insensitiveIncludes(blob.name, query)).length / 40);
        const totalGuildPages = Math.ceil(this.state.allGuilds.filter((guild)=>$20d311333dc41e5f$var$insensitiveIncludes(guild.name, query)).length / 3);
        return Math.max(totalEmojiPages, totalGuildPages);
    }
    // eslint-disable-next-line no-unused-vars
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.emojis !== prevProps.emojis) {
            // Calculate these values once, as they are fairly large.
            const allEmoji = this.props.emojis.getAllEmoji();
            const allGuilds = this.props.emojis.getAllGuilds();
            this.setState({
                allEmoji: allEmoji,
                allGuilds: allGuilds,
                loading: false
            }, ()=>{
                let search = new URL(window.location).searchParams;
                if (search.has("name")) this.handleQueryChange(null, search.get("name"));
            });
        }
    }
    componentDidMount() {
        if (this.props.emojis.groups.blobs.guilds.length > 0) {
            // Calculate these values once, as they are fairly large.
            const allEmoji = this.props.emojis.getAllEmoji();
            const allGuilds = this.props.emojis.getAllGuilds();
            this.setState({
                allEmoji: allEmoji,
                allGuilds: allGuilds,
                loading: false
            });
        }
    }
    render() {
        const { query: query, page: page, totalPages: totalPages, filteredBlobs: filteredBlobs, filteredGuilds: filteredGuilds, isDebouncing: isDebouncing } = this.state;
        const hasResults = totalPages !== 0 && filteredBlobs != null && filteredGuilds != null && (filteredBlobs.length !== 0 || Object.keys(filteredGuilds).length !== 0);
        const hideNoResults = query.length === 0 || isDebouncing;
        return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $28c3d1989808f867$export$ffb0004e005737fa), {
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                    title: this.state.loading ? "Loading" : "",
                    arrow: true,
                    children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $82487243438c141c$export$2e2bcd8739ae039), {
                        name: "Search for blobs and servers",
                        disabled: this.state.loading,
                        type: "text",
                        placeholder: "Search for blobs and servers",
                        value: query,
                        onChange: this.handleQueryChange,
                        fullWidth: true,
                        variant: "filled",
                        color: "secondary",
                        InputProps: {
                            endAdornment: this.state.loading ? /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $82e614f1d31a4829$export$2e2bcd8739ae039), {}) : null,
                            disableUnderline: true
                        },
                        inputProps: {
                            "aria-label": "Search for blobs and servers"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("div", {
                    children: !this.state.loading && /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($20d311333dc41e5f$var$Contents, {
                        hasResults: hasResults,
                        filteredBlobs: filteredBlobs,
                        filteredGuilds: filteredGuilds,
                        hideNoResults: hideNoResults,
                        sadBlob: this.getSadBlob(),
                        page: page,
                        totalPages: totalPages,
                        onPageChange: this.handlePageChange
                    })
                })
            ]
        });
    }
}
$20d311333dc41e5f$var$Search.propTypes = {
    emojis: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object.isRequired
};
var $20d311333dc41e5f$export$2e2bcd8739ae039 = $20d311333dc41e5f$var$Search;



function $611265ab7ed69764$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $611265ab7ed69764$var$INITIAL_EMOJI_COUNT = 4800;
const $611265ab7ed69764$var$BLOBS_ENDPOINT = "https://api.mousey.app/v3/emoji/blobs+community-blobs";
const $611265ab7ed69764$var$overHeaderStyle = {
    textAlign: "center",
    margin: "2em 0 0.125em 0"
};
const $611265ab7ed69764$var$subHeaderStyle = {
    textAlign: "center",
    marginBottom: "2em"
};
var $611265ab7ed69764$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
function $611265ab7ed69764$var$Homepage() {
    const [apiData, setApiData] = (0, $8dE9F.useState)({});
    const [emojis, setEmojis] = (0, $8dE9F.useState)({
        groups: {
            blobs: {
                guilds: []
            },
            "community-blobs": {
                guilds: []
            }
        }
    });
    const [formattedCount, setFormattedCount] = (0, $8dE9F.useState)(`Over ${(0, $46ae9d0281ece1ca$export$23814f3b7812d940)($611265ab7ed69764$var$INITIAL_EMOJI_COUNT)}`);
    (0, $8dE9F.useEffect)(()=>{
        if (apiData.hasOwnProperty("blobs")) return;
        const fetchData = async ()=>{
            const resp = await fetch($611265ab7ed69764$var$BLOBS_ENDPOINT);
            const data = await resp.json();
            setApiData(data);
        };
        fetchData();
    }, [
        apiData
    ]);
    (0, $8dE9F.useEffect)(()=>{
        if (!apiData.hasOwnProperty("blobs")) return;
        const newEmojis = new (0, $846f7192f54abc44$export$57244dfe9a4da758)(apiData);
        const count = (0, $46ae9d0281ece1ca$export$644a9299e733daa1)(apiData);
        (0, $46ae9d0281ece1ca$export$bef1f36f5486a6a3)("Emojis:", newEmojis);
        setEmojis(newEmojis);
        setFormattedCount((0, $46ae9d0281ece1ca$export$23814f3b7812d940)(count));
    }, [
        apiData
    ]);
    const [waiting, setWaiting] = (0, $8dE9F.useState)(true);
    const communityRender = (0, $8dE9F.useCallback)(function communityRender() {
        setWaiting(false);
    }, []);
    const officialEmojis = emojis.groups.blobs;
    const communityEmojis = emojis.groups["community-blobs"];
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $b00a3330140623b7$export$2e2bcd8739ae039), {
        css: $611265ab7ed69764$var$_ref,
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                variant: "h5",
                css: $611265ab7ed69764$var$overHeaderStyle,
                children: [
                    formattedCount,
                    " fun and playful Blob Emoji for Discord"
                ]
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                css: $611265ab7ed69764$var$subHeaderStyle,
                children: [
                    "Created by the Blob Emoji community.\xa0",
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6c8eeadba1a98c1a$export$2e2bcd8739ae039), {
                        underline: "hover",
                        href: "https://1.blobs.gg/",
                        target: "_blank",
                        rel: "noopener",
                        children: "Come join us!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $20d311333dc41e5f$export$2e2bcd8739ae039), {
                emojis: emojis
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $b7bc2af3477c0f39$export$2e2bcd8739ae039), {
                emojis: officialEmojis,
                communityRender: communityRender
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $44b3e118602e10ca$export$2e2bcd8739ae039), {
                emojis: communityEmojis,
                waiting: waiting
            })
        ]
    });
}
$611265ab7ed69764$var$Homepage.whyDidYouRender = true;
var $611265ab7ed69764$export$2e2bcd8739ae039 = $611265ab7ed69764$var$Homepage;







var $8dE9F = parcelRequire("8dE9F");

var $8p6fT = parcelRequire("8p6fT");



var $8dE9F = parcelRequire("8dE9F");




function $123e1243ed968053$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $123e1243ed968053$var$_ref = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $123e1243ed968053$var$_ref2 = {
    name: "12px103",
    styles: "display:flex;align-items:center;min-width:7.1rem"
};
var $123e1243ed968053$var$_ref3 = {
    name: "18dr3x4",
    styles: "margin:0.5rem"
};
var $123e1243ed968053$var$_ref4 = {
    name: "18dr3x4",
    styles: "margin:0.5rem"
};
var $123e1243ed968053$var$_ref5 = {
    name: "18dr3x4",
    styles: "margin:0.5rem"
};
var $123e1243ed968053$var$_ref6 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $123e1243ed968053$var$_ref7 = {
    name: "18dr3x4",
    styles: "margin:0.5rem"
};
const $123e1243ed968053$var$SkeletonChangeSet = /*#__PURE__*/ (0, $8dE9F.memo)(function SkeletonChangeSet() {
    const amounts = [
        3,
        4,
        5,
        6,
        7
    ];
    const [length] = (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).useState(amounts[Math.floor(Math.random() * amounts.length)]);
    const skeletons = Array.from({
        length: length
    }, (_, index)=>{
        const simple = Math.random() > 0.8;
        return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)("div", {
            css: $123e1243ed968053$var$_ref,
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)("div", {
                    css: $123e1243ed968053$var$_ref2,
                    children: [
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                            css: $123e1243ed968053$var$_ref3,
                            variant: "circular",
                            width: 35,
                            height: 35
                        }),
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                            css: $123e1243ed968053$var$_ref4,
                            variant: "text",
                            width: 50
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                    css: $123e1243ed968053$var$_ref5,
                    variant: "rectangular",
                    width: 32,
                    height: 32
                }),
                simple ? /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $28c3d1989808f867$export$ffb0004e005737fa), {
                    children: [
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                            variant: "text",
                            width: 20
                        }),
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)("div", {
                            css: $123e1243ed968053$var$_ref6,
                            children: [
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                                    css: $123e1243ed968053$var$_ref7,
                                    variant: "rectangular",
                                    width: 32,
                                    height: 32
                                }),
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                                    variant: "text",
                                    width: 80
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                    variant: "text",
                    width: 80
                })
            ]
        }, index);
    });
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6d6c7872fb88c6b4$export$2e2bcd8739ae039), {
        item: true,
        xs: 12,
        sm: 6,
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $c5c4f9daaf31609f$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $4bc03b18bc47d0d1$export$2e2bcd8739ae039), {
                    avatar: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                        variant: "circular",
                        width: 40,
                        height: 40
                    }),
                    title: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                        variant: "text",
                        width: "40%"
                    }),
                    subheader: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                        variant: "text",
                        width: "50%"
                    })
                }),
                skeletons
            ]
        })
    });
});
var $123e1243ed968053$export$2e2bcd8739ae039 = $123e1243ed968053$var$SkeletonChangeSet;




var $f8iEm = parcelRequire("f8iEm");

var $8dE9F = parcelRequire("8dE9F");

var $agf0O = parcelRequire("agf0O");




var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");



var $72F5q = parcelRequire("72F5q");


var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");

var $72F5q = parcelRequire("72F5q");





var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $5pwy0 = parcelRequire("5pwy0");




var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $abb6261a9bd375a1$export$5162da8f798e0959(slot) {
    return (0, $iobM3.default)('MuiCollapse', slot);
}
const $abb6261a9bd375a1$var$collapseClasses = (0, $5rH1e.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $abb6261a9bd375a1$export$2e2bcd8739ae039 = $abb6261a9bd375a1$var$collapseClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $d26ae435381cc293$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $d26ae435381cc293$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $abb6261a9bd375a1$export$5162da8f798e0959), classes);
};
const $d26ae435381cc293$var$CollapseRoot = (0, $e5aV5.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $7TrLl.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $d26ae435381cc293$var$CollapseWrapper = (0, $e5aV5.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $7TrLl.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $d26ae435381cc293$var$CollapseWrapperInner = (0, $e5aV5.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $7TrLl.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d26ae435381cc293$var$Collapse = /*#__PURE__*/ $8dE9F.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $5pwy0.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $6e41a3c5e4c6a6e2$export$2e2bcd8739ae039) } = props, other = (0, $1gVUU.default)(props, $d26ae435381cc293$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $d26ae435381cc293$var$useUtilityClasses(ownerState);
    const theme = (0, $88f720b0aa3cee5b$export$2e2bcd8739ae039)();
    const timer = (0, $49b369574eb65270$export$2e2bcd8739ae039)();
    const wrapperRef = $8dE9F.useRef(null);
    const autoTransitionDuration = $8dE9F.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $8dE9F.useRef(null);
    const handleRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $51002b2756b6e7b3$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $51002b2756b6e7b3$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $dzbn0.jsx)(TransitionComponent, (0, $7TrLl.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $dzbn0.jsx)($d26ae435381cc293$var$CollapseRoot, (0, $7TrLl.default)({
                as: component,
                className: (0, $72F5q.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $7TrLl.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $7TrLl.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $dzbn0.jsx)($d26ae435381cc293$var$CollapseWrapper, {
                    ownerState: (0, $7TrLl.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $dzbn0.jsx)($d26ae435381cc293$var$CollapseWrapperInner, {
                        ownerState: (0, $7TrLl.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$d26ae435381cc293$var$Collapse.muiSupportAuto = true;
var $d26ae435381cc293$export$2e2bcd8739ae039 = $d26ae435381cc293$var$Collapse;




var $8dE9F = parcelRequire("8dE9F");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $b885a2c181414ae0$var$AccordionContext = /*#__PURE__*/ $8dE9F.createContext({});
var $b885a2c181414ae0$export$2e2bcd8739ae039 = $b885a2c181414ae0$var$AccordionContext;





var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $3ba6afe517210cbf$export$80fb6a2cb3f13b8b(slot) {
    return (0, $iobM3.default)('MuiAccordion', slot);
}
const $3ba6afe517210cbf$var$accordionClasses = (0, $5rH1e.default)('MuiAccordion', [
    'root',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $3ba6afe517210cbf$export$2e2bcd8739ae039 = $3ba6afe517210cbf$var$accordionClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $2a1fbc11fd4cb931$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const $2a1fbc11fd4cb931$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        region: [
            'region'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $3ba6afe517210cbf$export$80fb6a2cb3f13b8b), classes);
};
const $2a1fbc11fd4cb931$var$AccordionRoot = (0, $e5aV5.default)((0, $d04b0e428813fc1b$export$2e2bcd8739ae039), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $3ba6afe517210cbf$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $3ba6afe517210cbf$export$2e2bcd8739ae039).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $3ba6afe517210cbf$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $3ba6afe517210cbf$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    }));
const $2a1fbc11fd4cb931$var$Accordion = /*#__PURE__*/ $8dE9F.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, $1gVUU.default)(props, $2a1fbc11fd4cb931$var$_excluded);
    const [expanded, setExpandedState] = (0, $c26a14c4024304e6$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $8dE9F.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $8dE9F.Children.toArray(childrenProp);
    const contextValue = $8dE9F.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $7TrLl.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $2a1fbc11fd4cb931$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $7TrLl.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, $7TrLl.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, $2405878f1c8488b6$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $d26ae435381cc293$export$2e2bcd8739ae039),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($2a1fbc11fd4cb931$var$AccordionRoot, (0, $7TrLl.default)({
        className: (0, $72F5q.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $dzbn0.jsx)((0, $b885a2c181414ae0$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $dzbn0.jsx)(TransitionSlot, (0, $7TrLl.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, $dzbn0.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $2a1fbc11fd4cb931$export$2e2bcd8739ae039 = $2a1fbc11fd4cb931$var$Accordion;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $a8945e40d1a23a9b$export$a6afb527becfac26(slot) {
    return (0, $iobM3.default)('MuiAccordionDetails', slot);
}
const $a8945e40d1a23a9b$var$accordionDetailsClasses = (0, $5rH1e.default)('MuiAccordionDetails', [
    'root'
]);
var $a8945e40d1a23a9b$export$2e2bcd8739ae039 = $a8945e40d1a23a9b$var$accordionDetailsClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $8df300c596ecf4ae$var$_excluded = [
    "className"
];
const $8df300c596ecf4ae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $a8945e40d1a23a9b$export$a6afb527becfac26), classes);
};
const $8df300c596ecf4ae$var$AccordionDetailsRoot = (0, $e5aV5.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $8df300c596ecf4ae$var$AccordionDetails = /*#__PURE__*/ $8dE9F.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className } = props, other = (0, $1gVUU.default)(props, $8df300c596ecf4ae$var$_excluded);
    const ownerState = props;
    const classes = $8df300c596ecf4ae$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($8df300c596ecf4ae$var$AccordionDetailsRoot, (0, $7TrLl.default)({
        className: (0, $72F5q.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $8df300c596ecf4ae$export$2e2bcd8739ae039 = $8df300c596ecf4ae$var$AccordionDetails;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");



var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $6bdcbcaa6ee21d9f$export$282216ad123d6580(slot) {
    return (0, $iobM3.default)('MuiAccordionSummary', slot);
}
const $6bdcbcaa6ee21d9f$var$accordionSummaryClasses = (0, $5rH1e.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $6bdcbcaa6ee21d9f$export$2e2bcd8739ae039 = $6bdcbcaa6ee21d9f$var$accordionSummaryClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $75cff09f1c334964$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $75cff09f1c334964$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $6bdcbcaa6ee21d9f$export$282216ad123d6580), classes);
};
const $75cff09f1c334964$var$AccordionSummaryRoot = (0, $e5aV5.default)((0, $66635f5fba848ee5$export$2e2bcd8739ae039), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $6bdcbcaa6ee21d9f$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $6bdcbcaa6ee21d9f$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $6bdcbcaa6ee21d9f$export$2e2bcd8739ae039).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $6bdcbcaa6ee21d9f$export$2e2bcd8739ae039).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
});
const $75cff09f1c334964$var$AccordionSummaryContent = (0, $e5aV5.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $6bdcbcaa6ee21d9f$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    }));
const $75cff09f1c334964$var$AccordionSummaryExpandIconWrapper = (0, $e5aV5.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $6bdcbcaa6ee21d9f$export$2e2bcd8739ae039).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $75cff09f1c334964$var$AccordionSummary = /*#__PURE__*/ $8dE9F.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $1gVUU.default)(props, $75cff09f1c334964$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $8dE9F.useContext((0, $b885a2c181414ae0$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $7TrLl.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $75cff09f1c334964$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($75cff09f1c334964$var$AccordionSummaryRoot, (0, $7TrLl.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $72F5q.default)(classes.root, className),
        focusVisibleClassName: (0, $72F5q.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $dzbn0.jsx)($75cff09f1c334964$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $dzbn0.jsx)($75cff09f1c334964$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $75cff09f1c334964$export$2e2bcd8739ae039 = $75cff09f1c334964$var$AccordionSummary;


var $ce33076020a00261$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($ce33076020a00261$exports, "__esModule", {
    value: true
});
$ce33076020a00261$exports.default = void 0;

var $ce33076020a00261$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $ce33076020a00261$var$_default = $ce33076020a00261$exports.default = (0, $ce33076020a00261$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');





var $f8iEm = parcelRequire("f8iEm");

var $agf0O = parcelRequire("agf0O");



function $5baf59e270c57cc7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5baf59e270c57cc7$var$RowDiv = /*#__PURE__*/ (0, $f8iEm.default)("div", {
    target: "ed6cmlq3"
})({
    name: "rriryy",
    styles: "display:flex;align-items:center;font-size:0.875rem"
});
const $5baf59e270c57cc7$var$EventDiv = /*#__PURE__*/ (0, $f8iEm.default)("div", {
    target: "ed6cmlq2"
})({
    name: "12px103",
    styles: "display:flex;align-items:center;min-width:7.1rem"
});
const $5baf59e270c57cc7$var$iconContainerStyle = {
    margin: "0.5rem"
};
const $5baf59e270c57cc7$var$ToDiv = /*#__PURE__*/ (0, $f8iEm.default)("div", {
    target: "ed6cmlq1"
})({
    name: "1w6frfr",
    styles: "padding:0.25rem"
});
const $5baf59e270c57cc7$var$TextDiv = /*#__PURE__*/ (0, $f8iEm.default)("div", {
    target: "ed6cmlq0"
})({
    name: "i9064t",
    styles: "padding:0.25rem;overflow:hidden;text-overflow:ellipsis"
});
function $5baf59e270c57cc7$var$ChangeRow({ eventIcon: eventIcon, eventName: eventName, emoji: emoji, afterEmoji: afterEmoji, changedAt: changedAt }) {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)($5baf59e270c57cc7$var$RowDiv, {
        children: [
            /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)($5baf59e270c57cc7$var$EventDiv, {
                children: [
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("div", {
                        css: $5baf59e270c57cc7$var$iconContainerStyle,
                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                            title: (0, $46ae9d0281ece1ca$export$22d2985352acd646)().format(new Date(changedAt)),
                            arrow: true,
                            children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("div", {
                                children: eventIcon
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("span", {
                        children: `${(0, $46ae9d0281ece1ca$export$348afa8c9ff47183)(eventName)}d`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7f50bfc76ce34f6e$export$2e2bcd8739ae039), {
                baseSize: 32,
                externalContainerStyle: $5baf59e270c57cc7$var$iconContainerStyle,
                ...emoji
            }),
            afterEmoji ? /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $28c3d1989808f867$export$ffb0004e005737fa), {
                children: [
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($5baf59e270c57cc7$var$ToDiv, {
                        children: "to"
                    }),
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7f50bfc76ce34f6e$export$2e2bcd8739ae039), {
                        baseSize: 32,
                        externalContainerStyle: $5baf59e270c57cc7$var$iconContainerStyle,
                        ...afterEmoji
                    }),
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($5baf59e270c57cc7$var$TextDiv, {
                        children: afterEmoji.name
                    })
                ]
            }) : /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($5baf59e270c57cc7$var$TextDiv, {
                children: emoji.name
            })
        ]
    });
}
$5baf59e270c57cc7$var$ChangeRow.propTypes = {
    eventIcon: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object.isRequired,
    eventName: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string.isRequired,
    emoji: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object.isRequired,
    afterEmoji: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).object,
    changedAt: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string.isRequired
};
var $5baf59e270c57cc7$export$2e2bcd8739ae039 = $5baf59e270c57cc7$var$ChangeRow;



function $f9db6fe0003aa60d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f9db6fe0003aa60d$var$emojiAction = {
    EMOJI_REMOVE: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7e88e947352f534a$export$28f4ed0fbb491ba9), {}),
    EMOJI_CREATE: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7e88e947352f534a$export$709605cc0aa8b94d), {}),
    EMOJI_RENAME: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7e88e947352f534a$export$f0ebbad5a430052f), {}),
    EMOJI_UPDATE: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7e88e947352f534a$export$6d2ba9a7d1a1164b), {})
};
const $f9db6fe0003aa60d$var$StyledAccordionSummary = /*#__PURE__*/ (0, $f8iEm.default)((0, $75cff09f1c334964$export$2e2bcd8739ae039), {
    target: "ez5d8vy1"
})({
    name: "ol9ofu",
    styles: "font-size:0.875rem"
});
const $f9db6fe0003aa60d$var$StyledAccordionDetails = /*#__PURE__*/ (0, $f8iEm.default)((0, $8df300c596ecf4ae$export$2e2bcd8739ae039), {
    target: "ez5d8vy0"
})({
    name: "qdeacm",
    styles: "flex-direction:column"
});
const $f9db6fe0003aa60d$var$DEFAULT_MAXIMUM = 10;
function $f9db6fe0003aa60d$var$ChangeSet({ changeSet: changeSet }) {
    const date = new Date(changeSet[0].changed_at);
    let guild = changeSet[0].guild;
    guild.id = guild.id.toString();
    let hasMore = false;
    let collapsedChangeSet = [];
    let collapsedRows = null;
    function rows(change, index) {
        const EventIcon = $f9db6fe0003aa60d$var$emojiAction[change.event];
        const emoji = change.emoji || change.before;
        const afterEmoji = change.after || null;
        return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $5baf59e270c57cc7$export$2e2bcd8739ae039), {
            eventIcon: EventIcon,
            eventName: change.event.split("_")[1],
            emoji: emoji,
            afterEmoji: afterEmoji,
            changedAt: change.changed_at
        }, `${change.changed_at}-${index}`);
    }
    if (changeSet.length > $f9db6fe0003aa60d$var$DEFAULT_MAXIMUM) {
        hasMore = true;
        collapsedChangeSet = changeSet.slice($f9db6fe0003aa60d$var$DEFAULT_MAXIMUM);
        collapsedRows = collapsedChangeSet.map(rows);
        changeSet = changeSet.slice(0, $f9db6fe0003aa60d$var$DEFAULT_MAXIMUM);
    }
    const blobs = changeSet.map(rows);
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6d6c7872fb88c6b4$export$2e2bcd8739ae039), {
        item: true,
        xs: 12,
        sm: 6,
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $c5c4f9daaf31609f$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $4bc03b18bc47d0d1$export$2e2bcd8739ae039), {
                    avatar: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7e88e947352f534a$export$ae00754399a30376), {
                        name: guild.name,
                        src: guild
                    }),
                    title: guild.name,
                    subheader: (0, $46ae9d0281ece1ca$export$22d2985352acd646)().format(date)
                }),
                blobs,
                hasMore && /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $2a1fbc11fd4cb931$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($f9db6fe0003aa60d$var$StyledAccordionSummary, {
                            expandIcon: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ce33076020a00261$exports))), {}),
                            "aria-controls": "Panel Controls",
                            children: `See ${collapsedChangeSet.length} more changes`
                        }),
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($f9db6fe0003aa60d$var$StyledAccordionDetails, {
                            children: collapsedRows
                        })
                    ]
                })
            ]
        })
    });
}
$f9db6fe0003aa60d$var$ChangeSet.propTypes = {
    changeSet: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).array.isRequired
};
$f9db6fe0003aa60d$var$ChangeSet.whyDidYouRender = true;
class $f9db6fe0003aa60d$var$ChangeSetWrapper extends (0, $8dE9F.Component) {
    // eslint-disable-next-line no-unused-vars
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextProps.changeSet.length !== this.props.changeSet.length;
    }
    render() {
        return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($f9db6fe0003aa60d$var$ChangeSet, {
            ...this.props
        });
    }
}
$f9db6fe0003aa60d$var$ChangeSetWrapper.propTypes = $f9db6fe0003aa60d$var$ChangeSet.propTypes;
var $f9db6fe0003aa60d$export$2e2bcd8739ae039 = $f9db6fe0003aa60d$var$ChangeSetWrapper;


const $ee383c103cd04a76$var$HISTORY_LIMIT = 50;
const $ee383c103cd04a76$var$HISTORY_ENDPOINT = `https://api.mousey.app/v3/emoji/blobs+community-blobs/changes?count=${$ee383c103cd04a76$var$HISTORY_LIMIT}`;
const $ee383c103cd04a76$var$HISTORY_EVENTS = [
    "EMOJI_CREATE",
    "EMOJI_RENAME",
    "EMOJI_UPDATE",
    "EMOJI_REMOVE"
];
function $ee383c103cd04a76$var$groupHistory(changeSets) {
    let changes = {};
    for (const changeSet of changeSets){
        if (!$ee383c103cd04a76$var$HISTORY_EVENTS.includes(changeSet.event)) continue;
        changeSet.changed_at += "+00:00";
        const date = new Date(changeSet.changed_at);
        const key = [
            changeSet.guild.id,
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours()
        ].join("_");
        if (!changes[key]) changes[key] = [];
        changes[key].push(changeSet);
    }
    return changes;
}
function $ee383c103cd04a76$var$RecentChanges() {
    const [changeSets, setChangeSets] = (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).useState(false);
    const [earliest, setEarliest] = (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).useState(null);
    const [reachedEnd, setReachedEnd] = (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).useState(false);
    const [skeletons] = (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).useState(Math.floor(Math.random() * 3) + 3);
    async function load() {
        setLoading(true);
        let endpoint = $ee383c103cd04a76$var$HISTORY_ENDPOINT;
        if (earliest) // If we've already loaded changes before, only load earlier ones.
        endpoint += `&before=${earliest}`;
        const response = await fetch(endpoint);
        const json = await response.json();
        if (json.length < $ee383c103cd04a76$var$HISTORY_LIMIT) setReachedEnd(true);
        setLoading(false);
        if (changeSets != null) {
            // We need to merge the changesets.
            const newChangeSets = $ee383c103cd04a76$var$groupHistory(json);
            const newState = (0, (/*@__PURE__*/$parcel$interopDefault($8p6fT)))(changeSets);
            for (const [key, value] of Object.entries(newChangeSets))if (key in newState) newState[key] = newState[key].concat(value);
            else newState[key] = value;
            setChangeSets(newState);
        } else setChangeSets($ee383c103cd04a76$var$groupHistory(json));
        setEarliest(json[json.length - 1].changed_at.replace("+00:00", ""));
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).useEffect(()=>{
        load();
    }, []);
    (0, $87cdd9a4ef227e74$export$887fcf96538e29f7)(()=>{
        if (!loading && !reachedEnd) load();
    });
    if (changeSets == null) return Array.from({
        length: skeletons
    }, (_, index)=>/*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $123e1243ed968053$export$2e2bcd8739ae039), {}, index));
    return Object.entries(changeSets).map(([key, changeSet])=>/*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $f9db6fe0003aa60d$export$2e2bcd8739ae039), {
            changeSet: changeSet
        }, key));
}
$ee383c103cd04a76$var$RecentChanges.whyDidYouRender = true;
var $ee383c103cd04a76$export$2e2bcd8739ae039 = $ee383c103cd04a76$var$RecentChanges;




function $60df887ce52d9e4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $60df887ce52d9e4c$var$_ref = {
    name: "1dabe76",
    styles: "padding-bottom:24px"
};
var $60df887ce52d9e4c$var$_ref2 = {
    name: "xjyhuw",
    styles: "margin:0.5rem 0 1rem 0"
};
function $60df887ce52d9e4c$var$ChangePage() {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $b00a3330140623b7$export$2e2bcd8739ae039), {
        css: $60df887ce52d9e4c$var$_ref,
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                variant: "h4",
                children: "Global Blob Changelog"
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                css: $60df887ce52d9e4c$var$_ref2,
                variant: "body1",
                children: "This page tracks the changes of all blobs in any of our partnered servers."
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6d6c7872fb88c6b4$export$2e2bcd8739ae039), {
                container: true,
                spacing: 3,
                children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $ee383c103cd04a76$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
$60df887ce52d9e4c$var$ChangePage.whyDidYouRender = true;
var $60df887ce52d9e4c$export$2e2bcd8739ae039 = $60df887ce52d9e4c$var$ChangePage;




var $8dE9F = parcelRequire("8dE9F");




var $agf0O = parcelRequire("agf0O");


var $8dE9F = parcelRequire("8dE9F");


var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $8dE9F = parcelRequire("8dE9F");
/**
 * @ignore - internal component.
 */ const $9b0cbbff3a302afc$var$Tablelvl2Context = /*#__PURE__*/ $8dE9F.createContext();
var $9b0cbbff3a302afc$export$2e2bcd8739ae039 = $9b0cbbff3a302afc$var$Tablelvl2Context;



var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $8112c714b69d1b15$export$98bd2a9b566ec665(slot) {
    return (0, $iobM3.default)('MuiTableBody', slot);
}
const $8112c714b69d1b15$var$tableBodyClasses = (0, $5rH1e.default)('MuiTableBody', [
    'root'
]);
var $8112c714b69d1b15$export$2e2bcd8739ae039 = $8112c714b69d1b15$var$tableBodyClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $fb3025b4b2a44e51$var$_excluded = [
    "className",
    "component"
];
const $fb3025b4b2a44e51$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $8112c714b69d1b15$export$98bd2a9b566ec665), classes);
};
const $fb3025b4b2a44e51$var$TableBodyRoot = (0, $e5aV5.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $fb3025b4b2a44e51$var$tablelvl2 = {
    variant: 'body'
};
const $fb3025b4b2a44e51$var$defaultComponent = 'tbody';
const $fb3025b4b2a44e51$var$TableBody = /*#__PURE__*/ $8dE9F.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $fb3025b4b2a44e51$var$defaultComponent } = props, other = (0, $1gVUU.default)(props, $fb3025b4b2a44e51$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component
    });
    const classes = $fb3025b4b2a44e51$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $9b0cbbff3a302afc$export$2e2bcd8739ae039).Provider, {
        value: $fb3025b4b2a44e51$var$tablelvl2,
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($fb3025b4b2a44e51$var$TableBodyRoot, (0, $7TrLl.default)({
            className: (0, $72F5q.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $fb3025b4b2a44e51$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $fb3025b4b2a44e51$export$2e2bcd8739ae039 = $fb3025b4b2a44e51$var$TableBody;




var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $kTR6J = parcelRequire("kTR6J");

var $8DPw0 = parcelRequire("8DPw0");

var $8dE9F = parcelRequire("8dE9F");
'use client';
/**
 * @ignore - internal component.
 */ const $d94e9e28210550c8$var$TableContext = /*#__PURE__*/ $8dE9F.createContext();
var $d94e9e28210550c8$export$2e2bcd8739ae039 = $d94e9e28210550c8$var$TableContext;




var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $b0337afde287ec44$export$33a0f07a16a10b1b(slot) {
    return (0, $iobM3.default)('MuiTableCell', slot);
}
const $b0337afde287ec44$var$tableCellClasses = (0, $5rH1e.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $b0337afde287ec44$export$2e2bcd8739ae039 = $b0337afde287ec44$var$tableCellClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $681c2c311f18e894$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $681c2c311f18e894$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $8DPw0.default)(align)}`,
            padding !== 'normal' && `padding${(0, $8DPw0.default)(padding)}`,
            `size${(0, $8DPw0.default)(size)}`
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $b0337afde287ec44$export$33a0f07a16a10b1b), classes);
};
const $681c2c311f18e894$var$TableCellRoot = (0, $e5aV5.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $8DPw0.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $8DPw0.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $8DPw0.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $kTR6J.lighten)((0, $kTR6J.alpha)(theme.palette.divider, 1), 0.88) : (0, $kTR6J.darken)((0, $kTR6J.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $b0337afde287ec44$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $681c2c311f18e894$var$TableCell = /*#__PURE__*/ $8dE9F.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $1gVUU.default)(props, $681c2c311f18e894$var$_excluded);
    const table = $8dE9F.useContext((0, $d94e9e28210550c8$export$2e2bcd8739ae039));
    const tablelvl2 = $8dE9F.useContext((0, $9b0cbbff3a302afc$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $7TrLl.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $681c2c311f18e894$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $dzbn0.jsx)($681c2c311f18e894$var$TableCellRoot, (0, $7TrLl.default)({
        as: component,
        ref: ref,
        className: (0, $72F5q.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $681c2c311f18e894$export$2e2bcd8739ae039 = $681c2c311f18e894$var$TableCell;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $kTR6J = parcelRequire("kTR6J");


var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $7cea77461fed4c85$export$ba0a6d6c28940107(slot) {
    return (0, $iobM3.default)('MuiTableRow', slot);
}
const $7cea77461fed4c85$var$tableRowClasses = (0, $5rH1e.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $7cea77461fed4c85$export$2e2bcd8739ae039 = $7cea77461fed4c85$var$tableRowClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $2a0f62a0a475f1e5$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $2a0f62a0a475f1e5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $7cea77461fed4c85$export$ba0a6d6c28940107), classes);
};
const $2a0f62a0a475f1e5$var$TableRowRoot = (0, $e5aV5.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $7cea77461fed4c85$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $7cea77461fed4c85$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTR6J.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTR6J.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $2a0f62a0a475f1e5$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $2a0f62a0a475f1e5$var$TableRow = /*#__PURE__*/ $8dE9F.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $2a0f62a0a475f1e5$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $1gVUU.default)(props, $2a0f62a0a475f1e5$var$_excluded);
    const tablelvl2 = $8dE9F.useContext((0, $9b0cbbff3a302afc$export$2e2bcd8739ae039));
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $2a0f62a0a475f1e5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($2a0f62a0a475f1e5$var$TableRowRoot, (0, $7TrLl.default)({
        as: component,
        ref: ref,
        className: (0, $72F5q.default)(classes.root, className),
        role: component === $2a0f62a0a475f1e5$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
var $2a0f62a0a475f1e5$export$2e2bcd8739ae039 = $2a0f62a0a475f1e5$var$TableRow;


function $ea4bb2a825463a00$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ea4bb2a825463a00$var$_ref = {
    name: "vao5p8",
    styles: "display:inline-block;margin-right:1px"
};
function $ea4bb2a825463a00$var$SkeletonApprovedSubmissions() {
    const amounts = (0, $46ae9d0281ece1ca$export$dda5fc2d183b5cbd)(3, 8);
    const [length] = (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).useState(amounts[Math.floor(Math.random() * amounts.length)]);
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $681c2c311f18e894$export$2e2bcd8739ae039), {
        width: 704,
        children: Array.from({
            length: length
        }, (_, index)=>/*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                variant: "circular",
                width: 32,
                height: 32,
                css: $ea4bb2a825463a00$var$_ref
            }, index))
    });
}
function $ea4bb2a825463a00$var$SkeletonNames() {
    const amounts = [
        50,
        70,
        90,
        110,
        130
    ];
    const [length] = (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).useState(amounts[Math.floor(Math.random() * amounts.length)]);
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $681c2c311f18e894$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
            variant: "rectangular",
            width: length,
            height: 20
        })
    });
}
const $ea4bb2a825463a00$var$SkeletonSubmissions = /*#__PURE__*/ (0, $8dE9F.memo)(function SkeletonSubmissions() {
    const amounts = (0, $46ae9d0281ece1ca$export$dda5fc2d183b5cbd)(8, 14);
    const [length] = (0, (/*@__PURE__*/$parcel$interopDefault($8dE9F))).useState(amounts[Math.floor(Math.random() * amounts.length)]);
    const skeletons = Array.from({
        length: length
    }, (_, index)=>{
        return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $2a0f62a0a475f1e5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $681c2c311f18e894$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $2c9c61712604a1ae$export$2e2bcd8739ae039), {
                        variant: "circular",
                        width: 64,
                        height: 64
                    })
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($ea4bb2a825463a00$var$SkeletonNames, {}),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($ea4bb2a825463a00$var$SkeletonApprovedSubmissions, {})
            ]
        }, index);
    });
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $fb3025b4b2a44e51$export$2e2bcd8739ae039), {
        children: skeletons
    });
});
var $ea4bb2a825463a00$export$2e2bcd8739ae039 = $ea4bb2a825463a00$var$SkeletonSubmissions;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $kTR6J = parcelRequire("kTR6J");
parcelRequire("8dE9F");

var $58054 = parcelRequire("58054");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
var $a010948925f67eca$export$2e2bcd8739ae039 = (0, $58054.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');





var $8DPw0 = parcelRequire("8DPw0");


var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $e3c13c93866e2931$export$31444911e4ee6fdd(slot) {
    return (0, $iobM3.default)('MuiChip', slot);
}
const $e3c13c93866e2931$var$chipClasses = (0, $5rH1e.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $e3c13c93866e2931$export$2e2bcd8739ae039 = $e3c13c93866e2931$var$chipClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $6004abc095dca5a5$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $6004abc095dca5a5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $8DPw0.default)(size)}`,
            `color${(0, $8DPw0.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $8DPw0.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $8DPw0.default)(color)}`,
            `${variant}${(0, $8DPw0.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $8DPw0.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $8DPw0.default)(size)}`,
            `avatarColor${(0, $8DPw0.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $8DPw0.default)(size)}`,
            `iconColor${(0, $8DPw0.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $8DPw0.default)(size)}`,
            `deleteIconColor${(0, $8DPw0.default)(color)}`,
            `deleteIcon${(0, $8DPw0.default)(variant)}Color${(0, $8DPw0.default)(color)}`
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $e3c13c93866e2931$export$31444911e4ee6fdd), classes);
};
const $6004abc095dca5a5$var$ChipRoot = (0, $e5aV5.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $8DPw0.default)(size)}`]
            },
            {
                [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $8DPw0.default)(color)}`]
            },
            {
                [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $8DPw0.default)(size)}`]
            },
            {
                [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $8DPw0.default)(iconColor)}`]
            },
            {
                [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $8DPw0.default)(size)}`]
            },
            {
                [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $8DPw0.default)(color)}`]
            },
            {
                [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $8DPw0.default)(variant)}Color${(0, $8DPw0.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $8DPw0.default)(size)}`],
            styles[`color${(0, $8DPw0.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $8DPw0.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $8DPw0.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $8DPw0.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $7TrLl.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).icon}`]: (0, $7TrLl.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $7TrLl.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).deleteIcon}`]: (0, $7TrLl.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $kTR6J.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $kTR6J.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $kTR6J.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTR6J.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTR6J.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTR6J.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kTR6J.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTR6J.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $kTR6J.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $e3c13c93866e2931$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kTR6J.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $6004abc095dca5a5$var$ChipLabel = (0, $e5aV5.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $8DPw0.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $7TrLl.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $6004abc095dca5a5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $6004abc095dca5a5$var$Chip = /*#__PURE__*/ $8dE9F.forwardRef(function Chip(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $1gVUU.default)(props, $6004abc095dca5a5$var$_excluded);
    const chipRef = $8dE9F.useRef(null);
    const handleRef = (0, $2b5ed6ec4169216c$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $6004abc095dca5a5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $6004abc095dca5a5$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $66635f5fba848ee5$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $8dE9F.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $6004abc095dca5a5$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $66635f5fba848ee5$export$2e2bcd8739ae039) ? (0, $7TrLl.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $8dE9F.isValidElement(deleteIconProp) ? /*#__PURE__*/ $8dE9F.cloneElement(deleteIconProp, {
        className: (0, $72F5q.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $dzbn0.jsx)((0, $a010948925f67eca$export$2e2bcd8739ae039), {
        className: (0, $72F5q.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $8dE9F.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $8dE9F.cloneElement(avatarProp, {
        className: (0, $72F5q.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $8dE9F.isValidElement(iconProp)) icon = /*#__PURE__*/ $8dE9F.cloneElement(iconProp, {
        className: (0, $72F5q.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $dzbn0.jsxs)($6004abc095dca5a5$var$ChipRoot, (0, $7TrLl.default)({
        as: component,
        className: (0, $72F5q.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $dzbn0.jsx)($6004abc095dca5a5$var$ChipLabel, {
                className: (0, $72F5q.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $6004abc095dca5a5$export$2e2bcd8739ae039 = $6004abc095dca5a5$var$Chip;




var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $93dbc4542ceb2f3e$export$eed427986a7abdf9(slot) {
    return (0, $iobM3.default)('MuiTableContainer', slot);
}
const $93dbc4542ceb2f3e$var$tableContainerClasses = (0, $5rH1e.default)('MuiTableContainer', [
    'root'
]);
var $93dbc4542ceb2f3e$export$2e2bcd8739ae039 = $93dbc4542ceb2f3e$var$tableContainerClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $d78a80be7928a48c$var$_excluded = [
    "className",
    "component"
];
const $d78a80be7928a48c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $93dbc4542ceb2f3e$export$eed427986a7abdf9), classes);
};
const $d78a80be7928a48c$var$TableContainerRoot = (0, $e5aV5.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const $d78a80be7928a48c$var$TableContainer = /*#__PURE__*/ $8dE9F.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $1gVUU.default)(props, $d78a80be7928a48c$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component
    });
    const classes = $d78a80be7928a48c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($d78a80be7928a48c$var$TableContainerRoot, (0, $7TrLl.default)({
        ref: ref,
        as: component,
        className: (0, $72F5q.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $d78a80be7928a48c$export$2e2bcd8739ae039 = $d78a80be7928a48c$var$TableContainer;



var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");


var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $08c5e054a7e349ba$export$2e731cea2d1c2392(slot) {
    return (0, $iobM3.default)('MuiTableHead', slot);
}
const $08c5e054a7e349ba$var$tableHeadClasses = (0, $5rH1e.default)('MuiTableHead', [
    'root'
]);
var $08c5e054a7e349ba$export$2e2bcd8739ae039 = $08c5e054a7e349ba$var$tableHeadClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $fa4457b44ab389b1$var$_excluded = [
    "className",
    "component"
];
const $fa4457b44ab389b1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $08c5e054a7e349ba$export$2e731cea2d1c2392), classes);
};
const $fa4457b44ab389b1$var$TableHeadRoot = (0, $e5aV5.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $fa4457b44ab389b1$var$tablelvl2 = {
    variant: 'head'
};
const $fa4457b44ab389b1$var$defaultComponent = 'thead';
const $fa4457b44ab389b1$var$TableHead = /*#__PURE__*/ $8dE9F.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $fa4457b44ab389b1$var$defaultComponent } = props, other = (0, $1gVUU.default)(props, $fa4457b44ab389b1$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component
    });
    const classes = $fa4457b44ab389b1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $9b0cbbff3a302afc$export$2e2bcd8739ae039).Provider, {
        value: $fa4457b44ab389b1$var$tablelvl2,
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($fa4457b44ab389b1$var$TableHeadRoot, (0, $7TrLl.default)({
            as: component,
            className: (0, $72F5q.default)(classes.root, className),
            ref: ref,
            role: component === $fa4457b44ab389b1$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $fa4457b44ab389b1$export$2e2bcd8739ae039 = $fa4457b44ab389b1$var$TableHead;





var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");


var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $2c5bff08accc44df$export$315cb19215f77ce0(slot) {
    return (0, $iobM3.default)('MuiTable', slot);
}
const $2c5bff08accc44df$var$tableClasses = (0, $5rH1e.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $2c5bff08accc44df$export$2e2bcd8739ae039 = $2c5bff08accc44df$var$tableClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $353e3bfa95d819da$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $353e3bfa95d819da$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $2c5bff08accc44df$export$315cb19215f77ce0), classes);
};
const $353e3bfa95d819da$var$TableRoot = (0, $e5aV5.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $7TrLl.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $353e3bfa95d819da$var$defaultComponent = 'table';
const $353e3bfa95d819da$var$Table = /*#__PURE__*/ $8dE9F.forwardRef(function Table(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $353e3bfa95d819da$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $1gVUU.default)(props, $353e3bfa95d819da$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $353e3bfa95d819da$var$useUtilityClasses(ownerState);
    const table = $8dE9F.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $d94e9e28210550c8$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($353e3bfa95d819da$var$TableRoot, (0, $7TrLl.default)({
            as: component,
            role: component === $353e3bfa95d819da$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $72F5q.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $353e3bfa95d819da$export$2e2bcd8739ae039 = $353e3bfa95d819da$var$Table;





function $fd90b5b876b207af$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $fd90b5b876b207af$var$DrawfestSubmissionsHead() {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $fa4457b44ab389b1$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $2a0f62a0a475f1e5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $681c2c311f18e894$export$2e2bcd8739ae039), {
                    width: 64
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $681c2c311f18e894$export$2e2bcd8739ae039), {
                    children: "User"
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $681c2c311f18e894$export$2e2bcd8739ae039), {
                    width: 704,
                    children: "Approved Submissions"
                })
            ]
        })
    });
}
var $fd90b5b876b207af$var$_ref = {
    name: "w5hw7h",
    styles: "margin-right:1px"
};
function $fd90b5b876b207af$var$ApprovedCell({ approvedSubmissions: approvedSubmissions, promptData: promptData }) {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $681c2c311f18e894$export$2e2bcd8739ae039), {
        children: approvedSubmissions.map((submission)=>{
            function onClick() {
                if (!submission.image_url) return;
                window.open(submission.image_url, "_blank");
            }
            return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                title: promptData[submission.prompt_id],
                arrow: true,
                children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $6004abc095dca5a5$export$2e2bcd8739ae039), {
                    label: submission.prompt_id + 1,
                    css: $fd90b5b876b207af$var$_ref,
                    clickable: true,
                    onClick: onClick
                })
            }, submission.prompt_id);
        })
    });
}
$fd90b5b876b207af$var$ApprovedCell.propTypes = {
    approvedSubmissions: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).shape({
        prompt_id: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).number,
        image_url: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string
    })).isRequired,
    promptData: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).array.isRequired
};
var $fd90b5b876b207af$var$_ref2 = {
    name: "173u6wr",
    styles: "width:64px;height:64px"
};
function $fd90b5b876b207af$var$DrawfestSubmissionsBody({ submissions: submissions, promptData: promptData }) {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $fb3025b4b2a44e51$export$2e2bcd8739ae039), {
        children: submissions.map((row)=>/*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $2a0f62a0a475f1e5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $681c2c311f18e894$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $aab3ebb6ea9060fa$export$2e2bcd8739ae039), {
                            alt: row.username,
                            src: `https://cdn.discordapp.com/avatars/${row.id}/${row.avatar}.webp?size=64`,
                            css: $fd90b5b876b207af$var$_ref2
                        })
                    }),
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $681c2c311f18e894$export$2e2bcd8739ae039), {
                        children: row.username
                    }),
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($fd90b5b876b207af$var$ApprovedCell, {
                        approvedSubmissions: row.submissions,
                        promptData: promptData
                    })
                ]
            }, row.id))
    });
}
$fd90b5b876b207af$var$DrawfestSubmissionsBody.propTypes = {
    submissions: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).shape({
        username: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string,
        approved_submissions: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).number),
        id: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).string
    })).isRequired,
    promptData: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).array.isRequired
};
function $fd90b5b876b207af$var$DrawfestSubmissions({ submissions: submissions, promptData: promptData }) {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $d78a80be7928a48c$export$2e2bcd8739ae039), {
        component: (0, $d04b0e428813fc1b$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $353e3bfa95d819da$export$2e2bcd8739ae039), {
            "aria-label": "Drawfest Submissions",
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($fd90b5b876b207af$var$DrawfestSubmissionsHead, {}),
                submissions.length === 0 ? /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $ea4bb2a825463a00$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($fd90b5b876b207af$var$DrawfestSubmissionsBody, {
                    submissions: submissions,
                    promptData: promptData
                })
            ]
        })
    });
}
$fd90b5b876b207af$var$DrawfestSubmissions.propTypes = {
    submissions: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).array.isRequired,
    promptData: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).array.isRequired
};
var $fd90b5b876b207af$export$2e2bcd8739ae039 = $fd90b5b876b207af$var$DrawfestSubmissions;




function $d8ba614b8f0e3f8e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d8ba614b8f0e3f8e$var$DRAWFEST_ENDPOINT = "https://api.blobs.gg/v1/events/drawfest/{year}/{type}";
const $d8ba614b8f0e3f8e$var$overHeaderStyle = {
    textAlign: "center",
    margin: "2em 0 0.125em 0"
};
const $d8ba614b8f0e3f8e$var$subHeaderStyle = {
    textAlign: "center",
    marginBottom: "2em"
};
function $d8ba614b8f0e3f8e$var$PumpkinBlobEmoji() {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7f50bfc76ce34f6e$export$2e2bcd8739ae039), {
        id: "850869054046732289",
        name: "ablobpumpkin",
        animated: true,
        externalContainerStyle: {
            margin: "0 0.25rem"
        },
        disableTooltip: true
    });
}
function $d8ba614b8f0e3f8e$var$SantaBlobEmoji() {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7f50bfc76ce34f6e$export$2e2bcd8739ae039), {
        id: "661861326888370186",
        name: "blobsanta",
        externalContainerStyle: {
            margin: "0 0.25rem"
        },
        disableTooltip: true,
        animated: false
    });
}
var $d8ba614b8f0e3f8e$var$_ref = {
    name: "1dabe76",
    styles: "padding-bottom:24px"
};
function $d8ba614b8f0e3f8e$var$DrawfestPage() {
    const [apiData, setApiData] = (0, $8dE9F.useState)([]);
    const [apiDataFetched, setApiDataFetched] = (0, $8dE9F.useState)(false);
    const [promptData, setPromptData] = (0, $8dE9F.useState)([]);
    const [promptDataFetched, setPromptDataFetched] = (0, $8dE9F.useState)(false);
    const { year: year } = (0, $aa49d4a669bfa59a$export$99eaa27ddbbb95ef)();
    const month = new Date().getMonth() + 1;
    (0, $8dE9F.useEffect)(()=>{
        if (apiDataFetched) return;
        const fetchData = async ()=>{
            setApiDataFetched(true);
            const resp = await fetch($d8ba614b8f0e3f8e$var$DRAWFEST_ENDPOINT.replace("{year}", year).replace("{type}", "digest"));
            const data = await resp.json();
            setApiData(data);
        };
        fetchData();
    }, [
        apiData,
        apiDataFetched
    ]);
    (0, $8dE9F.useEffect)(()=>{
        if (promptDataFetched) return;
        const fetchData = async ()=>{
            setPromptDataFetched(true);
            const resp = await fetch($d8ba614b8f0e3f8e$var$DRAWFEST_ENDPOINT.replace("{year}", year).replace("{type}", "prompts"));
            const data = await resp.json();
            setPromptData(data);
        };
        fetchData();
    }, [
        promptData,
        promptDataFetched
    ]);
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $b00a3330140623b7$export$2e2bcd8739ae039), {
        css: $d8ba614b8f0e3f8e$var$_ref,
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                variant: "h5",
                css: $d8ba614b8f0e3f8e$var$overHeaderStyle,
                children: [
                    month === 10 ? /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($d8ba614b8f0e3f8e$var$PumpkinBlobEmoji, {}) : /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($d8ba614b8f0e3f8e$var$SantaBlobEmoji, {}),
                    "We are currently running Drawfest ",
                    year,
                    "!",
                    month === 10 ? /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($d8ba614b8f0e3f8e$var$PumpkinBlobEmoji, {}) : /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($d8ba614b8f0e3f8e$var$SantaBlobEmoji, {})
                ]
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                css: $d8ba614b8f0e3f8e$var$subHeaderStyle,
                children: "You may view how many approved submissions you have here."
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $fd90b5b876b207af$export$2e2bcd8739ae039), {
                submissions: apiData,
                promptData: promptData
            })
        ]
    });
}
$d8ba614b8f0e3f8e$var$DrawfestPage.whyDidYouRender = true;
var $d8ba614b8f0e3f8e$export$2e2bcd8739ae039 = $d8ba614b8f0e3f8e$var$DrawfestPage;




parcelRequire("8dE9F");
const $3d3f071e4f94adae$var$SvgServer1 = (props)=>/*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 864 864",
        ...props,
        children: [
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("path", {
                d: "m0 108 432 324 432-324V0H0z",
                style: {
                    fill: "#ff4131"
                }
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("path", {
                d: "M864 108 432 432l432 324z",
                style: {
                    fill: "#0086f8"
                }
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("path", {
                d: "m0 756 432-324 432 324v108H0z",
                style: {
                    fill: "#00aa4b"
                }
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("path", {
                d: "M0 108v648l432-324z",
                style: {
                    fill: "#ffbd00"
                }
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("path", {
                d: "M432 185.14c-283 0-289.72 317.24-289.72 380.06S272.1 678.86 432 678.86s289.7-50.92 289.7-113.66S715 185.14 432 185.14Z",
                style: {
                    fill: "#fcc21b",
                    stroke: "#2f2f2f",
                    strokeMiterlimit: 10,
                    strokeWidth: 20
                }
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("path", {
                d: "M560.93 423.84H435.07V476h72.45c-6.76 33.15-35 52.18-72.45 52.18a79.81 79.81 0 1 1 0-159.62 78.1 78.1 0 0 1 49.73 17.8l39.29-39.29c-23.94-20.88-54.64-33.77-89-33.77a135.07 135.07 0 1 0 0 270.14C502.6 583.47 564 534.35 564 448.4a112.2 112.2 0 0 0-3.07-24.56",
                style: {
                    fill: "#2f2f2f"
                }
            })
        ]
    });
var $3d3f071e4f94adae$export$2e2bcd8739ae039 = $3d3f071e4f94adae$var$SvgServer1;



var $8dE9F = parcelRequire("8dE9F");

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $8DPw0 = parcelRequire("8DPw0");


var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $81da9b2679f9bbdc$export$47a2da616e55e8e9(slot) {
    return (0, $iobM3.default)('MuiAppBar', slot);
}
const $81da9b2679f9bbdc$var$appBarClasses = (0, $5rH1e.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $81da9b2679f9bbdc$export$2e2bcd8739ae039 = $81da9b2679f9bbdc$var$appBarClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $e69d2a6ea4885d36$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $e69d2a6ea4885d36$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $8DPw0.default)(color)}`,
            `position${(0, $8DPw0.default)(position)}`
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $81da9b2679f9bbdc$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $e69d2a6ea4885d36$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})` : var2;
const $e69d2a6ea4885d36$var$AppBarRoot = (0, $e5aV5.default)((0, $d04b0e428813fc1b$export$2e2bcd8739ae039), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $8DPw0.default)(ownerState.position)}`],
            styles[`color${(0, $8DPw0.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $7TrLl.default)({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === 'fixed' && {
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0,
        '@media print': {
            // Prevent the app bar to be visible on each printed page.
            position: 'absolute'
        }
    }, ownerState.position === 'absolute' && {
        position: 'absolute',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'sticky' && {
        // ⚠️ sticky is not supported by IE11.
        position: 'sticky',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'static' && {
        position: 'static'
    }, ownerState.position === 'relative' && {
        position: 'relative'
    }, !theme.vars && (0, $7TrLl.default)({}, ownerState.color === 'default' && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === 'transparent' && (0, $7TrLl.default)({
        backgroundColor: 'transparent',
        color: 'inherit'
    }, theme.palette.mode === 'dark' && {
        backgroundImage: 'none'
    })), theme.vars && (0, $7TrLl.default)({}, ownerState.color === 'default' && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $e69d2a6ea4885d36$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $e69d2a6ea4885d36$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $e69d2a6ea4885d36$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $e69d2a6ea4885d36$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, ![
        'inherit',
        'transparent'
    ].includes(ownerState.color) && {
        backgroundColor: 'var(--AppBar-background)'
    }, {
        color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
    }, ownerState.color === 'transparent' && {
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        color: 'inherit'
    }));
});
const $e69d2a6ea4885d36$var$AppBar = /*#__PURE__*/ $8dE9F.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed' } = props, other = (0, $1gVUU.default)(props, $e69d2a6ea4885d36$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $e69d2a6ea4885d36$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($e69d2a6ea4885d36$var$AppBarRoot, (0, $7TrLl.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $72F5q.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
var $e69d2a6ea4885d36$export$2e2bcd8739ae039 = $e69d2a6ea4885d36$var$AppBar;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $91b32ceedf69718c$export$b12cb262231eef32(slot) {
    return (0, $iobM3.default)('MuiToolbar', slot);
}
const $91b32ceedf69718c$var$toolbarClasses = (0, $5rH1e.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $91b32ceedf69718c$export$2e2bcd8739ae039 = $91b32ceedf69718c$var$toolbarClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $c9179604e52b08cb$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $c9179604e52b08cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $91b32ceedf69718c$export$b12cb262231eef32), classes);
};
const $c9179604e52b08cb$var$ToolbarRoot = (0, $e5aV5.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $c9179604e52b08cb$var$Toolbar = /*#__PURE__*/ $8dE9F.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $1gVUU.default)(props, $c9179604e52b08cb$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $c9179604e52b08cb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($c9179604e52b08cb$var$ToolbarRoot, (0, $7TrLl.default)({
        as: component,
        className: (0, $72F5q.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $c9179604e52b08cb$export$2e2bcd8739ae039 = $c9179604e52b08cb$var$Toolbar;




var $1c6d8c0ee6985558$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($1c6d8c0ee6985558$exports, "__esModule", {
    value: true
});
$1c6d8c0ee6985558$exports.default = void 0;

var $1c6d8c0ee6985558$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $1c6d8c0ee6985558$var$_default = $1c6d8c0ee6985558$exports.default = (0, $1c6d8c0ee6985558$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), 'Settings');


var $b0e13bac902559b4$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($b0e13bac902559b4$exports, "__esModule", {
    value: true
});
$b0e13bac902559b4$exports.default = void 0;

var $b0e13bac902559b4$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $b0e13bac902559b4$var$_default = $b0e13bac902559b4$exports.default = (0, $b0e13bac902559b4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M3 13h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7z"
}), 'List');


var $a6f45482272b8954$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($a6f45482272b8954$exports, "__esModule", {
    value: true
});
$a6f45482272b8954$exports.default = void 0;

var $a6f45482272b8954$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $a6f45482272b8954$var$_default = $a6f45482272b8954$exports.default = (0, $a6f45482272b8954$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), 'Home');





var $agf0O = parcelRequire("agf0O");


var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $kTR6J = parcelRequire("kTR6J");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $4877b9a64a1eccf0$export$46f01d01378ec5a2(slot) {
    return (0, $iobM3.default)('MuiDivider', slot);
}
const $4877b9a64a1eccf0$var$dividerClasses = (0, $5rH1e.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $4877b9a64a1eccf0$export$2e2bcd8739ae039 = $4877b9a64a1eccf0$var$dividerClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $8f402101b41e5553$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $8f402101b41e5553$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $4877b9a64a1eccf0$export$46f01d01378ec5a2), classes);
};
const $8f402101b41e5553$var$DividerRoot = (0, $e5aV5.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $kTR6J.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $7TrLl.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState: ownerState })=>(0, $7TrLl.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $8f402101b41e5553$var$DividerWrapper = (0, $e5aV5.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $8f402101b41e5553$var$Divider = /*#__PURE__*/ $8dE9F.forwardRef(function Divider(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $1gVUU.default)(props, $8f402101b41e5553$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $8f402101b41e5553$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($8f402101b41e5553$var$DividerRoot, (0, $7TrLl.default)({
        as: component,
        className: (0, $72F5q.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $dzbn0.jsx)($8f402101b41e5553$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $8f402101b41e5553$var$Divider.muiSkipListHighlight = true;
var $8f402101b41e5553$export$2e2bcd8739ae039 = $8f402101b41e5553$var$Divider;



var $311cM = parcelRequire("311cM");
function $8b7f9cde8c9246f7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8b7f9cde8c9246f7$var$_ref = {
    name: "jgu8go",
    styles: "flex-grow:1;color:inherit;text-decoration:none"
};
var $8b7f9cde8c9246f7$var$_ref2 = {
    name: "1ha41lr",
    styles: "margin:0 0.25rem"
};
const $8b7f9cde8c9246f7$var$Header = /*#__PURE__*/ (0, $8dE9F.memo)(function Header(props) {
    function handleOpen() {
        props.handleOpen(true);
    }
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $e69d2a6ea4885d36$export$2e2bcd8739ae039), {
        position: "static",
        color: "transparent",
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $c9179604e52b08cb$export$2e2bcd8739ae039), {
            disableGutters: true,
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $aab3ebb6ea9060fa$export$2e2bcd8739ae039), {
                    css: (theme)=>/*#__PURE__*/ (0, $311cM.css)({
                            marginRight: theme.spacing(2)
                        }, "", ""),
                    alt: "Blob Emoji Server Icon",
                    component: (0, $701be91339cf6054$export$a6c7ac8248d6e38a),
                    to: "/",
                    children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $3d3f071e4f94adae$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                    variant: "h6",
                    css: $8b7f9cde8c9246f7$var$_ref,
                    component: (0, $701be91339cf6054$export$a6c7ac8248d6e38a),
                    to: "/",
                    children: "Blob Emoji"
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                    title: "Home",
                    arrow: true,
                    children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $bc55b9c9c616a23b$export$2e2bcd8739ae039), {
                        component: (0, $701be91339cf6054$export$a6c7ac8248d6e38a),
                        to: "/",
                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a6f45482272b8954$exports))), {})
                    })
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                    title: "Emoji Changelog",
                    arrow: true,
                    children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $bc55b9c9c616a23b$export$2e2bcd8739ae039), {
                        component: (0, $701be91339cf6054$export$a6c7ac8248d6e38a),
                        to: "/changes",
                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b0e13bac902559b4$exports))), {})
                    })
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $8f402101b41e5553$export$2e2bcd8739ae039), {
                    css: $8b7f9cde8c9246f7$var$_ref2,
                    orientation: "vertical",
                    flexItem: true
                }),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                    title: "Settings",
                    arrow: true,
                    children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $bc55b9c9c616a23b$export$2e2bcd8739ae039), {
                        onClick: handleOpen,
                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1c6d8c0ee6985558$exports))), {})
                    })
                })
            ]
        })
    });
});
$8b7f9cde8c9246f7$var$Header.propTypes = {
    handleOpen: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).func.isRequired
};
var $8b7f9cde8c9246f7$export$2e2bcd8739ae039 = $8b7f9cde8c9246f7$var$Header;




var $fuS6y = parcelRequire("fuS6y");

var $8dE9F = parcelRequire("8dE9F");



'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $f676a948b6c55387$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $8dE9F.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $0b33b5af51106e3b$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $f676a948b6c55387$var$maybeReactUseSyncExternalStore = $8dE9F.useSyncExternalStore;
function $f676a948b6c55387$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $8dE9F.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $8dE9F.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $8dE9F.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $f676a948b6c55387$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $f676a948b6c55387$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $e6fd8e44c7111210$export$2e2bcd8739ae039)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $a5cb072d8a15407b$export$2e2bcd8739ae039)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme: theme
    });
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $f676a948b6c55387$var$maybeReactUseSyncExternalStore !== undefined ? $f676a948b6c55387$var$useMediaQueryNew : $f676a948b6c55387$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}




var $f8iEm = parcelRequire("f8iEm");

var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");


var $8DPw0 = parcelRequire("8DPw0");




var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $6d082f2c0846b4bd$export$2177af0aa15c34c2(slot) {
    return (0, $iobM3.default)('MuiDialog', slot);
}
const $6d082f2c0846b4bd$var$dialogClasses = (0, $5rH1e.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $6d082f2c0846b4bd$export$2e2bcd8739ae039 = $6d082f2c0846b4bd$var$dialogClasses;



var $8dE9F = parcelRequire("8dE9F");
const $bd1cebcf356dec12$var$DialogContext = /*#__PURE__*/ $8dE9F.createContext({});
var $bd1cebcf356dec12$export$2e2bcd8739ae039 = $bd1cebcf356dec12$var$DialogContext;





var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $9d266ce9dd577089$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $9d266ce9dd577089$var$DialogBackdrop = (0, $e5aV5.default)((0, $7d9e1f2500321019$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $9d266ce9dd577089$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $8DPw0.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $8DPw0.default)(scroll)}`,
            `paperWidth${(0, $8DPw0.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $6d082f2c0846b4bd$export$2177af0aa15c34c2), classes);
};
const $9d266ce9dd577089$var$DialogRoot = (0, $e5aV5.default)((0, $dedc4b31f1d2deed$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $9d266ce9dd577089$var$DialogContainer = (0, $e5aV5.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $8DPw0.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $7TrLl.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $9d266ce9dd577089$var$DialogPaper = (0, $e5aV5.default)((0, $d04b0e428813fc1b$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $8DPw0.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $8DPw0.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $6d082f2c0846b4bd$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $6d082f2c0846b4bd$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $6d082f2c0846b4bd$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $9d266ce9dd577089$var$Dialog = /*#__PURE__*/ $8dE9F.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $88f720b0aa3cee5b$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $d04b0e428813fc1b$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $489f51878043e5a2$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $1gVUU.default)(props, $9d266ce9dd577089$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $9d266ce9dd577089$var$useUtilityClasses(ownerState);
    const backdropClick = $8dE9F.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $02833fc3ddd87b8f$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $8dE9F.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($9d266ce9dd577089$var$DialogRoot, (0, $7TrLl.default)({
        className: (0, $72F5q.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $9d266ce9dd577089$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $7TrLl.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $dzbn0.jsx)(TransitionComponent, (0, $7TrLl.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $dzbn0.jsx)($9d266ce9dd577089$var$DialogContainer, {
                className: (0, $72F5q.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $dzbn0.jsx)($9d266ce9dd577089$var$DialogPaper, (0, $7TrLl.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $72F5q.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $dzbn0.jsx)((0, $bd1cebcf356dec12$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $9d266ce9dd577089$export$2e2bcd8739ae039 = $9d266ce9dd577089$var$Dialog;



var $8dE9F = parcelRequire("8dE9F");

var $agf0O = parcelRequire("agf0O");

var $7TrLl = parcelRequire("7TrLl");

var $1gVUU = parcelRequire("1gVUU");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");


var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $7347dfc51f5fc896$export$f5d2ec7e4c47e088(slot) {
    return (0, $iobM3.default)('MuiDialogTitle', slot);
}
const $7347dfc51f5fc896$var$dialogTitleClasses = (0, $5rH1e.default)('MuiDialogTitle', [
    'root'
]);
var $7347dfc51f5fc896$export$2e2bcd8739ae039 = $7347dfc51f5fc896$var$dialogTitleClasses;




var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $5ee627924345a8d1$var$_excluded = [
    "className",
    "id"
];
const $5ee627924345a8d1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $7347dfc51f5fc896$export$f5d2ec7e4c47e088), classes);
};
const $5ee627924345a8d1$var$DialogTitleRoot = (0, $e5aV5.default)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $5ee627924345a8d1$var$DialogTitle = /*#__PURE__*/ $8dE9F.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $1gVUU.default)(props, $5ee627924345a8d1$var$_excluded);
    const ownerState = props;
    const classes = $5ee627924345a8d1$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $8dE9F.useContext((0, $bd1cebcf356dec12$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $dzbn0.jsx)($5ee627924345a8d1$var$DialogTitleRoot, (0, $7TrLl.default)({
        component: "h2",
        className: (0, $72F5q.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $5ee627924345a8d1$export$2e2bcd8739ae039 = $5ee627924345a8d1$var$DialogTitle;



var $567e510f6ee0e200$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($567e510f6ee0e200$exports, "__esModule", {
    value: true
});
$567e510f6ee0e200$exports.default = void 0;

var $567e510f6ee0e200$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $567e510f6ee0e200$var$_default = $567e510f6ee0e200$exports.default = (0, $567e510f6ee0e200$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $b40ebeaae68813db$export$61b0ee1f05fb344e(slot) {
    return (0, $iobM3.default)('MuiDialogContent', slot);
}
const $b40ebeaae68813db$var$dialogContentClasses = (0, $5rH1e.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $b40ebeaae68813db$export$2e2bcd8739ae039 = $b40ebeaae68813db$var$dialogContentClasses;




var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $17726cd3a4f3cc2b$var$_excluded = [
    "className",
    "dividers"
];
const $17726cd3a4f3cc2b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $b40ebeaae68813db$export$61b0ee1f05fb344e), classes);
};
const $17726cd3a4f3cc2b$var$DialogContentRoot = (0, $e5aV5.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $7347dfc51f5fc896$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $17726cd3a4f3cc2b$var$DialogContent = /*#__PURE__*/ $8dE9F.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $1gVUU.default)(props, $17726cd3a4f3cc2b$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        dividers: dividers
    });
    const classes = $17726cd3a4f3cc2b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($17726cd3a4f3cc2b$var$DialogContentRoot, (0, $7TrLl.default)({
        className: (0, $72F5q.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $17726cd3a4f3cc2b$export$2e2bcd8739ae039 = $17726cd3a4f3cc2b$var$DialogContent;


var $07acf776ce70d9c4$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($07acf776ce70d9c4$exports, "__esModule", {
    value: true
});
$07acf776ce70d9c4$exports.default = void 0;

var $07acf776ce70d9c4$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $07acf776ce70d9c4$var$_default = $07acf776ce70d9c4$exports.default = (0, $07acf776ce70d9c4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
}), 'BrightnessHigh');


var $072288c5cc63b91c$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($072288c5cc63b91c$exports, "__esModule", {
    value: true
});
$072288c5cc63b91c$exports.default = void 0;

var $072288c5cc63b91c$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $072288c5cc63b91c$var$_default = $072288c5cc63b91c$exports.default = (0, $072288c5cc63b91c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2"
}), 'Brightness2');


var $27a5d82ed4200b9d$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($27a5d82ed4200b9d$exports, "__esModule", {
    value: true
});
$27a5d82ed4200b9d$exports.default = void 0;

var $27a5d82ed4200b9d$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $27a5d82ed4200b9d$var$_default = $27a5d82ed4200b9d$exports.default = (0, $27a5d82ed4200b9d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6"
}), 'Brightness4');



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $e5aV5 = parcelRequire("e5aV5");
var $6xVVB = parcelRequire("6xVVB");

var $lE3rX = parcelRequire("lE3rX");


var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $819afee1752315b2$export$d9c6dc45f75b0e4f(slot) {
    return (0, $iobM3.default)('MuiDialogContentText', slot);
}
const $819afee1752315b2$var$dialogContentTextClasses = (0, $5rH1e.default)('MuiDialogContentText', [
    'root'
]);
var $819afee1752315b2$export$2e2bcd8739ae039 = $819afee1752315b2$var$dialogContentTextClasses;



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $f1055812b5e9f556$var$_excluded = [
    "children",
    "className"
];
const $f1055812b5e9f556$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $fgPD6.default)(slots, (0, $819afee1752315b2$export$d9c6dc45f75b0e4f), classes);
    return (0, $7TrLl.default)({}, classes, composedClasses);
};
const $f1055812b5e9f556$var$DialogContentTextRoot = (0, $e5aV5.default)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $6xVVB.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $f1055812b5e9f556$var$DialogContentText = /*#__PURE__*/ $8dE9F.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { className: className } = props, ownerState = (0, $1gVUU.default)(props, $f1055812b5e9f556$var$_excluded);
    const classes = $f1055812b5e9f556$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)($f1055812b5e9f556$var$DialogContentTextRoot, (0, $7TrLl.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $72F5q.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
var $f1055812b5e9f556$export$2e2bcd8739ae039 = $f1055812b5e9f556$var$DialogContentText;



parcelRequire("8dE9F");
const $a49c402e21845732$var$Svg12H = (props)=>/*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        ...props,
        children: [
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("path", {
                d: "M12 4c-3.919-.065-7.644 2.752-8.658 6.537-1.06 3.566.376 7.691 3.447 9.803 3.13 2.302 7.751 2.19 10.768-.26 3.03-2.302 4.25-6.622 2.896-10.174C19.216 6.416 15.705 3.954 12 4m-.598 2.02c2.357-.184 4.808.846 6.207 2.793 2 2.571 1.81 6.526-.427 8.894A7 7 0 0 1 12 20c-3.231.063-6.264-2.415-6.857-5.59-.698-3.111 1.05-6.529 3.976-7.79a6.5 6.5 0 0 1 2.283-.6M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86zM7.88 3.39 6.6 1.86 2 5.71l1.29 1.53z"
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("path", {
                d: "M10.54 10.497v5H9.29v-3.75H8.04v-1.25zm4.584 2.916h-1.667v.834h2.5v1.25h-3.75v-2.084c0-.458.375-.833.833-.833h1.667v-.833h-2.5v-1.25h2.917c.458 0 .833.375.833.833v1.25a.836.836 0 0 1-.833.833"
            })
        ]
    });
var $a49c402e21845732$export$2e2bcd8739ae039 = $a49c402e21845732$var$Svg12H;



parcelRequire("8dE9F");
const $e00949b09cd9dc31$var$Svg24H = (props)=>/*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        ...props,
        children: [
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("path", {
                d: "M12.005 4c-3.918-.065-7.643 2.752-8.658 6.537-1.06 3.566.376 7.691 3.447 9.803 3.131 2.302 7.752 2.19 10.768-.26 3.03-2.302 4.25-6.622 2.896-10.174C19.221 6.416 15.71 3.954 12.005 4m-.597 2.02c2.357-.184 4.807.846 6.207 2.793 1.998 2.571 1.809 6.526-.428 8.894A7 7 0 0 1 12.005 20c-3.23.063-6.263-2.415-6.857-5.59-.698-3.111 1.05-6.529 3.976-7.79a6.5 6.5 0 0 1 2.284-.6M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86zM7.88 3.39 6.6 1.86 2 5.71l1.29 1.53z"
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)("path", {
                d: "M9.92 13.413H8.255v.834h2.5v1.25h-3.75v-2.084c0-.458.375-.833.833-.833h1.667v-.833h-2.5v-1.25H9.92c.458 0 .833.375.833.833v1.25a.836.836 0 0 1-.833.833m7.084.834h-.833v1.25h-1.25v-1.25h-2.5v-3.75h1.25v2.5h1.25v-2.5h1.25v2.5h.833z"
            })
        ]
    });
var $e00949b09cd9dc31$export$2e2bcd8739ae039 = $e00949b09cd9dc31$var$Svg24H;


var $b58f7ae1cf99640c$exports = {};
"use strict";
"use client";

var $btGXk = parcelRequire("btGXk");
Object.defineProperty($b58f7ae1cf99640c$exports, "__esModule", {
    value: true
});
$b58f7ae1cf99640c$exports.default = void 0;

var $b58f7ae1cf99640c$var$_createSvgIcon = $btGXk((parcelRequire("4tgii")));

var $dzbn0 = parcelRequire("dzbn0");
var $b58f7ae1cf99640c$var$_default = $b58f7ae1cf99640c$exports.default = (0, $b58f7ae1cf99640c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $dzbn0.jsx)("path", {
    d: "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1m0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1M6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1"
}), 'AvTimer');



var $i60vX = parcelRequire("i60vX");


var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $i1zjM = parcelRequire("i1zjM");

var $fgPD6 = parcelRequire("fgPD6");



var $8DPw0 = parcelRequire("8DPw0");

var $lE3rX = parcelRequire("lE3rX");

var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $21098cb2d1f1e594$export$21f89b560b65a301(slot) {
    return (0, $iobM3.default)('MuiToggleButton', slot);
}
const $21098cb2d1f1e594$var$toggleButtonClasses = (0, $5rH1e.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $21098cb2d1f1e594$export$2e2bcd8739ae039 = $21098cb2d1f1e594$var$toggleButtonClasses;



var $8dE9F = parcelRequire("8dE9F");
/**
 * @ignore - internal component.
 */ const $a28dad9e31cebe79$var$ToggleButtonGroupContext = /*#__PURE__*/ $8dE9F.createContext({});
var $a28dad9e31cebe79$export$2e2bcd8739ae039 = $a28dad9e31cebe79$var$ToggleButtonGroupContext;



var $8dE9F = parcelRequire("8dE9F");
/**
 * @ignore - internal component.
 */ const $bbe8e25b67d37c10$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $8dE9F.createContext(undefined);
var $bbe8e25b67d37c10$export$2e2bcd8739ae039 = $bbe8e25b67d37c10$var$ToggleButtonGroupButtonContext;


// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $c8a9d8ff38b0585b$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.indexOf(value) >= 0;
    return value === candidate;
}



var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $607871432bf329a7$var$_excluded = [
    "value"
], $607871432bf329a7$var$_excluded2 = [
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "onChange",
    "onClick",
    "selected",
    "size",
    "value"
];
const $607871432bf329a7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $8DPw0.default)(size)}`,
            color
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $21098cb2d1f1e594$export$21f89b560b65a301), classes);
};
const $607871432bf329a7$var$ToggleButtonRoot = (0, $e5aV5.default)((0, $66635f5fba848ee5$export$2e2bcd8739ae039), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $8DPw0.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    let selectedColor = ownerState.color === 'standard' ? theme.palette.text.primary : theme.palette[ownerState.color].main;
    let selectedColorChannel;
    if (theme.vars) {
        selectedColor = ownerState.color === 'standard' ? theme.vars.palette.text.primary : theme.vars.palette[ownerState.color].main;
        selectedColorChannel = ownerState.color === 'standard' ? theme.vars.palette.text.primaryChannel : theme.vars.palette[ownerState.color].mainChannel;
    }
    return (0, $7TrLl.default)({}, theme.typography.button, {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`&.${(0, $21098cb2d1f1e594$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $27f3efa2ce541753$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $21098cb2d1f1e594$export$2e2bcd8739ae039).selected}`]: {
            color: selectedColor,
            backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $27f3efa2ce541753$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $27f3efa2ce541753$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $27f3efa2ce541753$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity)
                }
            }
        }
    }, ownerState.size === 'small' && {
        padding: 7,
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && {
        padding: 15,
        fontSize: theme.typography.pxToRem(15)
    });
});
const $607871432bf329a7$var$ToggleButton = /*#__PURE__*/ $8dE9F.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const _React$useContext = $8dE9F.useContext((0, $a28dad9e31cebe79$export$2e2bcd8739ae039)), { value: contextValue } = _React$useContext, contextProps = (0, $1gVUU.default)(_React$useContext, $607871432bf329a7$var$_excluded);
    const toggleButtonGroupButtonContextPositionClassName = $8dE9F.useContext((0, $bbe8e25b67d37c10$export$2e2bcd8739ae039));
    const resolvedProps = (0, $i1zjM.default)((0, $7TrLl.default)({}, contextProps, {
        selected: (0, $c8a9d8ff38b0585b$export$2e2bcd8739ae039)(inProps.value, contextValue)
    }), inProps);
    const props = (0, $lE3rX.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value } = props, other = (0, $1gVUU.default)(props, $607871432bf329a7$var$_excluded2);
    const ownerState = (0, $7TrLl.default)({}, props, {
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    });
    const classes = $607871432bf329a7$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $dzbn0.jsx)($607871432bf329a7$var$ToggleButtonRoot, (0, $7TrLl.default)({
        className: (0, $72F5q.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected
    }, other, {
        children: children
    }));
});
var $607871432bf329a7$export$2e2bcd8739ae039 = $607871432bf329a7$var$ToggleButton;



var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");



var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $8dE9F = parcelRequire("8dE9F");
function $ad85b28022b36b60$export$2e2bcd8739ae039(children) {
    return $8dE9F.Children.toArray(children).filter((child)=>/*#__PURE__*/ $8dE9F.isValidElement(child));
}



var $e5aV5 = parcelRequire("e5aV5");

var $lE3rX = parcelRequire("lE3rX");

var $8DPw0 = parcelRequire("8DPw0");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $ee6c86fedd4e7da6$export$44aa3ae5b353cef1(slot) {
    return (0, $iobM3.default)('MuiToggleButtonGroup', slot);
}
const $ee6c86fedd4e7da6$var$toggleButtonGroupClasses = (0, $5rH1e.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $ee6c86fedd4e7da6$export$2e2bcd8739ae039 = $ee6c86fedd4e7da6$var$toggleButtonGroupClasses;






var $dzbn0 = parcelRequire("dzbn0");
'use client';
const $091cb83da70560cf$var$_excluded = [
    "children",
    "className",
    "color",
    "disabled",
    "exclusive",
    "fullWidth",
    "onChange",
    "orientation",
    "size",
    "value"
];
const $091cb83da70560cf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation === 'vertical' && 'vertical',
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $8DPw0.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $ee6c86fedd4e7da6$export$44aa3ae5b353cef1), classes);
};
const $091cb83da70560cf$var$ToggleButtonGroupRoot = (0, $e5aV5.default)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $8DPw0.default)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $7TrLl.default)({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).grouped}`]: (0, $7TrLl.default)({}, ownerState.orientation === 'horizontal' ? {
            [`&.${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).selected} + .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).grouped}.${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).selected}`]: {
                borderLeft: 0,
                marginLeft: 0
            }
        } : {
            [`&.${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).selected} + .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).grouped}.${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).selected}`]: {
                borderTop: 0,
                marginTop: 0
            }
        })
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).firstButton},& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).middleButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).lastButton},& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).middleButton}`]: {
            marginLeft: -1,
            borderLeft: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }
    } : {
        [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).firstButton},& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).middleButton}`]: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).lastButton},& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).middleButton}`]: {
            marginTop: -1,
            borderTop: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).lastButton}.${(0, $21098cb2d1f1e594$export$2e2bcd8739ae039).disabled},& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).middleButton}.${(0, $21098cb2d1f1e594$export$2e2bcd8739ae039).disabled}`]: {
            borderLeft: '1px solid transparent'
        }
    } : {
        [`& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).lastButton}.${(0, $21098cb2d1f1e594$export$2e2bcd8739ae039).disabled},& .${(0, $ee6c86fedd4e7da6$export$2e2bcd8739ae039).middleButton}.${(0, $21098cb2d1f1e594$export$2e2bcd8739ae039).disabled}`]: {
            borderTop: '1px solid transparent'
        }
    }));
const $091cb83da70560cf$var$ToggleButtonGroup = /*#__PURE__*/ $8dE9F.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value } = props, other = (0, $1gVUU.default)(props, $091cb83da70560cf$var$_excluded);
    const ownerState = (0, $7TrLl.default)({}, props, {
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    });
    const classes = $091cb83da70560cf$var$useUtilityClasses(ownerState);
    const handleChange = $8dE9F.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $8dE9F.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $8dE9F.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $ad85b28022b36b60$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $dzbn0.jsx)($091cb83da70560cf$var$ToggleButtonGroupRoot, (0, $7TrLl.default)({
        role: "group",
        className: (0, $72F5q.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $dzbn0.jsx)((0, $a28dad9e31cebe79$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $bbe8e25b67d37c10$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $091cb83da70560cf$export$2e2bcd8739ae039 = $091cb83da70560cf$var$ToggleButtonGroup;



var $311cM = parcelRequire("311cM");
function $a942445a0e68d59d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $a942445a0e68d59d$var$changeItem(event, value, key, reloadWrapper) {
    if (value == null) return;
    localStorage.setItem(key, value);
    reloadWrapper(Math.round(Math.random() * 100));
}
const $a942445a0e68d59d$var$DialogOptionContainer = /*#__PURE__*/ (0, $f8iEm.default)("div", {
    target: "e2hjzqh1"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const $a942445a0e68d59d$var$DialogOptionLabel = /*#__PURE__*/ (0, $f8iEm.default)((0, $f1055812b5e9f556$export$2e2bcd8739ae039), {
    target: "e2hjzqh0"
})({
    name: "fp0g1l",
    styles: "margin-right:2.5rem;margin-bottom:0"
});
const $a942445a0e68d59d$var$toggleButtonGroupStyle = {
    marginLeft: "auto"
};
var $a942445a0e68d59d$var$_ref = {
    name: "18vijjj",
    styles: "display:flex;flex-direction:column;gap:0.5rem 0"
};
function $a942445a0e68d59d$var$SettingsDialog(props) {
    const { open: open, onClose: onClose, handleReload: handleReload } = props;
    const onCloseWrapper = (0, $8dE9F.useCallback)(()=>onClose(false), [
        onClose
    ]);
    const handleReloadWrapper = (0, $8dE9F.useCallback)((randomInt)=>handleReload(randomInt), [
        handleReload
    ]);
    const themeChoice = localStorage.getItem("darkTheme");
    const hourFormatChoice = localStorage.getItem("prefers12Hour");
    function onThemeChange(event, value) {
        $a942445a0e68d59d$var$changeItem(event, value, "darkTheme", handleReloadWrapper);
    }
    function onHourFormatChange(event, value) {
        $a942445a0e68d59d$var$changeItem(event, value, "prefers12Hour", handleReloadWrapper);
    }
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $9d266ce9dd577089$export$2e2bcd8739ae039), {
        maxWidth: "xs",
        open: open,
        onClose: onCloseWrapper,
        "aria-labelledby": "settings-dialog-title",
        children: [
            /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $5ee627924345a8d1$export$2e2bcd8739ae039), {
                id: "settings-dialog-title",
                children: [
                    "Settings",
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $bc55b9c9c616a23b$export$2e2bcd8739ae039), {
                        "aria-label": "close",
                        onClick: onCloseWrapper,
                        css: (theme)=>/*#__PURE__*/ (0, $311cM.css)({
                                position: "absolute",
                                right: theme.spacing(1),
                                top: theme.spacing(1)
                            }, "", ""),
                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($567e510f6ee0e200$exports))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $17726cd3a4f3cc2b$export$2e2bcd8739ae039), {
                dividers: true,
                css: $a942445a0e68d59d$var$_ref,
                children: [
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)($a942445a0e68d59d$var$DialogOptionContainer, {
                        children: [
                            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($a942445a0e68d59d$var$DialogOptionLabel, {
                                children: "Theme"
                            }),
                            /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $091cb83da70560cf$export$2e2bcd8739ae039), {
                                value: themeChoice,
                                exclusive: true,
                                onChange: onThemeChange,
                                css: $a942445a0e68d59d$var$toggleButtonGroupStyle,
                                children: [
                                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                                        value: "1",
                                        title: "Dark Theme",
                                        arrow: true,
                                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $607871432bf329a7$export$2e2bcd8739ae039), {
                                            value: "1",
                                            children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($072288c5cc63b91c$exports))), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                                        value: "2",
                                        title: "Light Theme",
                                        arrow: true,
                                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $607871432bf329a7$export$2e2bcd8739ae039), {
                                            value: "2",
                                            children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($07acf776ce70d9c4$exports))), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                                        value: "3",
                                        title: "Automatic",
                                        arrow: true,
                                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $607871432bf329a7$export$2e2bcd8739ae039), {
                                            value: "3",
                                            children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($27a5d82ed4200b9d$exports))), {})
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)($a942445a0e68d59d$var$DialogOptionContainer, {
                        children: [
                            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($a942445a0e68d59d$var$DialogOptionLabel, {
                                children: "Hour Format"
                            }),
                            /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $091cb83da70560cf$export$2e2bcd8739ae039), {
                                value: hourFormatChoice,
                                exclusive: true,
                                onChange: onHourFormatChange,
                                css: $a942445a0e68d59d$var$toggleButtonGroupStyle,
                                children: [
                                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                                        value: "1",
                                        title: "12 Hour Format",
                                        arrow: true,
                                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $607871432bf329a7$export$2e2bcd8739ae039), {
                                            value: "1",
                                            children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $i60vX.default), {
                                                component: (0, $a49c402e21845732$export$2e2bcd8739ae039)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                                        value: "2",
                                        title: "24 Hour Format",
                                        arrow: true,
                                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $607871432bf329a7$export$2e2bcd8739ae039), {
                                            value: "2",
                                            children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $i60vX.default), {
                                                component: (0, $e00949b09cd9dc31$export$2e2bcd8739ae039)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $95ab773eed618108$export$2e2bcd8739ae039), {
                                        value: "3",
                                        title: "Automatic",
                                        arrow: true,
                                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $607871432bf329a7$export$2e2bcd8739ae039), {
                                            value: "3",
                                            children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b58f7ae1cf99640c$exports))), {})
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$a942445a0e68d59d$var$SettingsDialog.propTypes = {
    open: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).bool.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).func.isRequired,
    handleReload: (0, (/*@__PURE__*/$parcel$interopDefault($agf0O))).func.isRequired
};
var $a942445a0e68d59d$export$2e2bcd8739ae039 = $a942445a0e68d59d$var$SettingsDialog;







var $8dE9F = parcelRequire("8dE9F");


var $1gVUU = parcelRequire("1gVUU");

var $7TrLl = parcelRequire("7TrLl");

var $8dE9F = parcelRequire("8dE9F");


var $72F5q = parcelRequire("72F5q");

var $fgPD6 = parcelRequire("fgPD6");

var $8DPw0 = parcelRequire("8DPw0");




var $e5aV5 = parcelRequire("e5aV5");

var $5rH1e = parcelRequire("5rH1e");

var $iobM3 = parcelRequire("iobM3");
function $d62c54dd6f178fe9$export$4b135a4b3a6c4550(slot) {
    return (0, $iobM3.default)('MuiInputAdornment', slot);
}
const $d62c54dd6f178fe9$var$inputAdornmentClasses = (0, $5rH1e.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $d62c54dd6f178fe9$export$2e2bcd8739ae039 = $d62c54dd6f178fe9$var$inputAdornmentClasses;



var $lE3rX = parcelRequire("lE3rX");

var $dzbn0 = parcelRequire("dzbn0");
'use client';
var $3027145937ca6eea$var$_span;
const $3027145937ca6eea$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $3027145937ca6eea$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $8DPw0.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $3027145937ca6eea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $8DPw0.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $8DPw0.default)(size)}`
        ]
    };
    return (0, $fgPD6.default)(slots, (0, $d62c54dd6f178fe9$export$4b135a4b3a6c4550), classes);
};
const $3027145937ca6eea$var$InputAdornmentRoot = (0, $e5aV5.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $3027145937ca6eea$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $7TrLl.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $d62c54dd6f178fe9$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $d62c54dd6f178fe9$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $3027145937ca6eea$var$InputAdornment = /*#__PURE__*/ $8dE9F.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $lE3rX.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $1gVUU.default)(props, $3027145937ca6eea$var$_excluded);
    const muiFormControl = (0, $f8b97bdab202086e$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $7TrLl.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $3027145937ca6eea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $dzbn0.jsx)((0, $49ce0c570a89f67e$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $dzbn0.jsx)($3027145937ca6eea$var$InputAdornmentRoot, (0, $7TrLl.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $72F5q.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $dzbn0.jsx)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $dzbn0.jsxs)($8dE9F.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $3027145937ca6eea$var$_span || ($3027145937ca6eea$var$_span = /*#__PURE__*/ (0, $dzbn0.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $3027145937ca6eea$export$2e2bcd8739ae039 = $3027145937ca6eea$var$InputAdornment;




function $28224f90c0f413fe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $28224f90c0f413fe$var$overHeaderStyle = {
    textAlign: "center",
    margin: "2em 0 0.125em 0"
};
const $28224f90c0f413fe$var$subHeaderStyle = {
    textAlign: "center"
};
const $28224f90c0f413fe$var$subSubHeaderStyle = {
    textAlign: "center",
    marginBottom: "2em"
};
const $28224f90c0f413fe$var$dividerStyle = {
    margin: "1em 0"
};
const $28224f90c0f413fe$var$heresyCharacters = {
    e: [
        "\xe9",
        "\xe8",
        "\xea",
        "\xeb"
    ],
    g: [
        "\u011F",
        "\u011D",
        "\u0121",
        "\u0123"
    ],
    w: [
        "\u0175"
    ],
    c: [
        "\xe7"
    ],
    E: [
        "\xc9",
        "\xc8",
        "\xca",
        "\xcb"
    ],
    G: [
        "\u011E",
        "\u011C",
        "\u0120",
        "\u0122"
    ],
    W: [
        "\u0174"
    ],
    C: [
        "\xc7"
    ]
};
function $28224f90c0f413fe$var$MoneyBagEmoji() {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7f50bfc76ce34f6e$export$2e2bcd8739ae039), {
        id: "959232720314200134",
        name: "googlemoneybag",
        animated: false,
        externalContainerStyle: {
            margin: "0 0.25rem"
        },
        disableTooltip: true
    });
}
function $28224f90c0f413fe$var$ClipboardBlobEmoji() {
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $7f50bfc76ce34f6e$export$2e2bcd8739ae039), {
        id: "696784715428004001",
        name: "blobclipboard",
        animated: false,
        disableTooltip: true
    });
}
var $28224f90c0f413fe$var$_ref = {
    name: "1dabe76",
    styles: "padding-bottom:24px"
};
function $28224f90c0f413fe$var$AprilTranslate() {
    const [value, setValue] = (0, $8dE9F.useState)("");
    const [heresyText, setHerseyText] = (0, $8dE9F.useState)("");
    const translateText = (event)=>{
        setValue(event.target.value);
        let newText = "";
        for (const character of event.target.value)if (Object.keys($28224f90c0f413fe$var$heresyCharacters).includes(character)) newText += $28224f90c0f413fe$var$heresyCharacters[character][Math.floor(Math.random() * $28224f90c0f413fe$var$heresyCharacters[character].length)];
        else newText += character;
        setHerseyText(newText);
    };
    const clipboard = async ()=>{
        try {
            await navigator.clipboard.writeText(heresyText);
        } catch (e) {
            console.log(e);
        }
    };
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $b00a3330140623b7$export$2e2bcd8739ae039), {
        css: $28224f90c0f413fe$var$_ref,
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                variant: "h5",
                css: $28224f90c0f413fe$var$overHeaderStyle,
                children: [
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($28224f90c0f413fe$var$MoneyBagEmoji, {}),
                    "Meet the limited budget with our Message Cheapifier!",
                    /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($28224f90c0f413fe$var$MoneyBagEmoji, {})
                ]
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                css: $28224f90c0f413fe$var$subHeaderStyle,
                children: "Unfortunately, we couldn't afford to use Cs, Es, Gs and Ws on this server anymore."
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $9b24571cedf3c6d4$export$2e2bcd8739ae039), {
                css: $28224f90c0f413fe$var$subSubHeaderStyle,
                children: "As such, we have this service for replacing the scarce letters with still available ones!"
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $82487243438c141c$export$2e2bcd8739ae039), {
                name: "Type in the message to be cheapified",
                type: "text",
                placeholder: "Type in the message to be cheapified",
                value: value,
                onChange: translateText,
                fullWidth: true,
                variant: "filled",
                color: "secondary",
                inputProps: {
                    "aria-label": "Type in the message to be cheapified"
                }
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $8f402101b41e5553$export$2e2bcd8739ae039), {
                css: $28224f90c0f413fe$var$dividerStyle
            }),
            /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $82487243438c141c$export$2e2bcd8739ae039), {
                name: "Your cheapified message",
                type: "text",
                placeholder: "Your cheapified message",
                value: heresyText,
                fullWidth: true,
                variant: "filled",
                color: "secondary",
                inputProps: {
                    "aria-label": "Your cheapified message"
                },
                InputProps: {
                    endAdornment: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $3027145937ca6eea$export$2e2bcd8739ae039), {
                        position: "end",
                        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $bc55b9c9c616a23b$export$2e2bcd8739ae039), {
                            onClick: clipboard,
                            children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)($28224f90c0f413fe$var$ClipboardBlobEmoji, {})
                        })
                    }),
                    disableUnderline: true
                }
            })
        ]
    });
}
var $28224f90c0f413fe$export$2e2bcd8739ae039 = $28224f90c0f413fe$var$AprilTranslate;


function $632b6ddd5c4e3ba2$var$getConfig() {
    let prefersDarkMode = (0, $f676a948b6c55387$export$2e2bcd8739ae039)("(prefers-color-scheme: dark)", {
        noSsr: true
    });
    const defaultHoursFormat = (0, $46ae9d0281ece1ca$export$e9c7d7ddfc1ce9b2)();
    // eslint-disable-next-line no-unused-vars
    const [resPDM, resPDMLS] = (0, $46ae9d0281ece1ca$export$d913c0256eaa9b04)("darkTheme", prefersDarkMode);
    // eslint-disable-next-line no-unused-vars
    const [resHF, resHFLS] = (0, $46ae9d0281ece1ca$export$d913c0256eaa9b04)("prefers12Hour", defaultHoursFormat);
    return {
        prefersDarkMode: resPDM,
        prefersHour12: resHF
    };
}
// Taken from https://github.com/mui-org/material-ui/blob/27471b4564eb40ff769352d73a29938d25804e45/packages/material-ui/src/styles/createTypography.js#L45
const $632b6ddd5c4e3ba2$var$htmlFontSize = 16;
const $632b6ddd5c4e3ba2$var$fontSize = 14;
const $632b6ddd5c4e3ba2$var$coef = $632b6ddd5c4e3ba2$var$fontSize / 14;
const $632b6ddd5c4e3ba2$var$pxToRem = (size)=>`${size / $632b6ddd5c4e3ba2$var$htmlFontSize * $632b6ddd5c4e3ba2$var$coef}rem`;
function $632b6ddd5c4e3ba2$var$App() {
    const [settingsOpen, toggleSettingsOpen] = (0, $8dE9F.useState)(false);
    const [, handleReload] = (0, $8dE9F.useState)(0);
    const { prefersDarkMode: prefersDarkMode, prefersHour12: prefersHour12 } = $632b6ddd5c4e3ba2$var$getConfig();
    const theme = (0, $8dE9F.useMemo)(()=>(0, $aeVxa.default)({
            components: {
                MuiAccordion: {
                    styleOverrides: {
                        root: {
                            "&:before": {
                                display: "none"
                            },
                            "&$expanded": {
                                marginTop: "0"
                            }
                        }
                    }
                },
                MuiAccordionSummary: {
                    styleOverrides: {
                        root: {
                            borderBottom: "1px solid rgba(224, 224, 224, 1)"
                        }
                    }
                },
                MuiLink: {
                    defaultProps: {
                        underline: "hover"
                    },
                    styleOverrides: {
                        root: {
                            color: prefersDarkMode ? "white" : "black",
                            fontWeight: prefersDarkMode ? "normal" : "bold"
                        }
                    }
                },
                MuiFilledInput: {
                    styleOverrides: {
                        root: {
                            borderRadius: "4px"
                        },
                        input: {
                            paddingTop: "19px",
                            paddingBottom: "18px"
                        }
                    }
                },
                MuiCardHeader: {
                    styleOverrides: {
                        content: {
                            maxWidth: "calc(100% - 99px)"
                        },
                        title: {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }
                    }
                },
                MuiTooltip: {
                    styleOverrides: {
                        tooltipPlacementBottom: {
                            margin: "6px 0"
                        },
                        tooltip: {
                            fontSize: $632b6ddd5c4e3ba2$var$pxToRem(12)
                        }
                    }
                },
                MuiAppBar: {
                    styleOverrides: {
                        root: {
                            boxShadow: "none",
                            backgroundColor: "transparent",
                            backgroundImage: "none"
                        },
                        positionStatic: {
                            margin: "2em 0"
                        }
                    }
                },
                MuiToolbar: {
                    styleOverrides: {
                        regular: {
                            "@media (min-width:750px)": {
                                minHeight: "48px"
                            }
                        }
                    }
                }
            },
            palette: {
                mode: prefersDarkMode ? "dark" : "light",
                background: {
                    paper: prefersDarkMode ? (0, $fuS6y.default)[800] : (0, $fuS6y.default)[100],
                    default: prefersDarkMode ? (0, $fuS6y.default)[900] : (0, $fuS6y.default)[50]
                },
                primary: {
                    main: "#43B581"
                },
                secondary: {
                    main: "#FCC21B"
                }
            },
            typography: {
                body2: {
                    color: prefersDarkMode ? "#CCC" : "rgba(0, 0, 0, 0.85)"
                },
                h5: {
                    margin: "2rem 0",
                    fontWeight: "bold"
                }
            },
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 750,
                    md: 1100,
                    lg: 1200,
                    xl: 1536
                }
            }
        }), [
        prefersDarkMode,
        prefersHour12
    ]);
    return /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $iUv4u.default), {
        injectFirst: true,
        children: /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $d9e6dd7c4d4efd87$export$2e2bcd8739ae039), {
            theme: theme,
            children: [
                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $468ce5e67b745614$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $701be91339cf6054$export$9ba4e89fdfa1fc54), {
                    children: [
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $b00a3330140623b7$export$2e2bcd8739ae039), {
                            maxWidth: "md",
                            children: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $8b7f9cde8c9246f7$export$2e2bcd8739ae039), {
                                handleOpen: toggleSettingsOpen
                            })
                        }),
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$25062201e9e25d76)((0, $aa49d4a669bfa59a$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $aa49d4a669bfa59a$export$e7b0ac011bb776c6), {
                                    path: "/",
                                    element: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $611265ab7ed69764$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $aa49d4a669bfa59a$export$e7b0ac011bb776c6), {
                                    path: "/changes",
                                    element: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $60df887ce52d9e4c$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $aa49d4a669bfa59a$export$e7b0ac011bb776c6), {
                                    path: "/drawfest/:year",
                                    element: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $d8ba614b8f0e3f8e$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $aa49d4a669bfa59a$export$e7b0ac011bb776c6), {
                                    path: "/message_cheapifier",
                                    element: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $28224f90c0f413fe$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $aa49d4a669bfa59a$export$e7b0ac011bb776c6), {
                                    path: "/*",
                                    element: /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $aa49d4a669bfa59a$export$444b3ab0cb9aec40), {
                                        to: "/",
                                        replace: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $a942445a0e68d59d$export$2e2bcd8739ae039), {
                            open: settingsOpen,
                            onClose: toggleSettingsOpen,
                            handleReload: handleReload
                        })
                    ]
                })
            ]
        })
    });
}
var $632b6ddd5c4e3ba2$export$2e2bcd8739ae039 = $632b6ddd5c4e3ba2$var$App;




(0, (/*@__PURE__*/$parcel$interopDefault($f22ac357d192a259$exports))).render(/*#__PURE__*/ (0, $28c3d1989808f867$export$34b9dba7ce09269b)((0, $632b6ddd5c4e3ba2$export$2e2bcd8739ae039), {}), document.getElementById("root"));


//# sourceMappingURL=repo.54924708.js.map
